( () => {
    var e = {
        331: e => {
            function t() {
                this._events = this._events || {},
                this._maxListeners = this._maxListeners || void 0
            }
            function r(e) {
                return "function" == typeof e
            }
            function n(e) {
                return "object" == typeof e && null !== e
            }
            function i(e) {
                return void 0 === e
            }
            e.exports = t,
            t.prototype._events = void 0,
            t.prototype._maxListeners = void 0,
            t.defaultMaxListeners = 10,
            t.prototype.setMaxListeners = function(e) {
                if ("number" != typeof e || e < 0 || isNaN(e))
                    throw TypeError("n must be a positive number");
                return this._maxListeners = e,
                this
            }
            ,
            t.prototype.emit = function(e) {
                var t, o, a, s, c, u;
                if (this._events || (this._events = {}),
                "error" === e && (!this._events.error || n(this._events.error) && !this._events.error.length)) {
                    if ((t = arguments[1])instanceof Error)
                        throw t;
                    var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
                    throw l.context = t,
                    l
                }
                if (i(o = this._events[e]))
                    return !1;
                if (r(o))
                    switch (arguments.length) {
                    case 1:
                        o.call(this);
                        break;
                    case 2:
                        o.call(this, arguments[1]);
                        break;
                    case 3:
                        o.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        s = Array.prototype.slice.call(arguments, 1),
                        o.apply(this, s)
                    }
                else if (n(o))
                    for (s = Array.prototype.slice.call(arguments, 1),
                    a = (u = o.slice()).length,
                    c = 0; c < a; c++)
                        u[c].apply(this, s);
                return !0
            }
            ,
            t.prototype.addListener = function(e, o) {
                var a;
                if (!r(o))
                    throw TypeError("listener must be a function");
                return this._events || (this._events = {}),
                this._events.newListener && this.emit("newListener", e, r(o.listener) ? o.listener : o),
                this._events[e] ? n(this._events[e]) ? this._events[e].push(o) : this._events[e] = [this._events[e], o] : this._events[e] = o,
                n(this._events[e]) && !this._events[e].warned && (a = i(this._maxListeners) ? t.defaultMaxListeners : this._maxListeners) && a > 0 && this._events[e].length > a && (this._events[e].warned = !0,
                console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length),
                "function" == typeof console.trace && console.trace()),
                this
            }
            ,
            t.prototype.on = t.prototype.addListener,
            t.prototype.once = function(e, t) {
                if (!r(t))
                    throw TypeError("listener must be a function");
                var n = !1;
                function i() {
                    this.removeListener(e, i),
                    n || (n = !0,
                    t.apply(this, arguments))
                }
                return i.listener = t,
                this.on(e, i),
                this
            }
            ,
            t.prototype.removeListener = function(e, t) {
                var i, o, a, s;
                if (!r(t))
                    throw TypeError("listener must be a function");
                if (!this._events || !this._events[e])
                    return this;
                if (a = (i = this._events[e]).length,
                o = -1,
                i === t || r(i.listener) && i.listener === t)
                    delete this._events[e],
                    this._events.removeListener && this.emit("removeListener", e, t);
                else if (n(i)) {
                    for (s = a; s-- > 0; )
                        if (i[s] === t || i[s].listener && i[s].listener === t) {
                            o = s;
                            break
                        }
                    if (o < 0)
                        return this;
                    1 === i.length ? (i.length = 0,
                    delete this._events[e]) : i.splice(o, 1),
                    this._events.removeListener && this.emit("removeListener", e, t)
                }
                return this
            }
            ,
            t.prototype.removeAllListeners = function(e) {
                var t, n;
                if (!this._events)
                    return this;
                if (!this._events.removeListener)
                    return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e],
                    this;
                if (0 === arguments.length) {
                    for (t in this._events)
                        "removeListener" !== t && this.removeAllListeners(t);
                    return this.removeAllListeners("removeListener"),
                    this._events = {},
                    this
                }
                if (r(n = this._events[e]))
                    this.removeListener(e, n);
                else if (n)
                    for (; n.length; )
                        this.removeListener(e, n[n.length - 1]);
                return delete this._events[e],
                this
            }
            ,
            t.prototype.listeners = function(e) {
                return this._events && this._events[e] ? r(this._events[e]) ? [this._events[e]] : this._events[e].slice() : []
            }
            ,
            t.prototype.listenerCount = function(e) {
                if (this._events) {
                    var t = this._events[e];
                    if (r(t))
                        return 1;
                    if (t)
                        return t.length
                }
                return 0
            }
            ,
            t.listenerCount = function(e, t) {
                return e.listenerCount(t)
            }
        }
        ,
        131: (e, t, r) => {
            "use strict";
            var n = r(374)
              , i = r(450)
              , o = r(650)
              , a = r(775)
              , s = r(76);
            function c(e, t, r, i) {
                return new n(e,t,r,i)
            }
            c.version = r(336),
            c.AlgoliaSearchHelper = n,
            c.SearchParameters = a,
            c.RecommendParameters = i,
            c.SearchResults = s,
            c.RecommendResults = o,
            e.exports = c
        }
        ,
        78: (e, t, r) => {
            "use strict";
            var n = r(331);
            function i(e, t, r) {
                this.main = e,
                this.fn = t,
                this.recommendFn = r,
                this.lastResults = null,
                this.lastRecommendResults = null
            }
            r(853)(i, n),
            i.prototype.detach = function() {
                this.removeAllListeners(),
                this.main.detachDerivedHelper(this)
            }
            ,
            i.prototype.getModifiedState = function(e) {
                return this.fn(e)
            }
            ,
            i.prototype.getModifiedRecommendState = function(e) {
                return this.recommendFn(e)
            }
            ,
            e.exports = i
        }
        ,
        450: e => {
            "use strict";
            function t(e) {
                e = e || {},
                this.params = e.params || []
            }
            t.prototype = {
                constructor: t,
                addParams: function(e) {
                    var r = this.params.slice();
                    return r.push(e),
                    new t({
                        params: r
                    })
                },
                removeParams: function(e) {
                    return new t({
                        params: this.params.filter((function(t) {
                            return t.$$id !== e
                        }
                        ))
                    })
                },
                addFrequentlyBoughtTogether: function(e) {
                    return this.addParams(Object.assign({}, e, {
                        model: "bought-together"
                    }))
                },
                addRelatedProducts: function(e) {
                    return this.addParams(Object.assign({}, e, {
                        model: "related-products"
                    }))
                },
                addTrendingItems: function(e) {
                    return this.addParams(Object.assign({}, e, {
                        model: "trending-items"
                    }))
                },
                addTrendingFacets: function(e) {
                    return this.addParams(Object.assign({}, e, {
                        model: "trending-facets"
                    }))
                },
                addLookingSimilar: function(e) {
                    return this.addParams(Object.assign({}, e, {
                        model: "looking-similar"
                    }))
                },
                _buildQueries: function(e, t) {
                    return this.params.filter((function(e) {
                        return void 0 === t[e.$$id]
                    }
                    )).map((function(t) {
                        var r = Object.assign({}, t, {
                            indexName: e
                        });
                        return delete r.$$id,
                        r
                    }
                    ))
                }
            },
            e.exports = t
        }
        ,
        650: e => {
            "use strict";
            function t(e, t) {
                this._state = e,
                this._rawResults = {};
                var r = this;
                e.params.forEach((function(e) {
                    var n = e.$$id;
                    r[n] = t[n],
                    r._rawResults[n] = t[n]
                }
                ))
            }
            t.prototype = {
                constructor: t
            },
            e.exports = t
        }
        ,
        437: (e, t, r) => {
            "use strict";
            var n = r(344)
              , i = r(116)
              , o = r(803)
              , a = {
                addRefinement: function(e, t, r) {
                    if (a.isRefined(e, t, r))
                        return e;
                    var i = "" + r
                      , o = e[t] ? e[t].concat(i) : [i]
                      , s = {};
                    return s[t] = o,
                    n({}, s, e)
                },
                removeRefinement: function(e, t, r) {
                    if (void 0 === r)
                        return a.clearRefinement(e, (function(e, r) {
                            return t === r
                        }
                        ));
                    var n = "" + r;
                    return a.clearRefinement(e, (function(e, r) {
                        return t === r && n === e
                    }
                    ))
                },
                toggleRefinement: function(e, t, r) {
                    if (void 0 === r)
                        throw new Error("toggleRefinement should be used with a value");
                    return a.isRefined(e, t, r) ? a.removeRefinement(e, t, r) : a.addRefinement(e, t, r)
                },
                clearRefinement: function(e, t, r) {
                    if (void 0 === t)
                        return i(e) ? {} : e;
                    if ("string" == typeof t)
                        return o(e, [t]);
                    if ("function" == typeof t) {
                        var n = !1
                          , a = Object.keys(e).reduce((function(i, o) {
                            var a = e[o] || []
                              , s = a.filter((function(e) {
                                return !t(e, o, r)
                            }
                            ));
                            return s.length !== a.length && (n = !0),
                            i[o] = s,
                            i
                        }
                        ), {});
                        return n ? a : e
                    }
                },
                isRefined: function(e, t, r) {
                    var n = Boolean(e[t]) && e[t].length > 0;
                    if (void 0 === r || !n)
                        return n;
                    var i = "" + r;
                    return -1 !== e[t].indexOf(i)
                }
            };
            e.exports = a
        }
        ,
        775: (e, t, r) => {
            "use strict";
            var n = r(344)
              , i = r(888)
              , o = r(686)
              , a = r(185)
              , s = r(116)
              , c = r(803)
              , u = r(23)
              , l = r(801)
              , f = r(437);
            function p(e, t) {
                return Array.isArray(e) && Array.isArray(t) ? e.length === t.length && e.every((function(e, r) {
                    return p(t[r], e)
                }
                )) : e === t
            }
            function h(e) {
                var t = e ? h._parseNumbers(e) : {};
                void 0 === t.userToken || l(t.userToken) || console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"),
                this.facets = t.facets || [],
                this.disjunctiveFacets = t.disjunctiveFacets || [],
                this.hierarchicalFacets = t.hierarchicalFacets || [],
                this.facetsRefinements = t.facetsRefinements || {},
                this.facetsExcludes = t.facetsExcludes || {},
                this.disjunctiveFacetsRefinements = t.disjunctiveFacetsRefinements || {},
                this.numericRefinements = t.numericRefinements || {},
                this.tagRefinements = t.tagRefinements || [],
                this.hierarchicalFacetsRefinements = t.hierarchicalFacetsRefinements || {};
                var r = this;
                Object.keys(t).forEach((function(e) {
                    var n = -1 !== h.PARAMETERS.indexOf(e)
                      , i = void 0 !== t[e];
                    !n && i && (r[e] = t[e])
                }
                ))
            }
            h.PARAMETERS = Object.keys(new h),
            h._parseNumbers = function(e) {
                if (e instanceof h)
                    return e;
                var t = {};
                if (["aroundPrecision", "aroundRadius", "getRankingInfo", "minWordSizefor2Typos", "minWordSizefor1Typo", "page", "maxValuesPerFacet", "distinct", "minimumAroundRadius", "hitsPerPage", "minProximity"].forEach((function(r) {
                    var n = e[r];
                    if ("string" == typeof n) {
                        var i = parseFloat(n);
                        t[r] = isNaN(i) ? n : i
                    }
                }
                )),
                Array.isArray(e.insideBoundingBox) && (t.insideBoundingBox = e.insideBoundingBox.map((function(e) {
                    return Array.isArray(e) ? e.map((function(e) {
                        return parseFloat(e)
                    }
                    )) : e
                }
                ))),
                e.numericRefinements) {
                    var r = {};
                    Object.keys(e.numericRefinements).forEach((function(t) {
                        var n = e.numericRefinements[t] || {};
                        r[t] = {},
                        Object.keys(n).forEach((function(e) {
                            var i = n[e].map((function(e) {
                                return Array.isArray(e) ? e.map((function(e) {
                                    return "string" == typeof e ? parseFloat(e) : e
                                }
                                )) : "string" == typeof e ? parseFloat(e) : e
                            }
                            ));
                            r[t][e] = i
                        }
                        ))
                    }
                    )),
                    t.numericRefinements = r
                }
                return a(e, t)
            }
            ,
            h.make = function(e) {
                var t = new h(e);
                return (e.hierarchicalFacets || []).forEach((function(e) {
                    if (e.rootPath) {
                        var r = t.getHierarchicalRefinement(e.name);
                        r.length > 0 && 0 !== r[0].indexOf(e.rootPath) && (t = t.clearRefinements(e.name)),
                        0 === (r = t.getHierarchicalRefinement(e.name)).length && (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath))
                    }
                }
                )),
                t
            }
            ,
            h.validate = function(e, t) {
                var r = t || {};
                return e.tagFilters && r.tagRefinements && r.tagRefinements.length > 0 ? new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.") : e.tagRefinements.length > 0 && r.tagFilters ? new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.") : e.numericFilters && r.numericRefinements && s(r.numericRefinements) ? new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : s(e.numericRefinements) && r.numericFilters ? new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : null
            }
            ,
            h.prototype = {
                constructor: h,
                clearRefinements: function(e) {
                    var t = {
                        numericRefinements: this._clearNumericRefinements(e),
                        facetsRefinements: f.clearRefinement(this.facetsRefinements, e, "conjunctiveFacet"),
                        facetsExcludes: f.clearRefinement(this.facetsExcludes, e, "exclude"),
                        disjunctiveFacetsRefinements: f.clearRefinement(this.disjunctiveFacetsRefinements, e, "disjunctiveFacet"),
                        hierarchicalFacetsRefinements: f.clearRefinement(this.hierarchicalFacetsRefinements, e, "hierarchicalFacet")
                    };
                    return t.numericRefinements === this.numericRefinements && t.facetsRefinements === this.facetsRefinements && t.facetsExcludes === this.facetsExcludes && t.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && t.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(t)
                },
                clearTags: function() {
                    return void 0 === this.tagFilters && 0 === this.tagRefinements.length ? this : this.setQueryParameters({
                        tagFilters: void 0,
                        tagRefinements: []
                    })
                },
                setIndex: function(e) {
                    return e === this.index ? this : this.setQueryParameters({
                        index: e
                    })
                },
                setQuery: function(e) {
                    return e === this.query ? this : this.setQueryParameters({
                        query: e
                    })
                },
                setPage: function(e) {
                    return e === this.page ? this : this.setQueryParameters({
                        page: e
                    })
                },
                setFacets: function(e) {
                    return this.setQueryParameters({
                        facets: e
                    })
                },
                setDisjunctiveFacets: function(e) {
                    return this.setQueryParameters({
                        disjunctiveFacets: e
                    })
                },
                setHitsPerPage: function(e) {
                    return this.hitsPerPage === e ? this : this.setQueryParameters({
                        hitsPerPage: e
                    })
                },
                setTypoTolerance: function(e) {
                    return this.typoTolerance === e ? this : this.setQueryParameters({
                        typoTolerance: e
                    })
                },
                addNumericRefinement: function(e, t, r) {
                    var n = u(r);
                    if (this.isNumericRefined(e, t, n))
                        return this;
                    var i = a({}, this.numericRefinements);
                    return i[e] = a({}, i[e]),
                    i[e][t] ? (i[e][t] = i[e][t].slice(),
                    i[e][t].push(n)) : i[e][t] = [n],
                    this.setQueryParameters({
                        numericRefinements: i
                    })
                },
                getConjunctiveRefinements: function(e) {
                    return this.isConjunctiveFacet(e) && this.facetsRefinements[e] || []
                },
                getDisjunctiveRefinements: function(e) {
                    return this.isDisjunctiveFacet(e) && this.disjunctiveFacetsRefinements[e] || []
                },
                getHierarchicalRefinement: function(e) {
                    return this.hierarchicalFacetsRefinements[e] || []
                },
                getExcludeRefinements: function(e) {
                    return this.isConjunctiveFacet(e) && this.facetsExcludes[e] || []
                },
                removeNumericRefinement: function(e, t, r) {
                    var n = r;
                    return void 0 !== n ? this.isNumericRefined(e, t, n) ? this.setQueryParameters({
                        numericRefinements: this._clearNumericRefinements((function(r, i) {
                            return i === e && r.op === t && p(r.val, u(n))
                        }
                        ))
                    }) : this : void 0 !== t ? this.isNumericRefined(e, t) ? this.setQueryParameters({
                        numericRefinements: this._clearNumericRefinements((function(r, n) {
                            return n === e && r.op === t
                        }
                        ))
                    }) : this : this.isNumericRefined(e) ? this.setQueryParameters({
                        numericRefinements: this._clearNumericRefinements((function(t, r) {
                            return r === e
                        }
                        ))
                    }) : this
                },
                getNumericRefinements: function(e) {
                    return this.numericRefinements[e] || {}
                },
                getNumericRefinement: function(e, t) {
                    return this.numericRefinements[e] && this.numericRefinements[e][t]
                },
                _clearNumericRefinements: function(e) {
                    if (void 0 === e)
                        return s(this.numericRefinements) ? {} : this.numericRefinements;
                    if ("string" == typeof e)
                        return c(this.numericRefinements, [e]);
                    if ("function" == typeof e) {
                        var t = !1
                          , r = this.numericRefinements
                          , n = Object.keys(r).reduce((function(n, i) {
                            var o = r[i]
                              , a = {};
                            return o = o || {},
                            Object.keys(o).forEach((function(r) {
                                var n = o[r] || []
                                  , s = [];
                                n.forEach((function(t) {
                                    e({
                                        val: t,
                                        op: r
                                    }, i, "numeric") || s.push(t)
                                }
                                )),
                                s.length !== n.length && (t = !0),
                                a[r] = s
                            }
                            )),
                            n[i] = a,
                            n
                        }
                        ), {});
                        return t ? n : this.numericRefinements
                    }
                },
                addFacet: function(e) {
                    return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({
                        facets: this.facets.concat([e])
                    })
                },
                addDisjunctiveFacet: function(e) {
                    return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({
                        disjunctiveFacets: this.disjunctiveFacets.concat([e])
                    })
                },
                addHierarchicalFacet: function(e) {
                    if (this.isHierarchicalFacet(e.name))
                        throw new Error("Cannot declare two hierarchical facets with the same name: `" + e.name + "`");
                    return this.setQueryParameters({
                        hierarchicalFacets: this.hierarchicalFacets.concat([e])
                    })
                },
                addFacetRefinement: function(e, t) {
                    if (!this.isConjunctiveFacet(e))
                        throw new Error(e + " is not defined in the facets attribute of the helper configuration");
                    return f.isRefined(this.facetsRefinements, e, t) ? this : this.setQueryParameters({
                        facetsRefinements: f.addRefinement(this.facetsRefinements, e, t)
                    })
                },
                addExcludeRefinement: function(e, t) {
                    if (!this.isConjunctiveFacet(e))
                        throw new Error(e + " is not defined in the facets attribute of the helper configuration");
                    return f.isRefined(this.facetsExcludes, e, t) ? this : this.setQueryParameters({
                        facetsExcludes: f.addRefinement(this.facetsExcludes, e, t)
                    })
                },
                addDisjunctiveFacetRefinement: function(e, t) {
                    if (!this.isDisjunctiveFacet(e))
                        throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
                    return f.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this : this.setQueryParameters({
                        disjunctiveFacetsRefinements: f.addRefinement(this.disjunctiveFacetsRefinements, e, t)
                    })
                },
                addTagRefinement: function(e) {
                    if (this.isTagRefined(e))
                        return this;
                    var t = {
                        tagRefinements: this.tagRefinements.concat(e)
                    };
                    return this.setQueryParameters(t)
                },
                removeFacet: function(e) {
                    return this.isConjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
                        facets: this.facets.filter((function(t) {
                            return t !== e
                        }
                        ))
                    }) : this
                },
                removeDisjunctiveFacet: function(e) {
                    return this.isDisjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
                        disjunctiveFacets: this.disjunctiveFacets.filter((function(t) {
                            return t !== e
                        }
                        ))
                    }) : this
                },
                removeHierarchicalFacet: function(e) {
                    return this.isHierarchicalFacet(e) ? this.clearRefinements(e).setQueryParameters({
                        hierarchicalFacets: this.hierarchicalFacets.filter((function(t) {
                            return t.name !== e
                        }
                        ))
                    }) : this
                },
                removeFacetRefinement: function(e, t) {
                    if (!this.isConjunctiveFacet(e))
                        throw new Error(e + " is not defined in the facets attribute of the helper configuration");
                    return f.isRefined(this.facetsRefinements, e, t) ? this.setQueryParameters({
                        facetsRefinements: f.removeRefinement(this.facetsRefinements, e, t)
                    }) : this
                },
                removeExcludeRefinement: function(e, t) {
                    if (!this.isConjunctiveFacet(e))
                        throw new Error(e + " is not defined in the facets attribute of the helper configuration");
                    return f.isRefined(this.facetsExcludes, e, t) ? this.setQueryParameters({
                        facetsExcludes: f.removeRefinement(this.facetsExcludes, e, t)
                    }) : this
                },
                removeDisjunctiveFacetRefinement: function(e, t) {
                    if (!this.isDisjunctiveFacet(e))
                        throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
                    return f.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this.setQueryParameters({
                        disjunctiveFacetsRefinements: f.removeRefinement(this.disjunctiveFacetsRefinements, e, t)
                    }) : this
                },
                removeTagRefinement: function(e) {
                    if (!this.isTagRefined(e))
                        return this;
                    var t = {
                        tagRefinements: this.tagRefinements.filter((function(t) {
                            return t !== e
                        }
                        ))
                    };
                    return this.setQueryParameters(t)
                },
                toggleRefinement: function(e, t) {
                    return this.toggleFacetRefinement(e, t)
                },
                toggleFacetRefinement: function(e, t) {
                    if (this.isHierarchicalFacet(e))
                        return this.toggleHierarchicalFacetRefinement(e, t);
                    if (this.isConjunctiveFacet(e))
                        return this.toggleConjunctiveFacetRefinement(e, t);
                    if (this.isDisjunctiveFacet(e))
                        return this.toggleDisjunctiveFacetRefinement(e, t);
                    throw new Error("Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets")
                },
                toggleConjunctiveFacetRefinement: function(e, t) {
                    if (!this.isConjunctiveFacet(e))
                        throw new Error(e + " is not defined in the facets attribute of the helper configuration");
                    return this.setQueryParameters({
                        facetsRefinements: f.toggleRefinement(this.facetsRefinements, e, t)
                    })
                },
                toggleExcludeFacetRefinement: function(e, t) {
                    if (!this.isConjunctiveFacet(e))
                        throw new Error(e + " is not defined in the facets attribute of the helper configuration");
                    return this.setQueryParameters({
                        facetsExcludes: f.toggleRefinement(this.facetsExcludes, e, t)
                    })
                },
                toggleDisjunctiveFacetRefinement: function(e, t) {
                    if (!this.isDisjunctiveFacet(e))
                        throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
                    return this.setQueryParameters({
                        disjunctiveFacetsRefinements: f.toggleRefinement(this.disjunctiveFacetsRefinements, e, t)
                    })
                },
                toggleHierarchicalFacetRefinement: function(e, t) {
                    if (!this.isHierarchicalFacet(e))
                        throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration");
                    var r = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e))
                      , i = {};
                    return void 0 !== this.hierarchicalFacetsRefinements[e] && this.hierarchicalFacetsRefinements[e].length > 0 && (this.hierarchicalFacetsRefinements[e][0] === t || 0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + r)) ? -1 === t.indexOf(r) ? i[e] = [] : i[e] = [t.slice(0, t.lastIndexOf(r))] : i[e] = [t],
                    this.setQueryParameters({
                        hierarchicalFacetsRefinements: n({}, i, this.hierarchicalFacetsRefinements)
                    })
                },
                addHierarchicalFacetRefinement: function(e, t) {
                    if (this.isHierarchicalFacetRefined(e))
                        throw new Error(e + " is already refined.");
                    if (!this.isHierarchicalFacet(e))
                        throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
                    var r = {};
                    return r[e] = [t],
                    this.setQueryParameters({
                        hierarchicalFacetsRefinements: n({}, r, this.hierarchicalFacetsRefinements)
                    })
                },
                removeHierarchicalFacetRefinement: function(e) {
                    if (!this.isHierarchicalFacetRefined(e))
                        return this;
                    var t = {};
                    return t[e] = [],
                    this.setQueryParameters({
                        hierarchicalFacetsRefinements: n({}, t, this.hierarchicalFacetsRefinements)
                    })
                },
                toggleTagRefinement: function(e) {
                    return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e)
                },
                isDisjunctiveFacet: function(e) {
                    return this.disjunctiveFacets.indexOf(e) > -1
                },
                isHierarchicalFacet: function(e) {
                    return void 0 !== this.getHierarchicalFacetByName(e)
                },
                isConjunctiveFacet: function(e) {
                    return this.facets.indexOf(e) > -1
                },
                isFacetRefined: function(e, t) {
                    return !!this.isConjunctiveFacet(e) && f.isRefined(this.facetsRefinements, e, t)
                },
                isExcludeRefined: function(e, t) {
                    return !!this.isConjunctiveFacet(e) && f.isRefined(this.facetsExcludes, e, t)
                },
                isDisjunctiveFacetRefined: function(e, t) {
                    return !!this.isDisjunctiveFacet(e) && f.isRefined(this.disjunctiveFacetsRefinements, e, t)
                },
                isHierarchicalFacetRefined: function(e, t) {
                    if (!this.isHierarchicalFacet(e))
                        return !1;
                    var r = this.getHierarchicalRefinement(e);
                    return t ? -1 !== r.indexOf(t) : r.length > 0
                },
                isNumericRefined: function(e, t, r) {
                    if (void 0 === r && void 0 === t)
                        return Boolean(this.numericRefinements[e]);
                    var n = this.numericRefinements[e] && void 0 !== this.numericRefinements[e][t];
                    if (void 0 === r || !n)
                        return n;
                    var o, a, s = u(r), c = void 0 !== (o = this.numericRefinements[e][t],
                    a = s,
                    i(o, (function(e) {
                        return p(e, a)
                    }
                    )));
                    return n && c
                },
                isTagRefined: function(e) {
                    return -1 !== this.tagRefinements.indexOf(e)
                },
                getRefinedDisjunctiveFacets: function() {
                    var e = this
                      , t = o(Object.keys(this.numericRefinements).filter((function(t) {
                        return Object.keys(e.numericRefinements[t]).length > 0
                    }
                    )), this.disjunctiveFacets);
                    return Object.keys(this.disjunctiveFacetsRefinements).filter((function(t) {
                        return e.disjunctiveFacetsRefinements[t].length > 0
                    }
                    )).concat(t).concat(this.getRefinedHierarchicalFacets()).sort()
                },
                getRefinedHierarchicalFacets: function() {
                    var e = this;
                    return o(this.hierarchicalFacets.map((function(e) {
                        return e.name
                    }
                    )), Object.keys(this.hierarchicalFacetsRefinements).filter((function(t) {
                        return e.hierarchicalFacetsRefinements[t].length > 0
                    }
                    ))).sort()
                },
                getUnrefinedDisjunctiveFacets: function() {
                    var e = this.getRefinedDisjunctiveFacets();
                    return this.disjunctiveFacets.filter((function(t) {
                        return -1 === e.indexOf(t)
                    }
                    ))
                },
                managedParameters: ["index", "facets", "disjunctiveFacets", "facetsRefinements", "hierarchicalFacets", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacetsRefinements"],
                getQueryParams: function() {
                    var e = this.managedParameters
                      , t = {}
                      , r = this;
                    return Object.keys(this).forEach((function(n) {
                        var i = r[n];
                        -1 === e.indexOf(n) && void 0 !== i && (t[n] = i)
                    }
                    )),
                    t
                },
                setQueryParameter: function(e, t) {
                    if (this[e] === t)
                        return this;
                    var r = {};
                    return r[e] = t,
                    this.setQueryParameters(r)
                },
                setQueryParameters: function(e) {
                    if (!e)
                        return this;
                    var t = h.validate(this, e);
                    if (t)
                        throw t;
                    var r = this
                      , n = h._parseNumbers(e)
                      , i = Object.keys(this).reduce((function(e, t) {
                        return e[t] = r[t],
                        e
                    }
                    ), {})
                      , o = Object.keys(n).reduce((function(e, t) {
                        var r = void 0 !== e[t]
                          , i = void 0 !== n[t];
                        return r && !i ? c(e, [t]) : (i && (e[t] = n[t]),
                        e)
                    }
                    ), i);
                    return new this.constructor(o)
                },
                resetPage: function() {
                    return void 0 === this.page ? this : this.setPage(0)
                },
                _getHierarchicalFacetSortBy: function(e) {
                    return e.sortBy || ["isRefined:desc", "name:asc"]
                },
                _getHierarchicalFacetSeparator: function(e) {
                    return e.separator || " > "
                },
                _getHierarchicalRootPath: function(e) {
                    return e.rootPath || null
                },
                _getHierarchicalShowParentLevel: function(e) {
                    return "boolean" != typeof e.showParentLevel || e.showParentLevel
                },
                getHierarchicalFacetByName: function(e) {
                    return i(this.hierarchicalFacets, (function(t) {
                        return t.name === e
                    }
                    ))
                },
                getHierarchicalFacetBreadcrumb: function(e) {
                    if (!this.isHierarchicalFacet(e))
                        return [];
                    var t = this.getHierarchicalRefinement(e)[0];
                    if (!t)
                        return [];
                    var r = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e));
                    return t.split(r).map((function(e) {
                        return e.trim()
                    }
                    ))
                },
                toString: function() {
                    return JSON.stringify(this, null, 2)
                }
            },
            e.exports = h
        }
        ,
        210: (e, t, r) => {
            "use strict";
            e.exports = function(e) {
                return function(t, r) {
                    var n = e.hierarchicalFacets[r]
                      , u = e.hierarchicalFacetsRefinements[n.name] && e.hierarchicalFacetsRefinements[n.name][0] || ""
                      , l = e._getHierarchicalFacetSeparator(n)
                      , f = e._getHierarchicalRootPath(n)
                      , p = e._getHierarchicalShowParentLevel(n)
                      , h = o(e._getHierarchicalFacetSortBy(n))
                      , d = t.every((function(e) {
                        return e.exhaustive
                    }
                    ))
                      , m = function(e, t, r, n, o) {
                        return function(u, l, f) {
                            var p = u;
                            if (f > 0) {
                                var h = 0;
                                for (p = u; h < f; ) {
                                    var d = p && Array.isArray(p.data) ? p.data : [];
                                    p = i(d, (function(e) {
                                        return e.isRefined
                                    }
                                    )),
                                    h++
                                }
                            }
                            if (p) {
                                var m = Object.keys(l.data).map((function(e) {
                                    return [e, l.data[e]]
                                }
                                )).filter((function(e) {
                                    return function(e, t, r, n, i, o) {
                                        if (i && (0 !== e.indexOf(i) || i === e))
                                            return !1;
                                        return !i && -1 === e.indexOf(n) || i && e.split(n).length - i.split(n).length == 1 || -1 === e.indexOf(n) && -1 === r.indexOf(n) || 0 === r.indexOf(e) || 0 === e.indexOf(t + n) && (o || 0 === e.indexOf(r))
                                    }(e[0], p.path || r, o, t, r, n)
                                }
                                ));
                                p.data = a(m.map((function(e) {
                                    var r = e[0];
                                    return function(e, t, r, n, i) {
                                        var o = t.split(r);
                                        return {
                                            name: o[o.length - 1].trim(),
                                            path: t,
                                            escapedValue: s(t),
                                            count: e,
                                            isRefined: n === t || 0 === n.indexOf(t + r),
                                            exhaustive: i,
                                            data: null
                                        }
                                    }(e[1], r, t, c(o), l.exhaustive)
                                }
                                )), e[0], e[1])
                            }
                            return u
                        }
                    }(h, l, f, p, u)
                      , g = t;
                    return f && (g = t.slice(f.split(l).length)),
                    g.reduce(m, {
                        name: e.hierarchicalFacets[r].name,
                        count: null,
                        isRefined: !0,
                        path: null,
                        escapedValue: null,
                        exhaustive: d,
                        data: null
                    })
                }
            }
            ;
            var n = r(39)
              , i = r(888)
              , o = r(293)
              , a = r(148)
              , s = n.escapeFacetValue
              , c = n.unescapeFacetValue
        }
        ,
        76: (e, t, r) => {
            "use strict";
            var n = r(587)
              , i = r(344)
              , o = r(39)
              , a = r(888)
              , s = r(725)
              , c = r(293)
              , u = r(185)
              , l = r(148)
              , f = o.escapeFacetValue
              , p = o.unescapeFacetValue
              , h = r(210);
            function d(e) {
                var t = {};
                return e.forEach((function(e, r) {
                    t[e] = r
                }
                )),
                t
            }
            function m(e, t, r) {
                t && t[r] && (e.stats = t[r])
            }
            function g(e, t, r) {
                var o = t[0];
                this._rawResults = t;
                var c = this;
                Object.keys(o).forEach((function(e) {
                    c[e] = o[e]
                }
                ));
                var l = u({
                    persistHierarchicalRootCount: !1
                }, r);
                Object.keys(l).forEach((function(e) {
                    c[e] = l[e]
                }
                )),
                this.processingTimeMS = t.reduce((function(e, t) {
                    return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS
                }
                ), 0),
                this.disjunctiveFacets = [],
                this.hierarchicalFacets = e.hierarchicalFacets.map((function() {
                    return []
                }
                )),
                this.facets = [];
                var f = e.getRefinedDisjunctiveFacets()
                  , g = d(e.facets)
                  , y = d(e.disjunctiveFacets)
                  , v = 1
                  , b = o.facets || {};
                Object.keys(b).forEach((function(t) {
                    var r, n, i = b[t], u = (r = e.hierarchicalFacets,
                    n = t,
                    a(r, (function(e) {
                        return (e.attributes || []).indexOf(n) > -1
                    }
                    )));
                    if (u) {
                        var l = u.attributes.indexOf(t)
                          , f = s(e.hierarchicalFacets, (function(e) {
                            return e.name === u.name
                        }
                        ));
                        c.hierarchicalFacets[f][l] = {
                            attribute: t,
                            data: i,
                            exhaustive: o.exhaustiveFacetsCount
                        }
                    } else {
                        var p, h = -1 !== e.disjunctiveFacets.indexOf(t), d = -1 !== e.facets.indexOf(t);
                        h && (p = y[t],
                        c.disjunctiveFacets[p] = {
                            name: t,
                            data: i,
                            exhaustive: o.exhaustiveFacetsCount
                        },
                        m(c.disjunctiveFacets[p], o.facets_stats, t)),
                        d && (p = g[t],
                        c.facets[p] = {
                            name: t,
                            data: i,
                            exhaustive: o.exhaustiveFacetsCount
                        },
                        m(c.facets[p], o.facets_stats, t))
                    }
                }
                )),
                this.hierarchicalFacets = n(this.hierarchicalFacets),
                f.forEach((function(r) {
                    var n = t[v]
                      , a = n && n.facets ? n.facets : {}
                      , l = e.getHierarchicalFacetByName(r);
                    Object.keys(a).forEach((function(t) {
                        var r, f = a[t];
                        if (l) {
                            r = s(e.hierarchicalFacets, (function(e) {
                                return e.name === l.name
                            }
                            ));
                            var h = s(c.hierarchicalFacets[r], (function(e) {
                                return e.attribute === t
                            }
                            ));
                            if (-1 === h)
                                return;
                            c.hierarchicalFacets[r][h].data = u({}, c.hierarchicalFacets[r][h].data, f)
                        } else {
                            r = y[t];
                            var d = o.facets && o.facets[t] || {};
                            c.disjunctiveFacets[r] = {
                                name: t,
                                data: i({}, f, d),
                                exhaustive: n.exhaustiveFacetsCount
                            },
                            m(c.disjunctiveFacets[r], n.facets_stats, t),
                            e.disjunctiveFacetsRefinements[t] && e.disjunctiveFacetsRefinements[t].forEach((function(n) {
                                !c.disjunctiveFacets[r].data[n] && e.disjunctiveFacetsRefinements[t].indexOf(p(n)) > -1 && (c.disjunctiveFacets[r].data[n] = 0)
                            }
                            ))
                        }
                    }
                    )),
                    v++
                }
                )),
                e.getRefinedHierarchicalFacets().forEach((function(r) {
                    var n = e.getHierarchicalFacetByName(r)
                      , o = e._getHierarchicalFacetSeparator(n)
                      , a = e.getHierarchicalRefinement(r);
                    0 === a.length || a[0].split(o).length < 2 || t.slice(v).forEach((function(t) {
                        var r = t && t.facets ? t.facets : {};
                        Object.keys(r).forEach((function(t) {
                            var u = r[t]
                              , l = s(e.hierarchicalFacets, (function(e) {
                                return e.name === n.name
                            }
                            ))
                              , f = s(c.hierarchicalFacets[l], (function(e) {
                                return e.attribute === t
                            }
                            ));
                            if (-1 !== f) {
                                var p = {};
                                if (a.length > 0 && !c.persistHierarchicalRootCount) {
                                    var h = a[0].split(o)[0];
                                    p[h] = c.hierarchicalFacets[l][f].data[h]
                                }
                                c.hierarchicalFacets[l][f].data = i(p, u, c.hierarchicalFacets[l][f].data)
                            }
                        }
                        )),
                        v++
                    }
                    ))
                }
                )),
                Object.keys(e.facetsExcludes).forEach((function(t) {
                    var r = e.facetsExcludes[t]
                      , n = g[t];
                    c.facets[n] = {
                        name: t,
                        data: b[t],
                        exhaustive: o.exhaustiveFacetsCount
                    },
                    r.forEach((function(e) {
                        c.facets[n] = c.facets[n] || {
                            name: t
                        },
                        c.facets[n].data = c.facets[n].data || {},
                        c.facets[n].data[e] = 0
                    }
                    ))
                }
                )),
                this.hierarchicalFacets = this.hierarchicalFacets.map(h(e)),
                this.facets = n(this.facets),
                this.disjunctiveFacets = n(this.disjunctiveFacets),
                this._state = e
            }
            function y(e, t) {
                function r(e) {
                    return e.name === t
                }
                if (e._state.isConjunctiveFacet(t)) {
                    var n = a(e.facets, r);
                    return n ? Object.keys(n.data).map((function(r) {
                        var i = f(r);
                        return {
                            name: r,
                            escapedValue: i,
                            count: n.data[r],
                            isRefined: e._state.isFacetRefined(t, i),
                            isExcluded: e._state.isExcludeRefined(t, r)
                        }
                    }
                    )) : []
                }
                if (e._state.isDisjunctiveFacet(t)) {
                    var i = a(e.disjunctiveFacets, r);
                    return i ? Object.keys(i.data).map((function(r) {
                        var n = f(r);
                        return {
                            name: r,
                            escapedValue: n,
                            count: i.data[r],
                            isRefined: e._state.isDisjunctiveFacetRefined(t, n)
                        }
                    }
                    )) : []
                }
                if (e._state.isHierarchicalFacet(t)) {
                    var o = a(e.hierarchicalFacets, r);
                    if (!o)
                        return o;
                    var s = e._state.getHierarchicalFacetByName(t)
                      , c = e._state._getHierarchicalFacetSeparator(s)
                      , u = p(e._state.getHierarchicalRefinement(t)[0] || "");
                    0 === u.indexOf(s.rootPath) && (u = u.replace(s.rootPath + c, ""));
                    var l = u.split(c);
                    return l.unshift(t),
                    v(o, l, 0),
                    o
                }
            }
            function v(e, t, r) {
                e.isRefined = e.name === (t[r] && t[r].trim()),
                e.data && e.data.forEach((function(e) {
                    v(e, t, r + 1)
                }
                ))
            }
            function b(e, t, r, n) {
                if (n = n || 0,
                Array.isArray(t))
                    return e(t, r[n]);
                if (!t.data || 0 === t.data.length)
                    return t;
                var o = t.data.map((function(t) {
                    return b(e, t, r, n + 1)
                }
                ))
                  , a = e(o, r[n]);
                return i({
                    data: a
                }, t)
            }
            function S(e, t) {
                var r = a(e, (function(e) {
                    return e.name === t
                }
                ));
                return r && r.stats
            }
            function O(e, t, r, n, i) {
                var o = a(i, (function(e) {
                    return e.name === r
                }
                ))
                  , s = o && o.data && o.data[n] ? o.data[n] : 0
                  , c = o && o.exhaustive || !1;
                return {
                    type: t,
                    attributeName: r,
                    name: n,
                    count: s,
                    exhaustive: c
                }
            }
            g.prototype.getFacetByName = function(e) {
                function t(t) {
                    return t.name === e
                }
                return a(this.facets, t) || a(this.disjunctiveFacets, t) || a(this.hierarchicalFacets, t)
            }
            ,
            g.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"],
            g.prototype.getFacetValues = function(e, t) {
                var r = y(this, e);
                if (r) {
                    var n, o = i({}, t, {
                        sortBy: g.DEFAULT_SORT,
                        facetOrdering: !(t && t.sortBy)
                    }), a = this;
                    if (Array.isArray(r))
                        n = [e];
                    else
                        n = a._state.getHierarchicalFacetByName(r.name).attributes;
                    return b((function(e, t) {
                        if (o.facetOrdering) {
                            var r = function(e, t) {
                                return e.renderingContent && e.renderingContent.facetOrdering && e.renderingContent.facetOrdering.values && e.renderingContent.facetOrdering.values[t]
                            }(a, t);
                            if (r)
                                return function(e, t) {
                                    var r = []
                                      , n = []
                                      , i = (t.order || []).reduce((function(e, t, r) {
                                        return e[t] = r,
                                        e
                                    }
                                    ), {});
                                    e.forEach((function(e) {
                                        var t = e.path || e.name;
                                        void 0 !== i[t] ? r[i[t]] = e : n.push(e)
                                    }
                                    )),
                                    r = r.filter((function(e) {
                                        return e
                                    }
                                    ));
                                    var o, a = t.sortRemainingBy;
                                    return "hidden" === a ? r : (o = "alpha" === a ? [["path", "name"], ["asc", "asc"]] : [["count"], ["desc"]],
                                    r.concat(l(n, o[0], o[1])))
                                }(e, r)
                        }
                        if (Array.isArray(o.sortBy)) {
                            var n = c(o.sortBy, g.DEFAULT_SORT);
                            return l(e, n[0], n[1])
                        }
                        if ("function" == typeof o.sortBy)
                            return function(e, t) {
                                return t.sort(e)
                            }(o.sortBy, e);
                        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function")
                    }
                    ), r, n)
                }
            }
            ,
            g.prototype.getFacetStats = function(e) {
                return this._state.isConjunctiveFacet(e) ? S(this.facets, e) : this._state.isDisjunctiveFacet(e) ? S(this.disjunctiveFacets, e) : void 0
            }
            ,
            g.prototype.getRefinements = function() {
                var e = this._state
                  , t = this
                  , r = [];
                return Object.keys(e.facetsRefinements).forEach((function(n) {
                    e.facetsRefinements[n].forEach((function(i) {
                        r.push(O(e, "facet", n, i, t.facets))
                    }
                    ))
                }
                )),
                Object.keys(e.facetsExcludes).forEach((function(n) {
                    e.facetsExcludes[n].forEach((function(i) {
                        r.push(O(e, "exclude", n, i, t.facets))
                    }
                    ))
                }
                )),
                Object.keys(e.disjunctiveFacetsRefinements).forEach((function(n) {
                    e.disjunctiveFacetsRefinements[n].forEach((function(i) {
                        r.push(O(e, "disjunctive", n, i, t.disjunctiveFacets))
                    }
                    ))
                }
                )),
                Object.keys(e.hierarchicalFacetsRefinements).forEach((function(n) {
                    e.hierarchicalFacetsRefinements[n].forEach((function(i) {
                        r.push(function(e, t, r, n) {
                            var i = e.getHierarchicalFacetByName(t)
                              , o = e._getHierarchicalFacetSeparator(i)
                              , s = r.split(o)
                              , c = a(n, (function(e) {
                                return e.name === t
                            }
                            ))
                              , u = s.reduce((function(e, t) {
                                var r = e && a(e.data, (function(e) {
                                    return e.name === t
                                }
                                ));
                                return void 0 !== r ? r : e
                            }
                            ), c)
                              , l = u && u.count || 0
                              , f = u && u.exhaustive || !1
                              , p = u && u.path || "";
                            return {
                                type: "hierarchical",
                                attributeName: t,
                                name: p,
                                count: l,
                                exhaustive: f
                            }
                        }(e, n, i, t.hierarchicalFacets))
                    }
                    ))
                }
                )),
                Object.keys(e.numericRefinements).forEach((function(t) {
                    var n = e.numericRefinements[t];
                    Object.keys(n).forEach((function(e) {
                        n[e].forEach((function(n) {
                            r.push({
                                type: "numeric",
                                attributeName: t,
                                name: n,
                                numericValue: n,
                                operator: e
                            })
                        }
                        ))
                    }
                    ))
                }
                )),
                e.tagRefinements.forEach((function(e) {
                    r.push({
                        type: "tag",
                        attributeName: "_tags",
                        name: e
                    })
                }
                )),
                r
            }
            ,
            e.exports = g
        }
        ,
        374: (e, t, r) => {
            "use strict";
            var n = r(331)
              , i = r(78)
              , o = r(39).escapeFacetValue
              , a = r(853)
              , s = r(185)
              , c = r(116)
              , u = r(803)
              , l = r(450)
              , f = r(650)
              , p = r(394)
              , h = r(775)
              , d = r(76)
              , m = r(878)
              , g = r(336);
            function y(e, t, r, n) {
                "function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + g + ")"),
                this.setClient(e);
                var i = r || {};
                i.index = t,
                this.state = h.make(i),
                this.recommendState = new l({
                    params: i.recommendState
                }),
                this.lastResults = null,
                this.lastRecommendResults = null,
                this._queryId = 0,
                this._recommendQueryId = 0,
                this._lastQueryIdReceived = -1,
                this._lastRecommendQueryIdReceived = -1,
                this.derivedHelpers = [],
                this._currentNbQueries = 0,
                this._currentNbRecommendQueries = 0,
                this._searchResultsOptions = n,
                this._recommendCache = {}
            }
            function v(e) {
                if (e < 0)
                    throw new Error("Page requested below 0.");
                return this._change({
                    state: this.state.setPage(e),
                    isPageReset: !1
                }),
                this
            }
            function b() {
                return this.state.page
            }
            a(y, n),
            y.prototype.search = function() {
                return this._search({
                    onlyWithDerivedHelpers: !1
                }),
                this
            }
            ,
            y.prototype.searchOnlyWithDerivedHelpers = function() {
                return this._search({
                    onlyWithDerivedHelpers: !0
                }),
                this
            }
            ,
            y.prototype.recommend = function() {
                return this._recommend(),
                this
            }
            ,
            y.prototype.getQuery = function() {
                var e = this.state;
                return p._getHitsSearchParams(e)
            }
            ,
            y.prototype.searchOnce = function(e, t) {
                var r = e ? this.state.setQueryParameters(e) : this.state
                  , n = p._getQueries(r.index, r)
                  , i = this;
                if (this._currentNbQueries++,
                this.emit("searchOnce", {
                    state: r
                }),
                !t)
                    return this.client.search(n).then((function(e) {
                        return i._currentNbQueries--,
                        0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                        {
                            content: new d(r,e.results),
                            state: r,
                            _originalResponse: e
                        }
                    }
                    ), (function(e) {
                        throw i._currentNbQueries--,
                        0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                        e
                    }
                    ));
                this.client.search(n).then((function(e) {
                    i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                    t(null, new d(r,e.results), r)
                }
                )).catch((function(e) {
                    i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit("searchQueueEmpty"),
                    t(e, null, r)
                }
                ))
            }
            ,
            y.prototype.findAnswers = function(e) {
                console.warn("[algoliasearch-helper] answers is no longer supported");
                var t = this.state
                  , r = this.derivedHelpers[0];
                if (!r)
                    return Promise.resolve([]);
                var n = r.getModifiedState(t)
                  , i = s({
                    attributesForPrediction: e.attributesForPrediction,
                    nbHits: e.nbHits
                }, {
                    params: u(p._getHitsSearchParams(n), ["attributesToSnippet", "hitsPerPage", "restrictSearchableAttributes", "snippetEllipsisText"])
                })
                  , o = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
                if ("function" != typeof this.client.initIndex)
                    throw new Error(o);
                var a = this.client.initIndex(n.index);
                if ("function" != typeof a.findAnswers)
                    throw new Error(o);
                return a.findAnswers(n.query, e.queryLanguages, i)
            }
            ,
            y.prototype.searchForFacetValues = function(e, t, r, n) {
                var i = "function" == typeof this.client.searchForFacetValues
                  , a = "function" == typeof this.client.initIndex;
                if (!i && !a && "function" != typeof this.client.search)
                    throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
                var s = this.state.setQueryParameters(n || {})
                  , c = s.isDisjunctiveFacet(e)
                  , u = p.getSearchForFacetQuery(e, t, r, s);
                this._currentNbQueries++;
                var l, f = this;
                return i ? l = this.client.searchForFacetValues([{
                    indexName: s.index,
                    params: u
                }]) : a ? l = this.client.initIndex(s.index).searchForFacetValues(u) : (delete u.facetName,
                l = this.client.search([{
                    type: "facet",
                    facet: e,
                    indexName: s.index,
                    params: u
                }]).then((function(e) {
                    return e.results[0]
                }
                ))),
                this.emit("searchForFacetValues", {
                    state: s,
                    facet: e,
                    query: t
                }),
                l.then((function(t) {
                    return f._currentNbQueries--,
                    0 === f._currentNbQueries && f.emit("searchQueueEmpty"),
                    (t = Array.isArray(t) ? t[0] : t).facetHits.forEach((function(t) {
                        t.escapedValue = o(t.value),
                        t.isRefined = c ? s.isDisjunctiveFacetRefined(e, t.escapedValue) : s.isFacetRefined(e, t.escapedValue)
                    }
                    )),
                    t
                }
                ), (function(e) {
                    throw f._currentNbQueries--,
                    0 === f._currentNbQueries && f.emit("searchQueueEmpty"),
                    e
                }
                ))
            }
            ,
            y.prototype.setQuery = function(e) {
                return this._change({
                    state: this.state.resetPage().setQuery(e),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.clearRefinements = function(e) {
                return this._change({
                    state: this.state.resetPage().clearRefinements(e),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.clearTags = function() {
                return this._change({
                    state: this.state.resetPage().clearTags(),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.addDisjunctiveFacetRefinement = function(e, t) {
                return this._change({
                    state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.addDisjunctiveRefine = function() {
                return this.addDisjunctiveFacetRefinement.apply(this, arguments)
            }
            ,
            y.prototype.addHierarchicalFacetRefinement = function(e, t) {
                return this._change({
                    state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.addNumericRefinement = function(e, t, r) {
                return this._change({
                    state: this.state.resetPage().addNumericRefinement(e, t, r),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.addFacetRefinement = function(e, t) {
                return this._change({
                    state: this.state.resetPage().addFacetRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.addRefine = function() {
                return this.addFacetRefinement.apply(this, arguments)
            }
            ,
            y.prototype.addFacetExclusion = function(e, t) {
                return this._change({
                    state: this.state.resetPage().addExcludeRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.addExclude = function() {
                return this.addFacetExclusion.apply(this, arguments)
            }
            ,
            y.prototype.addTag = function(e) {
                return this._change({
                    state: this.state.resetPage().addTagRefinement(e),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.addFrequentlyBoughtTogether = function(e) {
                return this._recommendChange({
                    state: this.recommendState.addFrequentlyBoughtTogether(e)
                }),
                this
            }
            ,
            y.prototype.addRelatedProducts = function(e) {
                return this._recommendChange({
                    state: this.recommendState.addRelatedProducts(e)
                }),
                this
            }
            ,
            y.prototype.addTrendingItems = function(e) {
                return this._recommendChange({
                    state: this.recommendState.addTrendingItems(e)
                }),
                this
            }
            ,
            y.prototype.addTrendingFacets = function(e) {
                return this._recommendChange({
                    state: this.recommendState.addTrendingFacets(e)
                }),
                this
            }
            ,
            y.prototype.addLookingSimilar = function(e) {
                return this._recommendChange({
                    state: this.recommendState.addLookingSimilar(e)
                }),
                this
            }
            ,
            y.prototype.removeNumericRefinement = function(e, t, r) {
                return this._change({
                    state: this.state.resetPage().removeNumericRefinement(e, t, r),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.removeDisjunctiveFacetRefinement = function(e, t) {
                return this._change({
                    state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.removeDisjunctiveRefine = function() {
                return this.removeDisjunctiveFacetRefinement.apply(this, arguments)
            }
            ,
            y.prototype.removeHierarchicalFacetRefinement = function(e) {
                return this._change({
                    state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.removeFacetRefinement = function(e, t) {
                return this._change({
                    state: this.state.resetPage().removeFacetRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.removeRefine = function() {
                return this.removeFacetRefinement.apply(this, arguments)
            }
            ,
            y.prototype.removeFacetExclusion = function(e, t) {
                return this._change({
                    state: this.state.resetPage().removeExcludeRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.removeExclude = function() {
                return this.removeFacetExclusion.apply(this, arguments)
            }
            ,
            y.prototype.removeTag = function(e) {
                return this._change({
                    state: this.state.resetPage().removeTagRefinement(e),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.removeFrequentlyBoughtTogether = function(e) {
                return this._recommendChange({
                    state: this.recommendState.removeParams(e)
                }),
                this
            }
            ,
            y.prototype.removeRelatedProducts = function(e) {
                return this._recommendChange({
                    state: this.recommendState.removeParams(e)
                }),
                this
            }
            ,
            y.prototype.removeTrendingItems = function(e) {
                return this._recommendChange({
                    state: this.recommendState.removeParams(e)
                }),
                this
            }
            ,
            y.prototype.removeTrendingFacets = function(e) {
                return this._recommendChange({
                    state: this.recommendState.removeParams(e)
                }),
                this
            }
            ,
            y.prototype.removeLookingSimilar = function(e) {
                return this._recommendChange({
                    state: this.recommendState.removeParams(e)
                }),
                this
            }
            ,
            y.prototype.toggleFacetExclusion = function(e, t) {
                return this._change({
                    state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.toggleExclude = function() {
                return this.toggleFacetExclusion.apply(this, arguments)
            }
            ,
            y.prototype.toggleRefinement = function(e, t) {
                return this.toggleFacetRefinement(e, t)
            }
            ,
            y.prototype.toggleFacetRefinement = function(e, t) {
                return this._change({
                    state: this.state.resetPage().toggleFacetRefinement(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.toggleRefine = function() {
                return this.toggleFacetRefinement.apply(this, arguments)
            }
            ,
            y.prototype.toggleTag = function(e) {
                return this._change({
                    state: this.state.resetPage().toggleTagRefinement(e),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.nextPage = function() {
                var e = this.state.page || 0;
                return this.setPage(e + 1)
            }
            ,
            y.prototype.previousPage = function() {
                var e = this.state.page || 0;
                return this.setPage(e - 1)
            }
            ,
            y.prototype.setCurrentPage = v,
            y.prototype.setPage = v,
            y.prototype.setIndex = function(e) {
                return this._change({
                    state: this.state.resetPage().setIndex(e),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.setQueryParameter = function(e, t) {
                return this._change({
                    state: this.state.resetPage().setQueryParameter(e, t),
                    isPageReset: !0
                }),
                this
            }
            ,
            y.prototype.setState = function(e) {
                return this._change({
                    state: h.make(e),
                    isPageReset: !1
                }),
                this
            }
            ,
            y.prototype.overrideStateWithoutTriggeringChangeEvent = function(e) {
                return this.state = new h(e),
                this
            }
            ,
            y.prototype.hasRefinements = function(e) {
                return !!c(this.state.getNumericRefinements(e)) || (this.state.isConjunctiveFacet(e) ? this.state.isFacetRefined(e) : this.state.isDisjunctiveFacet(e) ? this.state.isDisjunctiveFacetRefined(e) : !!this.state.isHierarchicalFacet(e) && this.state.isHierarchicalFacetRefined(e))
            }
            ,
            y.prototype.isExcluded = function(e, t) {
                return this.state.isExcludeRefined(e, t)
            }
            ,
            y.prototype.isDisjunctiveRefined = function(e, t) {
                return this.state.isDisjunctiveFacetRefined(e, t)
            }
            ,
            y.prototype.hasTag = function(e) {
                return this.state.isTagRefined(e)
            }
            ,
            y.prototype.isTagRefined = function() {
                return this.hasTagRefinements.apply(this, arguments)
            }
            ,
            y.prototype.getIndex = function() {
                return this.state.index
            }
            ,
            y.prototype.getCurrentPage = b,
            y.prototype.getPage = b,
            y.prototype.getTags = function() {
                return this.state.tagRefinements
            }
            ,
            y.prototype.getRefinements = function(e) {
                var t = [];
                if (this.state.isConjunctiveFacet(e))
                    this.state.getConjunctiveRefinements(e).forEach((function(e) {
                        t.push({
                            value: e,
                            type: "conjunctive"
                        })
                    }
                    )),
                    this.state.getExcludeRefinements(e).forEach((function(e) {
                        t.push({
                            value: e,
                            type: "exclude"
                        })
                    }
                    ));
                else if (this.state.isDisjunctiveFacet(e)) {
                    this.state.getDisjunctiveRefinements(e).forEach((function(e) {
                        t.push({
                            value: e,
                            type: "disjunctive"
                        })
                    }
                    ))
                }
                var r = this.state.getNumericRefinements(e);
                return Object.keys(r).forEach((function(e) {
                    var n = r[e];
                    t.push({
                        value: n,
                        operator: e,
                        type: "numeric"
                    })
                }
                )),
                t
            }
            ,
            y.prototype.getNumericRefinement = function(e, t) {
                return this.state.getNumericRefinement(e, t)
            }
            ,
            y.prototype.getHierarchicalFacetBreadcrumb = function(e) {
                return this.state.getHierarchicalFacetBreadcrumb(e)
            }
            ,
            y.prototype._search = function(e) {
                var t = this.state
                  , r = []
                  , n = [];
                e.onlyWithDerivedHelpers || (n = p._getQueries(t.index, t),
                r.push({
                    state: t,
                    queriesCount: n.length,
                    helper: this
                }),
                this.emit("search", {
                    state: t,
                    results: this.lastResults
                }));
                var i = this.derivedHelpers.map((function(e) {
                    var n = e.getModifiedState(t)
                      , i = n.index ? p._getQueries(n.index, n) : [];
                    return r.push({
                        state: n,
                        queriesCount: i.length,
                        helper: e
                    }),
                    e.emit("search", {
                        state: n,
                        results: e.lastResults
                    }),
                    i
                }
                ))
                  , o = Array.prototype.concat.apply(n, i)
                  , a = this._queryId++;
                if (this._currentNbQueries++,
                !o.length)
                    return Promise.resolve({
                        results: []
                    }).then(this._dispatchAlgoliaResponse.bind(this, r, a));
                try {
                    this.client.search(o).then(this._dispatchAlgoliaResponse.bind(this, r, a)).catch(this._dispatchAlgoliaError.bind(this, a))
                } catch (e) {
                    this.emit("error", {
                        error: e
                    })
                }
            }
            ,
            y.prototype._recommend = function() {
                var e = this.state
                  , t = this.recommendState
                  , r = this.getIndex()
                  , n = [{
                    state: t,
                    index: r,
                    helper: this
                }]
                  , i = t.params.map((function(e) {
                    return e.$$id
                }
                ));
                this.emit("fetch", {
                    recommend: {
                        state: t,
                        results: this.lastRecommendResults
                    }
                });
                var o = this._recommendCache
                  , a = this.derivedHelpers.map((function(t) {
                    var r = t.getModifiedState(e).index;
                    if (!r)
                        return [];
                    var a = t.getModifiedRecommendState(new l);
                    return n.push({
                        state: a,
                        index: r,
                        helper: t
                    }),
                    i = Array.prototype.concat.apply(i, a.params.map((function(e) {
                        return e.$$id
                    }
                    ))),
                    t.emit("fetch", {
                        recommend: {
                            state: a,
                            results: t.lastRecommendResults
                        }
                    }),
                    a._buildQueries(r, o)
                }
                ))
                  , s = Array.prototype.concat.apply(this.recommendState._buildQueries(r, o), a);
                if (0 !== s.length)
                    if (s.length > 0 && void 0 === this.client.getRecommendations)
                        console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
                    else {
                        var c = this._recommendQueryId++;
                        this._currentNbRecommendQueries++;
                        try {
                            this.client.getRecommendations(s).then(this._dispatchRecommendResponse.bind(this, c, n, i)).catch(this._dispatchRecommendError.bind(this, c))
                        } catch (e) {
                            this.emit("error", {
                                error: e
                            })
                        }
                    }
            }
            ,
            y.prototype._dispatchAlgoliaResponse = function(e, t, r) {
                var n = this;
                if (!(t < this._lastQueryIdReceived)) {
                    this._currentNbQueries -= t - this._lastQueryIdReceived,
                    this._lastQueryIdReceived = t,
                    0 === this._currentNbQueries && this.emit("searchQueueEmpty");
                    var i = r.results.slice();
                    e.forEach((function(e) {
                        var t = e.state
                          , r = e.queriesCount
                          , o = e.helper
                          , a = i.splice(0, r);
                        t.index ? (o.lastResults = new d(t,a,n._searchResultsOptions),
                        o.emit("result", {
                            results: o.lastResults,
                            state: t
                        })) : o.emit("result", {
                            results: null,
                            state: t
                        })
                    }
                    ))
                }
            }
            ,
            y.prototype._dispatchRecommendResponse = function(e, t, r, n) {
                if (!(e < this._lastRecommendQueryIdReceived)) {
                    this._currentNbRecommendQueries -= e - this._lastRecommendQueryIdReceived,
                    this._lastRecommendQueryIdReceived = e,
                    0 === this._currentNbRecommendQueries && this.emit("recommendQueueEmpty");
                    var i = this._recommendCache
                      , o = {};
                    r.filter((function(e) {
                        return void 0 === i[e]
                    }
                    )).forEach((function(e, t) {
                        o[e] || (o[e] = []),
                        o[e].push(t)
                    }
                    )),
                    Object.keys(o).forEach((function(e) {
                        var t = o[e]
                          , r = n.results[t[0]];
                        1 !== t.length ? i[e] = Object.assign({}, r, {
                            hits: m(t.map((function(e) {
                                return n.results[e].hits
                            }
                            )))
                        }) : i[e] = r
                    }
                    ));
                    var a = {};
                    r.forEach((function(e) {
                        a[e] = i[e]
                    }
                    )),
                    t.forEach((function(e) {
                        var t = e.state
                          , r = e.helper;
                        e.index ? (r.lastRecommendResults = new f(t,a),
                        r.emit("recommend:result", {
                            recommend: {
                                results: r.lastRecommendResults,
                                state: t
                            }
                        })) : r.emit("recommend:result", {
                            results: null,
                            state: t
                        })
                    }
                    ))
                }
            }
            ,
            y.prototype._dispatchAlgoliaError = function(e, t) {
                e < this._lastQueryIdReceived || (this._currentNbQueries -= e - this._lastQueryIdReceived,
                this._lastQueryIdReceived = e,
                this.emit("error", {
                    error: t
                }),
                0 === this._currentNbQueries && this.emit("searchQueueEmpty"))
            }
            ,
            y.prototype._dispatchRecommendError = function(e, t) {
                e < this._lastRecommendQueryIdReceived || (this._currentNbRecommendQueries -= e - this._lastRecommendQueryIdReceived,
                this._lastRecommendQueryIdReceived = e,
                this.emit("error", {
                    error: t
                }),
                0 === this._currentNbRecommendQueries && this.emit("recommendQueueEmpty"))
            }
            ,
            y.prototype.containsRefinement = function(e, t, r, n) {
                return e || 0 !== t.length || 0 !== r.length || 0 !== n.length
            }
            ,
            y.prototype._hasDisjunctiveRefinements = function(e) {
                return this.state.disjunctiveRefinements[e] && this.state.disjunctiveRefinements[e].length > 0
            }
            ,
            y.prototype._change = function(e) {
                var t = e.state
                  , r = e.isPageReset;
                t !== this.state && (this.state = t,
                this.emit("change", {
                    state: this.state,
                    results: this.lastResults,
                    isPageReset: r
                }))
            }
            ,
            y.prototype._recommendChange = function(e) {
                var t = e.state;
                t !== this.recommendState && (this.recommendState = t,
                this.emit("recommend:change", {
                    search: {
                        results: this.lastResults,
                        state: this.state
                    },
                    recommend: {
                        results: this.lastRecommendResults,
                        state: this.recommendState
                    }
                }))
            }
            ,
            y.prototype.clearCache = function() {
                return this.client.clearCache && this.client.clearCache(),
                this
            }
            ,
            y.prototype.setClient = function(e) {
                return this.client === e || ("function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + g + ")"),
                this.client = e),
                this
            }
            ,
            y.prototype.getClient = function() {
                return this.client
            }
            ,
            y.prototype.derive = function(e, t) {
                var r = new i(this,e,t);
                return this.derivedHelpers.push(r),
                r
            }
            ,
            y.prototype.detachDerivedHelper = function(e) {
                var t = this.derivedHelpers.indexOf(e);
                if (-1 === t)
                    throw new Error("Derived helper already detached");
                this.derivedHelpers.splice(t, 1)
            }
            ,
            y.prototype.hasPendingRequests = function() {
                return this._currentNbQueries > 0
            }
            ,
            e.exports = y
        }
        ,
        587: e => {
            "use strict";
            e.exports = function(e) {
                return Array.isArray(e) ? e.filter(Boolean) : []
            }
        }
        ,
        344: e => {
            "use strict";
            e.exports = function() {
                return Array.prototype.slice.call(arguments).reduceRight((function(e, t) {
                    return Object.keys(Object(t)).forEach((function(r) {
                        void 0 !== t[r] && (void 0 !== e[r] && delete e[r],
                        e[r] = t[r])
                    }
                    )),
                    e
                }
                ), {})
            }
        }
        ,
        39: e => {
            "use strict";
            e.exports = {
                escapeFacetValue: function(e) {
                    return "string" != typeof e ? e : String(e).replace(/^-/, "\\-")
                },
                unescapeFacetValue: function(e) {
                    return "string" != typeof e ? e : e.replace(/^\\-/, "-")
                }
            }
        }
        ,
        888: e => {
            "use strict";
            e.exports = function(e, t) {
                if (Array.isArray(e))
                    for (var r = 0; r < e.length; r++)
                        if (t(e[r]))
                            return e[r]
            }
        }
        ,
        725: e => {
            "use strict";
            e.exports = function(e, t) {
                if (!Array.isArray(e))
                    return -1;
                for (var r = 0; r < e.length; r++)
                    if (t(e[r]))
                        return r;
                return -1
            }
        }
        ,
        948: e => {
            e.exports = function(e) {
                return e.reduce((function(e, t) {
                    return e.concat(t)
                }
                ), [])
            }
        }
        ,
        293: (e, t, r) => {
            "use strict";
            var n = r(888);
            e.exports = function(e, t) {
                var r = (t || []).map((function(e) {
                    return e.split(":")
                }
                ));
                return e.reduce((function(e, t) {
                    var i = t.split(":")
                      , o = n(r, (function(e) {
                        return e[0] === i[0]
                    }
                    ));
                    return i.length > 1 || !o ? (e[0].push(i[0]),
                    e[1].push(i[1]),
                    e) : (e[0].push(o[0]),
                    e[1].push(o[1]),
                    e)
                }
                ), [[], []])
            }
        }
        ,
        853: e => {
            "use strict";
            e.exports = function(e, t) {
                e.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                })
            }
        }
        ,
        686: e => {
            "use strict";
            e.exports = function(e, t) {
                return e.filter((function(r, n) {
                    return t.indexOf(r) > -1 && e.indexOf(r) === n
                }
                ))
            }
        }
        ,
        185: e => {
            "use strict";
            function t(e) {
                return "function" == typeof e || Array.isArray(e) || "[object Object]" === Object.prototype.toString.call(e)
            }
            function r(e, n) {
                if (e === n)
                    return e;
                for (var i in n)
                    if (Object.prototype.hasOwnProperty.call(n, i) && "__proto__" !== i && "constructor" !== i) {
                        var o = n[i]
                          , a = e[i];
                        void 0 !== a && void 0 === o || (t(a) && t(o) ? e[i] = r(a, o) : e[i] = "object" == typeof (s = o) && null !== s ? r(Array.isArray(s) ? [] : {}, s) : s)
                    }
                var s;
                return e
            }
            e.exports = function(e) {
                t(e) || (e = {});
                for (var n = 1, i = arguments.length; n < i; n++) {
                    var o = arguments[n];
                    t(o) && r(e, o)
                }
                return e
            }
        }
        ,
        116: e => {
            "use strict";
            e.exports = function(e) {
                return e && Object.keys(e).length > 0
            }
        }
        ,
        803: e => {
            "use strict";
            e.exports = function(e, t) {
                if (null === e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }
        }
        ,
        148: e => {
            "use strict";
            function t(e, t) {
                if (e !== t) {
                    var r = void 0 !== e
                      , n = null === e
                      , i = void 0 !== t
                      , o = null === t;
                    if (!o && e > t || n && i || !r)
                        return 1;
                    if (!n && e < t || o && r || !i)
                        return -1
                }
                return 0
            }
            e.exports = function(e, r, n) {
                if (!Array.isArray(e))
                    return [];
                Array.isArray(n) || (n = []);
                var i = e.map((function(e, t) {
                    return {
                        criteria: r.map((function(t) {
                            return e[t]
                        }
                        )),
                        index: t,
                        value: e
                    }
                }
                ));
                return i.sort((function(e, r) {
                    for (var i = -1; ++i < e.criteria.length; ) {
                        var o = t(e.criteria[i], r.criteria[i]);
                        if (o)
                            return i >= n.length ? o : "desc" === n[i] ? -o : o
                    }
                    return e.index - r.index
                }
                )),
                i.map((function(e) {
                    return e.value
                }
                ))
            }
        }
        ,
        23: e => {
            "use strict";
            e.exports = function e(t) {
                if ("number" == typeof t)
                    return t;
                if ("string" == typeof t)
                    return parseFloat(t);
                if (Array.isArray(t))
                    return t.map(e);
                throw new Error("The value should be a number, a parsable string or an array of those.")
            }
        }
        ,
        394: (e, t, r) => {
            "use strict";
            var n = r(185);
            function i(e) {
                return Object.keys(e).sort().reduce((function(t, r) {
                    return t[r] = e[r],
                    t
                }
                ), {})
            }
            var o = {
                _getQueries: function(e, t) {
                    var r = [];
                    return r.push({
                        indexName: e,
                        params: o._getHitsSearchParams(t)
                    }),
                    t.getRefinedDisjunctiveFacets().forEach((function(n) {
                        r.push({
                            indexName: e,
                            params: o._getDisjunctiveFacetSearchParams(t, n)
                        })
                    }
                    )),
                    t.getRefinedHierarchicalFacets().forEach((function(n) {
                        var i = t.getHierarchicalFacetByName(n)
                          , a = t.getHierarchicalRefinement(n)
                          , s = t._getHierarchicalFacetSeparator(i);
                        if (a.length > 0 && a[0].split(s).length > 1) {
                            var c = a[0].split(s).slice(0, -1).reduce((function(e, t, r) {
                                return e.concat({
                                    attribute: i.attributes[r],
                                    value: 0 === r ? t : [e[e.length - 1].value, t].join(s)
                                })
                            }
                            ), []);
                            c.forEach((function(n, a) {
                                var s = o._getDisjunctiveFacetSearchParams(t, n.attribute, 0 === a);
                                function u(e) {
                                    return i.attributes.some((function(t) {
                                        return t === e.split(":")[0]
                                    }
                                    ))
                                }
                                var l = (s.facetFilters || []).reduce((function(e, t) {
                                    if (Array.isArray(t)) {
                                        var r = t.filter((function(e) {
                                            return !u(e)
                                        }
                                        ));
                                        r.length > 0 && e.push(r)
                                    }
                                    return "string" != typeof t || u(t) || e.push(t),
                                    e
                                }
                                ), [])
                                  , f = c[a - 1];
                                s.facetFilters = a > 0 ? l.concat(f.attribute + ":" + f.value) : l.length > 0 ? l : void 0,
                                r.push({
                                    indexName: e,
                                    params: s
                                })
                            }
                            ))
                        }
                    }
                    )),
                    r
                },
                _getHitsSearchParams: function(e) {
                    var t = e.facets.concat(e.disjunctiveFacets).concat(o._getHitsHierarchicalFacetsAttributes(e)).sort()
                      , r = o._getFacetFilters(e)
                      , a = o._getNumericFilters(e)
                      , s = o._getTagFilters(e)
                      , c = {
                        facets: t.indexOf("*") > -1 ? ["*"] : t,
                        tagFilters: s
                    };
                    return r.length > 0 && (c.facetFilters = r),
                    a.length > 0 && (c.numericFilters = a),
                    i(n({}, e.getQueryParams(), c))
                },
                _getDisjunctiveFacetSearchParams: function(e, t, r) {
                    var a = o._getFacetFilters(e, t, r)
                      , s = o._getNumericFilters(e, t)
                      , c = o._getTagFilters(e)
                      , u = {
                        hitsPerPage: 0,
                        page: 0,
                        analytics: !1,
                        clickAnalytics: !1
                    };
                    c.length > 0 && (u.tagFilters = c);
                    var l = e.getHierarchicalFacetByName(t);
                    return u.facets = l ? o._getDisjunctiveHierarchicalFacetAttribute(e, l, r) : t,
                    s.length > 0 && (u.numericFilters = s),
                    a.length > 0 && (u.facetFilters = a),
                    i(n({}, e.getQueryParams(), u))
                },
                _getNumericFilters: function(e, t) {
                    if (e.numericFilters)
                        return e.numericFilters;
                    var r = [];
                    return Object.keys(e.numericRefinements).forEach((function(n) {
                        var i = e.numericRefinements[n] || {};
                        Object.keys(i).forEach((function(e) {
                            var o = i[e] || [];
                            t !== n && o.forEach((function(t) {
                                if (Array.isArray(t)) {
                                    var i = t.map((function(t) {
                                        return n + e + t
                                    }
                                    ));
                                    r.push(i)
                                } else
                                    r.push(n + e + t)
                            }
                            ))
                        }
                        ))
                    }
                    )),
                    r
                },
                _getTagFilters: function(e) {
                    return e.tagFilters ? e.tagFilters : e.tagRefinements.join(",")
                },
                _getFacetFilters: function(e, t, r) {
                    var n = []
                      , i = e.facetsRefinements || {};
                    Object.keys(i).sort().forEach((function(e) {
                        (i[e] || []).slice().sort().forEach((function(t) {
                            n.push(e + ":" + t)
                        }
                        ))
                    }
                    ));
                    var o = e.facetsExcludes || {};
                    Object.keys(o).sort().forEach((function(e) {
                        (o[e] || []).sort().forEach((function(t) {
                            n.push(e + ":-" + t)
                        }
                        ))
                    }
                    ));
                    var a = e.disjunctiveFacetsRefinements || {};
                    Object.keys(a).sort().forEach((function(e) {
                        var r = a[e] || [];
                        if (e !== t && r && 0 !== r.length) {
                            var i = [];
                            r.slice().sort().forEach((function(t) {
                                i.push(e + ":" + t)
                            }
                            )),
                            n.push(i)
                        }
                    }
                    ));
                    var s = e.hierarchicalFacetsRefinements || {};
                    return Object.keys(s).sort().forEach((function(i) {
                        var o = (s[i] || [])[0];
                        if (void 0 !== o) {
                            var a, c, u = e.getHierarchicalFacetByName(i), l = e._getHierarchicalFacetSeparator(u), f = e._getHierarchicalRootPath(u);
                            if (t === i) {
                                if (-1 === o.indexOf(l) || !f && !0 === r || f && f.split(l).length === o.split(l).length)
                                    return;
                                f ? (c = f.split(l).length - 1,
                                o = f) : (c = o.split(l).length - 2,
                                o = o.slice(0, o.lastIndexOf(l))),
                                a = u.attributes[c]
                            } else
                                c = o.split(l).length - 1,
                                a = u.attributes[c];
                            a && n.push([a + ":" + o])
                        }
                    }
                    )),
                    n
                },
                _getHitsHierarchicalFacetsAttributes: function(e) {
                    return e.hierarchicalFacets.reduce((function(t, r) {
                        var n = e.getHierarchicalRefinement(r.name)[0];
                        if (!n)
                            return t.push(r.attributes[0]),
                            t;
                        var i = e._getHierarchicalFacetSeparator(r)
                          , o = n.split(i).length
                          , a = r.attributes.slice(0, o + 1);
                        return t.concat(a)
                    }
                    ), [])
                },
                _getDisjunctiveHierarchicalFacetAttribute: function(e, t, r) {
                    var n = e._getHierarchicalFacetSeparator(t);
                    if (!0 === r) {
                        var i = e._getHierarchicalRootPath(t)
                          , o = 0;
                        return i && (o = i.split(n).length),
                        [t.attributes[o]]
                    }
                    var a = (e.getHierarchicalRefinement(t.name)[0] || "").split(n).length - 1;
                    return t.attributes.slice(0, a + 1)
                },
                getSearchForFacetQuery: function(e, t, r, a) {
                    var s = a.isDisjunctiveFacet(e) ? a.clearRefinements(e) : a
                      , c = {
                        facetQuery: t,
                        facetName: e
                    };
                    return "number" == typeof r && (c.maxFacetHits = r),
                    i(n({}, o._getHitsSearchParams(s), c))
                }
            };
            e.exports = o
        }
        ,
        801: e => {
            "use strict";
            e.exports = function(e) {
                return null !== e && /^[a-zA-Z0-9_-]{1,64}$/.test(e)
            }
        }
        ,
        878: (e, t, r) => {
            "use strict";
            var n = r(888)
              , i = r(948);
            e.exports = function(e) {
                var t = {};
                return e.forEach((function(e) {
                    e.forEach((function(e, r) {
                        t[e.objectID] ? t[e.objectID] = {
                            indexSum: t[e.objectID].indexSum + r,
                            count: t[e.objectID].count + 1
                        } : t[e.objectID] = {
                            indexSum: r,
                            count: 1
                        }
                    }
                    ))
                }
                )),
                function(e, t) {
                    var r = [];
                    return Object.keys(e).forEach((function(n) {
                        e[n].count < 2 && (e[n].indexSum += 100),
                        r.push({
                            objectID: n,
                            avgOfIndices: e[n].indexSum / t
                        })
                    }
                    )),
                    r.sort((function(e, t) {
                        return e.avgOfIndices > t.avgOfIndices ? 1 : -1
                    }
                    ))
                }(t, e.length).reduce((function(t, r) {
                    var o = n(i(e), (function(e) {
                        return e.objectID === r.objectID
                    }
                    ));
                    return o ? t.concat(o) : t
                }
                ), [])
            }
        }
        ,
        336: e => {
            "use strict";
            e.exports = "3.21.0"
        }
        ,
        290: function(e) {
            e.exports = function() {
                "use strict";
                function e(e, t, r) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r,
                    e
                }
                function t(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable
                        }
                        ))),
                        r.push.apply(r, n)
                    }
                    return r
                }
                function r(r) {
                    for (var n = 1; n < arguments.length; n++) {
                        var i = null != arguments[n] ? arguments[n] : {};
                        n % 2 ? t(Object(i), !0).forEach((function(t) {
                            e(r, t, i[t])
                        }
                        )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach((function(e) {
                            Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e))
                        }
                        ))
                    }
                    return r
                }
                function n(e, t) {
                    if (null == e)
                        return {};
                    var r, n, i = function(e, t) {
                        if (null == e)
                            return {};
                        var r, n, i = {}, o = Object.keys(e);
                        for (n = 0; n < o.length; n++)
                            r = o[n],
                            t.indexOf(r) >= 0 || (i[r] = e[r]);
                        return i
                    }(e, t);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        for (n = 0; n < o.length; n++)
                            r = o[n],
                            t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
                    }
                    return i
                }
                function i(e, t) {
                    return function(e) {
                        if (Array.isArray(e))
                            return e
                    }(e) || function(e, t) {
                        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
                            var r = []
                              , n = !0
                              , i = !1
                              , o = void 0;
                            try {
                                for (var a, s = e[Symbol.iterator](); !(n = (a = s.next()).done) && (r.push(a.value),
                                !t || r.length !== t); n = !0)
                                    ;
                            } catch (e) {
                                i = !0,
                                o = e
                            } finally {
                                try {
                                    n || null == s.return || s.return()
                                } finally {
                                    if (i)
                                        throw o
                                }
                            }
                            return r
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance")
                    }()
                }
                function o(e) {
                    return function(e) {
                        if (Array.isArray(e)) {
                            for (var t = 0, r = new Array(e.length); t < e.length; t++)
                                r[t] = e[t];
                            return r
                        }
                    }(e) || function(e) {
                        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
                            return Array.from(e)
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance")
                    }()
                }
                function a(e) {
                    var t, r = "algoliasearch-client-js-".concat(e.key), n = function() {
                        return void 0 === t && (t = e.localStorage || window.localStorage),
                        t
                    }, o = function() {
                        return JSON.parse(n().getItem(r) || "{}")
                    }, a = function(e) {
                        n().setItem(r, JSON.stringify(e))
                    }, s = function() {
                        var t = e.timeToLive ? 1e3 * e.timeToLive : null
                          , r = o()
                          , n = Object.fromEntries(Object.entries(r).filter((function(e) {
                            return void 0 !== i(e, 2)[1].timestamp
                        }
                        )));
                        if (a(n),
                        t) {
                            var s = Object.fromEntries(Object.entries(n).filter((function(e) {
                                var r = i(e, 2)[1]
                                  , n = (new Date).getTime();
                                return !(r.timestamp + t < n)
                            }
                            )));
                            a(s)
                        }
                    };
                    return {
                        get: function(e, t) {
                            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                                miss: function() {
                                    return Promise.resolve()
                                }
                            };
                            return Promise.resolve().then((function() {
                                s();
                                var t = JSON.stringify(e);
                                return o()[t]
                            }
                            )).then((function(e) {
                                return Promise.all([e ? e.value : t(), void 0 !== e])
                            }
                            )).then((function(e) {
                                var t = i(e, 2)
                                  , n = t[0]
                                  , o = t[1];
                                return Promise.all([n, o || r.miss(n)])
                            }
                            )).then((function(e) {
                                return i(e, 1)[0]
                            }
                            ))
                        },
                        set: function(e, t) {
                            return Promise.resolve().then((function() {
                                var i = o();
                                return i[JSON.stringify(e)] = {
                                    timestamp: (new Date).getTime(),
                                    value: t
                                },
                                n().setItem(r, JSON.stringify(i)),
                                t
                            }
                            ))
                        },
                        delete: function(e) {
                            return Promise.resolve().then((function() {
                                var t = o();
                                delete t[JSON.stringify(e)],
                                n().setItem(r, JSON.stringify(t))
                            }
                            ))
                        },
                        clear: function() {
                            return Promise.resolve().then((function() {
                                n().removeItem(r)
                            }
                            ))
                        }
                    }
                }
                function s(e) {
                    var t = o(e.caches)
                      , r = t.shift();
                    return void 0 === r ? {
                        get: function(e, t) {
                            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                                miss: function() {
                                    return Promise.resolve()
                                }
                            };
                            return t().then((function(e) {
                                return Promise.all([e, r.miss(e)])
                            }
                            )).then((function(e) {
                                return i(e, 1)[0]
                            }
                            ))
                        },
                        set: function(e, t) {
                            return Promise.resolve(t)
                        },
                        delete: function(e) {
                            return Promise.resolve()
                        },
                        clear: function() {
                            return Promise.resolve()
                        }
                    } : {
                        get: function(e, n) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                                miss: function() {
                                    return Promise.resolve()
                                }
                            };
                            return r.get(e, n, i).catch((function() {
                                return s({
                                    caches: t
                                }).get(e, n, i)
                            }
                            ))
                        },
                        set: function(e, n) {
                            return r.set(e, n).catch((function() {
                                return s({
                                    caches: t
                                }).set(e, n)
                            }
                            ))
                        },
                        delete: function(e) {
                            return r.delete(e).catch((function() {
                                return s({
                                    caches: t
                                }).delete(e)
                            }
                            ))
                        },
                        clear: function() {
                            return r.clear().catch((function() {
                                return s({
                                    caches: t
                                }).clear()
                            }
                            ))
                        }
                    }
                }
                function c() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                        serializable: !0
                    }
                      , t = {};
                    return {
                        get: function(r, n) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                                miss: function() {
                                    return Promise.resolve()
                                }
                            }
                              , o = JSON.stringify(r);
                            if (o in t)
                                return Promise.resolve(e.serializable ? JSON.parse(t[o]) : t[o]);
                            var a = n()
                              , s = i && i.miss || function() {
                                return Promise.resolve()
                            }
                            ;
                            return a.then((function(e) {
                                return s(e)
                            }
                            )).then((function() {
                                return a
                            }
                            ))
                        },
                        set: function(r, n) {
                            return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n,
                            Promise.resolve(n)
                        },
                        delete: function(e) {
                            return delete t[JSON.stringify(e)],
                            Promise.resolve()
                        },
                        clear: function() {
                            return t = {},
                            Promise.resolve()
                        }
                    }
                }
                function u(e) {
                    for (var t = e.length - 1; t > 0; t--) {
                        var r = Math.floor(Math.random() * (t + 1))
                          , n = e[t];
                        e[t] = e[r],
                        e[r] = n
                    }
                    return e
                }
                function l(e, t) {
                    return t ? (Object.keys(t).forEach((function(r) {
                        e[r] = t[r](e)
                    }
                    )),
                    e) : e
                }
                function f(e) {
                    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
                        r[n - 1] = arguments[n];
                    var i = 0;
                    return e.replace(/%s/g, (function() {
                        return encodeURIComponent(r[i++])
                    }
                    ))
                }
                var p = {
                    WithinQueryParameters: 0,
                    WithinHeaders: 1
                };
                function h(e, t) {
                    var r = e || {}
                      , n = r.data || {};
                    return Object.keys(r).forEach((function(e) {
                        -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(e) && (n[e] = r[e])
                    }
                    )),
                    {
                        data: Object.entries(n).length > 0 ? n : void 0,
                        timeout: r.timeout || t,
                        headers: r.headers || {},
                        queryParameters: r.queryParameters || {},
                        cacheable: r.cacheable
                    }
                }
                var d = {
                    Read: 1,
                    Write: 2,
                    Any: 3
                }
                  , m = 1
                  , g = 2
                  , y = 3;
                function v(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : m;
                    return r(r({}, e), {}, {
                        status: t,
                        lastUpdate: Date.now()
                    })
                }
                function b(e) {
                    return "string" == typeof e ? {
                        protocol: "https",
                        url: e,
                        accept: d.Any
                    } : {
                        protocol: e.protocol || "https",
                        url: e.url,
                        accept: e.accept || d.Any
                    }
                }
                var S = "GET"
                  , O = "POST";
                function w(e, t) {
                    return Promise.all(t.map((function(t) {
                        return e.get(t, (function() {
                            return Promise.resolve(v(t))
                        }
                        ))
                    }
                    ))).then((function(e) {
                        var r = e.filter((function(e) {
                            return function(e) {
                                return e.status === m || Date.now() - e.lastUpdate > 12e4
                            }(e)
                        }
                        ))
                          , n = e.filter((function(e) {
                            return function(e) {
                                return e.status === y && Date.now() - e.lastUpdate <= 12e4
                            }(e)
                        }
                        ))
                          , i = [].concat(o(r), o(n));
                        return {
                            getTimeout: function(e, t) {
                                return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t
                            },
                            statelessHosts: i.length > 0 ? i.map((function(e) {
                                return b(e)
                            }
                            )) : t
                        }
                    }
                    ))
                }
                function _(e, t, n, i) {
                    var a = []
                      , s = function(e, t) {
                        if (e.method !== S && (void 0 !== e.data || void 0 !== t.data)) {
                            var n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
                            return JSON.stringify(n)
                        }
                    }(n, i)
                      , c = function(e, t) {
                        var n = r(r({}, e.headers), t.headers)
                          , i = {};
                        return Object.keys(n).forEach((function(e) {
                            var t = n[e];
                            i[e.toLowerCase()] = t
                        }
                        )),
                        i
                    }(e, i)
                      , u = n.method
                      , l = n.method !== S ? {} : r(r({}, n.data), i.data)
                      , f = r(r(r({
                        "x-algolia-agent": e.userAgent.value
                    }, e.queryParameters), l), i.queryParameters)
                      , p = 0
                      , h = function t(r, o) {
                        var l = r.pop();
                        if (void 0 === l)
                            throw {
                                name: "RetryError",
                                message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
                                transporterStackTrace: x(a)
                            };
                        var h = {
                            data: s,
                            headers: c,
                            method: u,
                            url: P(l, n.path, f),
                            connectTimeout: o(p, e.timeouts.connect),
                            responseTimeout: o(p, i.timeout)
                        }
                          , d = function(e) {
                            var t = {
                                request: h,
                                response: e,
                                host: l,
                                triesLeft: r.length
                            };
                            return a.push(t),
                            t
                        }
                          , m = {
                            onSuccess: function(e) {
                                return function(e) {
                                    try {
                                        return JSON.parse(e.content)
                                    } catch (t) {
                                        throw function(e, t) {
                                            return {
                                                name: "DeserializationError",
                                                message: e,
                                                response: t
                                            }
                                        }(t.message, e)
                                    }
                                }(e)
                            },
                            onRetry: function(n) {
                                var i = d(n);
                                return n.isTimedOut && p++,
                                Promise.all([e.logger.info("Retryable failure", E(i)), e.hostsCache.set(l, v(l, n.isTimedOut ? y : g))]).then((function() {
                                    return t(r, o)
                                }
                                ))
                            },
                            onFail: function(e) {
                                throw d(e),
                                function(e, t) {
                                    var r = e.content
                                      , n = e.status
                                      , i = r;
                                    try {
                                        i = JSON.parse(r).message
                                    } catch (e) {}
                                    return function(e, t, r) {
                                        return {
                                            name: "ApiError",
                                            message: e,
                                            status: t,
                                            transporterStackTrace: r
                                        }
                                    }(i, n, t)
                                }(e, x(a))
                            }
                        };
                        return e.requester.send(h).then((function(e) {
                            return function(e, t) {
                                return function(e) {
                                    var t = e.status;
                                    return e.isTimedOut || function(e) {
                                        var t = e.isTimedOut
                                          , r = e.status;
                                        return !t && 0 == ~~r
                                    }(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100)
                                }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e)
                            }(e, m)
                        }
                        ))
                    };
                    return w(e.hostsCache, t).then((function(e) {
                        return h(o(e.statelessHosts).reverse(), e.getTimeout)
                    }
                    ))
                }
                function j(e) {
                    var t = {
                        value: "Algolia for JavaScript (".concat(e, ")"),
                        add: function(e) {
                            var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
                            return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)),
                            t
                        }
                    };
                    return t
                }
                function P(e, t, r) {
                    var n = R(r)
                      , i = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
                    return n.length && (i += "?".concat(n)),
                    i
                }
                function R(e) {
                    return Object.keys(e).map((function(t) {
                        return f("%s=%s", t, (r = e[t],
                        "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
                        var r
                    }
                    )).join("&")
                }
                function x(e) {
                    return e.map((function(e) {
                        return E(e)
                    }
                    ))
                }
                function E(e) {
                    var t = e.request.headers["x-algolia-api-key"] ? {
                        "x-algolia-api-key": "*****"
                    } : {};
                    return r(r({}, e), {}, {
                        request: r(r({}, e.request), {}, {
                            headers: r(r({}, e.request.headers), t)
                        })
                    })
                }
                var k = function(e) {
                    var t = e.appId
                      , n = function(e, t, r) {
                        var n = {
                            "x-algolia-api-key": r,
                            "x-algolia-application-id": t
                        };
                        return {
                            headers: function() {
                                return e === p.WithinHeaders ? n : {}
                            },
                            queryParameters: function() {
                                return e === p.WithinQueryParameters ? n : {}
                            }
                        }
                    }(void 0 !== e.authMode ? e.authMode : p.WithinHeaders, t, e.apiKey)
                      , o = function(e) {
                        var t = e.hostsCache
                          , r = e.logger
                          , n = e.requester
                          , o = e.requestsCache
                          , a = e.responsesCache
                          , s = e.timeouts
                          , c = e.userAgent
                          , u = e.hosts
                          , l = e.queryParameters
                          , f = {
                            hostsCache: t,
                            logger: r,
                            requester: n,
                            requestsCache: o,
                            responsesCache: a,
                            timeouts: s,
                            userAgent: c,
                            headers: e.headers,
                            queryParameters: l,
                            hosts: u.map((function(e) {
                                return b(e)
                            }
                            )),
                            read: function(e, t) {
                                var r = h(t, f.timeouts.read)
                                  , n = function() {
                                    return _(f, f.hosts.filter((function(e) {
                                        return 0 != (e.accept & d.Read)
                                    }
                                    )), e, r)
                                };
                                if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable))
                                    return n();
                                var o = {
                                    request: e,
                                    mappedRequestOptions: r,
                                    transporter: {
                                        queryParameters: f.queryParameters,
                                        headers: f.headers
                                    }
                                };
                                return f.responsesCache.get(o, (function() {
                                    return f.requestsCache.get(o, (function() {
                                        return f.requestsCache.set(o, n()).then((function(e) {
                                            return Promise.all([f.requestsCache.delete(o), e])
                                        }
                                        ), (function(e) {
                                            return Promise.all([f.requestsCache.delete(o), Promise.reject(e)])
                                        }
                                        )).then((function(e) {
                                            var t = i(e, 2);
                                            return t[0],
                                            t[1]
                                        }
                                        ))
                                    }
                                    ))
                                }
                                ), {
                                    miss: function(e) {
                                        return f.responsesCache.set(o, e)
                                    }
                                })
                            },
                            write: function(e, t) {
                                return _(f, f.hosts.filter((function(e) {
                                    return 0 != (e.accept & d.Write)
                                }
                                )), e, h(t, f.timeouts.write))
                            }
                        };
                        return f
                    }(r(r({
                        hosts: [{
                            url: "".concat(t, "-dsn.algolia.net"),
                            accept: d.Read
                        }, {
                            url: "".concat(t, ".algolia.net"),
                            accept: d.Write
                        }].concat(u([{
                            url: "".concat(t, "-1.algolianet.com")
                        }, {
                            url: "".concat(t, "-2.algolianet.com")
                        }, {
                            url: "".concat(t, "-3.algolianet.com")
                        }]))
                    }, e), {}, {
                        headers: r(r(r({}, n.headers()), {
                            "content-type": "application/x-www-form-urlencoded"
                        }), e.headers),
                        queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
                    }));
                    return l({
                        transporter: o,
                        appId: t,
                        addAlgoliaAgent: function(e, t) {
                            o.userAgent.add({
                                segment: e,
                                version: t
                            })
                        },
                        clearCache: function() {
                            return Promise.all([o.requestsCache.clear(), o.responsesCache.clear()]).then((function() {}
                            ))
                        }
                    }, e.methods)
                }
                  , I = function(e) {
                    return function(t, r) {
                        return t.method === S ? e.transporter.read(t, r) : e.transporter.write(t, r)
                    }
                }
                  , T = function(e) {
                    return function(t) {
                        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return l({
                            transporter: e.transporter,
                            appId: e.appId,
                            indexName: t
                        }, r.methods)
                    }
                }
                  , N = function(e) {
                    return function(t, n) {
                        var i = t.map((function(e) {
                            return r(r({}, e), {}, {
                                params: R(e.params || {})
                            })
                        }
                        ));
                        return e.transporter.read({
                            method: O,
                            path: "1/indexes/*/queries",
                            data: {
                                requests: i
                            },
                            cacheable: !0
                        }, n)
                    }
                }
                  , F = function(e) {
                    return function(t, i) {
                        return Promise.all(t.map((function(t) {
                            var o = t.params
                              , a = o.facetName
                              , s = o.facetQuery
                              , c = n(o, ["facetName", "facetQuery"]);
                            return T(e)(t.indexName, {
                                methods: {
                                    searchForFacetValues: D
                                }
                            }).searchForFacetValues(a, s, r(r({}, i), c))
                        }
                        )))
                    }
                }
                  , C = function(e) {
                    return function(t, r, n) {
                        return e.transporter.read({
                            method: O,
                            path: f("1/answers/%s/prediction", e.indexName),
                            data: {
                                query: t,
                                queryLanguages: r
                            },
                            cacheable: !0
                        }, n)
                    }
                }
                  , A = function(e) {
                    return function(t, r) {
                        return e.transporter.read({
                            method: O,
                            path: f("1/indexes/%s/query", e.indexName),
                            data: {
                                query: t
                            },
                            cacheable: !0
                        }, r)
                    }
                }
                  , D = function(e) {
                    return function(t, r, n) {
                        return e.transporter.read({
                            method: O,
                            path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
                            data: {
                                facetQuery: r
                            },
                            cacheable: !0
                        }, n)
                    }
                }
                  , H = 1
                  , $ = 2
                  , L = 3;
                function M(e, t, n) {
                    var i, o = {
                        appId: e,
                        apiKey: t,
                        timeouts: {
                            connect: 1,
                            read: 2,
                            write: 30
                        },
                        requester: {
                            send: function(e) {
                                return new Promise((function(t) {
                                    var r = new XMLHttpRequest;
                                    r.open(e.method, e.url, !0),
                                    Object.keys(e.headers).forEach((function(t) {
                                        return r.setRequestHeader(t, e.headers[t])
                                    }
                                    ));
                                    var n, i = function(e, n) {
                                        return setTimeout((function() {
                                            r.abort(),
                                            t({
                                                status: 0,
                                                content: n,
                                                isTimedOut: !0
                                            })
                                        }
                                        ), 1e3 * e)
                                    }, o = i(e.connectTimeout, "Connection timeout");
                                    r.onreadystatechange = function() {
                                        r.readyState > r.OPENED && void 0 === n && (clearTimeout(o),
                                        n = i(e.responseTimeout, "Socket timeout"))
                                    }
                                    ,
                                    r.onerror = function() {
                                        0 === r.status && (clearTimeout(o),
                                        clearTimeout(n),
                                        t({
                                            content: r.responseText || "Network request failed",
                                            status: r.status,
                                            isTimedOut: !1
                                        }))
                                    }
                                    ,
                                    r.onload = function() {
                                        clearTimeout(o),
                                        clearTimeout(n),
                                        t({
                                            content: r.responseText,
                                            status: r.status,
                                            isTimedOut: !1
                                        })
                                    }
                                    ,
                                    r.send(e.data)
                                }
                                ))
                            }
                        },
                        logger: (i = L,
                        {
                            debug: function(e, t) {
                                return H >= i && console.debug(e, t),
                                Promise.resolve()
                            },
                            info: function(e, t) {
                                return $ >= i && console.info(e, t),
                                Promise.resolve()
                            },
                            error: function(e, t) {
                                return console.error(e, t),
                                Promise.resolve()
                            }
                        }),
                        responsesCache: c(),
                        requestsCache: c({
                            serializable: !1
                        }),
                        hostsCache: s({
                            caches: [a({
                                key: "".concat("4.20.0", "-").concat(e)
                            }), c()]
                        }),
                        userAgent: j("4.20.0").add({
                            segment: "Browser",
                            version: "lite"
                        }),
                        authMode: p.WithinQueryParameters
                    };
                    return k(r(r(r({}, o), n), {}, {
                        methods: {
                            search: N,
                            searchForFacetValues: F,
                            multipleQueries: N,
                            multipleSearchForFacetValues: F,
                            customRequest: I,
                            initIndex: function(e) {
                                return function(t) {
                                    return T(e)(t, {
                                        methods: {
                                            search: A,
                                            searchForFacetValues: D,
                                            findAnswers: C
                                        }
                                    })
                                }
                            }
                        }
                    }))
                }
                return M.version = "4.20.0",
                M
            }()
        },
        397: (e, t) => {
            !function(e) {
                var t = /\S/
                  , r = /\"/g
                  , n = /\n/g
                  , i = /\r/g
                  , o = /\\/g
                  , a = /\u2028/
                  , s = /\u2029/;
                function c(e) {
                    "}" === e.n.substr(e.n.length - 1) && (e.n = e.n.substring(0, e.n.length - 1))
                }
                function u(e) {
                    return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, "")
                }
                function l(e, t, r) {
                    if (t.charAt(r) != e.charAt(0))
                        return !1;
                    for (var n = 1, i = e.length; n < i; n++)
                        if (t.charAt(r + n) != e.charAt(n))
                            return !1;
                    return !0
                }
                e.tags = {
                    "#": 1,
                    "^": 2,
                    "<": 3,
                    $: 4,
                    "/": 5,
                    "!": 6,
                    ">": 7,
                    "=": 8,
                    _v: 9,
                    "{": 10,
                    "&": 11,
                    _t: 12
                },
                e.scan = function(r, n) {
                    var i = r.length
                      , o = 0
                      , a = null
                      , s = null
                      , f = ""
                      , p = []
                      , h = !1
                      , d = 0
                      , m = 0
                      , g = "{{"
                      , y = "}}";
                    function v() {
                        f.length > 0 && (p.push({
                            tag: "_t",
                            text: new String(f)
                        }),
                        f = "")
                    }
                    function b(r, n) {
                        if (v(),
                        r && function() {
                            for (var r = !0, n = m; n < p.length; n++)
                                if (!(r = e.tags[p[n].tag] < e.tags._v || "_t" == p[n].tag && null === p[n].text.match(t)))
                                    return !1;
                            return r
                        }())
                            for (var i, o = m; o < p.length; o++)
                                p[o].text && ((i = p[o + 1]) && ">" == i.tag && (i.indent = p[o].text.toString()),
                                p.splice(o, 1));
                        else
                            n || p.push({
                                tag: "\n"
                            });
                        h = !1,
                        m = p.length
                    }
                    function S(e, t) {
                        var r = "=" + y
                          , n = e.indexOf(r, t)
                          , i = u(e.substring(e.indexOf("=", t) + 1, n)).split(" ");
                        return g = i[0],
                        y = i[i.length - 1],
                        n + r.length - 1
                    }
                    for (n && (n = n.split(" "),
                    g = n[0],
                    y = n[1]),
                    d = 0; d < i; d++)
                        0 == o ? l(g, r, d) ? (--d,
                        v(),
                        o = 1) : "\n" == r.charAt(d) ? b(h) : f += r.charAt(d) : 1 == o ? (d += g.length - 1,
                        "=" == (a = (s = e.tags[r.charAt(d + 1)]) ? r.charAt(d + 1) : "_v") ? (d = S(r, d),
                        o = 0) : (s && d++,
                        o = 2),
                        h = d) : l(y, r, d) ? (p.push({
                            tag: a,
                            n: u(f),
                            otag: g,
                            ctag: y,
                            i: "/" == a ? h - g.length : d + y.length
                        }),
                        f = "",
                        d += y.length - 1,
                        o = 0,
                        "{" == a && ("}}" == y ? d++ : c(p[p.length - 1]))) : f += r.charAt(d);
                    return b(h, !0),
                    p
                }
                ;
                var f = {
                    _t: !0,
                    "\n": !0,
                    $: !0,
                    "/": !0
                };
                function p(t, r, n, i) {
                    var o, a = [], s = null, c = null;
                    for (o = n[n.length - 1]; t.length > 0; ) {
                        if (c = t.shift(),
                        o && "<" == o.tag && !(c.tag in f))
                            throw new Error("Illegal content in < super tag.");
                        if (e.tags[c.tag] <= e.tags.$ || h(c, i))
                            n.push(c),
                            c.nodes = p(t, c.tag, n, i);
                        else {
                            if ("/" == c.tag) {
                                if (0 === n.length)
                                    throw new Error("Closing tag without opener: /" + c.n);
                                if (s = n.pop(),
                                c.n != s.n && !d(c.n, s.n, i))
                                    throw new Error("Nesting error: " + s.n + " vs. " + c.n);
                                return s.end = c.i,
                                a
                            }
                            "\n" == c.tag && (c.last = 0 == t.length || "\n" == t[0].tag)
                        }
                        a.push(c)
                    }
                    if (n.length > 0)
                        throw new Error("missing closing tag: " + n.pop().n);
                    return a
                }
                function h(e, t) {
                    for (var r = 0, n = t.length; r < n; r++)
                        if (t[r].o == e.n)
                            return e.tag = "#",
                            !0
                }
                function d(e, t, r) {
                    for (var n = 0, i = r.length; n < i; n++)
                        if (r[n].c == e && r[n].o == t)
                            return !0
                }
                function m(e) {
                    var t = [];
                    for (var r in e.partials)
                        t.push('"' + y(r) + '":{name:"' + y(e.partials[r].name) + '", ' + m(e.partials[r]) + "}");
                    return "partials: {" + t.join(",") + "}, subs: " + function(e) {
                        var t = [];
                        for (var r in e)
                            t.push('"' + y(r) + '": function(c,p,t,i) {' + e[r] + "}");
                        return "{ " + t.join(",") + " }"
                    }(e.subs)
                }
                e.stringify = function(t, r, n) {
                    return "{code: function (c,p,i) { " + e.wrapMain(t.code) + " }," + m(t) + "}"
                }
                ;
                var g = 0;
                function y(e) {
                    return e.replace(o, "\\\\").replace(r, '\\"').replace(n, "\\n").replace(i, "\\r").replace(a, "\\u2028").replace(s, "\\u2029")
                }
                function v(e) {
                    return ~e.indexOf(".") ? "d" : "f"
                }
                function b(e, t) {
                    var r = "<" + (t.prefix || "") + e.n + g++;
                    return t.partials[r] = {
                        name: e.n,
                        partials: {}
                    },
                    t.code += 't.b(t.rp("' + y(r) + '",c,p,"' + (e.indent || "") + '"));',
                    r
                }
                function S(e, t) {
                    t.code += "t.b(t.t(t." + v(e.n) + '("' + y(e.n) + '",c,p,0)));'
                }
                function O(e) {
                    return "t.b(" + e + ");"
                }
                e.generate = function(t, r, n) {
                    g = 0;
                    var i = {
                        code: "",
                        subs: {},
                        partials: {}
                    };
                    return e.walk(t, i),
                    n.asString ? this.stringify(i, r, n) : this.makeTemplate(i, r, n)
                }
                ,
                e.wrapMain = function(e) {
                    return 'var t=this;t.b(i=i||"");' + e + "return t.fl();"
                }
                ,
                e.template = e.Template,
                e.makeTemplate = function(e, t, r) {
                    var n = this.makePartials(e);
                    return n.code = new Function("c","p","i",this.wrapMain(e.code)),
                    new this.template(n,t,this,r)
                }
                ,
                e.makePartials = function(e) {
                    var t, r = {
                        subs: {},
                        partials: e.partials,
                        name: e.name
                    };
                    for (t in r.partials)
                        r.partials[t] = this.makePartials(r.partials[t]);
                    for (t in e.subs)
                        r.subs[t] = new Function("c","p","t","i",e.subs[t]);
                    return r
                }
                ,
                e.codegen = {
                    "#": function(t, r) {
                        r.code += "if(t.s(t." + v(t.n) + '("' + y(t.n) + '",c,p,1),c,p,0,' + t.i + "," + t.end + ',"' + t.otag + " " + t.ctag + '")){t.rs(c,p,function(c,p,t){',
                        e.walk(t.nodes, r),
                        r.code += "});c.pop();}"
                    },
                    "^": function(t, r) {
                        r.code += "if(!t.s(t." + v(t.n) + '("' + y(t.n) + '",c,p,1),c,p,1,0,0,"")){',
                        e.walk(t.nodes, r),
                        r.code += "};"
                    },
                    ">": b,
                    "<": function(t, r) {
                        var n = {
                            partials: {},
                            code: "",
                            subs: {},
                            inPartial: !0
                        };
                        e.walk(t.nodes, n);
                        var i = r.partials[b(t, r)];
                        i.subs = n.subs,
                        i.partials = n.partials
                    },
                    $: function(t, r) {
                        var n = {
                            subs: {},
                            code: "",
                            partials: r.partials,
                            prefix: t.n
                        };
                        e.walk(t.nodes, n),
                        r.subs[t.n] = n.code,
                        r.inPartial || (r.code += 't.sub("' + y(t.n) + '",c,p,i);')
                    },
                    "\n": function(e, t) {
                        t.code += O('"\\n"' + (e.last ? "" : " + i"))
                    },
                    _v: function(e, t) {
                        t.code += "t.b(t.v(t." + v(e.n) + '("' + y(e.n) + '",c,p,0)));'
                    },
                    _t: function(e, t) {
                        t.code += O('"' + y(e.text) + '"')
                    },
                    "{": S,
                    "&": S
                },
                e.walk = function(t, r) {
                    for (var n, i = 0, o = t.length; i < o; i++)
                        (n = e.codegen[t[i].tag]) && n(t[i], r);
                    return r
                }
                ,
                e.parse = function(e, t, r) {
                    return p(e, 0, [], (r = r || {}).sectionTags || [])
                }
                ,
                e.cache = {},
                e.cacheKey = function(e, t) {
                    return [e, !!t.asString, !!t.disableLambda, t.delimiters, !!t.modelGet].join("||")
                }
                ,
                e.compile = function(t, r) {
                    r = r || {};
                    var n = e.cacheKey(t, r)
                      , i = this.cache[n];
                    if (i) {
                        var o = i.partials;
                        for (var a in o)
                            delete o[a].instance;
                        return i
                    }
                    return i = this.generate(this.parse(this.scan(t, r.delimiters), t, r), t, r),
                    this.cache[n] = i
                }
            }(t)
        }
        ,
        485: (e, t, r) => {
            var n = r(397);
            n.Template = r(882).Template,
            n.template = n.Template,
            e.exports = n
        }
        ,
        882: (e, t) => {
            !function(e) {
                function t(e, t, r) {
                    var n;
                    return t && "object" == typeof t && (void 0 !== t[e] ? n = t[e] : r && t.get && "function" == typeof t.get && (n = t.get(e))),
                    n
                }
                e.Template = function(e, t, r, n) {
                    e = e || {},
                    this.r = e.code || this.r,
                    this.c = r,
                    this.options = n || {},
                    this.text = t || "",
                    this.partials = e.partials || {},
                    this.subs = e.subs || {},
                    this.buf = ""
                }
                ,
                e.Template.prototype = {
                    r: function(e, t, r) {
                        return ""
                    },
                    v: function(e) {
                        return e = c(e),
                        s.test(e) ? e.replace(r, "&amp;").replace(n, "&lt;").replace(i, "&gt;").replace(o, "&#39;").replace(a, "&quot;") : e
                    },
                    t: c,
                    render: function(e, t, r) {
                        return this.ri([e], t || {}, r)
                    },
                    ri: function(e, t, r) {
                        return this.r(e, t, r)
                    },
                    ep: function(e, t) {
                        var r = this.partials[e]
                          , n = t[r.name];
                        if (r.instance && r.base == n)
                            return r.instance;
                        if ("string" == typeof n) {
                            if (!this.c)
                                throw new Error("No compiler available.");
                            n = this.c.compile(n, this.options)
                        }
                        if (!n)
                            return null;
                        if (this.partials[e].base = n,
                        r.subs) {
                            for (key in t.stackText || (t.stackText = {}),
                            r.subs)
                                t.stackText[key] || (t.stackText[key] = void 0 !== this.activeSub && t.stackText[this.activeSub] ? t.stackText[this.activeSub] : this.text);
                            n = function(e, t, r, n, i, o) {
                                function a() {}
                                function s() {}
                                var c;
                                a.prototype = e,
                                s.prototype = e.subs;
                                var u = new a;
                                for (c in u.subs = new s,
                                u.subsText = {},
                                u.buf = "",
                                n = n || {},
                                u.stackSubs = n,
                                u.subsText = o,
                                t)
                                    n[c] || (n[c] = t[c]);
                                for (c in n)
                                    u.subs[c] = n[c];
                                for (c in i = i || {},
                                u.stackPartials = i,
                                r)
                                    i[c] || (i[c] = r[c]);
                                for (c in i)
                                    u.partials[c] = i[c];
                                return u
                            }(n, r.subs, r.partials, this.stackSubs, this.stackPartials, t.stackText)
                        }
                        return this.partials[e].instance = n,
                        n
                    },
                    rp: function(e, t, r, n) {
                        var i = this.ep(e, r);
                        return i ? i.ri(t, r, n) : ""
                    },
                    rs: function(e, t, r) {
                        var n = e[e.length - 1];
                        if (u(n))
                            for (var i = 0; i < n.length; i++)
                                e.push(n[i]),
                                r(e, t, this),
                                e.pop();
                        else
                            r(e, t, this)
                    },
                    s: function(e, t, r, n, i, o, a) {
                        var s;
                        return (!u(e) || 0 !== e.length) && ("function" == typeof e && (e = this.ms(e, t, r, n, i, o, a)),
                        s = !!e,
                        !n && s && t && t.push("object" == typeof e ? e : t[t.length - 1]),
                        s)
                    },
                    d: function(e, r, n, i) {
                        var o, a = e.split("."), s = this.f(a[0], r, n, i), c = this.options.modelGet, l = null;
                        if ("." === e && u(r[r.length - 2]))
                            s = r[r.length - 1];
                        else
                            for (var f = 1; f < a.length; f++)
                                void 0 !== (o = t(a[f], s, c)) ? (l = s,
                                s = o) : s = "";
                        return !(i && !s) && (i || "function" != typeof s || (r.push(l),
                        s = this.mv(s, r, n),
                        r.pop()),
                        s)
                    },
                    f: function(e, r, n, i) {
                        for (var o = !1, a = !1, s = this.options.modelGet, c = r.length - 1; c >= 0; c--)
                            if (void 0 !== (o = t(e, r[c], s))) {
                                a = !0;
                                break
                            }
                        return a ? (i || "function" != typeof o || (o = this.mv(o, r, n)),
                        o) : !i && ""
                    },
                    ls: function(e, t, r, n, i) {
                        var o = this.options.delimiters;
                        return this.options.delimiters = i,
                        this.b(this.ct(c(e.call(t, n)), t, r)),
                        this.options.delimiters = o,
                        !1
                    },
                    ct: function(e, t, r) {
                        if (this.options.disableLambda)
                            throw new Error("Lambda features disabled.");
                        return this.c.compile(e, this.options).render(t, r)
                    },
                    b: function(e) {
                        this.buf += e
                    },
                    fl: function() {
                        var e = this.buf;
                        return this.buf = "",
                        e
                    },
                    ms: function(e, t, r, n, i, o, a) {
                        var s, c = t[t.length - 1], u = e.call(c);
                        return "function" == typeof u ? !!n || (s = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text,
                        this.ls(u, c, r, s.substring(i, o), a)) : u
                    },
                    mv: function(e, t, r) {
                        var n = t[t.length - 1]
                          , i = e.call(n);
                        return "function" == typeof i ? this.ct(c(i.call(n)), n, r) : i
                    },
                    sub: function(e, t, r, n) {
                        var i = this.subs[e];
                        i && (this.activeSub = e,
                        i(t, r, this, n),
                        this.activeSub = !1)
                    }
                };
                var r = /&/g
                  , n = /</g
                  , i = />/g
                  , o = /\'/g
                  , a = /\"/g
                  , s = /[&<>\"\']/;
                function c(e) {
                    return String(null == e ? "" : e)
                }
                var u = Array.isArray || function(e) {
                    return "[object Array]" === Object.prototype.toString.call(e)
                }
            }(t)
        }
        ,
        904: e => {
            "use strict";
            var t = String.prototype.replace
              , r = /%20/g
              , n = "RFC1738"
              , i = "RFC3986";
            e.exports = {
                default: i,
                formatters: {
                    RFC1738: function(e) {
                        return t.call(e, r, "+")
                    },
                    RFC3986: function(e) {
                        return String(e)
                    }
                },
                RFC1738: n,
                RFC3986: i
            }
        }
        ,
        368: (e, t, r) => {
            "use strict";
            var n = r(307)
              , i = r(316)
              , o = r(904);
            e.exports = {
                formats: o,
                parse: i,
                stringify: n
            }
        }
        ,
        316: (e, t, r) => {
            "use strict";
            var n = r(84)
              , i = Object.prototype.hasOwnProperty
              , o = Array.isArray
              , a = {
                allowDots: !1,
                allowPrototypes: !1,
                arrayLimit: 20,
                charset: "utf-8",
                charsetSentinel: !1,
                comma: !1,
                decoder: n.decode,
                delimiter: "&",
                depth: 5,
                ignoreQueryPrefix: !1,
                interpretNumericEntities: !1,
                parameterLimit: 1e3,
                parseArrays: !0,
                plainObjects: !1,
                strictNullHandling: !1
            }
              , s = function(e) {
                return e.replace(/&#(\d+);/g, (function(e, t) {
                    return String.fromCharCode(parseInt(t, 10))
                }
                ))
            }
              , c = function(e, t) {
                return e && "string" == typeof e && t.comma && e.indexOf(",") > -1 ? e.split(",") : e
            }
              , u = function(e, t, r, n) {
                if (e) {
                    var o = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e
                      , a = /(\[[^[\]]*])/g
                      , s = r.depth > 0 && /(\[[^[\]]*])/.exec(o)
                      , u = s ? o.slice(0, s.index) : o
                      , l = [];
                    if (u) {
                        if (!r.plainObjects && i.call(Object.prototype, u) && !r.allowPrototypes)
                            return;
                        l.push(u)
                    }
                    for (var f = 0; r.depth > 0 && null !== (s = a.exec(o)) && f < r.depth; ) {
                        if (f += 1,
                        !r.plainObjects && i.call(Object.prototype, s[1].slice(1, -1)) && !r.allowPrototypes)
                            return;
                        l.push(s[1])
                    }
                    return s && l.push("[" + o.slice(s.index) + "]"),
                    function(e, t, r, n) {
                        for (var i = n ? t : c(t, r), o = e.length - 1; o >= 0; --o) {
                            var a, s = e[o];
                            if ("[]" === s && r.parseArrays)
                                a = [].concat(i);
                            else {
                                a = r.plainObjects ? Object.create(null) : {};
                                var u = "[" === s.charAt(0) && "]" === s.charAt(s.length - 1) ? s.slice(1, -1) : s
                                  , l = parseInt(u, 10);
                                r.parseArrays || "" !== u ? !isNaN(l) && s !== u && String(l) === u && l >= 0 && r.parseArrays && l <= r.arrayLimit ? (a = [])[l] = i : "__proto__" !== u && (a[u] = i) : a = {
                                    0: i
                                }
                            }
                            i = a
                        }
                        return i
                    }(l, t, r, n)
                }
            };
            e.exports = function(e, t) {
                var r = function(e) {
                    if (!e)
                        return a;
                    if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder)
                        throw new TypeError("Decoder has to be a function.");
                    if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset)
                        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                    var t = void 0 === e.charset ? a.charset : e.charset;
                    return {
                        allowDots: void 0 === e.allowDots ? a.allowDots : !!e.allowDots,
                        allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : a.allowPrototypes,
                        arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : a.arrayLimit,
                        charset: t,
                        charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : a.charsetSentinel,
                        comma: "boolean" == typeof e.comma ? e.comma : a.comma,
                        decoder: "function" == typeof e.decoder ? e.decoder : a.decoder,
                        delimiter: "string" == typeof e.delimiter || n.isRegExp(e.delimiter) ? e.delimiter : a.delimiter,
                        depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : a.depth,
                        ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
                        interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : a.interpretNumericEntities,
                        parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : a.parameterLimit,
                        parseArrays: !1 !== e.parseArrays,
                        plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : a.plainObjects,
                        strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : a.strictNullHandling
                    }
                }(t);
                if ("" === e || null == e)
                    return r.plainObjects ? Object.create(null) : {};
                for (var l = "string" == typeof e ? function(e, t) {
                    var r, u = {}, l = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, f = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, p = l.split(t.delimiter, f), h = -1, d = t.charset;
                    if (t.charsetSentinel)
                        for (r = 0; r < p.length; ++r)
                            0 === p[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === p[r] ? d = "utf-8" : "utf8=%26%2310003%3B" === p[r] && (d = "iso-8859-1"),
                            h = r,
                            r = p.length);
                    for (r = 0; r < p.length; ++r)
                        if (r !== h) {
                            var m, g, y = p[r], v = y.indexOf("]="), b = -1 === v ? y.indexOf("=") : v + 1;
                            -1 === b ? (m = t.decoder(y, a.decoder, d, "key"),
                            g = t.strictNullHandling ? null : "") : (m = t.decoder(y.slice(0, b), a.decoder, d, "key"),
                            g = n.maybeMap(c(y.slice(b + 1), t), (function(e) {
                                return t.decoder(e, a.decoder, d, "value")
                            }
                            ))),
                            g && t.interpretNumericEntities && "iso-8859-1" === d && (g = s(g)),
                            y.indexOf("[]=") > -1 && (g = o(g) ? [g] : g),
                            i.call(u, m) ? u[m] = n.combine(u[m], g) : u[m] = g
                        }
                    return u
                }(e, r) : e, f = r.plainObjects ? Object.create(null) : {}, p = Object.keys(l), h = 0; h < p.length; ++h) {
                    var d = p[h]
                      , m = u(d, l[d], r, "string" == typeof e);
                    f = n.merge(f, m, r)
                }
                return n.compact(f)
            }
        }
        ,
        307: (e, t, r) => {
            "use strict";
            var n = r(84)
              , i = r(904)
              , o = Object.prototype.hasOwnProperty
              , a = {
                brackets: function(e) {
                    return e + "[]"
                },
                comma: "comma",
                indices: function(e, t) {
                    return e + "[" + t + "]"
                },
                repeat: function(e) {
                    return e
                }
            }
              , s = Array.isArray
              , c = String.prototype.split
              , u = Array.prototype.push
              , l = function(e, t) {
                u.apply(e, s(t) ? t : [t])
            }
              , f = Date.prototype.toISOString
              , p = i.default
              , h = {
                addQueryPrefix: !1,
                allowDots: !1,
                charset: "utf-8",
                charsetSentinel: !1,
                delimiter: "&",
                encode: !0,
                encoder: n.encode,
                encodeValuesOnly: !1,
                format: p,
                formatter: i.formatters[p],
                indices: !1,
                serializeDate: function(e) {
                    return f.call(e)
                },
                skipNulls: !1,
                strictNullHandling: !1
            }
              , d = function e(t, r, i, o, a, u, f, p, d, m, g, y, v, b) {
                var S, O = t;
                if ("function" == typeof f ? O = f(r, O) : O instanceof Date ? O = m(O) : "comma" === i && s(O) && (O = n.maybeMap(O, (function(e) {
                    return e instanceof Date ? m(e) : e
                }
                ))),
                null === O) {
                    if (o)
                        return u && !v ? u(r, h.encoder, b, "key", g) : r;
                    O = ""
                }
                if ("string" == typeof (S = O) || "number" == typeof S || "boolean" == typeof S || "symbol" == typeof S || "bigint" == typeof S || n.isBuffer(O)) {
                    if (u) {
                        var w = v ? r : u(r, h.encoder, b, "key", g);
                        if ("comma" === i && v) {
                            for (var _ = c.call(String(O), ","), j = "", P = 0; P < _.length; ++P)
                                j += (0 === P ? "" : ",") + y(u(_[P], h.encoder, b, "value", g));
                            return [y(w) + "=" + j]
                        }
                        return [y(w) + "=" + y(u(O, h.encoder, b, "value", g))]
                    }
                    return [y(r) + "=" + y(String(O))]
                }
                var R, x = [];
                if (void 0 === O)
                    return x;
                if ("comma" === i && s(O))
                    R = [{
                        value: O.length > 0 ? O.join(",") || null : void 0
                    }];
                else if (s(f))
                    R = f;
                else {
                    var E = Object.keys(O);
                    R = p ? E.sort(p) : E
                }
                for (var k = 0; k < R.length; ++k) {
                    var I = R[k]
                      , T = "object" == typeof I && void 0 !== I.value ? I.value : O[I];
                    if (!a || null !== T) {
                        var N = s(O) ? "function" == typeof i ? i(r, I) : r : r + (d ? "." + I : "[" + I + "]");
                        l(x, e(T, N, i, o, a, u, f, p, d, m, g, y, v, b))
                    }
                }
                return x
            };
            e.exports = function(e, t) {
                var r, n = e, c = function(e) {
                    if (!e)
                        return h;
                    if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder)
                        throw new TypeError("Encoder has to be a function.");
                    var t = e.charset || h.charset;
                    if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset)
                        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                    var r = i.default;
                    if (void 0 !== e.format) {
                        if (!o.call(i.formatters, e.format))
                            throw new TypeError("Unknown format option provided.");
                        r = e.format
                    }
                    var n = i.formatters[r]
                      , a = h.filter;
                    return ("function" == typeof e.filter || s(e.filter)) && (a = e.filter),
                    {
                        addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : h.addQueryPrefix,
                        allowDots: void 0 === e.allowDots ? h.allowDots : !!e.allowDots,
                        charset: t,
                        charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : h.charsetSentinel,
                        delimiter: void 0 === e.delimiter ? h.delimiter : e.delimiter,
                        encode: "boolean" == typeof e.encode ? e.encode : h.encode,
                        encoder: "function" == typeof e.encoder ? e.encoder : h.encoder,
                        encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : h.encodeValuesOnly,
                        filter: a,
                        format: r,
                        formatter: n,
                        serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : h.serializeDate,
                        skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : h.skipNulls,
                        sort: "function" == typeof e.sort ? e.sort : null,
                        strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : h.strictNullHandling
                    }
                }(t);
                "function" == typeof c.filter ? n = (0,
                c.filter)("", n) : s(c.filter) && (r = c.filter);
                var u, f = [];
                if ("object" != typeof n || null === n)
                    return "";
                u = t && t.arrayFormat in a ? t.arrayFormat : t && "indices"in t ? t.indices ? "indices" : "repeat" : "indices";
                var p = a[u];
                r || (r = Object.keys(n)),
                c.sort && r.sort(c.sort);
                for (var m = 0; m < r.length; ++m) {
                    var g = r[m];
                    c.skipNulls && null === n[g] || l(f, d(n[g], g, p, c.strictNullHandling, c.skipNulls, c.encode ? c.encoder : null, c.filter, c.sort, c.allowDots, c.serializeDate, c.format, c.formatter, c.encodeValuesOnly, c.charset))
                }
                var y = f.join(c.delimiter)
                  , v = !0 === c.addQueryPrefix ? "?" : "";
                return c.charsetSentinel && ("iso-8859-1" === c.charset ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"),
                y.length > 0 ? v + y : ""
            }
        }
        ,
        84: (e, t, r) => {
            "use strict";
            var n = r(904)
              , i = Object.prototype.hasOwnProperty
              , o = Array.isArray
              , a = function() {
                for (var e = [], t = 0; t < 256; ++t)
                    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
                return e
            }()
              , s = function(e, t) {
                for (var r = t && t.plainObjects ? Object.create(null) : {}, n = 0; n < e.length; ++n)
                    void 0 !== e[n] && (r[n] = e[n]);
                return r
            };
            e.exports = {
                arrayToObject: s,
                assign: function(e, t) {
                    return Object.keys(t).reduce((function(e, r) {
                        return e[r] = t[r],
                        e
                    }
                    ), e)
                },
                combine: function(e, t) {
                    return [].concat(e, t)
                },
                compact: function(e) {
                    for (var t = [{
                        obj: {
                            o: e
                        },
                        prop: "o"
                    }], r = [], n = 0; n < t.length; ++n)
                        for (var i = t[n], a = i.obj[i.prop], s = Object.keys(a), c = 0; c < s.length; ++c) {
                            var u = s[c]
                              , l = a[u];
                            "object" == typeof l && null !== l && -1 === r.indexOf(l) && (t.push({
                                obj: a,
                                prop: u
                            }),
                            r.push(l))
                        }
                    return function(e) {
                        for (; e.length > 1; ) {
                            var t = e.pop()
                              , r = t.obj[t.prop];
                            if (o(r)) {
                                for (var n = [], i = 0; i < r.length; ++i)
                                    void 0 !== r[i] && n.push(r[i]);
                                t.obj[t.prop] = n
                            }
                        }
                    }(t),
                    e
                },
                decode: function(e, t, r) {
                    var n = e.replace(/\+/g, " ");
                    if ("iso-8859-1" === r)
                        return n.replace(/%[0-9a-f]{2}/gi, unescape);
                    try {
                        return decodeURIComponent(n)
                    } catch (e) {
                        return n
                    }
                },
                encode: function(e, t, r, i, o) {
                    if (0 === e.length)
                        return e;
                    var s = e;
                    if ("symbol" == typeof e ? s = Symbol.prototype.toString.call(e) : "string" != typeof e && (s = String(e)),
                    "iso-8859-1" === r)
                        return escape(s).replace(/%u[0-9a-f]{4}/gi, (function(e) {
                            return "%26%23" + parseInt(e.slice(2), 16) + "%3B"
                        }
                        ));
                    for (var c = "", u = 0; u < s.length; ++u) {
                        var l = s.charCodeAt(u);
                        45 === l || 46 === l || 95 === l || 126 === l || l >= 48 && l <= 57 || l >= 65 && l <= 90 || l >= 97 && l <= 122 || o === n.RFC1738 && (40 === l || 41 === l) ? c += s.charAt(u) : l < 128 ? c += a[l] : l < 2048 ? c += a[192 | l >> 6] + a[128 | 63 & l] : l < 55296 || l >= 57344 ? c += a[224 | l >> 12] + a[128 | l >> 6 & 63] + a[128 | 63 & l] : (u += 1,
                        l = 65536 + ((1023 & l) << 10 | 1023 & s.charCodeAt(u)),
                        c += a[240 | l >> 18] + a[128 | l >> 12 & 63] + a[128 | l >> 6 & 63] + a[128 | 63 & l])
                    }
                    return c
                },
                isBuffer: function(e) {
                    return !(!e || "object" != typeof e) && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e))
                },
                isRegExp: function(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e)
                },
                maybeMap: function(e, t) {
                    if (o(e)) {
                        for (var r = [], n = 0; n < e.length; n += 1)
                            r.push(t(e[n]));
                        return r
                    }
                    return t(e)
                },
                merge: function e(t, r, n) {
                    if (!r)
                        return t;
                    if ("object" != typeof r) {
                        if (o(t))
                            t.push(r);
                        else {
                            if (!t || "object" != typeof t)
                                return [t, r];
                            (n && (n.plainObjects || n.allowPrototypes) || !i.call(Object.prototype, r)) && (t[r] = !0)
                        }
                        return t
                    }
                    if (!t || "object" != typeof t)
                        return [t].concat(r);
                    var a = t;
                    return o(t) && !o(r) && (a = s(t, n)),
                    o(t) && o(r) ? (r.forEach((function(r, o) {
                        if (i.call(t, o)) {
                            var a = t[o];
                            a && "object" == typeof a && r && "object" == typeof r ? t[o] = e(a, r, n) : t.push(r)
                        } else
                            t[o] = r
                    }
                    )),
                    t) : Object.keys(r).reduce((function(t, o) {
                        var a = r[o];
                        return i.call(t, o) ? t[o] = e(t[o], a, n) : t[o] = a,
                        t
                    }
                    ), a)
                }
            }
        }
    }
      , t = {};
    function r(n) {
        var i = t[n];
        if (void 0 !== i)
            return i.exports;
        var o = t[n] = {
            exports: {}
        };
        return e[n].call(o.exports, o, o.exports, r),
        o.exports
    }
    r.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return r.d(t, {
            a: t
        }),
        t
    }
    ,
    r.d = (e, t) => {
        for (var n in t)
            r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            })
    }
    ,
    r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t),
    ( () => {
        "use strict";
        var e = r(290)
          , t = r.n(e)
          , n = function(e) {
            return function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
                  , r = t.descendantName
                  , n = t.modifierName
                  , i = r ? "-".concat(r) : ""
                  , o = n ? "--".concat(n) : "";
                return "".concat("ais", "-").concat(e).concat(i).concat(o)
            }
        };
        function i(e, t) {
            return (Array.isArray(t) ? t : t.split(".")).reduce((function(e, t) {
                return e && e[t]
            }
            ), e)
        }
        var o = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }
          , a = /[&<>"']/g
          , s = RegExp(a.source);
        var c = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }
          , u = /&(amp|quot|lt|gt|#39);/g
          , l = RegExp(u.source);
        function f(e) {
            return e && l.test(e) ? e.replace(u, (function(e) {
                return c[e]
            }
            )) : e
        }
        function p(e) {
            return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            p(e)
        }
        function h(e) {
            if (!function(e) {
                return "object" === p(e) && null !== e
            }(e) || "[object Object]" !== function(e) {
                return null === e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e)
            }(e))
                return !1;
            if (null === Object.getPrototypeOf(e))
                return !0;
            for (var t = e; null !== Object.getPrototypeOf(t); )
                t = Object.getPrototypeOf(t);
            return Object.getPrototypeOf(e) === t
        }
        function d(e) {
            return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            d(e)
        }
        function m() {
            return m = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            m.apply(this, arguments)
        }
        function g(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function y(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? g(Object(r), !0).forEach((function(t) {
                    v(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function v(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== d(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== d(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === d(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var b = {
            highlightPreTag: "__ais-highlight__",
            highlightPostTag: "__/ais-highlight__"
        }
          , S = {
            highlightPreTag: "<mark>",
            highlightPostTag: "</mark>"
        };
        function O(e) {
            return function(e) {
                return e && s.test(e) ? e.replace(a, (function(e) {
                    return o[e]
                }
                )) : e
            }(e).replace(new RegExp(b.highlightPreTag,"g"), S.highlightPreTag).replace(new RegExp(b.highlightPostTag,"g"), S.highlightPostTag)
        }
        function w(e) {
            return h(e) && "string" != typeof e.value ? Object.keys(e).reduce((function(t, r) {
                return y(y({}, t), {}, v({}, r, w(e[r])))
            }
            ), {}) : Array.isArray(e) ? e.map(w) : y(y({}, e), {}, {
                value: O(e.value)
            })
        }
        function _(e) {
            return void 0 === e.__escaped && ((e = e.map((function(e) {
                var t = m({}, (function(e) {
                    if (null == e)
                        throw new TypeError("Cannot destructure " + e)
                }(e),
                e));
                return t._highlightResult && (t._highlightResult = w(t._highlightResult)),
                t._snippetResult && (t._snippetResult = w(t._snippetResult)),
                t
            }
            ))).__escaped = !0),
            e
        }
        var j = n("Highlight");
        function P(e) {
            var t = e.attribute
              , r = e.highlightedTagName
              , n = void 0 === r ? "mark" : r
              , o = e.hit
              , a = e.cssClasses
              , s = void 0 === a ? {} : a
              , c = (i(o._highlightResult, t) || {}).value
              , u = void 0 === c ? "" : c
              , l = j({
                descendantName: "highlighted"
            }) + (s.highlighted ? " ".concat(s.highlighted) : "");
            return u.replace(new RegExp(S.highlightPreTag,"g"), "<".concat(n, ' class="').concat(l, '">')).replace(new RegExp(S.highlightPostTag,"g"), "</".concat(n, ">"))
        }
        function R(e) {
            var t = S.highlightPreTag
              , r = S.highlightPostTag;
            return e.map((function(e) {
                return e.isHighlighted ? t + e.value + r : e.value
            }
            )).join("")
        }
        var x = new RegExp(/\w/i);
        function E(e, t) {
            var r, n, i = e[t], o = (null === (r = e[t + 1]) || void 0 === r ? void 0 : r.isHighlighted) || !0, a = (null === (n = e[t - 1]) || void 0 === n ? void 0 : n.isHighlighted) || !0;
            return x.test(f(i.value)) || a !== o ? i.isHighlighted : a
        }
        function k(e) {
            return k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            k(e)
        }
        function I(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function T(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? I(Object(r), !0).forEach((function(t) {
                    N(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function N(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== k(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== k(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === k(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function F(e) {
            return e.some((function(e) {
                return e.isHighlighted
            }
            )) ? e.map((function(t, r) {
                return T(T({}, t), {}, {
                    isHighlighted: !E(e, r)
                })
            }
            )) : e.map((function(e) {
                return T(T({}, e), {}, {
                    isHighlighted: !1
                })
            }
            ))
        }
        function C(e) {
            var t = S.highlightPostTag
              , r = S.highlightPreTag
              , n = e.split(r)
              , i = n.shift()
              , o = i ? [{
                value: i,
                isHighlighted: !1
            }] : [];
            return n.forEach((function(e) {
                var r = e.split(t);
                o.push({
                    value: r[0],
                    isHighlighted: !0
                }),
                "" !== r[1] && o.push({
                    value: r[1],
                    isHighlighted: !1
                })
            }
            )),
            o
        }
        var A = n("ReverseHighlight");
        function D(e) {
            var t = e.attribute
              , r = e.highlightedTagName
              , n = void 0 === r ? "mark" : r
              , o = e.hit
              , a = e.cssClasses
              , s = void 0 === a ? {} : a
              , c = (i(o._highlightResult, t) || {}).value
              , u = void 0 === c ? "" : c
              , l = A({
                descendantName: "highlighted"
            }) + (s.highlighted ? " ".concat(s.highlighted) : "");
            return R(F(C(u))).replace(new RegExp(S.highlightPreTag,"g"), "<".concat(n, ' class="').concat(l, '">')).replace(new RegExp(S.highlightPostTag,"g"), "</".concat(n, ">"))
        }
        var H = n("Snippet");
        function $(e) {
            var t = e.attribute
              , r = e.highlightedTagName
              , n = void 0 === r ? "mark" : r
              , o = e.hit
              , a = e.cssClasses
              , s = void 0 === a ? {} : a
              , c = (i(o._snippetResult, t) || {}).value
              , u = void 0 === c ? "" : c
              , l = H({
                descendantName: "highlighted"
            }) + (s.highlighted ? " ".concat(s.highlighted) : "");
            return u.replace(new RegExp(S.highlightPreTag,"g"), "<".concat(n, ' class="').concat(l, '">')).replace(new RegExp(S.highlightPostTag,"g"), "</".concat(n, ">"))
        }
        var L = n("ReverseSnippet");
        function M(e) {
            var t = e.attribute
              , r = e.highlightedTagName
              , n = void 0 === r ? "mark" : r
              , o = e.hit
              , a = e.cssClasses
              , s = void 0 === a ? {} : a
              , c = (i(o._snippetResult, t) || {}).value
              , u = void 0 === c ? "" : c
              , l = L({
                descendantName: "highlighted"
            }) + (s.highlighted ? " ".concat(s.highlighted) : "");
            return R(F(C(u))).replace(new RegExp(S.highlightPreTag,"g"), "<".concat(n, ' class="').concat(l, '">')).replace(new RegExp(S.highlightPostTag,"g"), "</".concat(n, ">"))
        }
        function q(e) {
            return btoa(encodeURIComponent(JSON.stringify(e)))
        }
        function W(e) {
            return JSON.parse(decodeURIComponent(atob(e)))
        }
        function U(e) {
            return U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            U(e)
        }
        function B(e, t) {
            return function(e) {
                var t, r = e.method, n = e.payload;
                if ("object" !== U(n))
                    throw new Error("The insights helper expects the payload to be an object.");
                try {
                    t = q(n)
                } catch (e) {
                    throw new Error("Could not JSON serialize the payload object.")
                }
                return 'data-insights-method="'.concat(r, '" data-insights-payload="').concat(t, '"')
            }({
                method: e,
                payload: t
            })
        }
        function Q(e) {
            return Q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Q(e)
        }
        var V = "_ALGOLIA";
        function z() {
            return function(e) {
                if ("object" === ("undefined" == typeof document ? "undefined" : Q(document)) && "string" == typeof document.cookie)
                    for (var t = "".concat(e, "="), r = document.cookie.split(";"), n = 0; n < r.length; n++) {
                        for (var i = r[n]; " " === i.charAt(0); )
                            i = i.substring(1);
                        if (0 === i.indexOf(t))
                            return i.substring(t.length, i.length)
                    }
            }(V)
        }
        function J(e) {
            var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                fallback: function() {}
            }).fallback;
            return "undefined" == typeof window ? t() : e({
                window
            })
        }
        function K(e) {
            return e !== Object(e)
        }
        function Y(e, t) {
            if (e === t)
                return !0;
            if (K(e) || K(t) || "function" == typeof e || "function" == typeof t)
                return e === t;
            if (Object.keys(e).length !== Object.keys(t).length)
                return !1;
            for (var r = 0, n = Object.keys(e); r < n.length; r++) {
                var i = n[r];
                if (!(i in t))
                    return !1;
                if (!Y(e[i], t[i]))
                    return !1
            }
            return !0
        }
        var G = ["page"];
        function X(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Z(e) {
            var t = e || {};
            t.page;
            return X(t, G)
        }
        var ee = "ais.infiniteHits";
        var te = r(331)
          , re = r(131);
        function ne() {}
        function ie(e, t) {
            for (var r, n = 0; n < e.length; n++)
                if (t(r = e[n], n, e))
                    return r
        }
        function oe(e) {
            return oe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            oe(e)
        }
        function ae(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function se(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ae(Object(r), !0).forEach((function(t) {
                    ce(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ae(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function ce(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== oe(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== oe(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === oe(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function ue(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || fe(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function le(e) {
            return function(e) {
                if (Array.isArray(e))
                    return pe(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || fe(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function fe(e, t) {
            if (e) {
                if ("string" == typeof e)
                    return pe(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === r && e.constructor && (r = e.constructor.name),
                "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? pe(e, t) : void 0
            }
        }
        function pe(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        var he = "2.13.0"
          , de = "https://cdn.jsdelivr.net/npm/search-insights@".concat(he, "/dist/search-insights.min.js");
        function me() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
              , t = e.insightsClient
              , r = e.insightsInitParams
              , n = e.onEvent
              , i = e.$$internal
              , o = void 0 !== i && i
              , a = e.$$automatic
              , s = void 0 !== a && a
              , c = t;
            t || null === t || J((function(e) {
                var t = e.window
                  , r = t.AlgoliaAnalyticsObject || "aa";
                "string" == typeof r && (c = t[r]),
                c || (t.AlgoliaAnalyticsObject = r,
                t[r] || (t[r] = function() {
                    t[r].queue || (t[r].queue = []);
                    for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
                        n[i] = arguments[i];
                    t[r].queue.push(n)
                }
                ,
                t[r].version = he,
                t[r].shouldAddScript = !0),
                c = t[r])
            }
            ));
            var u = c || ne;
            return function(e) {
                var t = e.instantSearchInstance
                  , i = t.middleware.filter((function(e) {
                    return "ais.insights" === e.instance.$$type && e.instance.$$internal
                }
                )).map((function(e) {
                    return e.creator
                }
                ));
                t.unuse.apply(t, le(i));
                var a, c, l = ue(function(e) {
                    if (e.transporter) {
                        var t = e.transporter
                          , r = t.headers
                          , n = t.queryParameters
                          , i = "x-algolia-application-id"
                          , o = "x-algolia-api-key";
                        return [r[i] || n[i], r[o] || n[o]]
                    }
                    return [e.applicationID, e.apiKey]
                }(t.client), 2), f = l[0], p = l[1], h = void 0, d = void 0, m = void 0, g = void 0, y = u.queue;
                if (Array.isArray(y)) {
                    var v = ["setUserToken", "setAuthenticatedUserToken"].map((function(e) {
                        var t = ie(y.slice().reverse(), (function(t) {
                            return ue(t, 1)[0] === e
                        }
                        )) || [];
                        return ue(t, 2)[1]
                    }
                    ))
                      , b = ue(v, 2);
                    h = b[0],
                    d = b[1]
                }
                return u("getUserToken", null, (function(e, t) {
                    m = ye(t)
                }
                )),
                u("getAuthenticatedUserToken", null, (function(e, t) {
                    g = ye(t)
                }
                )),
                !r && ge(u) || u("init", se({
                    appId: f,
                    apiKey: p,
                    partial: !0
                }, r)),
                {
                    $$type: "ais.insights",
                    $$internal: o,
                    $$automatic: s,
                    onStateChange: function() {},
                    subscribe: function() {
                        if (u.shouldAddScript) {
                            var e = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                            try {
                                var r = document.createElement("script");
                                r.async = !0,
                                r.src = de,
                                r.onerror = function() {
                                    t.emit("error", new Error(e))
                                }
                                ,
                                document.body.appendChild(r),
                                u.shouldAddScript = !1
                            } catch (r) {
                                u.shouldAddScript = !1,
                                t.emit("error", new Error(e))
                            }
                        }
                    },
                    started: function() {
                        u("addAlgoliaAgent", "insights-middleware"),
                        c = t.mainHelper,
                        a = {
                            userToken: c.state.userToken,
                            clickAnalytics: c.state.clickAnalytics
                        },
                        s || c.overrideStateWithoutTriggeringChangeEvent(se(se({}, c.state), {}, {
                            clickAnalytics: !0
                        })),
                        o || t.scheduleSearch();
                        var e = function(e) {
                            var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                              , n = ye(e);
                            if (n) {
                                var i = c.state.userToken;
                                r ? o() : setTimeout(o, 0)
                            }
                            function o() {
                                c.overrideStateWithoutTriggeringChangeEvent(se(se({}, c.state), {}, {
                                    userToken: n
                                })),
                                i && i !== e && t.scheduleSearch()
                            }
                        }
                          , r = z();
                        function i(t, r, n) {
                            e(t, !0),
                            r && u("setUserToken", r),
                            n && u("setAuthenticatedUserToken", n)
                        }
                        r && e(r, !0);
                        var l = g || m
                          , y = d || h;
                        l ? i(l, m, g) : y && i(y, h, d),
                        u("onUserTokenChange", e, {
                            immediate: !0
                        }),
                        u("onAuthenticatedUserTokenChange", (function(t) {
                            t || u("getUserToken", null, (function(t, r) {
                                e(r)
                            }
                            )),
                            e(t)
                        }
                        ), {
                            immediate: !0
                        });
                        var v = u;
                        ge(u) && (v = function(e, t) {
                            return u(e, t, {
                                headers: {
                                    "X-Algolia-Application-Id": f,
                                    "X-Algolia-API-Key": p
                                }
                            })
                        }
                        ),
                        t.sendEventToInsights = function(e) {
                            n ? n(e, v) : e.insightsMethod && (e.payload.algoliaSource = ["instantsearch"],
                            s && e.payload.algoliaSource.push("instantsearch-automatic"),
                            "internal" === e.eventModifier && e.payload.algoliaSource.push("instantsearch-internal"),
                            v(e.insightsMethod, e.payload))
                        }
                    },
                    unsubscribe: function() {
                        u("onUserTokenChange", void 0),
                        u("onAuthenticatedUserTokenChange", void 0),
                        t.sendEventToInsights = ne,
                        c && a && (c.overrideStateWithoutTriggeringChangeEvent(se(se({}, c.state), a)),
                        t.scheduleSearch())
                    }
                }
            }
        }
        function ge(e) {
            var t = ue((e.version || "").split(".").map(Number), 2)
              , r = t[0]
              , n = t[1];
            return r >= 3 || 2 === r && n >= 6 || 1 === r && n >= 10
        }
        function ye(e) {
            if (e)
                return "number" == typeof e ? e.toString() : e
        }
        function ve(e, t, r) {
            var n = t.getHelper();
            return {
                uiState: r,
                helper: n,
                parent: t,
                instantSearchInstance: e,
                state: n.state,
                renderState: e.renderState,
                templatesConfig: e.templatesConfig,
                createURL: t.createURL,
                scopedResults: [],
                searchMetadata: {
                    isSearchStalled: "stalled" === e.status
                },
                status: e.status,
                error: e.error
            }
        }
        function be(e, t, r) {
            var n = t.getResultsForWidget(r)
              , i = t.getHelper();
            return {
                helper: i,
                parent: t,
                instantSearchInstance: e,
                results: n,
                scopedResults: t.getScopedResults(),
                state: n && "_state"in n ? n._state : i.state,
                renderState: e.renderState,
                templatesConfig: e.templatesConfig,
                createURL: t.createURL,
                searchMetadata: {
                    isSearchStalled: "stalled" === e.status
                },
                status: e.status,
                error: e.error
            }
        }
        function Se(e, t, r) {
            var n = ve(t, t.mainIndex, t._initialUiState);
            e.forEach((function(e) {
                var i = {};
                if (e.getWidgetRenderState) {
                    var o = e.getWidgetRenderState(n);
                    o && o.widgetParams && (i = o.widgetParams)
                }
                var a = Object.keys(i).filter((function(e) {
                    return void 0 !== i[e]
                }
                ));
                r.widgets.push({
                    type: e.$$type,
                    widgetType: e.$$widgetType,
                    params: a
                }),
                "ais.index" === e.$$type && Se(e.getWidgets(), t, r)
            }
            ))
        }
        function Oe() {
            var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).$$internal
              , t = void 0 !== e && e;
            return function(e) {
                var r = e.instantSearchInstance
                  , n = {
                    widgets: []
                }
                  , i = document.createElement("meta")
                  , o = document.querySelector("head");
                return i.name = "instantsearch:widgets",
                {
                    $$type: "ais.metadata",
                    $$internal: t,
                    onStateChange: function() {},
                    subscribe: function() {
                        setTimeout((function() {
                            var e = r.client;
                            n.ua = e.transporter && e.transporter.userAgent ? e.transporter.userAgent.value : e._ua,
                            Se(r.mainIndex.getWidgets(), r, n),
                            r.middleware.forEach((function(e) {
                                return n.widgets.push({
                                    middleware: !0,
                                    type: e.instance.$$type,
                                    internal: e.instance.$$internal
                                })
                            }
                            )),
                            i.content = JSON.stringify(n),
                            o.appendChild(i)
                        }
                        ), 0)
                    },
                    started: function() {},
                    unsubscribe: function() {
                        i.remove()
                    }
                }
            }
        }
        var we = r(368);
        function _e(e) {
            return _e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            _e(e)
        }
        function je(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, Re(n.key), n)
            }
        }
        function Pe(e, t, r) {
            return (t = Re(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Re(e) {
            var t = function(e, t) {
                if ("object" !== _e(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== _e(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === _e(t) ? t : String(t)
        }
        var xe = function(e) {
            e && (window.document.title = e)
        }
          , Ee = function() {
            function e(t) {
                var r = this
                  , n = t.windowTitle
                  , i = t.writeDelay
                  , o = void 0 === i ? 400 : i
                  , a = t.createURL
                  , s = t.parseURL
                  , c = t.getLocation
                  , u = t.start
                  , l = t.dispose
                  , f = t.push
                  , p = t.cleanUrlOnDispose;
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e),
                Pe(this, "$$type", "ais.browser"),
                Pe(this, "windowTitle", void 0),
                Pe(this, "writeDelay", void 0),
                Pe(this, "_createURL", void 0),
                Pe(this, "parseURL", void 0),
                Pe(this, "getLocation", void 0),
                Pe(this, "writeTimer", void 0),
                Pe(this, "_onPopState", void 0),
                Pe(this, "inPopState", !1),
                Pe(this, "isDisposed", !1),
                Pe(this, "latestAcknowledgedHistory", 0),
                Pe(this, "_start", void 0),
                Pe(this, "_dispose", void 0),
                Pe(this, "_push", void 0),
                Pe(this, "_cleanUrlOnDispose", void 0),
                this.windowTitle = n,
                this.writeTimer = void 0,
                this.writeDelay = o,
                this._createURL = a,
                this.parseURL = s,
                this.getLocation = c,
                this._start = u,
                this._dispose = l,
                this._push = f,
                this._cleanUrlOnDispose = void 0 === p || p,
                J((function(e) {
                    var t = e.window
                      , n = r.windowTitle && r.windowTitle(r.read());
                    xe(n),
                    r.latestAcknowledgedHistory = t.history.length
                }
                ))
            }
            var t, r, n;
            return t = e,
            r = [{
                key: "read",
                value: function() {
                    return this.parseURL({
                        qsModule: we,
                        location: this.getLocation()
                    })
                }
            }, {
                key: "write",
                value: function(e) {
                    var t = this;
                    J((function(r) {
                        var n = r.window
                          , i = t.createURL(e)
                          , o = t.windowTitle && t.windowTitle(e);
                        t.writeTimer && clearTimeout(t.writeTimer),
                        t.writeTimer = setTimeout((function() {
                            xe(o),
                            t.shouldWrite(i) && (t._push ? t._push(i) : n.history.pushState(e, o || "", i),
                            t.latestAcknowledgedHistory = n.history.length),
                            t.inPopState = !1,
                            t.writeTimer = void 0
                        }
                        ), t.writeDelay)
                    }
                    ))
                }
            }, {
                key: "onUpdate",
                value: function(e) {
                    var t = this;
                    this._start && this._start((function() {
                        e(t.read())
                    }
                    )),
                    this._onPopState = function() {
                        t.writeTimer && (clearTimeout(t.writeTimer),
                        t.writeTimer = void 0),
                        t.inPopState = !0,
                        e(t.read())
                    }
                    ,
                    J((function(e) {
                        e.window.addEventListener("popstate", t._onPopState)
                    }
                    ))
                }
            }, {
                key: "createURL",
                value: function(e) {
                    return this._createURL({
                        qsModule: we,
                        routeState: e,
                        location: this.getLocation()
                    })
                }
            }, {
                key: "dispose",
                value: function() {
                    var e = this;
                    this._dispose && this._dispose(),
                    this.isDisposed = !0,
                    J((function(t) {
                        var r = t.window;
                        e._onPopState && r.removeEventListener("popstate", e._onPopState)
                    }
                    )),
                    this.writeTimer && clearTimeout(this.writeTimer),
                    this._cleanUrlOnDispose && this.write({})
                }
            }, {
                key: "start",
                value: function() {
                    this.isDisposed = !1
                }
            }, {
                key: "shouldWrite",
                value: function(e) {
                    var t = this;
                    return J((function(r) {
                        var n = r.window
                          , i = !(t.isDisposed && t.latestAcknowledgedHistory !== n.history.length);
                        return !t.inPopState && i && e !== n.location.href
                    }
                    ))
                }
            }],
            r && je(t.prototype, r),
            n && je(t, n),
            Object.defineProperty(t, "prototype", {
                writable: !1
            }),
            e
        }();
        function ke(e) {
            return ke = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            ke(e)
        }
        var Ie = ["configure"];
        function Te(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Ne(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Te(Object(r), !0).forEach((function(t) {
                    Fe(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Te(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Fe(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== ke(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== ke(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === ke(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Ce(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Ae(e) {
            e.configure;
            return Ce(e, Ie)
        }
        function De(e) {
            return De = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            De(e)
        }
        function He(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function $e(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? He(Object(r), !0).forEach((function(t) {
                    Le(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : He(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Le(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== De(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== De(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === De(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Me = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
              , t = e.router
              , r = void 0 === t ? function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
                  , t = e.createURL
                  , r = void 0 === t ? function(e) {
                    var t = e.qsModule
                      , r = e.routeState
                      , n = e.location
                      , i = n.protocol
                      , o = n.hostname
                      , a = n.port
                      , s = void 0 === a ? "" : a
                      , c = n.pathname
                      , u = n.hash
                      , l = t.stringify(r)
                      , f = "" === s ? "" : ":".concat(s);
                    return l ? "".concat(i, "//").concat(o).concat(f).concat(c, "?").concat(l).concat(u) : "".concat(i, "//").concat(o).concat(f).concat(c).concat(u)
                }
                : t
                  , n = e.parseURL
                  , i = void 0 === n ? function(e) {
                    var t = e.qsModule
                      , r = e.location;
                    return t.parse(r.search.slice(1), {
                        arrayLimit: 99
                    })
                }
                : n
                  , o = e.writeDelay
                  , a = void 0 === o ? 400 : o
                  , s = e.windowTitle
                  , c = e.getLocation
                  , u = void 0 === c ? function() {
                    return J((function(e) {
                        return e.window.location
                    }
                    ), {
                        fallback: function() {
                            throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.")
                        }
                    })
                }
                : c
                  , l = e.start
                  , f = e.dispose
                  , p = e.push
                  , h = e.cleanUrlOnDispose;
                return new Ee({
                    createURL: r,
                    parseURL: i,
                    writeDelay: a,
                    windowTitle: s,
                    getLocation: u,
                    start: l,
                    dispose: f,
                    push: p,
                    cleanUrlOnDispose: h
                })
            }() : t
              , n = e.stateMapping
              , i = void 0 === n ? {
                $$type: "ais.simple",
                stateToRoute: function(e) {
                    return Object.keys(e).reduce((function(t, r) {
                        return Ne(Ne({}, t), {}, Fe({}, r, Ae(e[r])))
                    }
                    ), {})
                },
                routeToState: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return Object.keys(e).reduce((function(t, r) {
                        return Ne(Ne({}, t), {}, Fe({}, r, Ae(e[r])))
                    }
                    ), {})
                }
            } : n
              , o = e.$$internal
              , a = void 0 !== o && o;
            return function(e) {
                var t = e.instantSearchInstance;
                t._createURL = function(e) {
                    var n = 0 === t.mainIndex.getWidgets().length ? t._initialUiState : t.mainIndex.getWidgetUiState({})
                      , o = Object.keys(e).reduce((function(t, r) {
                        return $e($e({}, t), {}, Le({}, r, e[r]))
                    }
                    ), n)
                      , a = i.stateToRoute(o);
                    return r.createURL(a)
                }
                ;
                var n = void 0
                  , o = t._initialUiState;
                return {
                    $$type: "ais.router({router:".concat(r.$$type || "__unknown__", ", stateMapping:").concat(i.$$type || "__unknown__", "})"),
                    $$internal: a,
                    onStateChange: function(e) {
                        var t = e.uiState
                          , o = i.stateToRoute(t);
                        void 0 !== n && Y(n, o) || (r.write(o),
                        n = o)
                    },
                    subscribe: function() {
                        t._initialUiState = $e($e({}, o), i.routeToState(r.read())),
                        r.onUpdate((function(e) {
                            t.mainIndex.getWidgets().length > 0 && t.setUiState(i.routeToState(e))
                        }
                        ))
                    },
                    started: function() {
                        var e;
                        null === (e = r.start) || void 0 === e || e.call(r)
                    },
                    unsubscribe: function() {
                        r.dispose()
                    }
                }
            }
        };
        function qe() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                t[r] = arguments[r];
            var n = t.map((function(e) {
                return r = (t = e).name,
                n = t.connector,
                ["https://www.algolia.com/doc/api-reference/widgets/", r, "/js/", void 0 !== n && n ? "#connector" : ""].join("");
                var t, r, n
            }
            )).join(", ");
            return function(e) {
                return [e, "See documentation: ".concat(n)].filter(Boolean).join("\n\n")
            }
        }
        function We(e) {
            return "ais.index" === e.$$type
        }
        function Ue(e) {
            return e.filter((function(e, t, r) {
                return r.indexOf(e) === t
            }
            ))
        }
        function Be(e) {
            return Be = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Be(e)
        }
        var Qe = ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"];
        function Ve(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ze(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ve(Object(r), !0).forEach((function(t) {
                    Je(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ve(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Je(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Be(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Be(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Be(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Ke(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        var Ye = function(e, t) {
            return e.setQueryParameters({
                hierarchicalFacets: t.hierarchicalFacets.reduce((function(e, t) {
                    var r = function(e, t) {
                        if (!Array.isArray(e))
                            return -1;
                        for (var r = 0; r < e.length; r++)
                            if (t(e[r]))
                                return r;
                        return -1
                    }(e, (function(e) {
                        return e.name === t.name
                    }
                    ));
                    if (-1 === r)
                        return e.concat(t);
                    var n = e.slice();
                    return n.splice(r, 1, t),
                    n
                }
                ), e.hierarchicalFacets)
            })
        }
          , Ge = function() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                t[r] = arguments[r];
            return t.reduce((function(e, t) {
                var r = function(e, t) {
                    return e.setQueryParameters({
                        hierarchicalFacetsRefinements: ze(ze({}, e.hierarchicalFacetsRefinements), t.hierarchicalFacetsRefinements)
                    })
                }(e, t)
                  , n = function(e, t) {
                    return t.tagRefinements.reduce((function(e, t) {
                        return e.addTagRefinement(t)
                    }
                    ), e)
                }(Ye(r, t), t)
                  , i = function(e, t) {
                    return e.setQueryParameters({
                        numericRefinements: ze(ze({}, e.numericRefinements), t.numericRefinements)
                    })
                }(n, t)
                  , o = function(e, t) {
                    return e.setQueryParameters({
                        disjunctiveFacetsRefinements: ze(ze({}, e.disjunctiveFacetsRefinements), t.disjunctiveFacetsRefinements)
                    })
                }(i, t)
                  , a = function(e, t) {
                    return e.setQueryParameters({
                        facetsExcludes: ze(ze({}, e.facetsExcludes), t.facetsExcludes)
                    })
                }(o, t)
                  , s = function(e, t) {
                    return e.setQueryParameters({
                        facetsRefinements: ze(ze({}, e.facetsRefinements), t.facetsRefinements)
                    })
                }(a, t)
                  , c = function(e, t) {
                    return t.disjunctiveFacets.reduce((function(e, t) {
                        return e.addDisjunctiveFacet(t)
                    }
                    ), e)
                }(s, t)
                  , u = function(e, t) {
                    var r = Ue([].concat(e.ruleContexts).concat(t.ruleContexts).filter(Boolean));
                    return r.length > 0 ? e.setQueryParameters({
                        ruleContexts: r
                    }) : e
                }(c, t)
                  , l = function(e, t) {
                    return t.facets.reduce((function(e, t) {
                        return e.addFacet(t)
                    }
                    ), e)
                }(u, t);
                return function(e, t) {
                    t.facets,
                    t.disjunctiveFacets,
                    t.facetsRefinements,
                    t.facetsExcludes,
                    t.disjunctiveFacetsRefinements,
                    t.numericRefinements,
                    t.tagRefinements,
                    t.hierarchicalFacets,
                    t.hierarchicalFacetsRefinements,
                    t.ruleContexts;
                    var r = Ke(t, Qe);
                    return e.setQueryParameters(r)
                }(l, t)
            }
            ))
        };
        var Xe = 0;
        function Ze(e) {
            return Ze = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Ze(e)
        }
        var et = ["initialSearchParameters"]
          , tt = ["initialRecommendParameters"];
        function rt(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function nt(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? rt(Object(r), !0).forEach((function(t) {
                    it(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rt(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function it(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Ze(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Ze(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Ze(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function ot(e) {
            return function(e) {
                if (Array.isArray(e))
                    return at(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return at(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return at(e, t)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function at(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function st(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        var ct = qe({
            name: "index-widget"
        });
        function ut(e, t) {
            var r = t.state
              , n = t.recommendState
              , i = t.isPageReset
              , o = t._uiState;
            r !== e.state && (e.state = r,
            e.emit("change", {
                state: e.state,
                results: e.lastResults,
                isPageReset: i,
                _uiState: o
            })),
            n !== e.recommendState && (e.recommendState = n)
        }
        function lt(e, t) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return e.reduce((function(e, r) {
                return We(r) ? e : r.getWidgetUiState || r.getWidgetState ? r.getWidgetUiState ? r.getWidgetUiState(e, t) : r.getWidgetState(e, t) : e
            }
            ), r)
        }
        function ft(e, t) {
            var r = t.initialSearchParameters
              , n = st(t, et);
            return e.reduce((function(e, t) {
                return !t.getWidgetSearchParameters || We(t) ? e : "search" === t.dependsOn && t.getWidgetParameters ? t.getWidgetParameters(e, n) : t.getWidgetSearchParameters(e, n)
            }
            ), r)
        }
        function pt(e, t) {
            var r = t.initialRecommendParameters
              , n = st(t, tt);
            return e.reduce((function(e, t) {
                return !We(t) && "recommend" === t.dependsOn && t.getWidgetParameters ? t.getWidgetParameters(e, n) : e
            }
            ), r)
        }
        function ht(e) {
            var t = e.filter(We);
            0 !== t.length && t.forEach((function(e) {
                var t = e.getHelper();
                ut(t, {
                    state: t.state.resetPage(),
                    recommendState: t.recommendState,
                    isPageReset: !0
                }),
                ht(e.getWidgets())
            }
            ))
        }
        function dt(e) {
            return e.filter(We).reduce((function(e, t) {
                return e.concat.apply(e, [{
                    indexId: t.getIndexId(),
                    results: t.getResults(),
                    helper: t.getHelper()
                }].concat(ot(dt(t.getWidgets()))))
            }
            ), [])
        }
        const mt = function(e) {
            if (void 0 === e || void 0 === e.indexName)
                throw new Error(ct("The `indexName` option is required."));
            var t = e.indexName
              , r = e.indexId
              , n = void 0 === r ? t : r
              , i = []
              , o = {}
              , a = null
              , s = null
              , c = null
              , u = null
              , l = null
              , f = !1
              , p = !1;
            return {
                $$type: "ais.index",
                $$widgetType: "ais.index",
                getIndexName: function() {
                    return t
                },
                getIndexId: function() {
                    return n
                },
                getHelper: function() {
                    return c
                },
                getResults: function() {
                    var e;
                    return null !== (e = u) && void 0 !== e && e.lastResults ? (u.lastResults._state = c.state,
                    u.lastResults) : null
                },
                getResultsForWidget: function(e) {
                    var t;
                    return "recommend" !== e.dependsOn || We(e) || void 0 === e.$$id ? this.getResults() : null !== (t = c) && void 0 !== t && t.lastRecommendResults ? c.lastRecommendResults[e.$$id] : null
                },
                getPreviousState: function() {
                    return l
                },
                getScopedResults: function() {
                    var e = this.getParent();
                    return dt(e ? e.getWidgets() : 0 === t.length ? this.getWidgets() : [this])
                },
                getParent: function() {
                    return s
                },
                createURL: function(e) {
                    return "function" == typeof e ? a._createURL(it({}, n, e(o))) : a._createURL(it({}, n, lt(i, {
                        searchParameters: e,
                        helper: c
                    })))
                },
                getWidgets: function() {
                    return i
                },
                addWidgets: function(e) {
                    var t = this;
                    if (!Array.isArray(e))
                        throw new Error(ct("The `addWidgets` method expects an array of widgets."));
                    if (e.some((function(e) {
                        return "function" != typeof e.init && "function" != typeof e.render
                    }
                    )))
                        throw new Error(ct("The widget definition expects a `render` and/or an `init` method."));
                    return e.forEach((function(e) {
                        We(e) || (a && "recommend" === e.dependsOn ? a._hasRecommendWidget = !0 : a ? a._hasSearchWidget = !0 : "recommend" === e.dependsOn ? f = !0 : p = !0,
                        function(e) {
                            "recommend" === e.dependsOn && (e.$$id = Xe++)
                        }(e))
                    }
                    )),
                    i = i.concat(e),
                    a && Boolean(e.length) && (ut(c, {
                        state: ft(i, {
                            uiState: o,
                            initialSearchParameters: c.state
                        }),
                        recommendState: pt(i, {
                            uiState: o,
                            initialRecommendParameters: c.recommendState
                        }),
                        _uiState: o
                    }),
                    e.forEach((function(e) {
                        e.getRenderState && gt({
                            renderState: e.getRenderState(a.renderState[t.getIndexId()] || {}, ve(a, t, a._initialUiState)),
                            instantSearchInstance: a,
                            parent: t
                        })
                    }
                    )),
                    e.forEach((function(e) {
                        e.init && e.init(ve(a, t, a._initialUiState))
                    }
                    )),
                    a.scheduleSearch()),
                    this
                },
                removeWidgets: function(e) {
                    var t = this;
                    if (!Array.isArray(e))
                        throw new Error(ct("The `removeWidgets` method expects an array of widgets."));
                    if (e.some((function(e) {
                        return "function" != typeof e.dispose
                    }
                    )))
                        throw new Error(ct("The widget definition expects a `dispose` method."));
                    if ((i = i.filter((function(t) {
                        return -1 === e.indexOf(t)
                    }
                    ))).forEach((function(e) {
                        We(e) || (a && "recommend" === e.dependsOn ? a._hasRecommendWidget = !0 : a ? a._hasSearchWidget = !0 : "recommend" === e.dependsOn ? f = !0 : p = !0)
                    }
                    )),
                    a && Boolean(e.length)) {
                        var r = e.reduce((function(e, r) {
                            var n = r.dispose({
                                helper: c,
                                state: e.cleanedSearchState,
                                recommendState: e.cleanedRecommendState,
                                parent: t
                            });
                            return n instanceof re.RecommendParameters ? e.cleanedRecommendState = n : n && (e.cleanedSearchState = n),
                            e
                        }
                        ), {
                            cleanedSearchState: c.state,
                            cleanedRecommendState: c.recommendState
                        })
                          , n = r.cleanedSearchState
                          , s = r.cleanedRecommendState
                          , u = a.future.preserveSharedStateOnUnmount ? ft(i, {
                            uiState: o,
                            initialSearchParameters: new re.SearchParameters({
                                index: this.getIndexName()
                            })
                        }) : ft(i, {
                            uiState: lt(i, {
                                searchParameters: n,
                                helper: c
                            }),
                            initialSearchParameters: n
                        });
                        o = lt(i, {
                            searchParameters: u,
                            helper: c
                        }),
                        c.setState(u),
                        c.recommendState = s,
                        i.length && a.scheduleSearch()
                    }
                    return this
                },
                init: function(e) {
                    var r, h = this, d = e.instantSearchInstance, m = e.parent, g = e.uiState;
                    if (null === c) {
                        a = d,
                        s = m,
                        o = g[n] || {};
                        var y = d.mainHelper
                          , v = ft(i, {
                            uiState: o,
                            initialSearchParameters: new re.SearchParameters({
                                index: t
                            })
                        })
                          , b = pt(i, {
                            uiState: o,
                            initialRecommendParameters: new re.RecommendParameters
                        });
                        (c = re({}, v.index, v)).recommendState = b,
                        c.search = function() {
                            return d.onStateChange ? (d.onStateChange({
                                uiState: d.mainIndex.getWidgetUiState({}),
                                setUiState: function(e) {
                                    return d.setUiState(e, !1)
                                }
                            }),
                            y) : y.search()
                        }
                        ,
                        c.searchWithoutTriggeringOnStateChange = function() {
                            return y.search()
                        }
                        ,
                        c.searchForFacetValues = function(e, t, r, n) {
                            var i = c.state.setQueryParameters(n);
                            return y.searchForFacetValues(e, t, r, i)
                        }
                        ,
                        u = y.derive((function() {
                            return Ge.apply(void 0, [y.state].concat(ot(function(e) {
                                for (var t = e.getParent(), r = [e.getHelper().state]; null !== t; )
                                    r = [t.getHelper().state].concat(r),
                                    t = t.getParent();
                                return r
                            }(h))))
                        }
                        ), (function() {
                            return h.getHelper().recommendState
                        }
                        ));
                        var S = null === (r = d._initialResults) || void 0 === r ? void 0 : r[this.getIndexId()];
                        if (null != S && S.results) {
                            var O = new re.SearchResults(new re.SearchParameters(S.state),S.results);
                            u.lastResults = O,
                            c.lastResults = O
                        }
                        if (null != S && S.recommendResults) {
                            var w = new re.RecommendResults(new re.RecommendParameters({
                                params: S.recommendResults.params
                            }),S.recommendResults.results);
                            u.lastRecommendResults = w,
                            c.lastRecommendResults = w
                        }
                        c.on("change", (function(e) {
                            e.isPageReset && ht(i)
                        }
                        )),
                        u.on("search", (function() {
                            d.scheduleStalledRender()
                        }
                        )),
                        u.on("result", (function(e) {
                            var t = e.results;
                            d.scheduleRender(),
                            c.lastResults = t,
                            l = null == t ? void 0 : t._state
                        }
                        )),
                        u.on("recommend:result", (function(e) {
                            var t = e.recommend;
                            d.scheduleRender(),
                            c.lastRecommendResults = t.results
                        }
                        )),
                        i.forEach((function(e) {
                            e.getRenderState && gt({
                                renderState: e.getRenderState(d.renderState[h.getIndexId()] || {}, ve(d, h, g)),
                                instantSearchInstance: d,
                                parent: h
                            })
                        }
                        )),
                        i.forEach((function(e) {
                            e.init && e.init(ve(d, h, g))
                        }
                        )),
                        c.on("change", (function(e) {
                            var t = e.state
                              , r = e._uiState;
                            o = lt(i, {
                                searchParameters: t,
                                helper: c
                            }, r || {}),
                            d.onStateChange || d.onInternalStateChange()
                        }
                        )),
                        S && d.scheduleRender(),
                        f && (d._hasRecommendWidget = !0),
                        p && (d._hasSearchWidget = !0)
                    }
                },
                render: function(e) {
                    var t, r = this, n = e.instantSearchInstance;
                    "error" === n.status && !n.mainHelper.hasPendingRequests() && l && c.setState(l);
                    var o = this.getResults() || null !== (t = u) && void 0 !== t && t.lastRecommendResults ? i : i.filter(We);
                    (o = o.filter((function(e) {
                        return !e.shouldRender || e.shouldRender({
                            instantSearchInstance: n
                        })
                    }
                    ))).forEach((function(e) {
                        e.getRenderState && gt({
                            renderState: e.getRenderState(n.renderState[r.getIndexId()] || {}, be(n, r, e)),
                            instantSearchInstance: n,
                            parent: r
                        })
                    }
                    )),
                    o.forEach((function(e) {
                        e.render && e.render(be(n, r, e))
                    }
                    ))
                },
                dispose: function() {
                    var e, t, r = this;
                    i.forEach((function(e) {
                        e.dispose && c && e.dispose({
                            helper: c,
                            state: c.state,
                            recommendState: c.recommendState,
                            parent: r
                        })
                    }
                    )),
                    a = null,
                    s = null,
                    null === (e = c) || void 0 === e || e.removeAllListeners(),
                    c = null,
                    null === (t = u) || void 0 === t || t.detach(),
                    u = null
                },
                getWidgetUiState: function(e) {
                    return i.filter(We).reduce((function(e, t) {
                        return t.getWidgetUiState(e)
                    }
                    ), nt(nt({}, e), {}, it({}, n, nt(nt({}, e[n]), o))))
                },
                getWidgetState: function(e) {
                    return this.getWidgetUiState(e)
                },
                getWidgetSearchParameters: function(e, t) {
                    var r = t.uiState;
                    return ft(i, {
                        uiState: r,
                        initialSearchParameters: e
                    })
                },
                refreshUiState: function() {
                    o = lt(i, {
                        searchParameters: this.getHelper().state,
                        helper: this.getHelper()
                    }, o)
                },
                setIndexUiState: function(e) {
                    var t = "function" == typeof e ? e(o) : e;
                    a.setUiState((function(e) {
                        return nt(nt({}, e), {}, it({}, n, t))
                    }
                    ))
                }
            }
        };
        function gt(e) {
            var t = e.renderState
              , r = e.instantSearchInstance
              , n = e.parent
              , i = n ? n.getIndexId() : r.mainIndex.getIndexId();
            r.renderState = nt(nt({}, r.renderState), {}, it({}, i, nt(nt({}, r.renderState[i]), t)))
        }
        function yt(e, t) {
            return e.toLocaleString(t)
        }
        function vt(e) {
            return vt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            vt(e)
        }
        function bt(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function St(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? bt(Object(r), !0).forEach((function(t) {
                    Ot(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bt(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Ot(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== vt(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== vt(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === vt(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function wt(e) {
            var t = e.numberLocale;
            return {
                formatNumber: function(e, r) {
                    return yt(Number(r(e)), t)
                },
                highlight: function(e, t) {
                    try {
                        return t(P(St(St({}, JSON.parse(e)), {}, {
                            hit: this
                        })))
                    } catch (e) {
                        throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }')
                    }
                },
                reverseHighlight: function(e, t) {
                    try {
                        return t(D(St(St({}, JSON.parse(e)), {}, {
                            hit: this
                        })))
                    } catch (e) {
                        throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }')
                    }
                },
                snippet: function(e, t) {
                    try {
                        return t($(St(St({}, JSON.parse(e)), {}, {
                            hit: this
                        })))
                    } catch (e) {
                        throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }')
                    }
                },
                reverseSnippet: function(e, t) {
                    try {
                        return t(M(St(St({}, JSON.parse(e)), {}, {
                            hit: this
                        })))
                    } catch (e) {
                        throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }')
                    }
                },
                insights: function(e, t) {
                    try {
                        var r = JSON.parse(e)
                          , n = r.method
                          , i = r.payload;
                        return t(B(n, St({
                            objectIDs: [this.objectID]
                        }, i)))
                    } catch (e) {
                        throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }')
                    }
                }
            }
        }
        var _t = Promise.resolve();
        function jt(e) {
            var t = null
              , r = !1
              , n = function() {
                for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
                    i[o] = arguments[o];
                null === t && (t = _t.then((function() {
                    t = null,
                    r ? r = !1 : e.apply(void 0, i)
                }
                )))
            };
            return n.wait = function() {
                if (null === t)
                    throw new Error("The deferred function should be called before calling `wait()`");
                return t
            }
            ,
            n.cancel = function() {
                null !== t && (r = !0)
            }
            ,
            n
        }
        function Pt(e) {
            return Pt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Pt(e)
        }
        function Rt(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return xt(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return xt(e, t)
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function xt(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function Et(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function kt(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Et(Object(r), !0).forEach((function(t) {
                    It(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Et(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function It(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Pt(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Pt(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Pt(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Tt(e) {
            return Object.keys(e).map((function(t) {
                return function(e) {
                    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
                        r[n - 1] = arguments[n];
                    var i = 0;
                    return e.replace(/%s/g, (function() {
                        return encodeURIComponent(r[i++])
                    }
                    ))
                }("%s=%s", t, (r = e[t],
                "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
                var r
            }
            )).join("&")
        }
        function Nt(e) {
            return Nt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Nt(e)
        }
        function Ft(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Ct(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ft(Object(r), !0).forEach((function(t) {
                    At(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ft(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function At(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Nt(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Nt(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Nt(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Dt(e, t) {
            var r = e[t.getIndexId()] || {};
            t.getHelper().setState(t.getWidgetSearchParameters(t.getHelper().state, {
                uiState: r
            })),
            t.getWidgets().filter(We).forEach((function(t) {
                return Dt(e, t)
            }
            ))
        }
        const Ht = "4.70.0";
        function $t(e) {
            return $t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            $t(e)
        }
        function Lt(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Mt(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Lt(Object(r), !0).forEach((function(t) {
                    Vt(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Lt(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function qt(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, zt(n.key), n)
            }
        }
        function Wt(e, t) {
            return Wt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t,
                e
            }
            ,
            Wt(e, t)
        }
        function Ut(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
                    ))),
                    !0
                } catch (e) {
                    return !1
                }
            }();
            return function() {
                var r, n = Qt(e);
                if (t) {
                    var i = Qt(this).constructor;
                    r = Reflect.construct(n, arguments, i)
                } else
                    r = n.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === $t(t) || "function" == typeof t))
                        return t;
                    if (void 0 !== t)
                        throw new TypeError("Derived constructors may only return object or undefined");
                    return Bt(e)
                }(this, r)
            }
        }
        function Bt(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }
        function Qt(e) {
            return Qt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e)
            }
            ,
            Qt(e)
        }
        function Vt(e, t, r) {
            return (t = zt(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function zt(e) {
            var t = function(e, t) {
                if ("object" !== $t(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== $t(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === $t(t) ? t : String(t)
        }
        var Jt = qe({
            name: "instantsearch"
        });
        function Kt() {
            return "#"
        }
        var Yt = {
            preserveSharedStateOnUnmount: !1,
            persistHierarchicalRootCount: !1
        }
          , Gt = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }),
                Object.defineProperty(e, "prototype", {
                    writable: !1
                }),
                t && Wt(e, t)
            }(o, e);
            var t, r, n, i = Ut(o);
            function o(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, o),
                Vt(Bt(t = i.call(this)), "client", void 0),
                Vt(Bt(t), "indexName", void 0),
                Vt(Bt(t), "insightsClient", void 0),
                Vt(Bt(t), "onStateChange", null),
                Vt(Bt(t), "future", void 0),
                Vt(Bt(t), "helper", void 0),
                Vt(Bt(t), "mainHelper", void 0),
                Vt(Bt(t), "mainIndex", void 0),
                Vt(Bt(t), "started", void 0),
                Vt(Bt(t), "templatesConfig", void 0),
                Vt(Bt(t), "renderState", {}),
                Vt(Bt(t), "_stalledSearchDelay", void 0),
                Vt(Bt(t), "_searchStalledTimer", void 0),
                Vt(Bt(t), "_initialUiState", void 0),
                Vt(Bt(t), "_initialResults", void 0),
                Vt(Bt(t), "_createURL", void 0),
                Vt(Bt(t), "_searchFunction", void 0),
                Vt(Bt(t), "_mainHelperSearch", void 0),
                Vt(Bt(t), "_hasSearchWidget", !1),
                Vt(Bt(t), "_hasRecommendWidget", !1),
                Vt(Bt(t), "_insights", void 0),
                Vt(Bt(t), "middleware", []),
                Vt(Bt(t), "sendEventToInsights", void 0),
                Vt(Bt(t), "status", "idle"),
                Vt(Bt(t), "error", void 0),
                Vt(Bt(t), "scheduleSearch", jt((function() {
                    t.started && t.mainHelper.search()
                }
                ))),
                Vt(Bt(t), "scheduleRender", jt((function() {
                    var e, r = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    null !== (e = t.mainHelper) && void 0 !== e && e.hasPendingRequests() || (clearTimeout(t._searchStalledTimer),
                    t._searchStalledTimer = null,
                    r && (t.status = "idle",
                    t.error = void 0)),
                    t.mainIndex.render({
                        instantSearchInstance: Bt(t)
                    }),
                    t.emit("render")
                }
                ))),
                Vt(Bt(t), "onInternalStateChange", jt((function() {
                    var e = t.mainIndex.getWidgetUiState({});
                    t.middleware.forEach((function(t) {
                        t.instance.onStateChange({
                            uiState: e
                        })
                    }
                    ))
                }
                ))),
                t.setMaxListeners(100);
                var r = e.indexName
                  , n = void 0 === r ? "" : r
                  , a = e.numberLocale
                  , s = e.initialUiState
                  , c = void 0 === s ? {} : s
                  , u = e.routing
                  , l = void 0 === u ? null : u
                  , f = e.insights
                  , p = void 0 === f ? void 0 : f
                  , h = e.searchFunction
                  , d = e.stalledSearchDelay
                  , m = void 0 === d ? 200 : d
                  , g = e.searchClient
                  , y = void 0 === g ? null : g
                  , v = e.insightsClient
                  , b = void 0 === v ? null : v
                  , S = e.onStateChange
                  , O = void 0 === S ? null : S
                  , w = e.future
                  , _ = void 0 === w ? Mt(Mt({}, Yt), e.future || {}) : w;
                if (null === y)
                    throw new Error(Jt("The `searchClient` option is required."));
                if ("function" != typeof y.search)
                    throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
                if ("function" == typeof y.addAlgoliaAgent && y.addAlgoliaAgent("instantsearch.js (".concat(Ht, ")")),
                b && "function" != typeof b)
                    throw new Error(Jt("The `insightsClient` option should be a function."));
                if (t.client = y,
                t.future = _,
                t.insightsClient = b,
                t.indexName = n,
                t.helper = null,
                t.mainHelper = null,
                t.mainIndex = mt({
                    indexName: n
                }),
                t.onStateChange = O,
                t.started = !1,
                t.templatesConfig = {
                    helpers: wt({
                        numberLocale: a
                    }),
                    compileOptions: {}
                },
                t._stalledSearchDelay = m,
                t._searchStalledTimer = null,
                t._createURL = Kt,
                t._initialUiState = c,
                t._initialResults = null,
                t._insights = p,
                h && (t._searchFunction = h),
                t.sendEventToInsights = ne,
                l) {
                    var j = "boolean" == typeof l ? {} : l;
                    j.$$internal = !0,
                    t.use(Me(j))
                }
                if (p) {
                    var P = "boolean" == typeof p ? {} : p;
                    P.$$internal = !0,
                    t.use(me(P))
                }
                return J((function(e) {
                    var t, r;
                    return (null === (t = e.window.navigator) || void 0 === t || null === (r = t.userAgent) || void 0 === r ? void 0 : r.indexOf("Algolia Crawler")) > -1
                }
                ), {
                    fallback: function() {
                        return !1
                    }
                }) && t.use(Oe({
                    $$internal: !0
                })),
                t
            }
            return t = o,
            r = [{
                key: "_isSearchStalled",
                get: function() {
                    return "stalled" === this.status
                }
            }, {
                key: "use",
                value: function() {
                    for (var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
                        r[n] = arguments[n];
                    var i = r.map((function(t) {
                        var r = Mt({
                            $$type: "__unknown__",
                            $$internal: !1,
                            subscribe: ne,
                            started: ne,
                            unsubscribe: ne,
                            onStateChange: ne
                        }, t({
                            instantSearchInstance: e
                        }));
                        return e.middleware.push({
                            creator: t,
                            instance: r
                        }),
                        r
                    }
                    ));
                    return this.started && i.forEach((function(e) {
                        e.subscribe(),
                        e.started()
                    }
                    )),
                    this
                }
            }, {
                key: "unuse",
                value: function() {
                    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                        t[r] = arguments[r];
                    return this.middleware.filter((function(e) {
                        return t.includes(e.creator)
                    }
                    )).forEach((function(e) {
                        return e.instance.unsubscribe()
                    }
                    )),
                    this.middleware = this.middleware.filter((function(e) {
                        return !t.includes(e.creator)
                    }
                    )),
                    this
                }
            }, {
                key: "EXPERIMENTAL_use",
                value: function() {
                    return this.use.apply(this, arguments)
                }
            }, {
                key: "addWidget",
                value: function(e) {
                    return this.addWidgets([e])
                }
            }, {
                key: "addWidgets",
                value: function(e) {
                    if (!Array.isArray(e))
                        throw new Error(Jt("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                    if (e.some((function(e) {
                        return "function" != typeof e.init && "function" != typeof e.render
                    }
                    )))
                        throw new Error(Jt("The widget definition expects a `render` and/or an `init` method."));
                    return this.mainIndex.addWidgets(e),
                    this
                }
            }, {
                key: "removeWidget",
                value: function(e) {
                    return this.removeWidgets([e])
                }
            }, {
                key: "removeWidgets",
                value: function(e) {
                    if (!Array.isArray(e))
                        throw new Error(Jt("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                    if (e.some((function(e) {
                        return "function" != typeof e.dispose
                    }
                    )))
                        throw new Error(Jt("The widget definition expects a `dispose` method."));
                    return this.mainIndex.removeWidgets(e),
                    this
                }
            }, {
                key: "start",
                value: function() {
                    var e = this;
                    if (this.started)
                        throw new Error(Jt("The `start` method has already been called once."));
                    var t, r, n, i = this.mainHelper || re(this.client, this.indexName, void 0, {
                        persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                    });
                    if (i.search = function() {
                        return e.status = "loading",
                        e.scheduleRender(!1),
                        e._hasSearchWidget && i.searchOnlyWithDerivedHelpers(),
                        e._hasRecommendWidget && i.recommend(),
                        i
                    }
                    ,
                    this._searchFunction) {
                        var o = {
                            search: function() {
                                return new Promise(ne)
                            }
                        };
                        this._mainHelperSearch = i.search.bind(i),
                        i.search = function() {
                            var t = e.mainIndex.getHelper()
                              , r = re(o, t.state.index, t.state);
                            return r.once("search", (function(r) {
                                var n = r.state;
                                t.overrideStateWithoutTriggeringChangeEvent(n),
                                e._mainHelperSearch()
                            }
                            )),
                            r.on("change", (function(e) {
                                var r = e.state;
                                t.setState(r)
                            }
                            )),
                            e._searchFunction(r),
                            i
                        }
                    }
                    if (i.on("error", (function(t) {
                        var r = t.error;
                        if (!(r instanceof Error)) {
                            var n = r;
                            r = Object.keys(n).reduce((function(e, t) {
                                return e[t] = n[t],
                                e
                            }
                            ), new Error(n.message))
                        }
                        r.error = r,
                        e.error = r,
                        e.status = "error",
                        e.scheduleRender(!1),
                        e.emit("error", r)
                    }
                    )),
                    this.mainHelper = i,
                    this.middleware.forEach((function(e) {
                        e.instance.subscribe()
                    }
                    )),
                    this.mainIndex.init({
                        instantSearchInstance: this,
                        parent: null,
                        uiState: this._initialUiState
                    }),
                    this._initialResults) {
                        !function(e, t) {
                            if (t && ("transporter"in e && !e._cacheHydrated || e._useCache && "function" == typeof e.addAlgoliaAgent)) {
                                var r = Object.keys(t).map((function(e) {
                                    var r = t[e]
                                      , n = r.state
                                      , i = r.requestParams
                                      , o = r.results;
                                    return o && n ? o.map((function(e) {
                                        return kt({
                                            indexName: n.index || e.index
                                        }, i || e.params ? {
                                            params: Tt(i || (t = e.params,
                                            t.split("&").reduce((function(e, t) {
                                                var r = Rt(t.split("="), 2)
                                                  , n = r[0]
                                                  , i = r[1];
                                                return e[n] = i ? decodeURIComponent(i) : "",
                                                e
                                            }
                                            ), {})))
                                        } : {});
                                        var t
                                    }
                                    )) : []
                                }
                                ))
                                  , n = Object.keys(t).reduce((function(e, r) {
                                    var n = t[r].results;
                                    return n ? e.concat(n) : e
                                }
                                ), []);
                                if ("transporter"in e && !e._cacheHydrated) {
                                    e._cacheHydrated = !0;
                                    var i = e.search;
                                    e.search = function(t) {
                                        for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
                                            n[o - 1] = arguments[o];
                                        var a = t.map((function(e) {
                                            return kt(kt({}, e), {}, {
                                                params: Tt(e.params)
                                            })
                                        }
                                        ));
                                        return e.transporter.responsesCache.get({
                                            method: "search",
                                            args: [a].concat(n)
                                        }, (function() {
                                            return i.apply(void 0, [t].concat(n))
                                        }
                                        ))
                                    }
                                    ,
                                    e.transporter.responsesCache.set({
                                        method: "search",
                                        args: r
                                    }, {
                                        results: n
                                    })
                                }
                                if (!("transporter"in e)) {
                                    var o = "/1/indexes/*/queries_body_".concat(JSON.stringify({
                                        requests: r
                                    }));
                                    e.cache = kt(kt({}, e.cache), {}, It({}, o, JSON.stringify({
                                        results: Object.keys(t).map((function(e) {
                                            return t[e].results
                                        }
                                        ))
                                    })))
                                }
                            }
                        }(this.client, this._initialResults),
                        t = this.mainHelper,
                        r = this._initialResults,
                        n = Object.keys(r).reduce((function(e, t) {
                            var n = r[t];
                            return n.recommendResults ? Ct(Ct({}, e), n.recommendResults.results) : e
                        }
                        ), {}),
                        t._recommendCache = n;
                        var a = this.scheduleSearch;
                        this.scheduleSearch = jt(ne),
                        jt((function() {
                            e.scheduleSearch = a
                        }
                        ))()
                    } else
                        this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
                    this.helper = this.mainIndex.getHelper(),
                    this.started = !0,
                    this.middleware.forEach((function(e) {
                        e.instance.started()
                    }
                    )),
                    void 0 === this._insights && i.derivedHelpers[0].once("result", (function() {
                        e.mainIndex.getScopedResults().some((function(e) {
                            var t = e.results;
                            return null == t ? void 0 : t._automaticInsights
                        }
                        )) && e.use(me({
                            $$internal: !0,
                            $$automatic: !0
                        }))
                    }
                    ))
                }
            }, {
                key: "dispose",
                value: function() {
                    var e;
                    this.scheduleSearch.cancel(),
                    this.scheduleRender.cancel(),
                    clearTimeout(this._searchStalledTimer),
                    this.removeWidgets(this.mainIndex.getWidgets()),
                    this.mainIndex.dispose(),
                    this.started = !1,
                    this.removeAllListeners(),
                    null === (e = this.mainHelper) || void 0 === e || e.removeAllListeners(),
                    this.mainHelper = null,
                    this.helper = null,
                    this.middleware.forEach((function(e) {
                        e.instance.unsubscribe()
                    }
                    ))
                }
            }, {
                key: "scheduleStalledRender",
                value: function() {
                    var e = this;
                    this._searchStalledTimer || (this._searchStalledTimer = setTimeout((function() {
                        e.status = "stalled",
                        e.scheduleRender()
                    }
                    ), this._stalledSearchDelay))
                }
            }, {
                key: "setUiState",
                value: function(e) {
                    var t = this
                      , r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    if (!this.mainHelper)
                        throw new Error(Jt("The `start` method needs to be called before `setUiState`."));
                    this.mainIndex.refreshUiState();
                    var n = "function" == typeof e ? e(this.mainIndex.getWidgetUiState({})) : e;
                    this.onStateChange && r ? this.onStateChange({
                        uiState: n,
                        setUiState: function(e) {
                            Dt("function" == typeof e ? e(n) : e, t.mainIndex),
                            t.scheduleSearch(),
                            t.onInternalStateChange()
                        }
                    }) : (Dt(n, this.mainIndex),
                    this.scheduleSearch(),
                    this.onInternalStateChange())
                }
            }, {
                key: "getUiState",
                value: function() {
                    return this.started && this.mainIndex.refreshUiState(),
                    this.mainIndex.getWidgetUiState({})
                }
            }, {
                key: "createURL",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    if (!this.started)
                        throw new Error(Jt("The `start` method needs to be called before `createURL`."));
                    return this._createURL(e)
                }
            }, {
                key: "refresh",
                value: function() {
                    if (!this.mainHelper)
                        throw new Error(Jt("The `start` method needs to be called before `refresh`."));
                    this.mainHelper.clearCache().search()
                }
            }],
            r && qt(t.prototype, r),
            n && qt(t, n),
            Object.defineProperty(t, "prototype", {
                writable: !1
            }),
            o
        }(te);
        const Xt = Gt;
        var Zt = function(e, t) {
            return e
        };
        var er = function(e) {
            return new Xt(e)
        };
        er.version = Ht,
        er.createInfiniteHitsSessionStorageCache = Zt((function() {
            return {
                read: function(e) {
                    var t = e.state
                      , r = J((function(e) {
                        return e.window.sessionStorage
                    }
                    ));
                    if (!r)
                        return null;
                    try {
                        var n = JSON.parse(r.getItem(ee));
                        return n && Y(n.state, Z(t)) ? n.hits : null
                    } catch (e) {
                        if (e instanceof SyntaxError)
                            try {
                                r.removeItem(ee)
                            } catch (e) {}
                        return null
                    }
                },
                write: function(e) {
                    var t = e.state
                      , r = e.hits
                      , n = J((function(e) {
                        return e.window.sessionStorage
                    }
                    ));
                    if (n)
                        try {
                            n.setItem(ee, JSON.stringify({
                                state: Z(t),
                                hits: r
                            }))
                        } catch (e) {}
                }
            }
        }
        )),
        er.highlight = Zt(P),
        er.reverseHighlight = Zt(D),
        er.snippet = Zt($),
        er.reverseSnippet = Zt(M),
        er.insights = B,
        er.getInsightsAnonymousUserToken = function() {
            return z()
        }
        ,
        Object.defineProperty(er, "widgets", {
            get: function() {
                throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'")
            }
        }),
        Object.defineProperty(er, "connectors", {
            get: function() {
                throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'")
            }
        });
        const tr = er;
        function rr() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                t[r] = arguments[r];
            return t.reduce((function(e, t) {
                return Array.isArray(t) ? e.concat(t) : e.concat([t])
            }
            ), []).filter(Boolean).join(" ")
        }
        var nr, ir, or, ar, sr, cr, ur, lr = {}, fr = [], pr = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, hr = Array.isArray;
        function dr(e, t) {
            for (var r in t)
                e[r] = t[r];
            return e
        }
        function mr(e) {
            var t = e.parentNode;
            t && t.removeChild(e)
        }
        function gr(e, t, r) {
            var n, i, o, a = {};
            for (o in t)
                "key" == o ? n = t[o] : "ref" == o ? i = t[o] : a[o] = t[o];
            if (arguments.length > 2 && (a.children = arguments.length > 3 ? nr.call(arguments, 2) : r),
            "function" == typeof e && null != e.defaultProps)
                for (o in e.defaultProps)
                    void 0 === a[o] && (a[o] = e.defaultProps[o]);
            return yr(e, a, n, i, null)
        }
        function yr(e, t, r, n, i) {
            var o = {
                type: e,
                props: t,
                key: r,
                ref: n,
                __k: null,
                __: null,
                __b: 0,
                __e: null,
                __d: void 0,
                __c: null,
                __h: null,
                constructor: void 0,
                __v: null == i ? ++or : i
            };
            return null == i && null != ir.vnode && ir.vnode(o),
            o
        }
        function vr(e) {
            return e.children
        }
        function br(e, t) {
            this.props = e,
            this.context = t
        }
        function Sr(e, t) {
            if (null == t)
                return e.__ ? Sr(e.__, e.__.__k.indexOf(e) + 1) : null;
            for (var r; t < e.__k.length; t++)
                if (null != (r = e.__k[t]) && null != r.__e)
                    return r.__e;
            return "function" == typeof e.type ? Sr(e) : null
        }
        function Or(e) {
            var t, r;
            if (null != (e = e.__) && null != e.__c) {
                for (e.__e = e.__c.base = null,
                t = 0; t < e.__k.length; t++)
                    if (null != (r = e.__k[t]) && null != r.__e) {
                        e.__e = e.__c.base = r.__e;
                        break
                    }
                return Or(e)
            }
        }
        function wr(e) {
            (!e.__d && (e.__d = !0) && ar.push(e) && !_r.__r++ || sr !== ir.debounceRendering) && ((sr = ir.debounceRendering) || cr)(_r)
        }
        function _r() {
            var e, t, r, n, i, o, a, s, c;
            for (ar.sort(ur); e = ar.shift(); )
                e.__d && (t = ar.length,
                n = void 0,
                i = void 0,
                o = void 0,
                s = (a = (r = e).__v).__e,
                (c = r.__P) && (n = [],
                i = [],
                (o = dr({}, a)).__v = a.__v + 1,
                Nr(c, a, o, r.__n, void 0 !== c.ownerSVGElement, null != a.__h ? [s] : null, n, null == s ? Sr(a) : s, a.__h, i),
                Fr(n, a, i),
                a.__e != s && Or(a)),
                ar.length > t && ar.sort(ur));
            _r.__r = 0
        }
        function jr(e, t, r, n, i, o, a, s, c, u, l) {
            var f, p, h, d, m, g, y, v, b, S = 0, O = n && n.__k || fr, w = O.length, _ = w, j = t.length;
            for (r.__k = [],
            f = 0; f < j; f++)
                null != (d = r.__k[f] = null == (d = t[f]) || "boolean" == typeof d || "function" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? yr(null, d, null, null, d) : hr(d) ? yr(vr, {
                    children: d
                }, null, null, null) : d.__b > 0 ? yr(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d) ? (d.__ = r,
                d.__b = r.__b + 1,
                -1 === (v = xr(d, O, y = f + S, _)) ? h = lr : (h = O[v] || lr,
                O[v] = void 0,
                _--),
                Nr(e, d, h, i, o, a, s, c, u, l),
                m = d.__e,
                (p = d.ref) && h.ref != p && (h.ref && Ar(h.ref, null, d),
                l.push(p, d.__c || m, d)),
                null != m && (null == g && (g = m),
                (b = h === lr || null === h.__v) ? -1 == v && S-- : v !== y && (v === y + 1 ? S++ : v > y ? _ > j - y ? S += v - y : S-- : S = v < y && v == y - 1 ? v - y : 0),
                y = f + S,
                "function" != typeof d.type || v === y && h.__k !== d.__k ? "function" == typeof d.type || v === y && !b ? void 0 !== d.__d ? (c = d.__d,
                d.__d = void 0) : c = m.nextSibling : c = Rr(e, m, c) : c = Pr(d, c, e),
                "function" == typeof r.type && (r.__d = c))) : (h = O[f]) && null == h.key && h.__e && (h.__e == c && (c = Sr(h)),
                Dr(h, h, !1),
                O[f] = null);
            for (r.__e = g,
            f = w; f--; )
                null != O[f] && ("function" == typeof r.type && null != O[f].__e && O[f].__e == r.__d && (r.__d = O[f].__e.nextSibling),
                Dr(O[f], O[f]))
        }
        function Pr(e, t, r) {
            for (var n, i = e.__k, o = 0; i && o < i.length; o++)
                (n = i[o]) && (n.__ = e,
                t = "function" == typeof n.type ? Pr(n, t, r) : Rr(r, n.__e, t));
            return t
        }
        function Rr(e, t, r) {
            return null == r || r.parentNode !== e ? e.insertBefore(t, null) : t == r && null != t.parentNode || e.insertBefore(t, r),
            t.nextSibling
        }
        function xr(e, t, r, n) {
            var i = e.key
              , o = e.type
              , a = r - 1
              , s = r + 1
              , c = t[r];
            if (null === c || c && i == c.key && o === c.type)
                return r;
            if (n > (null != c ? 1 : 0))
                for (; a >= 0 || s < t.length; ) {
                    if (a >= 0) {
                        if ((c = t[a]) && i == c.key && o === c.type)
                            return a;
                        a--
                    }
                    if (s < t.length) {
                        if ((c = t[s]) && i == c.key && o === c.type)
                            return s;
                        s++
                    }
                }
            return -1
        }
        function Er(e, t, r) {
            "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || pr.test(t) ? r : r + "px"
        }
        function kr(e, t, r, n, i) {
            var o;
            e: if ("style" === t)
                if ("string" == typeof r)
                    e.style.cssText = r;
                else {
                    if ("string" == typeof n && (e.style.cssText = n = ""),
                    n)
                        for (t in n)
                            r && t in r || Er(e.style, t, "");
                    if (r)
                        for (t in r)
                            n && r[t] === n[t] || Er(e.style, t, r[t])
                }
            else if ("o" === t[0] && "n" === t[1])
                o = t !== (t = t.replace(/(PointerCapture)$|Capture$/, "$1")),
                t = t.toLowerCase()in e ? t.toLowerCase().slice(2) : t.slice(2),
                e.l || (e.l = {}),
                e.l[t + o] = r,
                r ? n || e.addEventListener(t, o ? Tr : Ir, o) : e.removeEventListener(t, o ? Tr : Ir, o);
            else if ("dangerouslySetInnerHTML" !== t) {
                if (i)
                    t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
                else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && t in e)
                    try {
                        e[t] = null == r ? "" : r;
                        break e
                    } catch (e) {}
                "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r))
            }
        }
        function Ir(e) {
            return this.l[e.type + !1](ir.event ? ir.event(e) : e)
        }
        function Tr(e) {
            return this.l[e.type + !0](ir.event ? ir.event(e) : e)
        }
        function Nr(e, t, r, n, i, o, a, s, c, u) {
            var l, f, p, h, d, m, g, y, v, b, S, O, w, _, j, P = t.type;
            if (void 0 !== t.constructor)
                return null;
            null != r.__h && (c = r.__h,
            s = t.__e = r.__e,
            t.__h = null,
            o = [s]),
            (l = ir.__b) && l(t);
            e: if ("function" == typeof P)
                try {
                    if (y = t.props,
                    v = (l = P.contextType) && n[l.__c],
                    b = l ? v ? v.props.value : l.__ : n,
                    r.__c ? g = (f = t.__c = r.__c).__ = f.__E : ("prototype"in P && P.prototype.render ? t.__c = f = new P(y,b) : (t.__c = f = new br(y,b),
                    f.constructor = P,
                    f.render = Hr),
                    v && v.sub(f),
                    f.props = y,
                    f.state || (f.state = {}),
                    f.context = b,
                    f.__n = n,
                    p = f.__d = !0,
                    f.__h = [],
                    f._sb = []),
                    null == f.__s && (f.__s = f.state),
                    null != P.getDerivedStateFromProps && (f.__s == f.state && (f.__s = dr({}, f.__s)),
                    dr(f.__s, P.getDerivedStateFromProps(y, f.__s))),
                    h = f.props,
                    d = f.state,
                    f.__v = t,
                    p)
                        null == P.getDerivedStateFromProps && null != f.componentWillMount && f.componentWillMount(),
                        null != f.componentDidMount && f.__h.push(f.componentDidMount);
                    else {
                        if (null == P.getDerivedStateFromProps && y !== h && null != f.componentWillReceiveProps && f.componentWillReceiveProps(y, b),
                        !f.__e && (null != f.shouldComponentUpdate && !1 === f.shouldComponentUpdate(y, f.__s, b) || t.__v === r.__v)) {
                            for (t.__v !== r.__v && (f.props = y,
                            f.state = f.__s,
                            f.__d = !1),
                            t.__e = r.__e,
                            t.__k = r.__k,
                            t.__k.forEach((function(e) {
                                e && (e.__ = t)
                            }
                            )),
                            S = 0; S < f._sb.length; S++)
                                f.__h.push(f._sb[S]);
                            f._sb = [],
                            f.__h.length && a.push(f);
                            break e
                        }
                        null != f.componentWillUpdate && f.componentWillUpdate(y, f.__s, b),
                        null != f.componentDidUpdate && f.__h.push((function() {
                            f.componentDidUpdate(h, d, m)
                        }
                        ))
                    }
                    if (f.context = b,
                    f.props = y,
                    f.__P = e,
                    f.__e = !1,
                    O = ir.__r,
                    w = 0,
                    "prototype"in P && P.prototype.render) {
                        for (f.state = f.__s,
                        f.__d = !1,
                        O && O(t),
                        l = f.render(f.props, f.state, f.context),
                        _ = 0; _ < f._sb.length; _++)
                            f.__h.push(f._sb[_]);
                        f._sb = []
                    } else
                        do {
                            f.__d = !1,
                            O && O(t),
                            l = f.render(f.props, f.state, f.context),
                            f.state = f.__s
                        } while (f.__d && ++w < 25);
                    f.state = f.__s,
                    null != f.getChildContext && (n = dr(dr({}, n), f.getChildContext())),
                    p || null == f.getSnapshotBeforeUpdate || (m = f.getSnapshotBeforeUpdate(h, d)),
                    jr(e, hr(j = null != l && l.type === vr && null == l.key ? l.props.children : l) ? j : [j], t, r, n, i, o, a, s, c, u),
                    f.base = t.__e,
                    t.__h = null,
                    f.__h.length && a.push(f),
                    g && (f.__E = f.__ = null)
                } catch (e) {
                    t.__v = null,
                    (c || null != o) && (t.__e = s,
                    t.__h = !!c,
                    o[o.indexOf(s)] = null),
                    ir.__e(e, t, r)
                }
            else
                null == o && t.__v === r.__v ? (t.__k = r.__k,
                t.__e = r.__e) : t.__e = Cr(r.__e, t, r, n, i, o, a, c, u);
            (l = ir.diffed) && l(t)
        }
        function Fr(e, t, r) {
            for (var n = 0; n < r.length; n++)
                Ar(r[n], r[++n], r[++n]);
            ir.__c && ir.__c(t, e),
            e.some((function(t) {
                try {
                    e = t.__h,
                    t.__h = [],
                    e.some((function(e) {
                        e.call(t)
                    }
                    ))
                } catch (e) {
                    ir.__e(e, t.__v)
                }
            }
            ))
        }
        function Cr(e, t, r, n, i, o, a, s, c) {
            var u, l, f, p = r.props, h = t.props, d = t.type, m = 0;
            if ("svg" === d && (i = !0),
            null != o)
                for (; m < o.length; m++)
                    if ((u = o[m]) && "setAttribute"in u == !!d && (d ? u.localName === d : 3 === u.nodeType)) {
                        e = u,
                        o[m] = null;
                        break
                    }
            if (null == e) {
                if (null === d)
                    return document.createTextNode(h);
                e = i ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, h.is && h),
                o = null,
                s = !1
            }
            if (null === d)
                p === h || s && e.data === h || (e.data = h);
            else {
                if (o = o && nr.call(e.childNodes),
                l = (p = r.props || lr).dangerouslySetInnerHTML,
                f = h.dangerouslySetInnerHTML,
                !s) {
                    if (null != o)
                        for (p = {},
                        m = 0; m < e.attributes.length; m++)
                            p[e.attributes[m].name] = e.attributes[m].value;
                    (f || l) && (f && (l && f.__html == l.__html || f.__html === e.innerHTML) || (e.innerHTML = f && f.__html || ""))
                }
                if (function(e, t, r, n, i) {
                    var o;
                    for (o in r)
                        "children" === o || "key" === o || o in t || kr(e, o, null, r[o], n);
                    for (o in t)
                        i && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || r[o] === t[o] || kr(e, o, t[o], r[o], n)
                }(e, h, p, i, s),
                f)
                    t.__k = [];
                else if (jr(e, hr(m = t.props.children) ? m : [m], t, r, n, i && "foreignObject" !== d, o, a, o ? o[0] : r.__k && Sr(r, 0), s, c),
                null != o)
                    for (m = o.length; m--; )
                        null != o[m] && mr(o[m]);
                s || ("value"in h && void 0 !== (m = h.value) && (m !== e.value || "progress" === d && !m || "option" === d && m !== p.value) && kr(e, "value", m, p.value, !1),
                "checked"in h && void 0 !== (m = h.checked) && m !== e.checked && kr(e, "checked", m, p.checked, !1))
            }
            return e
        }
        function Ar(e, t, r) {
            try {
                "function" == typeof e ? e(t) : e.current = t
            } catch (e) {
                ir.__e(e, r)
            }
        }
        function Dr(e, t, r) {
            var n, i;
            if (ir.unmount && ir.unmount(e),
            (n = e.ref) && (n.current && n.current !== e.__e || Ar(n, null, t)),
            null != (n = e.__c)) {
                if (n.componentWillUnmount)
                    try {
                        n.componentWillUnmount()
                    } catch (e) {
                        ir.__e(e, t)
                    }
                n.base = n.__P = null,
                e.__c = void 0
            }
            if (n = e.__k)
                for (i = 0; i < n.length; i++)
                    n[i] && Dr(n[i], t, r || "function" != typeof e.type);
            r || null == e.__e || mr(e.__e),
            e.__ = e.__e = e.__d = void 0
        }
        function Hr(e, t, r) {
            return this.constructor(e, r)
        }
        function $r(e, t, r) {
            var n, i, o, a;
            ir.__ && ir.__(e, t),
            i = (n = "function" == typeof r) ? null : r && r.__k || t.__k,
            o = [],
            a = [],
            Nr(t, e = (!n && r || t).__k = gr(vr, null, [e]), i || lr, lr, void 0 !== t.ownerSVGElement, !n && r ? [r] : i ? null : t.firstChild ? nr.call(t.childNodes) : null, o, !n && r ? r : i ? i.__e : t.firstChild, n, a),
            Fr(o, e, a)
        }
        function Lr(e) {
            return function(e) {
                if (Array.isArray(e))
                    return Mr(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return Mr(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return Mr(e, t)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function Mr(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function qr(e) {
            var t = e.start
              , r = void 0 === t ? 0 : t
              , n = e.end
              , i = e.step
              , o = void 0 === i ? 1 : i
              , a = 0 === o ? 1 : o
              , s = Math.round((n - r) / a);
            return Lr(Array(s)).map((function(e, t) {
                return r + t * a
            }
            ))
        }
        function Wr(e) {
            return Wr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Wr(e)
        }
        function Ur(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Br(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ur(Object(r), !0).forEach((function(t) {
                    Qr(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ur(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Qr(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Wr(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Wr(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Wr(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        nr = fr.slice,
        ir = {
            __e: function(e, t, r, n) {
                for (var i, o, a; t = t.__; )
                    if ((i = t.__c) && !i.__)
                        try {
                            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(e)),
                            a = i.__d),
                            null != i.componentDidCatch && (i.componentDidCatch(e, n || {}),
                            a = i.__d),
                            a)
                                return i.__E = i
                        } catch (t) {
                            e = t
                        }
                throw e
            }
        },
        or = 0,
        br.prototype.setState = function(e, t) {
            var r;
            r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = dr({}, this.state),
            "function" == typeof e && (e = e(dr({}, r), this.props)),
            e && dr(r, e),
            null != e && this.__v && (t && this._sb.push(t),
            wr(this))
        }
        ,
        br.prototype.forceUpdate = function(e) {
            this.__v && (this.__e = !0,
            e && this.__h.push(e),
            wr(this))
        }
        ,
        br.prototype.render = vr,
        ar = [],
        cr = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout,
        ur = function(e, t) {
            return e.__v.__b - t.__v.__b
        }
        ,
        _r.__r = 0;
        const Vr = function(e) {
            var t = e.style
              , r = e.children
              , n = Math.round(parseFloat(t.left))
              , i = [0, 50, 100].includes(n)
              , o = r
              , a = Math.round(100 * parseInt(o, 10)) / 100;
            return gr("div", {
                style: Br(Br({}, t), {}, {
                    marginLeft: 100 === n ? "-2px" : 0
                }),
                className: rr("rheostat-marker", "rheostat-marker-horizontal", i && "rheostat-marker-large")
            }, i && gr("div", {
                className: "rheostat-value"
            }, a))
        };
        function zr(e) {
            return zr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            zr(e)
        }
        function Jr(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, en(n.key), n)
            }
        }
        function Kr(e, t) {
            return Kr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t,
                e
            }
            ,
            Kr(e, t)
        }
        function Yr(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
                    ))),
                    !0
                } catch (e) {
                    return !1
                }
            }();
            return function() {
                var r, n = Xr(e);
                if (t) {
                    var i = Xr(this).constructor;
                    r = Reflect.construct(n, arguments, i)
                } else
                    r = n.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === zr(t) || "function" == typeof t))
                        return t;
                    if (void 0 !== t)
                        throw new TypeError("Derived constructors may only return object or undefined");
                    return Gr(e)
                }(this, r)
            }
        }
        function Gr(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }
        function Xr(e) {
            return Xr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e)
            }
            ,
            Xr(e)
        }
        function Zr(e, t, r) {
            return (t = en(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function en(e) {
            var t = function(e, t) {
                if ("object" !== zr(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== zr(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === zr(t) ? t : String(t)
        }
        function tn() {
            return tn = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            tn.apply(this, arguments)
        }
        var rn = 40
          , nn = 35
          , on = 27
          , an = 36
          , sn = 37
          , cn = 34
          , un = 33
          , ln = 39
          , fn = 38
          , pn = 100;
        function hn(e, t, r) {
            return (e - t) / (r - t) * 100
        }
        function dn(e, t, r) {
            var n = e / 100;
            return 0 === e ? t : 100 === e ? r : Math.round((r - t) * n + t)
        }
        function mn(e) {
            return ["rheostat", "vertical" === e.orientation ? "rheostat-vertical" : "rheostat-horizontal"].concat(e.className.split(" ")).join(" ")
        }
        function gn(e) {
            return Number(e.currentTarget.getAttribute("data-handle-key"))
        }
        function yn(e) {
            e.stopPropagation(),
            e.preventDefault()
        }
        var vn = gr("div", {
            className: "rheostat-background"
        })
          , bn = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }),
                Object.defineProperty(e, "prototype", {
                    writable: !1
                }),
                t && Kr(e, t)
            }(o, e);
            var t, r, n, i = Yr(o);
            function o() {
                var e;
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, o);
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
                    r[n] = arguments[n];
                return Zr(Gr(e = i.call.apply(i, [this].concat(r))), "x", [0, 0].map((function(e) {
                    return e
                }
                ))),
                Zr(Gr(e), "state", {
                    className: mn(e.props),
                    handlePos: e.props.values.map((function(t) {
                        return hn(t, e.props.min, e.props.max)
                    }
                    )),
                    handleDimensions: 0,
                    mousePos: null,
                    sliderBox: {},
                    slidingIndex: null,
                    values: e.props.values
                }),
                Zr(Gr(e), "rheostat", {
                    current: null
                }),
                Zr(Gr(e), "componentWillReceiveProps", (function(t) {
                    var r = e.props
                      , n = r.className
                      , i = r.disabled
                      , o = r.min
                      , a = r.max
                      , s = r.orientation
                      , c = e.state
                      , u = c.values
                      , l = c.slidingIndex
                      , f = t.min !== o || t.max !== a
                      , p = u.length !== t.values.length || u.some((function(e, r) {
                        return t.values[r] !== e
                    }
                    ))
                      , h = t.className !== n || t.orientation !== s
                      , d = t.disabled && !i;
                    h && e.setState({
                        className: mn(t)
                    }),
                    (f || p) && e.updateNewValues(t),
                    d && null !== l && e.endSlide()
                }
                )),
                Zr(Gr(e), "getPublicState", (function() {
                    var t = e.props
                      , r = t.min;
                    return {
                        max: t.max,
                        min: r,
                        values: e.state.values
                    }
                }
                )),
                Zr(Gr(e), "getSliderBoundingBox", (function() {
                    var t = e.rheostat.current
                      , r = t.getBoundingClientRect();
                    return {
                        height: r.height || t.clientHeight,
                        left: r.left,
                        top: r.top,
                        width: r.width || t.clientWidth
                    }
                }
                )),
                Zr(Gr(e), "getProgressStyle", (function(t) {
                    var r = e.state.handlePos
                      , n = r[t];
                    if (0 === t)
                        return "vertical" === e.props.orientation ? {
                            height: "".concat(n, "%"),
                            top: 0
                        } : {
                            left: 0,
                            width: "".concat(n, "%")
                        };
                    var i = r[t - 1]
                      , o = n - i;
                    return "vertical" === e.props.orientation ? {
                        height: "".concat(o, "%"),
                        top: "".concat(i, "%")
                    } : {
                        left: "".concat(i, "%"),
                        width: "".concat(o, "%")
                    }
                }
                )),
                Zr(Gr(e), "getMinValue", (function(t) {
                    return e.state.values[t - 1] ? Math.max(e.props.min, e.state.values[t - 1]) : e.props.min
                }
                )),
                Zr(Gr(e), "getMaxValue", (function(t) {
                    return e.state.values[t + 1] ? Math.min(e.props.max, e.state.values[t + 1]) : e.props.max
                }
                )),
                Zr(Gr(e), "getHandleDimensions", (function(t, r) {
                    var n = t.currentTarget || null;
                    return n ? "vertical" === e.props.orientation ? n.clientHeight / r.height * pn / 2 : n.clientWidth / r.width * pn / 2 : 0
                }
                )),
                Zr(Gr(e), "getClosestSnapPoint", (function(t) {
                    return e.props.snapPoints.length ? e.props.snapPoints.reduce((function(e, r) {
                        return Math.abs(e - t) < Math.abs(r - t) ? e : r
                    }
                    )) : t
                }
                )),
                Zr(Gr(e), "getSnapPosition", (function(t) {
                    if (!e.props.snap)
                        return t;
                    var r = e.props
                      , n = r.max
                      , i = r.min
                      , o = dn(t, i, n);
                    return hn(e.getClosestSnapPoint(o), i, n)
                }
                )),
                Zr(Gr(e), "getNextPositionForKey", (function(t, r) {
                    var n, i = e.state, o = i.handlePos, a = i.values, s = e.props, c = s.max, u = s.min, l = s.snapPoints, f = e.props.snap, p = a[t], h = o[t], d = h, m = 1;
                    c >= 100 ? h = Math.round(h) : m = 100 / (c - u);
                    var g = null;
                    f && (g = l.indexOf(e.getClosestSnapPoint(a[t])));
                    var y = (Zr(n = {}, sn, (function(e) {
                        return -1 * e
                    }
                    )),
                    Zr(n, ln, (function(e) {
                        return e
                    }
                    )),
                    Zr(n, fn, (function(e) {
                        return e
                    }
                    )),
                    Zr(n, rn, (function(e) {
                        return -1 * e
                    }
                    )),
                    Zr(n, cn, (function(e) {
                        return e > 1 ? -e : -10 * e
                    }
                    )),
                    Zr(n, un, (function(e) {
                        return e > 1 ? e : 10 * e
                    }
                    )),
                    n);
                    if (Object.prototype.hasOwnProperty.call(y, r))
                        h += y[r](m),
                        f && g && (h > d ? g < l.length - 1 && (p = l[g + 1]) : g > 0 && (p = l[g - 1]));
                    else if (r === an)
                        h = 0,
                        f && (p = l[0]);
                    else {
                        if (r !== nn)
                            return null;
                        h = pn,
                        f && (p = l[l.length - 1])
                    }
                    return f ? hn(p, u, c) : h
                }
                )),
                Zr(Gr(e), "getNextState", (function(t, r) {
                    var n = e.state.handlePos
                      , i = e.props
                      , o = i.max
                      , a = i.min
                      , s = e.validatePosition(t, r)
                      , c = n.map((function(e, r) {
                        return r === t ? s : e
                    }
                    ));
                    return {
                        handlePos: c,
                        values: c.map((function(e) {
                            return dn(e, a, o)
                        }
                        ))
                    }
                }
                )),
                Zr(Gr(e), "getClosestHandle", (function(t) {
                    var r = e.state.handlePos;
                    return r.reduce((function(e, n, i) {
                        return Math.abs(r[i] - t) < Math.abs(r[e] - t) ? i : e
                    }
                    ), 0)
                }
                )),
                Zr(Gr(e), "setStartSlide", (function(t, r, n) {
                    var i = e.getSliderBoundingBox();
                    e.setState({
                        handleDimensions: e.getHandleDimensions(t, i),
                        mousePos: {
                            x: r,
                            y: n
                        },
                        sliderBox: i,
                        slidingIndex: gn(t)
                    })
                }
                )),
                Zr(Gr(e), "startMouseSlide", (function(t) {
                    e.setStartSlide(t, t.clientX, t.clientY),
                    document.addEventListener("mousemove", e.handleMouseSlide, !1),
                    document.addEventListener("mouseup", e.endSlide, !1),
                    yn(t)
                }
                )),
                Zr(Gr(e), "startTouchSlide", (function(t) {
                    if (!(t.changedTouches.length > 1)) {
                        var r = t.changedTouches[0];
                        e.setStartSlide(t, r.clientX, r.clientY),
                        document.addEventListener("touchmove", e.handleTouchSlide, !1),
                        document.addEventListener("touchend", e.endSlide, !1),
                        e.props.onSliderDragStart && e.props.onSliderDragStart(),
                        yn(t)
                    }
                }
                )),
                Zr(Gr(e), "handleMouseSlide", (function(t) {
                    null !== e.state.slidingIndex && (e.handleSlide(t.clientX, t.clientY),
                    yn(t))
                }
                )),
                Zr(Gr(e), "handleTouchSlide", (function(t) {
                    if (null !== e.state.slidingIndex)
                        if (t.changedTouches.length > 1)
                            e.endSlide();
                        else {
                            var r = t.changedTouches[0];
                            e.handleSlide(r.clientX, r.clientY),
                            yn(t)
                        }
                }
                )),
                Zr(Gr(e), "handleSlide", (function(t, r) {
                    var n = e.state
                      , i = n.slidingIndex
                      , o = n.sliderBox
                      , a = "vertical" === e.props.orientation ? (r - o.top) / o.height * pn : (t - o.left) / o.width * pn;
                    e.slideTo(i, a),
                    e.canMove(i, a) && (e.setState({
                        mousePos: {
                            x: t,
                            y: r
                        }
                    }),
                    e.props.onSliderDragMove && e.props.onSliderDragMove())
                }
                )),
                Zr(Gr(e), "endSlide", (function() {
                    var t = e.state.slidingIndex;
                    if (e.setState({
                        slidingIndex: null
                    }),
                    document.removeEventListener("mouseup", e.endSlide, !1),
                    document.removeEventListener("touchend", e.endSlide, !1),
                    document.removeEventListener("touchmove", e.handleTouchSlide, !1),
                    document.removeEventListener("mousemove", e.handleMouseSlide, !1),
                    e.props.onSliderDragEnd && e.props.onSliderDragEnd(),
                    e.props.snap) {
                        var r = e.getSnapPosition(e.state.handlePos[t]);
                        e.slideTo(t, r, (function() {
                            return e.fireChangeEvent()
                        }
                        ))
                    } else
                        e.fireChangeEvent()
                }
                )),
                Zr(Gr(e), "handleClick", (function(t) {
                    if (!t.target.getAttribute("data-handle-key")) {
                        var r = e.getSliderBoundingBox()
                          , n = ("vertical" === e.props.orientation ? (t.clientY - r.top) / r.height : (t.clientX - r.left) / r.width) * pn
                          , i = e.getClosestHandle(n)
                          , o = e.getSnapPosition(n);
                        e.slideTo(i, o, (function() {
                            return e.fireChangeEvent()
                        }
                        )),
                        e.props.onClick && e.props.onClick()
                    }
                }
                )),
                Zr(Gr(e), "handleKeydown", (function(t) {
                    var r = gn(t);
                    if (t.keyCode !== on) {
                        var n = e.getNextPositionForKey(r, t.keyCode);
                        null !== n && (e.canMove(r, n) && (e.slideTo(r, n, (function() {
                            return e.fireChangeEvent()
                        }
                        )),
                        e.props.onKeyPress && e.props.onKeyPress()),
                        yn(t))
                    } else
                        t.currentTarget.blur()
                }
                )),
                Zr(Gr(e), "validatePosition", (function(t, r) {
                    var n = e.state
                      , i = n.handlePos
                      , o = n.handleDimensions;
                    return Math.max(Math.min(r, void 0 !== i[t + 1] ? i[t + 1] - o : pn), void 0 !== i[t - 1] ? i[t - 1] + o : 0)
                }
                )),
                Zr(Gr(e), "validateValues", (function(t, r) {
                    var n = r || e.props
                      , i = n.max
                      , o = n.min;
                    return t.map((function(e, t, r) {
                        var n = Math.max(Math.min(e, i), o);
                        return r.length && n < r[t - 1] ? r[t - 1] : n
                    }
                    ))
                }
                )),
                Zr(Gr(e), "canMove", (function(t, r) {
                    var n = e.state
                      , i = n.handlePos
                      , o = n.handleDimensions;
                    return !(r < 0) && (!(r > pn) && (!(r > (void 0 !== i[t + 1] ? i[t + 1] - o : 1 / 0)) && !(r < (void 0 !== i[t - 1] ? i[t - 1] + o : -1 / 0))))
                }
                )),
                Zr(Gr(e), "fireChangeEvent", (function() {
                    var t = e.props.onChange;
                    t && t(e.getPublicState())
                }
                )),
                Zr(Gr(e), "slideTo", (function(t, r, n) {
                    var i = e.getNextState(t, r);
                    e.setState(i, (function() {
                        var t = e.props.onValuesUpdated;
                        t && t(e.getPublicState()),
                        n && n()
                    }
                    ))
                }
                )),
                Zr(Gr(e), "updateNewValues", (function(t) {
                    if (null === e.state.slidingIndex) {
                        var r = t.max
                          , n = t.min
                          , i = t.values
                          , o = e.validateValues(i, t);
                        e.setState({
                            handlePos: o.map((function(e) {
                                return hn(e, n, r)
                            }
                            )),
                            values: o
                        }, (function() {
                            return e.fireChangeEvent()
                        }
                        ))
                    }
                }
                )),
                Zr(Gr(e), "render", (function() {
                    var t = e.props
                      , r = t.children
                      , n = t.disabled
                      , i = t.handle
                      , o = t.max
                      , a = t.min
                      , s = t.orientation
                      , c = t.pitComponent
                      , u = t.pitPoints
                      , l = t.progressBar
                      , f = e.state
                      , p = f.className
                      , h = f.handlePos
                      , d = f.values;
                    return gr("div", {
                        className: p,
                        ref: e.rheostat,
                        onClick: n ? void 0 : e.handleClick,
                        style: {
                            position: "relative"
                        }
                    }, vn, h.map((function(t, r) {
                        var o = "vertical" === s ? {
                            top: "".concat(t, "%"),
                            position: "absolute"
                        } : {
                            left: "".concat(t, "%"),
                            position: "absolute"
                        };
                        return gr(i, {
                            "aria-valuemax": e.getMaxValue(r),
                            "aria-valuemin": e.getMinValue(r),
                            "aria-valuenow": d[r],
                            "aria-disabled": n,
                            "data-handle-key": r,
                            className: "rheostat-handle",
                            key: "handle-".concat(r),
                            onClick: yn,
                            onKeyDown: n ? void 0 : e.handleKeydown,
                            onMouseDown: n ? void 0 : e.startMouseSlide,
                            onTouchStart: n ? void 0 : e.startTouchSlide,
                            role: "slider",
                            style: o,
                            tabIndex: 0
                        })
                    }
                    )), h.map((function(t, r, n) {
                        return 0 === r && n.length > 1 ? null : gr(l, {
                            className: "rheostat-progress",
                            key: "progress-bar-".concat(r),
                            style: e.getProgressStyle(r)
                        })
                    }
                    )), c && u.map((function(e) {
                        var t = hn(e, a, o)
                          , r = "vertical" === s ? {
                            top: "".concat(t, "%"),
                            position: "absolute"
                        } : {
                            left: "".concat(t, "%"),
                            position: "absolute"
                        };
                        return gr(c, {
                            key: "pit-".concat(e),
                            style: r
                        }, e)
                    }
                    )), r)
                }
                )),
                e
            }
            return t = o,
            r && Jr(t.prototype, r),
            n && Jr(t, n),
            Object.defineProperty(t, "prototype", {
                writable: !1
            }),
            t
        }(br);
        Zr(bn, "defaultProps", {
            className: "",
            children: null,
            disabled: !1,
            handle: function(e) {
                return gr("button", tn({}, e, {
                    type: "button"
                }))
            },
            max: pn,
            min: 0,
            onClick: null,
            onChange: null,
            onKeyPress: null,
            onSliderDragEnd: null,
            onSliderDragMove: null,
            onSliderDragStart: null,
            onValuesUpdated: null,
            orientation: "horizontal",
            pitComponent: null,
            pitPoints: [],
            progressBar: "div",
            snap: !1,
            snapPoints: [],
            values: [0]
        });
        const Sn = bn;
        function On(e) {
            return function(e) {
                if (Array.isArray(e))
                    return wn(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return wn(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return wn(e, t)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function wn(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function _n() {
            return _n = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            _n.apply(this, arguments)
        }
        function jn(e) {
            return jn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            jn(e)
        }
        function Pn(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, Tn(n.key), n)
            }
        }
        function Rn(e, t) {
            return Rn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t,
                e
            }
            ,
            Rn(e, t)
        }
        function xn(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
                    ))),
                    !0
                } catch (e) {
                    return !1
                }
            }();
            return function() {
                var r, n = kn(e);
                if (t) {
                    var i = kn(this).constructor;
                    r = Reflect.construct(n, arguments, i)
                } else
                    r = n.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === jn(t) || "function" == typeof t))
                        return t;
                    if (void 0 !== t)
                        throw new TypeError("Derived constructors may only return object or undefined");
                    return En(e)
                }(this, r)
            }
        }
        function En(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }
        function kn(e) {
            return kn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e)
            }
            ,
            kn(e)
        }
        function In(e, t, r) {
            return (t = Tn(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Tn(e) {
            var t = function(e, t) {
                if ("object" !== jn(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== jn(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === jn(t) ? t : String(t)
        }
        var Nn = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }),
                Object.defineProperty(e, "prototype", {
                    writable: !1
                }),
                t && Rn(e, t)
            }(o, e);
            var t, r, n, i = xn(o);
            function o() {
                var e;
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, o);
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
                    r[n] = arguments[n];
                return In(En(e = i.call.apply(i, [this].concat(r))), "handleChange", (function(t) {
                    var r = t.values;
                    e.isDisabled || e.props.refine(r)
                }
                )),
                In(En(e), "createHandleComponent", (function(e) {
                    return function(t) {
                        var r = Math.round(100 * parseFloat(t["aria-valuenow"])) / 100
                          , n = "object" === jn(e) && e.format ? e.format(r) : r;
                        return gr("div", _n({}, t, {
                            className: rr(t.className, 0 === t["data-handle-key"] && "rheostat-handle-lower", 1 === t["data-handle-key"] && "rheostat-handle-upper"),
                            "aria-label": 0 === t["data-handle-key"] ? "Minimum Filter Handle" : "Maximum Filter Handle"
                        }), e && gr("div", {
                            className: "rheostat-tooltip"
                        }, n))
                    }
                }
                )),
                e
            }
            return t = o,
            r = [{
                key: "isDisabled",
                get: function() {
                    return this.props.min >= this.props.max
                }
            }, {
                key: "computeDefaultPitPoints",
                value: function(e) {
                    var t = e.min
                      , r = e.max
                      , n = (r - t) / 34;
                    return [t].concat(On(qr({
                        end: 33
                    }).map((function(e) {
                        return t + n * (e + 1)
                    }
                    ))), [r])
                }
            }, {
                key: "computeSnapPoints",
                value: function(e) {
                    var t = e.min
                      , r = e.max
                      , n = e.step;
                    if (n)
                        return [].concat(On(qr({
                            start: t,
                            end: r,
                            step: n
                        })), [r])
                }
            }, {
                key: "render",
                value: function() {
                    var e = this.props
                      , t = e.tooltips
                      , r = e.step
                      , n = e.pips
                      , i = e.values
                      , o = e.cssClasses
                      , a = this.isDisabled ? {
                        min: this.props.min,
                        max: this.props.max + .001
                    } : this.props
                      , s = a.min
                      , c = a.max
                      , u = this.computeSnapPoints({
                        min: s,
                        max: c,
                        step: r
                    })
                      , l = !1 === n ? [] : this.computeDefaultPitPoints({
                        min: s,
                        max: c
                    });
                    return gr("div", {
                        className: rr(o.root, this.isDisabled && o.disabledRoot)
                    }, gr(Sn, {
                        handle: this.createHandleComponent(t),
                        onChange: this.handleChange,
                        min: s,
                        max: c,
                        pitComponent: Vr,
                        pitPoints: l,
                        snap: !0,
                        snapPoints: u,
                        values: this.isDisabled ? [s, c] : i,
                        disabled: this.isDisabled
                    }))
                }
            }],
            r && Pn(t.prototype, r),
            n && Pn(t, n),
            Object.defineProperty(t, "prototype", {
                writable: !1
            }),
            o
        }(br);
        const Fn = Nn;
        function Cn(e, t) {
            if (void 0 === e || "function" != typeof e)
                throw new Error("The render function is not valid (received type ".concat((r = e,
                Object.prototype.toString.call(r).slice(8, -1)), ").\n\n").concat(t));
            var r
        }
        function An(e) {
            return "number" == typeof e && isFinite(e)
        }
        function Dn(e) {
            return Dn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Dn(e)
        }
        function Hn(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function $n(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Hn(Object(r), !0).forEach((function(t) {
                    Ln(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hn(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Ln(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Dn(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Dn(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Dn(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Mn(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return qn(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return qn(e, t)
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function qn(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        var Wn = qe({
            name: "range-input",
            connector: !0
        }, {
            name: "range-slider",
            connector: !0
        });
        function Un(e) {
            var t = e.min
              , r = e.max
              , n = e.precision
              , i = Math.pow(10, n);
            return {
                min: t ? Math.floor(t * i) / i : t,
                max: r ? Math.ceil(r * i) / i : r
            }
        }
        const Bn = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, Wn()),
            function(r) {
                var n = r || {}
                  , i = n.attribute
                  , o = void 0 === i ? "" : i
                  , a = n.min
                  , s = n.max
                  , c = n.precision
                  , u = void 0 === c ? 0 : c;
                if (!o)
                    throw new Error(Wn("The `attribute` option is required."));
                if (An(a) && An(s) && a > s)
                    throw new Error(Wn("The `max` option can't be lower than `min`."));
                var l = {
                    from: function(e) {
                        return e.toLocaleString()
                    },
                    to: function(e) {
                        return function(e) {
                            return Number(Number(e).toFixed(u))
                        }(e).toLocaleString()
                    }
                }
                  , f = function(e) {
                    return function() {
                        1 !== arguments.length || e.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0])
                    }
                };
                function p(e, t) {
                    return function() {
                        var r = Mn(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [void 0, void 0], 2)
                          , n = r[0]
                          , i = r[1]
                          , c = function(e, t, r, n) {
                            var i, c, l = e.state, f = t.min, p = t.max, h = Mn(l.getNumericRefinement(o, ">=") || [], 1)[0], d = Mn(l.getNumericRefinement(o, "<=") || [], 1)[0], m = void 0 === r || "" === r, g = void 0 === n || "" === n, y = Un({
                                min: m ? void 0 : parseFloat(r),
                                max: g ? void 0 : parseFloat(n),
                                precision: u
                            }), v = y.min, b = y.max;
                            i = An(a) || f !== v ? An(a) && m ? a : v : void 0,
                            c = An(s) || p !== b ? An(s) && g ? s : b : void 0;
                            var S = void 0 === i
                              , O = An(f) && f <= i
                              , w = S || An(i) && (!An(f) || O)
                              , _ = void 0 === c
                              , j = An(c) && p >= c
                              , P = _ || An(c) && (!An(p) || j);
                            return (h !== i || d !== c) && w && P ? (l = l.removeNumericRefinement(o),
                            An(i) && (l = l.addNumericRefinement(o, ">=", i)),
                            An(c) && (l = l.addNumericRefinement(o, "<=", c)),
                            l.resetPage()) : null
                        }(e, t, n, i);
                        c && e.setState(c).search()
                    }
                }
                return {
                    $$type: "ais.range",
                    init: function(t) {
                        e($n($n({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !0)
                    },
                    render: function(t) {
                        e($n($n({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !1)
                    },
                    getRenderState: function(e, t) {
                        return $n($n({}, e), {}, {
                            range: $n($n({}, e.range), {}, Ln({}, o, this.getWidgetRenderState(t)))
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.results
                          , n = e.helper
                          , i = e.instantSearchInstance
                          , c = ie(t && t.disjunctiveFacets || [], (function(e) {
                            return e.name === o
                        }
                        ))
                          , h = function(e) {
                            return Un({
                                min: An(a) ? a : An(e.min) ? e.min : 0,
                                max: An(s) ? s : An(e.max) ? e.max : 0,
                                precision: u
                            })
                        }(c && c.stats || {
                            min: void 0,
                            max: void 0
                        })
                          , d = function(e) {
                            var t = Mn(e.getNumericRefinement(o, ">=") || [], 1)[0]
                              , r = Mn(e.getNumericRefinement(o, "<=") || [], 1)[0];
                            return [An(t) ? t : -1 / 0, An(r) ? r : 1 / 0]
                        }(n);
                        return {
                            refine: p(n, t ? h : {
                                min: void 0,
                                max: void 0
                            }),
                            canRefine: h.min !== h.max,
                            format: l,
                            range: h,
                            sendEvent: f(i),
                            widgetParams: $n($n({}, r), {}, {
                                precision: u
                            }),
                            start: d
                        }
                    },
                    dispose: function(e) {
                        var r = e.state;
                        return t(),
                        r.removeDisjunctiveFacet(o).removeNumericRefinement(o)
                    },
                    getWidgetUiState: function(e, t) {
                        var r = t.searchParameters.getNumericRefinements(o)
                          , n = r[">="]
                          , i = void 0 === n ? [] : n
                          , a = r["<="]
                          , s = void 0 === a ? [] : a;
                        return 0 === i.length && 0 === s.length ? e : $n($n({}, e), {}, {
                            range: $n($n({}, e.range), {}, Ln({}, o, "".concat(i, ":").concat(s)))
                        })
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var r = t.uiState
                          , n = e.addDisjunctiveFacet(o).setQueryParameters({
                            numericRefinements: $n($n({}, e.numericRefinements), {}, Ln({}, o, {}))
                        });
                        An(a) && (n = n.addNumericRefinement(o, ">=", a)),
                        An(s) && (n = n.addNumericRefinement(o, "<=", s));
                        var i = r.range && r.range[o];
                        if (!i || -1 === i.indexOf(":"))
                            return n;
                        var c = Mn(i.split(":").map(parseFloat), 2)
                          , u = c[0]
                          , l = c[1];
                        return An(u) && (!An(a) || a < u) && (n = (n = n.removeNumericRefinement(o, ">=")).addNumericRefinement(o, ">=", u)),
                        An(l) && (!An(s) || l < s) && (n = (n = n.removeNumericRefinement(o, "<=")).addNumericRefinement(o, "<=", l)),
                        n
                    }
                }
            }
        };
        function Qn(e) {
            var t, r = "string" == typeof e, n = r ? document.querySelector(e) : e;
            if (!((t = n)instanceof HTMLElement || Boolean(t) && t.nodeType > 0)) {
                var i = "Container must be `string` or `HTMLElement`.";
                throw r && (i += " Unable to find ".concat(e)),
                new Error(i)
            }
            return n
        }
        function Vn(e) {
            return Vn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Vn(e)
        }
        function zn(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Jn(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? zn(Object(r), !0).forEach((function(t) {
                    Kn(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zn(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Kn(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Vn(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Vn(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Vn(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Yn(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return Gn(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return Gn(e, t)
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function Gn(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        var Xn = qe({
            name: "range-slider"
        })
          , Zn = n("RangeSlider");
        const ei = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.attribute
              , i = t.min
              , o = t.max
              , a = t.cssClasses
              , s = void 0 === a ? {} : a
              , c = t.step
              , u = t.pips
              , l = void 0 === u || u
              , f = t.precision
              , p = void 0 === f ? 0 : f
              , h = t.tooltips
              , d = void 0 === h || h;
            if (!r)
                throw new Error(Xn("The `container` option is required."));
            var m = Qn(r)
              , g = {
                root: rr(Zn(), s.root),
                disabledRoot: rr(Zn({
                    modifierName: "disabled"
                }), s.disabledRoot)
            }
              , y = function(e) {
                var t = e.containerNode
                  , r = e.cssClasses
                  , n = e.pips
                  , i = e.step
                  , o = e.tooltips;
                return function(e, a) {
                    var s = e.refine
                      , c = e.range
                      , u = e.start;
                    if (!a) {
                        var l = c.min
                          , f = c.max
                          , p = Yn(u, 2)
                          , h = p[0]
                          , d = p[1]
                          , m = h === -1 / 0 ? l : h
                          , g = d === 1 / 0 ? f : d;
                        $r(gr(Fn, {
                            cssClasses: r,
                            refine: s,
                            min: l,
                            max: f,
                            values: [m > f ? f : m, g < l ? l : g],
                            tooltips: o,
                            step: i,
                            pips: n
                        }), t)
                    }
                }
            }({
                containerNode: m,
                step: c,
                pips: l,
                tooltips: d,
                cssClasses: g
            });
            return Jn(Jn({}, Bn(y, (function() {
                return $r(null, m)
            }
            ))({
                attribute: n,
                min: i,
                max: o,
                precision: p
            })), {}, {
                $$type: "ais.rangeSlider",
                $$widgetType: "ais.rangeSlider"
            })
        };
        function ti(e) {
            return 1 === e.button || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey
        }
        var ri = r(485)
          , ni = function(e, t, r, n) {
            var i;
            t[0] = 0;
            for (var o = 1; o < t.length; o++) {
                var a = t[o++]
                  , s = t[o] ? (t[0] |= a ? 1 : 2,
                r[t[o++]]) : t[++o];
                3 === a ? n[0] = s : 4 === a ? n[1] = Object.assign(n[1] || {}, s) : 5 === a ? (n[1] = n[1] || {})[t[++o]] = s : 6 === a ? n[1][t[++o]] += s + "" : a ? (i = e.apply(s, ni(e, s, r, ["", null])),
                n.push(i),
                s[0] ? t[0] |= 2 : (t[o - 2] = 0,
                t[o] = i)) : n.push(s)
            }
            return n
        }
          , ii = new Map;
        var oi = function(e) {
            var t = ii.get(this);
            return t || (t = new Map,
            ii.set(this, t)),
            (t = ni(this, t.get(e) || (t.set(e, t = function(e) {
                for (var t, r, n = 1, i = "", o = "", a = [0], s = function(e) {
                    1 === n && (e || (i = i.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? a.push(0, e, i) : 3 === n && (e || i) ? (a.push(3, e, i),
                    n = 2) : 2 === n && "..." === i && e ? a.push(4, e, 0) : 2 === n && i && !e ? a.push(5, 0, !0, i) : n >= 5 && ((i || !e && 5 === n) && (a.push(n, 0, i, r),
                    n = 6),
                    e && (a.push(n, e, 0, r),
                    n = 6)),
                    i = ""
                }, c = 0; c < e.length; c++) {
                    c && (1 === n && s(),
                    s(c));
                    for (var u = 0; u < e[c].length; u++)
                        t = e[c][u],
                        1 === n ? "<" === t ? (s(),
                        a = [a],
                        n = 3) : i += t : 4 === n ? "--" === i && ">" === t ? (n = 1,
                        i = "") : i = t + i[0] : o ? t === o ? o = "" : i += t : '"' === t || "'" === t ? o = t : ">" === t ? (s(),
                        n = 1) : n && ("=" === t ? (n = 5,
                        r = i,
                        i = "") : "/" === t && (n < 5 || ">" === e[c][u + 1]) ? (s(),
                        3 === n && (a = a[0]),
                        n = a,
                        (a = a[0]).push(2, 0, n),
                        n = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (s(),
                        n = 2) : i += t),
                        3 === n && "!--" === i && (n = 4,
                        a = a[0])
                }
                return s(),
                a
            }(e)),
            t), arguments, [])).length > 1 ? t : t[0]
        }
        .bind(gr);
        function ai() {
            return ai = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        ({}).hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            ai.apply(null, arguments)
        }
        function si(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r = {};
                for (var n in e)
                    if ({}.hasOwnProperty.call(e, n)) {
                        if (t.indexOf(n) >= 0)
                            continue;
                        r[n] = e[n]
                    }
                return r
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        var ci = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];
        var ui, li, fi, pi, hi = (li = (ui = {
            createElement: gr,
            Fragment: vr
        }).createElement,
        fi = ui.Fragment,
        pi = function(e) {
            var t = e.createElement;
            return function(e) {
                var r = e.classNames
                  , n = e.children
                  , i = e.highlightedTagName
                  , o = e.isHighlighted
                  , a = e.nonHighlightedTagName;
                return t(o ? i : a, {
                    className: o ? r.highlighted : r.nonHighlighted
                }, n)
            }
        }({
            createElement: li,
            Fragment: fi
        }),
        function(e) {
            var t = e.parts
              , r = e.highlightedTagName
              , n = void 0 === r ? "mark" : r
              , i = e.nonHighlightedTagName
              , o = void 0 === i ? "span" : i
              , a = e.separator
              , s = void 0 === a ? ", " : a
              , c = e.className
              , u = e.classNames
              , l = void 0 === u ? {} : u
              , f = si(e, ci);
            return li("span", ai({}, f, {
                className: rr(l.root, c)
            }), t.map((function(e, r) {
                var i = r === t.length - 1;
                return li(fi, {
                    key: r
                }, e.map((function(e, t) {
                    return li(pi, {
                        key: t,
                        classNames: l,
                        highlightedTagName: n,
                        nonHighlightedTagName: o,
                        isHighlighted: e.isHighlighted
                    }, e.value)
                }
                )), !i && li("span", {
                    className: l.separator
                }, s))
            }
            )))
        }
        ), di = ["classNames"];
        function mi() {
            return mi = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            mi.apply(this, arguments)
        }
        function gi(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function yi(e) {
            var t = e.classNames
              , r = void 0 === t ? {} : t
              , n = gi(e, di);
            return gr(hi, mi({
                classNames: {
                    root: rr("ais-Highlight", r.root),
                    highlighted: rr("ais-Highlight-highlighted", r.highlighted),
                    nonHighlighted: rr("ais-Highlight-nonHighlighted", r.nonHighlighted),
                    separator: rr("ais-Highlight-separator", r.separator)
                }
            }, n))
        }
        function vi(e) {
            return Array.isArray(e) ? e : [e]
        }
        var bi = ["hit", "attribute", "cssClasses"];
        function Si() {
            return Si = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Si.apply(this, arguments)
        }
        function Oi(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function wi(e) {
            var t = e.hit
              , r = e.attribute
              , n = e.cssClasses
              , o = Oi(e, bi)
              , a = vi(i(t._highlightResult, r) || []).map((function(e) {
                return C(f(e.value || ""))
            }
            ));
            return gr(yi, Si({}, o, {
                parts: a,
                classNames: n
            }))
        }
        var _i = ["classNames"];
        function ji() {
            return ji = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            ji.apply(this, arguments)
        }
        function Pi(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Ri(e) {
            var t = e.classNames
              , r = void 0 === t ? {} : t
              , n = Pi(e, _i);
            return gr(hi, ji({
                classNames: {
                    root: rr("ais-ReverseHighlight", r.root),
                    highlighted: rr("ais-ReverseHighlight-highlighted", r.highlighted),
                    nonHighlighted: rr("ais-ReverseHighlight-nonHighlighted", r.nonHighlighted),
                    separator: rr("ais-ReverseHighlight-separator", r.separator)
                }
            }, n))
        }
        function xi(e) {
            return xi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            xi(e)
        }
        var Ei = ["hit", "attribute", "cssClasses"]
          , ki = ["isHighlighted"];
        function Ii() {
            return Ii = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Ii.apply(this, arguments)
        }
        function Ti(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Ni(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ti(Object(r), !0).forEach((function(t) {
                    Fi(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ti(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Fi(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== xi(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== xi(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === xi(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Ci(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Ai(e) {
            var t = e.hit
              , r = e.attribute
              , n = e.cssClasses
              , o = Ci(e, Ei)
              , a = vi(i(t._highlightResult, r) || []).map((function(e) {
                return C(f(e.value || "")).map((function(e) {
                    var t = e.isHighlighted;
                    return Ni(Ni({}, Ci(e, ki)), {}, {
                        isHighlighted: !t
                    })
                }
                ))
            }
            ));
            return gr(Ri, Ii({}, o, {
                parts: a,
                classNames: n
            }))
        }
        var Di = ["classNames"];
        function Hi() {
            return Hi = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Hi.apply(this, arguments)
        }
        function $i(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Li(e) {
            var t = e.classNames
              , r = void 0 === t ? {} : t
              , n = $i(e, Di);
            return gr(hi, Hi({
                classNames: {
                    root: rr("ais-Snippet", r.root),
                    highlighted: rr("ais-Snippet-highlighted", r.highlighted),
                    nonHighlighted: rr("ais-Snippet-nonHighlighted", r.nonHighlighted),
                    separator: rr("ais-Snippet-separator", r.separator)
                }
            }, n))
        }
        var Mi = ["hit", "attribute", "cssClasses"];
        function qi() {
            return qi = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            qi.apply(this, arguments)
        }
        function Wi(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Ui(e) {
            var t = e.hit
              , r = e.attribute
              , n = e.cssClasses
              , o = Wi(e, Mi)
              , a = vi(i(t._snippetResult, r) || []).map((function(e) {
                return C(f(e.value || ""))
            }
            ));
            return gr(Li, qi({}, o, {
                parts: a,
                classNames: n
            }))
        }
        var Bi = ["classNames"];
        function Qi() {
            return Qi = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Qi.apply(this, arguments)
        }
        function Vi(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function zi(e) {
            var t = e.classNames
              , r = void 0 === t ? {} : t
              , n = Vi(e, Bi);
            return gr(hi, Qi({
                classNames: {
                    root: rr("ais-ReverseSnippet", r.root),
                    highlighted: rr("ais-ReverseSnippet-highlighted", r.highlighted),
                    nonHighlighted: rr("ais-ReverseSnippet-nonHighlighted", r.nonHighlighted),
                    separator: rr("ais-ReverseSnippet-separator", r.separator)
                }
            }, n))
        }
        function Ji(e) {
            return Ji = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Ji(e)
        }
        var Ki = ["hit", "attribute", "cssClasses"]
          , Yi = ["isHighlighted"];
        function Gi() {
            return Gi = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Gi.apply(this, arguments)
        }
        function Xi(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Zi(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Xi(Object(r), !0).forEach((function(t) {
                    eo(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xi(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function eo(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Ji(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Ji(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Ji(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function to(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function ro(e) {
            var t = e.hit
              , r = e.attribute
              , n = e.cssClasses
              , o = to(e, Ki)
              , a = vi(i(t._snippetResult, r) || []).map((function(e) {
                return C(f(e.value || "")).map((function(e) {
                    var t = e.isHighlighted;
                    return Zi(Zi({}, to(e, Yi)), {}, {
                        isHighlighted: !t
                    })
                }
                ))
            }
            ));
            return gr(zi, Gi({}, o, {
                parts: a,
                classNames: n
            }))
        }
        function no(e) {
            return no = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            no(e)
        }
        function io(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function oo(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? io(Object(r), !0).forEach((function(t) {
                    ao(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : io(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function ao(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== no(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== no(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === no(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function so(e) {
            var t = e.templates
              , r = e.templateKey
              , n = e.compileOptions
              , i = e.helpers
              , o = e.data
              , a = e.bindEvent
              , s = e.sendEvent
              , c = t[r];
            if ("string" != typeof c && "function" != typeof c)
                throw new Error("Template must be 'string' or 'function', was '".concat(no(c), "' (key: ").concat(r, ")"));
            if ("function" == typeof c) {
                var u = a || {};
                return u.html = oi,
                u.sendEvent = s,
                u.components = {
                    Highlight: wi,
                    ReverseHighlight: Ai,
                    Snippet: Ui,
                    ReverseSnippet: ro
                },
                c(o, u)
            }
            var l = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
                  , t = arguments.length > 1 ? arguments[1] : void 0
                  , r = arguments.length > 2 ? arguments[2] : void 0;
                return Object.keys(e).reduce((function(n, i) {
                    return oo(oo({}, n), {}, ao({}, i, (function() {
                        var n = this;
                        return function(o) {
                            return e[i].call(r, o, (function(e) {
                                return ri.compile(e, t).render(n)
                            }
                            ))
                        }
                    }
                    )))
                }
                ), {})
            }(i, n, o);
            return ri.compile(c, n).render(oo(oo({}, o), {}, {
                helpers: l
            })).replace(/[ \n\r\t\f\xA0]+/g, (function(e) {
                return e.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ")
            }
            )).trim()
        }
        function co() {
            return co = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            co.apply(this, arguments)
        }
        function uo(e) {
            return uo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            uo(e)
        }
        function lo(e) {
            return function(e) {
                if (Array.isArray(e))
                    return fo(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return fo(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return fo(e, t)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function fo(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function po(e, t) {
            if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function")
        }
        function ho(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, wo(n.key), n)
            }
        }
        function mo(e, t, r) {
            return t && ho(e.prototype, t),
            r && ho(e, r),
            Object.defineProperty(e, "prototype", {
                writable: !1
            }),
            e
        }
        function go(e, t) {
            if ("function" != typeof t && null !== t)
                throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            Object.defineProperty(e, "prototype", {
                writable: !1
            }),
            t && yo(e, t)
        }
        function yo(e, t) {
            return yo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t,
                e
            }
            ,
            yo(e, t)
        }
        function vo(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
                    ))),
                    !0
                } catch (e) {
                    return !1
                }
            }();
            return function() {
                var r, n = So(e);
                if (t) {
                    var i = So(this).constructor;
                    r = Reflect.construct(n, arguments, i)
                } else
                    r = n.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === uo(t) || "function" == typeof t))
                        return t;
                    if (void 0 !== t)
                        throw new TypeError("Derived constructors may only return object or undefined");
                    return bo(e)
                }(this, r)
            }
        }
        function bo(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }
        function So(e) {
            return So = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e)
            }
            ,
            So(e)
        }
        function Oo(e, t, r) {
            return (t = wo(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function wo(e) {
            var t = function(e, t) {
                if ("object" !== uo(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== uo(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === uo(t) ? t : String(t)
        }
        var _o = function(e) {
            go(r, e);
            var t = vo(r);
            function r() {
                var e;
                po(this, r);
                for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
                    i[o] = arguments[o];
                return Oo(bo(e = t.call.apply(t, [this].concat(i))), "ref", {
                    current: null
                }),
                Oo(bo(e), "nodes", []),
                e
            }
            return mo(r, [{
                key: "componentDidMount",
                value: function() {
                    var e = new DocumentFragment
                      , t = document.createElement("div");
                    t.innerHTML = this.props.content,
                    this.nodes = lo(t.childNodes),
                    this.nodes.forEach((function(t) {
                        return e.appendChild(t)
                    }
                    )),
                    this.ref.current.replaceWith(e)
                }
            }, {
                key: "componentWillUnmount",
                value: function() {
                    this.nodes.forEach((function(e) {
                        e instanceof Element ? e.outerHTML = "" : e.nodeValue = ""
                    }
                    )),
                    this.nodes[0].nodeValue && (this.nodes[0].nodeValue = "")
                }
            }, {
                key: "render",
                value: function() {
                    return gr("div", {
                        ref: this.ref
                    })
                }
            }]),
            r
        }(br)
          , jo = function(e) {
            go(r, e);
            var t = vo(r);
            function r() {
                return po(this, r),
                t.apply(this, arguments)
            }
            return mo(r, [{
                key: "shouldComponentUpdate",
                value: function(e) {
                    return !Y(this.props.data, e.data) || this.props.templateKey !== e.templateKey || !Y(this.props.rootProps, e.rootProps)
                }
            }, {
                key: "render",
                value: function() {
                    var e = "fragment" === this.props.rootTagName ? vr : this.props.rootTagName
                      , t = this.props.useCustomCompileOptions[this.props.templateKey] ? this.props.templatesConfig.compileOptions : {}
                      , r = so({
                        templates: this.props.templates,
                        templateKey: this.props.templateKey,
                        compileOptions: t,
                        helpers: this.props.templatesConfig.helpers,
                        data: this.props.data,
                        bindEvent: this.props.bindEvent,
                        sendEvent: this.props.sendEvent
                    });
                    return null === r ? null : "object" === uo(r) ? gr(e, this.props.rootProps, r) : e === vr ? gr(_o, {
                        content: r,
                        key: r
                    }) : gr(e, co({}, this.props.rootProps, {
                        dangerouslySetInnerHTML: {
                            __html: r
                        }
                    }))
                }
            }]),
            r
        }(br);
        Oo(jo, "defaultProps", {
            data: {},
            rootTagName: "div",
            useCustomCompileOptions: {},
            templates: {},
            templatesConfig: {}
        });
        const Po = jo;
        function Ro(e) {
            return Ro = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Ro(e)
        }
        function xo(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, Fo(n.key), n)
            }
        }
        function Eo(e, t) {
            return Eo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t,
                e
            }
            ,
            Eo(e, t)
        }
        function ko(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
                    ))),
                    !0
                } catch (e) {
                    return !1
                }
            }();
            return function() {
                var r, n = To(e);
                if (t) {
                    var i = To(this).constructor;
                    r = Reflect.construct(n, arguments, i)
                } else
                    r = n.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === Ro(t) || "function" == typeof t))
                        return t;
                    if (void 0 !== t)
                        throw new TypeError("Derived constructors may only return object or undefined");
                    return Io(e)
                }(this, r)
            }
        }
        function Io(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }
        function To(e) {
            return To = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e)
            }
            ,
            To(e)
        }
        function No(e, t, r) {
            return (t = Fo(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Fo(e) {
            var t = function(e, t) {
                if ("object" !== Ro(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== Ro(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === Ro(t) ? t : String(t)
        }
        var Co = {
            query: "",
            showSubmit: !0,
            showReset: !0,
            showLoadingIndicator: !0,
            autofocus: !1,
            searchAsYouType: !0,
            ignoreCompositionEvents: !1,
            isSearchStalled: !1,
            disabled: !1,
            ariaLabel: "Search",
            onChange: ne,
            onSubmit: ne,
            onReset: ne,
            refine: ne
        }
          , Ao = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }),
                Object.defineProperty(e, "prototype", {
                    writable: !1
                }),
                t && Eo(e, t)
            }(o, e);
            var t, r, n, i = ko(o);
            function o() {
                var e;
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, o);
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
                    r[n] = arguments[n];
                return No(Io(e = i.call.apply(i, [this].concat(r))), "state", {
                    query: e.props.query,
                    focused: !1
                }),
                No(Io(e), "input", {
                    current: null
                }),
                No(Io(e), "onInput", (function(t) {
                    var r = e.props
                      , n = r.searchAsYouType
                      , i = r.refine
                      , o = r.onChange
                      , a = t.target.value;
                    e.props.ignoreCompositionEvents && t.isComposing || (n && i(a),
                    e.setState({
                        query: a
                    }),
                    o(t))
                }
                )),
                No(Io(e), "onSubmit", (function(t) {
                    var r = e.props
                      , n = r.searchAsYouType
                      , i = r.refine
                      , o = r.onSubmit;
                    return t.preventDefault(),
                    t.stopPropagation(),
                    e.input.current && e.input.current.blur(),
                    n || i(e.state.query),
                    o(t),
                    !1
                }
                )),
                No(Io(e), "onReset", (function(t) {
                    var r = e.props
                      , n = r.refine
                      , i = r.onReset;
                    e.input.current && e.input.current.focus(),
                    n(""),
                    e.setState({
                        query: ""
                    }),
                    i(t)
                }
                )),
                No(Io(e), "onBlur", (function() {
                    e.setState({
                        focused: !1
                    })
                }
                )),
                No(Io(e), "onFocus", (function() {
                    e.setState({
                        focused: !0
                    })
                }
                )),
                e
            }
            return t = o,
            (r = [{
                key: "resetInput",
                value: function() {
                    this.setState({
                        query: ""
                    })
                }
            }, {
                key: "componentWillReceiveProps",
                value: function(e) {
                    this.state.focused || e.query === this.state.query || this.setState({
                        query: e.query
                    })
                }
            }, {
                key: "render",
                value: function() {
                    var e = this.props
                      , t = e.cssClasses
                      , r = e.placeholder
                      , n = e.autofocus
                      , i = e.showSubmit
                      , o = e.showReset
                      , a = e.showLoadingIndicator
                      , s = e.templates
                      , c = e.isSearchStalled
                      , u = e.ariaLabel;
                    return gr("div", {
                        className: t.root
                    }, gr("form", {
                        action: "",
                        role: "search",
                        className: t.form,
                        noValidate: !0,
                        onSubmit: this.onSubmit,
                        onReset: this.onReset
                    }, gr("input", {
                        ref: this.input,
                        value: this.state.query,
                        disabled: this.props.disabled,
                        className: t.input,
                        type: "search",
                        placeholder: r,
                        autoFocus: n,
                        autoComplete: "off",
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        spellCheck: "false",
                        maxLength: 512,
                        onInput: this.onInput,
                        oncompositionend: this.onInput,
                        onBlur: this.onBlur,
                        onFocus: this.onFocus,
                        "aria-label": u
                    }), gr(Po, {
                        templateKey: "submit",
                        rootTagName: "button",
                        rootProps: {
                            className: t.submit,
                            type: "submit",
                            title: "Submit the search query",
                            hidden: !i
                        },
                        templates: s,
                        data: {
                            cssClasses: t
                        }
                    }), gr(Po, {
                        templateKey: "reset",
                        rootTagName: "button",
                        rootProps: {
                            className: t.reset,
                            type: "reset",
                            title: "Clear the search query",
                            hidden: !(o && this.state.query.trim() && !c)
                        },
                        templates: s,
                        data: {
                            cssClasses: t
                        }
                    }), a && gr(Po, {
                        templateKey: "loadingIndicator",
                        rootTagName: "span",
                        rootProps: {
                            className: t.loadingIndicator,
                            hidden: !c
                        },
                        templates: s,
                        data: {
                            cssClasses: t
                        }
                    })))
                }
            }]) && xo(t.prototype, r),
            n && xo(t, n),
            Object.defineProperty(t, "prototype", {
                writable: !1
            }),
            o
        }(br);
        No(Ao, "defaultProps", Co);
        const Do = Ao;
        function Ho() {
            return Ho = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Ho.apply(this, arguments)
        }
        const $o = function(e) {
            var t = e.className
              , r = e.handleClick
              , n = e.facetValueToRefine
              , i = e.isRefined
              , o = e.templateProps
              , a = e.templateKey
              , s = e.templateData
              , c = e.subItems;
            return gr("li", {
                className: t,
                onClick: function(e) {
                    r({
                        facetValueToRefine: n,
                        isRefined: i,
                        originalEvent: e
                    })
                }
            }, gr(Po, Ho({}, o, {
                templateKey: a,
                data: s
            })), c)
        };
        var Lo = ["root"];
        function Mo(e) {
            return Mo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Mo(e)
        }
        function qo(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Wo(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? qo(Object(r), !0).forEach((function(t) {
                    Yo(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qo(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Uo() {
            return Uo = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Uo.apply(this, arguments)
        }
        function Bo(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Qo(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, Go(n.key), n)
            }
        }
        function Vo(e, t) {
            return Vo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t,
                e
            }
            ,
            Vo(e, t)
        }
        function zo(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
                    ))),
                    !0
                } catch (e) {
                    return !1
                }
            }();
            return function() {
                var r, n = Ko(e);
                if (t) {
                    var i = Ko(this).constructor;
                    r = Reflect.construct(n, arguments, i)
                } else
                    r = n.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === Mo(t) || "function" == typeof t))
                        return t;
                    if (void 0 !== t)
                        throw new TypeError("Derived constructors may only return object or undefined");
                    return Jo(e)
                }(this, r)
            }
        }
        function Jo(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }
        function Ko(e) {
            return Ko = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e)
            }
            ,
            Ko(e)
        }
        function Yo(e, t, r) {
            return (t = Go(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Go(e) {
            var t = function(e, t) {
                if ("object" !== Mo(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== Mo(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === Mo(t) ? t : String(t)
        }
        function Xo(e) {
            return void 0 !== e.data
        }
        var Zo = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }),
                Object.defineProperty(e, "prototype", {
                    writable: !1
                }),
                t && Vo(e, t)
            }(o, e);
            var t, r, n, i = zo(o);
            function o() {
                var e;
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, o);
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
                    r[n] = arguments[n];
                return Yo(Jo(e = i.call.apply(i, [this].concat(r))), "searchBox", {
                    current: null
                }),
                Yo(Jo(e), "_generateFacetItem", (function(t) {
                    var r;
                    if (Xo(t) && Array.isArray(t.data) && t.data.length > 0) {
                        var n = e.props.cssClasses
                          , i = (n.root,
                        Bo(n, Lo));
                        r = gr(o, Uo({}, e.props, {
                            cssClasses: i,
                            depth: e.props.depth + 1,
                            facetValues: t.data,
                            showMore: !1,
                            className: e.props.cssClasses.childList
                        }))
                    }
                    var a = e.props.createURL(t.value)
                      , s = Wo(Wo({}, t), {}, {
                        url: a,
                        attribute: e.props.attribute,
                        cssClasses: e.props.cssClasses,
                        isFromSearch: e.props.isFromSearch
                    })
                      , c = t.value;
                    void 0 !== t.isRefined && (c += "/".concat(t.isRefined)),
                    void 0 !== t.count && (c += "/".concat(t.count));
                    var u = rr(e.props.cssClasses.item, t.isRefined && e.props.cssClasses.selectedItem, !t.count && e.props.cssClasses.disabledItem, Boolean(Xo(t) && Array.isArray(t.data) && t.data.length > 0) && e.props.cssClasses.parentItem);
                    return gr($o, {
                        templateKey: "item",
                        key: c,
                        facetValueToRefine: t.value,
                        handleClick: e.handleItemClick,
                        isRefined: t.isRefined,
                        className: u,
                        subItems: r,
                        templateData: s,
                        templateProps: e.props.templateProps
                    })
                }
                )),
                Yo(Jo(e), "handleItemClick", (function(t) {
                    var r = t.facetValueToRefine
                      , n = t.isRefined
                      , i = t.originalEvent;
                    if (!ti(i)) {
                        var o = i.target;
                        if (!(null === o || null === o.parentNode || n && o.parentNode.querySelector('input[type="radio"]:checked')))
                            if ("INPUT" !== o.tagName) {
                                for (; o !== i.currentTarget; ) {
                                    if ("LABEL" === o.tagName && (o.querySelector('input[type="checkbox"]') || o.querySelector('input[type="radio"]')))
                                        return;
                                    "A" === o.tagName && o.href && i.preventDefault(),
                                    o = o.parentNode
                                }
                                i.stopPropagation(),
                                e.refine(r)
                            } else
                                e.refine(r)
                    }
                }
                )),
                e
            }
            return t = o,
            r = [{
                key: "shouldComponentUpdate",
                value: function(e) {
                    return !Y(this.props.facetValues, e.facetValues)
                }
            }, {
                key: "refine",
                value: function(e) {
                    this.props.toggleRefinement(e)
                }
            }, {
                key: "componentWillReceiveProps",
                value: function(e) {
                    this.searchBox.current && !e.isFromSearch && this.searchBox.current.resetInput()
                }
            }, {
                key: "refineFirstValue",
                value: function() {
                    var e = this.props.facetValues && this.props.facetValues[0];
                    if (e) {
                        var t = e.value;
                        this.props.toggleRefinement(t)
                    }
                }
            }, {
                key: "render",
                value: function() {
                    var e = this
                      , t = rr(this.props.cssClasses.showMore, !(!0 === this.props.showMore && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore)
                      , r = !0 === this.props.showMore && gr(Po, Uo({}, this.props.templateProps, {
                        templateKey: "showMoreText",
                        rootTagName: "button",
                        rootProps: {
                            className: t,
                            disabled: !this.props.canToggleShowMore,
                            onClick: this.props.toggleShowMore
                        },
                        data: {
                            isShowingMore: this.props.isShowingMore
                        }
                    }))
                      , n = !0 !== this.props.searchIsAlwaysActive && !(this.props.isFromSearch || !this.props.hasExhaustiveItems)
                      , i = this.props.searchFacetValues && gr("div", {
                        className: this.props.cssClasses.searchBox
                    }, gr(Do, {
                        ref: this.searchBox,
                        placeholder: this.props.searchPlaceholder,
                        disabled: n,
                        cssClasses: this.props.cssClasses.searchable,
                        templates: this.props.searchBoxTemplateProps.templates,
                        onChange: function(t) {
                            return e.props.searchFacetValues(t.target.value)
                        },
                        onReset: function() {
                            return e.props.searchFacetValues("")
                        },
                        onSubmit: function() {
                            return e.refineFirstValue()
                        },
                        searchAsYouType: !1,
                        ariaLabel: "Search for filters"
                    }))
                      , o = this.props.facetValues && this.props.facetValues.length > 0 && gr("ul", {
                        className: this.props.cssClasses.list
                    }, this.props.facetValues.map(this._generateFacetItem, this))
                      , a = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || 0 === this.props.facetValues.length) && gr(Po, Uo({}, this.props.templateProps, {
                        templateKey: "searchableNoResults",
                        rootProps: {
                            className: this.props.cssClasses.noResults
                        }
                    }));
                    return gr("div", {
                        className: rr(this.props.cssClasses.root, (!this.props.facetValues || 0 === this.props.facetValues.length) && this.props.cssClasses.noRefinementRoot, this.props.className)
                    }, this.props.children, i, o, a, r)
                }
            }],
            r && Qo(t.prototype, r),
            n && Qo(t, n),
            Object.defineProperty(t, "prototype", {
                writable: !1
            }),
            o
        }(br);
        Yo(Zo, "defaultProps", {
            cssClasses: {},
            depth: 0
        });
        const ea = Zo;
        function ta(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ra(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ta(Object(r), !0).forEach((function(t) {
                    na(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ta(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function na(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== ia(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== ia(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === ia(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function ia(e) {
            return ia = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            ia(e)
        }
        function oa(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return aa(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return aa(e, t)
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function aa(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function sa(e) {
            var t = e.instantSearchInstance
              , r = e.helper
              , n = e.attribute
              , i = e.widgetType;
            return function() {
                for (var e = arguments.length, o = new Array(e), a = 0; a < e; a++)
                    o[a] = arguments[a];
                var s = o[1]
                  , c = o[2]
                  , u = void 0 === c ? "Filter Applied" : c
                  , l = o[3]
                  , f = void 0 === l ? {} : l
                  , p = oa(o[0].split(":"), 2)
                  , h = p[0]
                  , d = p[1]
                  , m = "string" == typeof n ? n : n(s);
                1 === o.length && "object" === ia(o[0]) ? t.sendEventToInsights(o[0]) : "click" === h && o.length >= 2 && o.length <= 4 && (function(e, t, r) {
                    return e.state.isHierarchicalFacet(t) ? e.state.isHierarchicalFacetRefined(t, r) : e.state.isConjunctiveFacet(t) ? e.state.isFacetRefined(t, r) : e.state.isDisjunctiveFacetRefined(t, r)
                }(r, m, s) || t.sendEventToInsights({
                    insightsMethod: "clickedFilters",
                    widgetType: i,
                    eventType: h,
                    eventModifier: d,
                    payload: ra({
                        eventName: u,
                        index: r.getIndex(),
                        filters: ["".concat(m, ":").concat(s)]
                    }, f),
                    attribute: m
                }))
            }
        }
        var ca = ["name", "escapedValue", "path"];
        function ua(e) {
            return ua = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            ua(e)
        }
        function la(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function fa(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return pa(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return pa(e, t)
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function pa(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function ha(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function da(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ha(Object(r), !0).forEach((function(t) {
                    ma(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ha(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function ma(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== ua(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== ua(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === ua(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var ga = qe({
            name: "menu",
            connector: !0
        })
          , ya = ["isRefined", "name:asc"];
        const va = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, ga()),
            function(r) {
                var n, i, o, a = r || {}, s = a.attribute, c = a.limit, u = void 0 === c ? 10 : c, l = a.showMore, f = void 0 !== l && l, p = a.showMoreLimit, h = void 0 === p ? 20 : p, d = a.sortBy, m = void 0 === d ? ya : d, g = a.transformItems, y = void 0 === g ? function(e) {
                    return e
                }
                : g;
                if (!s)
                    throw new Error(ga("The `attribute` option is required."));
                if (!0 === f && h <= u)
                    throw new Error(ga("The `showMoreLimit` option must be greater than `limit`."));
                var v = !1
                  , b = function() {};
                function S() {
                    b()
                }
                function O() {
                    return v ? h : u
                }
                return {
                    $$type: "ais.menu",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(da(da({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(da(da({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function(e) {
                        var r = e.state;
                        return t(),
                        r.removeHierarchicalFacet(s).setQueryParameter("maxValuesPerFacet", void 0)
                    },
                    getRenderState: function(e, t) {
                        return da(da({}, e), {}, {
                            menu: da(da({}, e.menu), {}, ma({}, s, this.getWidgetRenderState(t)))
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = this
                          , a = e.results
                          , c = e.createURL
                          , u = e.instantSearchInstance
                          , l = e.helper
                          , p = []
                          , h = !1;
                        if (n || (n = sa({
                            instantSearchInstance: u,
                            helper: l,
                            attribute: s,
                            widgetType: this.$$type
                        })),
                        i || (i = function(e) {
                            return c((function(r) {
                                return t.getWidgetUiState(r, {
                                    searchParameters: l.state.resetPage().toggleFacetRefinement(s, e),
                                    helper: l
                                })
                            }
                            ))
                        }
                        ),
                        o || (o = function(e) {
                            var t = fa(l.getHierarchicalFacetBreadcrumb(s), 1)[0];
                            n("click:internal", e || t),
                            l.toggleFacetRefinement(s, e || t).search()
                        }
                        ),
                        e.results && (b = function(e, t) {
                            return function() {
                                v = !v,
                                t.render(e)
                            }
                        }(e, this)),
                        a) {
                            var d = a.getFacetValues(s, {
                                sortBy: m,
                                facetOrdering: m === ya
                            })
                              , g = d && !Array.isArray(d) && d.data ? d.data : [];
                            h = f && (v || g.length > O()),
                            p = y(g.slice(0, O()).map((function(e) {
                                var t = e.name
                                  , r = e.escapedValue;
                                e.path;
                                return da(da({}, la(e, ca)), {}, {
                                    label: t,
                                    value: r
                                })
                            }
                            )), {
                                results: a
                            })
                        }
                        return {
                            items: p,
                            createURL: i,
                            refine: o,
                            sendEvent: n,
                            canRefine: p.length > 0,
                            widgetParams: r,
                            isShowingMore: v,
                            toggleShowMore: S,
                            canToggleShowMore: h
                        }
                    },
                    getWidgetUiState: function(e, t) {
                        var r = fa(t.searchParameters.getHierarchicalFacetBreadcrumb(s), 1)[0];
                        return function(e, t) {
                            if (!e.menu)
                                return e;
                            void 0 === e.menu[t] && delete e.menu[t];
                            0 === Object.keys(e.menu).length && delete e.menu;
                            return e
                        }(da(da({}, e), {}, {
                            menu: da(da({}, e.menu), {}, ma({}, s, r))
                        }), s)
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var r = t.uiState
                          , n = r.menu && r.menu[s];
                        if (e.isConjunctiveFacet(s) || e.isDisjunctiveFacet(s))
                            return e;
                        var i = e.removeHierarchicalFacet(s).addHierarchicalFacet({
                            name: s,
                            attributes: [s]
                        })
                          , o = i.maxValuesPerFacet || 0
                          , a = Math.max(o, f ? h : u)
                          , c = i.setQueryParameter("maxValuesPerFacet", a);
                        return n ? c.addHierarchicalFacetRefinement(s, n) : c.setQueryParameters({
                            hierarchicalFacetsRefinements: da(da({}, c.hierarchicalFacetsRefinements), {}, ma({}, s, []))
                        })
                    }
                }
            }
        };
        function ba(e) {
            return ba = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            ba(e)
        }
        function Sa(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Oa(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== ba(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== ba(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === ba(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function wa(e) {
            return function(e) {
                if (Array.isArray(e))
                    return _a(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return _a(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return _a(e, t)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function _a(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function ja(e) {
            var t = e.defaultTemplates
              , r = e.templates
              , n = e.templatesConfig
              , i = function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return Ue([].concat(wa(Object.keys(e || {})), wa(Object.keys(t)))).reduce((function(r, n) {
                    var i = e ? e[n] : void 0
                      , o = t[n]
                      , a = void 0 !== o && o !== i;
                    return r.templates[n] = a ? o : i,
                    r.useCustomCompileOptions[n] = a,
                    r
                }
                ), {
                    templates: {},
                    useCustomCompileOptions: {}
                })
            }(t, r);
            return function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Sa(Object(r), !0).forEach((function(t) {
                        Oa(e, t, r[t])
                    }
                    )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sa(Object(r)).forEach((function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                    }
                    ))
                }
                return e
            }({
                templatesConfig: n
            }, i)
        }
        var Pa = {
            item: function(e) {
                var t = e.cssClasses
                  , r = e.url
                  , n = e.label
                  , i = e.count;
                return gr("a", {
                    className: rr(t.link),
                    href: r
                }, gr("span", {
                    className: rr(t.label)
                }, n), gr("span", {
                    className: rr(t.count)
                }, yt(i)))
            },
            showMoreText: function(e) {
                return e.isShowingMore ? "Show less" : "Show more"
            }
        };
        const Ra = Pa;
        function xa(e) {
            return xa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            xa(e)
        }
        function Ea(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ka(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ea(Object(r), !0).forEach((function(t) {
                    Ia(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ea(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Ia(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== xa(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== xa(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === xa(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Ta = qe({
            name: "menu"
        })
          , Na = n("Menu");
        const Fa = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.attribute
              , i = t.sortBy
              , o = t.limit
              , a = t.showMore
              , s = t.showMoreLimit
              , c = t.cssClasses
              , u = void 0 === c ? {} : c
              , l = t.templates
              , f = void 0 === l ? {} : l
              , p = t.transformItems;
            if (!r)
                throw new Error(Ta("The `container` option is required."));
            var h = Qn(r)
              , d = {
                root: rr(Na(), u.root),
                noRefinementRoot: rr(Na({
                    modifierName: "noRefinement"
                }), u.noRefinementRoot),
                list: rr(Na({
                    descendantName: "list"
                }), u.list),
                item: rr(Na({
                    descendantName: "item"
                }), u.item),
                selectedItem: rr(Na({
                    descendantName: "item",
                    modifierName: "selected"
                }), u.selectedItem),
                link: rr(Na({
                    descendantName: "link"
                }), u.link),
                label: rr(Na({
                    descendantName: "label"
                }), u.label),
                count: rr(Na({
                    descendantName: "count"
                }), u.count),
                showMore: rr(Na({
                    descendantName: "showMore"
                }), u.showMore),
                disabledShowMore: rr(Na({
                    descendantName: "showMore",
                    modifierName: "disabled"
                }), u.disabledShowMore)
            }
              , m = function(e) {
                var t = e.containerNode
                  , r = e.cssClasses
                  , n = e.renderState
                  , i = e.templates
                  , o = e.showMore;
                return function(e, a) {
                    var s = e.refine
                      , c = e.items
                      , u = e.createURL
                      , l = e.instantSearchInstance
                      , f = e.isShowingMore
                      , p = e.toggleShowMore
                      , h = e.canToggleShowMore;
                    if (a)
                        n.templateProps = ja({
                            defaultTemplates: Ra,
                            templatesConfig: l.templatesConfig,
                            templates: i
                        });
                    else {
                        var d = c.map((function(e) {
                            return ka(ka({}, e), {}, {
                                url: u(e.value)
                            })
                        }
                        ));
                        $r(gr(ea, {
                            createURL: u,
                            cssClasses: r,
                            facetValues: d,
                            showMore: o,
                            templateProps: n.templateProps,
                            toggleRefinement: s,
                            toggleShowMore: p,
                            isShowingMore: f,
                            canToggleShowMore: h
                        }), t)
                    }
                }
            }({
                containerNode: h,
                cssClasses: d,
                renderState: {},
                templates: f,
                showMore: a
            });
            return ka(ka({}, va(m, (function() {
                return $r(null, h)
            }
            ))({
                attribute: n,
                limit: o,
                showMore: a,
                showMoreLimit: s,
                sortBy: i,
                transformItems: p
            })), {}, {
                $$widgetType: "ais.menu"
            })
        };
        function Ca(e) {
            return Ca = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Ca(e)
        }
        var Aa = ["name", "escapedValue"]
          , Da = ["escapedValue", "value"];
        function Ha(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function $a(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ha(Object(r), !0).forEach((function(t) {
                    La(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ha(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function La(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Ca(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Ca(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Ca(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Ma(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        var qa = qe({
            name: "refinement-list",
            connector: !0
        })
          , Wa = ["isRefined", "count:desc", "name:asc"];
        const Ua = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, qa()),
            function(r) {
                var n = r || {}
                  , i = n.attribute
                  , o = n.operator
                  , a = void 0 === o ? "or" : o
                  , s = n.limit
                  , c = void 0 === s ? 10 : s
                  , u = n.showMore
                  , l = void 0 !== u && u
                  , f = n.showMoreLimit
                  , p = void 0 === f ? 20 : f
                  , h = n.sortBy
                  , d = void 0 === h ? Wa : h
                  , m = n.escapeFacetValues
                  , g = void 0 === m || m
                  , v = n.transformItems
                  , w = void 0 === v ? function(e) {
                    return e
                }
                : v;
                if (!i)
                    throw new Error(qa("The `attribute` option is required."));
                if (!/^(and|or)$/.test(a))
                    throw new Error(qa('The `operator` must one of: `"and"`, `"or"` (got "'.concat(a, '").')));
                if (!0 === l && p <= c)
                    throw new Error(qa("`showMoreLimit` should be greater than `limit`."));
                var _, j, P, R = function(e) {
                    var t = e.name
                      , r = e.escapedValue;
                    return $a($a({}, Ma(e, Aa)), {}, {
                        value: r,
                        label: t,
                        highlighted: t
                    })
                }, x = [], E = !0, k = !1, I = function() {};
                function T() {
                    I()
                }
                function N() {
                    return k ? p : c
                }
                var F = function() {
                    return function() {}
                }
                  , C = function(t, r) {
                    return function(n) {
                        return function(o) {
                            var a = n.instantSearchInstance
                              , s = n.results;
                            if ("" === o && x)
                                e($a($a({}, r.getWidgetRenderState($a($a({}, n), {}, {
                                    results: _
                                }))), {}, {
                                    instantSearchInstance: a
                                }), !1);
                            else {
                                var c = {
                                    highlightPreTag: g ? b.highlightPreTag : S.highlightPreTag,
                                    highlightPostTag: g ? b.highlightPostTag : S.highlightPostTag
                                };
                                t.searchForFacetValues(i, o, Math.min(N(), 100), c).then((function(t) {
                                    var i = g ? t.facetHits.map((function(e) {
                                        return y(y({}, e), {}, {
                                            highlighted: O(e.highlighted)
                                        })
                                    }
                                    )) : t.facetHits
                                      , o = w(i.map((function(e) {
                                        var t = e.escapedValue
                                          , r = e.value;
                                        return $a($a({}, Ma(e, Da)), {}, {
                                            value: t,
                                            label: r
                                        })
                                    }
                                    )), {
                                        results: s
                                    });
                                    e($a($a({}, r.getWidgetRenderState($a($a({}, n), {}, {
                                        results: _
                                    }))), {}, {
                                        items: o,
                                        canToggleShowMore: !1,
                                        canRefine: !0,
                                        isFromSearch: !0,
                                        instantSearchInstance: a
                                    }), !1)
                                }
                                ))
                            }
                        }
                    }
                };
                return {
                    $$type: "ais.refinementList",
                    init: function(t) {
                        e($a($a({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !0)
                    },
                    render: function(t) {
                        e($a($a({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !1)
                    },
                    getRenderState: function(e, t) {
                        return $a($a({}, e), {}, {
                            refinementList: $a($a({}, e.refinementList), {}, La({}, i, this.getWidgetRenderState(t)))
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = this
                          , n = e.results
                          , o = e.state
                          , a = e.createURL
                          , s = e.instantSearchInstance
                          , u = e.helper
                          , f = []
                          , p = [];
                        if (P && j && F || (P = sa({
                            instantSearchInstance: s,
                            helper: u,
                            attribute: i,
                            widgetType: this.$$type
                        }),
                        j = function(e) {
                            P("click:internal", e),
                            u.toggleFacetRefinement(i, e).search()
                        }
                        ,
                        F = C(u, this)),
                        n) {
                            var h = n.getFacetValues(i, {
                                sortBy: d,
                                facetOrdering: d === Wa
                            });
                            p = h && Array.isArray(h) ? h : [],
                            f = w(p.slice(0, N()).map(R), {
                                results: n
                            });
                            var m = o.maxValuesPerFacet
                              , g = N();
                            E = m > g ? p.length <= g : p.length < g,
                            _ = n,
                            x = f,
                            e.results && (I = function(e, t) {
                                return function() {
                                    k = !k,
                                    t.render(e)
                                }
                            }(e, this))
                        }
                        var y = F && F(e)
                          , v = k && x.length > c || l && !E;
                        return {
                            createURL: function(e) {
                                return a((function(r) {
                                    return t.getWidgetUiState(r, {
                                        searchParameters: o.resetPage().toggleFacetRefinement(i, e),
                                        helper: u
                                    })
                                }
                                ))
                            },
                            items: f,
                            refine: j,
                            searchForItems: y,
                            isFromSearch: !1,
                            canRefine: f.length > 0,
                            widgetParams: r,
                            isShowingMore: k,
                            canToggleShowMore: v,
                            toggleShowMore: T,
                            sendEvent: P,
                            hasExhaustiveItems: E
                        }
                    },
                    dispose: function(e) {
                        var r = e.state;
                        t();
                        var n = r.setQueryParameter("maxValuesPerFacet", void 0);
                        return "and" === a ? n.removeFacet(i) : n.removeDisjunctiveFacet(i)
                    },
                    getWidgetUiState: function(e, t) {
                        var r = t.searchParameters
                          , n = "or" === a ? r.getDisjunctiveRefinements(i) : r.getConjunctiveRefinements(i);
                        return function(e, t) {
                            if (!e.refinementList)
                                return e;
                            e.refinementList[t] && 0 !== e.refinementList[t].length || delete e.refinementList[t];
                            0 === Object.keys(e.refinementList).length && delete e.refinementList;
                            return e
                        }($a($a({}, e), {}, {
                            refinementList: $a($a({}, e.refinementList), {}, La({}, i, n))
                        }), i)
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var r = t.uiState
                          , n = "or" === a;
                        if (e.isHierarchicalFacet(i))
                            return e;
                        if (n && e.isConjunctiveFacet(i) || !n && e.isDisjunctiveFacet(i))
                            return e;
                        var o = r.refinementList && r.refinementList[i]
                          , s = n ? e.addDisjunctiveFacet(i).removeDisjunctiveFacetRefinement(i) : e.addFacet(i).removeFacetRefinement(i)
                          , u = s.maxValuesPerFacet || 0
                          , f = Math.max(u, l ? p : c)
                          , h = s.setQueryParameter("maxValuesPerFacet", f);
                        if (!o) {
                            var d = n ? "disjunctiveFacetsRefinements" : "facetsRefinements";
                            return h.setQueryParameters(La({}, d, $a($a({}, h[d]), {}, La({}, i, []))))
                        }
                        return o.reduce((function(e, t) {
                            return n ? e.addDisjunctiveFacetRefinement(i, t) : e.addFacetRefinement(i, t)
                        }
                        ), h)
                    }
                }
            }
        };
        var Ba = gr("path", {
            d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
        })
          , Qa = gr("path", {
            d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
        })
          , Va = gr("g", {
            fill: "none",
            "fill-rule": "evenodd"
        }, gr("g", {
            transform: "translate(1 1)",
            "stroke-width": "2"
        }, gr("circle", {
            "stroke-opacity": ".5",
            cx: "18",
            cy: "18",
            r: "18"
        }), gr("path", {
            d: "M36 18c0-9.94-8.06-18-18-18"
        }, gr("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "1s",
            repeatCount: "indefinite"
        }))))
          , za = {
            reset: function(e) {
                return gr("svg", {
                    className: e.cssClasses.resetIcon,
                    viewBox: "0 0 20 20",
                    width: "10",
                    height: "10",
                    "aria-hidden": "true"
                }, Ba)
            },
            submit: function(e) {
                return gr("svg", {
                    className: e.cssClasses.submitIcon,
                    width: "10",
                    height: "10",
                    viewBox: "0 0 40 40",
                    "aria-hidden": "true"
                }, Qa)
            },
            loadingIndicator: function(e) {
                return gr("svg", {
                    "aria-label": "Results are loading",
                    className: e.cssClasses.loadingIcon,
                    width: "16",
                    height: "16",
                    viewBox: "0 0 38 38",
                    stroke: "#444",
                    "aria-hidden": "true"
                }, Va)
            }
        };
        const Ja = za;
        var Ka = {
            item: function(e) {
                var t = e.cssClasses
                  , r = e.count
                  , n = e.value
                  , i = e.highlighted
                  , o = e.isRefined
                  , a = e.isFromSearch;
                return gr("label", {
                    className: rr(t.label)
                }, gr("input", {
                    type: "checkbox",
                    className: rr(t.checkbox),
                    value: n,
                    defaultChecked: o
                }), gr("span", {
                    className: rr(t.labelText),
                    dangerouslySetInnerHTML: a ? {
                        __html: i
                    } : void 0
                }, !a && i), gr("span", {
                    className: rr(t.count)
                }, yt(r)))
            },
            showMoreText: function(e) {
                return e.isShowingMore ? "Show less" : "Show more"
            },
            searchableNoResults: function() {
                return "No results"
            }
        };
        const Ya = Ka;
        function Ga(e) {
            return Ga = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Ga(e)
        }
        function Xa(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Za(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Xa(Object(r), !0).forEach((function(t) {
                    es(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xa(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function es(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Ga(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Ga(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Ga(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var ts = qe({
            name: "refinement-list"
        })
          , rs = n("RefinementList")
          , ns = n("SearchBox");
        const is = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.attribute
              , i = t.operator
              , o = t.sortBy
              , a = t.limit
              , s = t.showMore
              , c = t.showMoreLimit
              , u = t.searchable
              , l = void 0 !== u && u
              , f = t.searchablePlaceholder
              , p = void 0 === f ? "Search..." : f
              , h = t.searchableEscapeFacetValues
              , d = void 0 === h || h
              , m = t.searchableIsAlwaysActive
              , g = void 0 === m || m
              , y = t.cssClasses
              , v = void 0 === y ? {} : y
              , b = t.templates
              , S = void 0 === b ? {} : b
              , O = t.transformItems;
            if (!r)
                throw new Error(ts("The `container` option is required."));
            var w = !!l && Boolean(d)
              , _ = Qn(r)
              , j = {
                root: rr(rs(), v.root),
                noRefinementRoot: rr(rs({
                    modifierName: "noRefinement"
                }), v.noRefinementRoot),
                list: rr(rs({
                    descendantName: "list"
                }), v.list),
                item: rr(rs({
                    descendantName: "item"
                }), v.item),
                selectedItem: rr(rs({
                    descendantName: "item",
                    modifierName: "selected"
                }), v.selectedItem),
                searchBox: rr(rs({
                    descendantName: "searchBox"
                }), v.searchBox),
                label: rr(rs({
                    descendantName: "label"
                }), v.label),
                checkbox: rr(rs({
                    descendantName: "checkbox"
                }), v.checkbox),
                labelText: rr(rs({
                    descendantName: "labelText"
                }), v.labelText),
                count: rr(rs({
                    descendantName: "count"
                }), v.count),
                noResults: rr(rs({
                    descendantName: "noResults"
                }), v.noResults),
                showMore: rr(rs({
                    descendantName: "showMore"
                }), v.showMore),
                disabledShowMore: rr(rs({
                    descendantName: "showMore",
                    modifierName: "disabled"
                }), v.disabledShowMore),
                searchable: {
                    root: rr(ns(), v.searchableRoot),
                    form: rr(ns({
                        descendantName: "form"
                    }), v.searchableForm),
                    input: rr(ns({
                        descendantName: "input"
                    }), v.searchableInput),
                    submit: rr(ns({
                        descendantName: "submit"
                    }), v.searchableSubmit),
                    submitIcon: rr(ns({
                        descendantName: "submitIcon"
                    }), v.searchableSubmitIcon),
                    reset: rr(ns({
                        descendantName: "reset"
                    }), v.searchableReset),
                    resetIcon: rr(ns({
                        descendantName: "resetIcon"
                    }), v.searchableResetIcon),
                    loadingIndicator: rr(ns({
                        descendantName: "loadingIndicator"
                    }), v.searchableLoadingIndicator),
                    loadingIcon: rr(ns({
                        descendantName: "loadingIcon"
                    }), v.searchableLoadingIcon)
                }
            }
              , P = function(e) {
                var t = e.containerNode
                  , r = e.cssClasses
                  , n = e.templates
                  , i = e.searchBoxTemplates
                  , o = e.renderState
                  , a = e.showMore
                  , s = e.searchable
                  , c = e.searchablePlaceholder
                  , u = e.searchableIsAlwaysActive;
                return function(e, l) {
                    var f = e.refine
                      , p = e.items
                      , h = e.createURL
                      , d = e.searchForItems
                      , m = e.isFromSearch
                      , g = e.instantSearchInstance
                      , y = e.toggleShowMore
                      , v = e.isShowingMore
                      , b = e.hasExhaustiveItems
                      , S = e.canToggleShowMore;
                    if (l)
                        return o.templateProps = ja({
                            defaultTemplates: Ya,
                            templatesConfig: g.templatesConfig,
                            templates: n
                        }),
                        void (o.searchBoxTemplateProps = ja({
                            defaultTemplates: Ja,
                            templatesConfig: g.templatesConfig,
                            templates: i
                        }));
                    $r(gr(ea, {
                        createURL: h,
                        cssClasses: r,
                        facetValues: p,
                        templateProps: o.templateProps,
                        searchBoxTemplateProps: o.searchBoxTemplateProps,
                        toggleRefinement: f,
                        searchFacetValues: s ? d : void 0,
                        searchPlaceholder: c,
                        searchIsAlwaysActive: u,
                        isFromSearch: m,
                        showMore: a && !m && p.length > 0,
                        toggleShowMore: y,
                        isShowingMore: v,
                        hasExhaustiveItems: b,
                        canToggleShowMore: S
                    }), t)
                }
            }({
                containerNode: _,
                cssClasses: j,
                templates: S,
                searchBoxTemplates: {
                    submit: S.searchableSubmit,
                    reset: S.searchableReset,
                    loadingIndicator: S.searchableLoadingIndicator
                },
                renderState: {},
                searchable: l,
                searchablePlaceholder: p,
                searchableIsAlwaysActive: g,
                showMore: s
            });
            return Za(Za({}, Ua(P, (function() {
                return $r(null, _)
            }
            ))({
                attribute: n,
                operator: i,
                limit: a,
                showMore: s,
                showMoreLimit: c,
                sortBy: o,
                escapeFacetValues: w,
                transformItems: O
            })), {}, {
                $$widgetType: "ais.refinementList"
            })
        };
        function os(e) {
            return os = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            os(e)
        }
        function as(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ss(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? as(Object(r), !0).forEach((function(t) {
                    cs(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : as(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function cs(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== os(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== os(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === os(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var us = qe({
            name: "search-box",
            connector: !0
        })
          , ls = function(e, t) {
            return t(e)
        };
        const fs = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, us()),
            function(r) {
                var n, i, o = (r || {}).queryHook, a = void 0 === o ? ls : o;
                return {
                    $$type: "ais.searchBox",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(ss(ss({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(ss(ss({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function(e) {
                        var r = e.state;
                        return t(),
                        r.setQueryParameter("query", void 0)
                    },
                    getRenderState: function(e, t) {
                        return ss(ss({}, e), {}, {
                            searchBox: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.helper
                          , o = e.instantSearchInstance
                          , s = e.state;
                        return n || (n = function(e) {
                            a(e, (function(e) {
                                return t.setQuery(e).search()
                            }
                            ))
                        }
                        ,
                        i = function() {
                            t.setQuery("").search()
                        }
                        ),
                        {
                            query: s.query || "",
                            refine: n,
                            clear: i,
                            widgetParams: r,
                            isSearchStalled: "stalled" === o.status
                        }
                    },
                    getWidgetUiState: function(e, t) {
                        var r = t.searchParameters.query || "";
                        return "" === r || e && e.query === r ? e : ss(ss({}, e), {}, {
                            query: r
                        })
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var r = t.uiState;
                        return e.setQueryParameter("query", r.query || "")
                    }
                }
            }
        };
        function ps(e) {
            return ps = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            ps(e)
        }
        function hs(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ds(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? hs(Object(r), !0).forEach((function(t) {
                    ms(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hs(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function ms(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== ps(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== ps(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === ps(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var gs = qe({
            name: "search-box"
        })
          , ys = n("SearchBox");
        const vs = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.placeholder
              , i = void 0 === n ? "" : n
              , o = t.cssClasses
              , a = void 0 === o ? {} : o
              , s = t.autofocus
              , c = void 0 !== s && s
              , u = t.searchAsYouType
              , l = void 0 === u || u
              , f = t.ignoreCompositionEvents
              , p = void 0 !== f && f
              , h = t.showReset
              , d = void 0 === h || h
              , m = t.showSubmit
              , g = void 0 === m || m
              , y = t.showLoadingIndicator
              , v = void 0 === y || y
              , b = t.queryHook
              , S = t.templates
              , O = void 0 === S ? {} : S;
            if (!r)
                throw new Error(gs("The `container` option is required."));
            var w = Qn(r)
              , _ = {
                root: rr(ys(), a.root),
                form: rr(ys({
                    descendantName: "form"
                }), a.form),
                input: rr(ys({
                    descendantName: "input"
                }), a.input),
                submit: rr(ys({
                    descendantName: "submit"
                }), a.submit),
                submitIcon: rr(ys({
                    descendantName: "submitIcon"
                }), a.submitIcon),
                reset: rr(ys({
                    descendantName: "reset"
                }), a.reset),
                resetIcon: rr(ys({
                    descendantName: "resetIcon"
                }), a.resetIcon),
                loadingIndicator: rr(ys({
                    descendantName: "loadingIndicator"
                }), a.loadingIndicator),
                loadingIcon: rr(ys({
                    descendantName: "loadingIcon"
                }), a.loadingIcon)
            }
              , j = ds(ds({}, Ja), O)
              , P = function(e) {
                var t = e.containerNode
                  , r = e.cssClasses
                  , n = e.placeholder
                  , i = e.templates
                  , o = e.autofocus
                  , a = e.searchAsYouType
                  , s = e.ignoreCompositionEvents
                  , c = e.showReset
                  , u = e.showSubmit
                  , l = e.showLoadingIndicator;
                return function(e) {
                    var f = e.refine
                      , p = e.query
                      , h = e.isSearchStalled;
                    $r(gr(Do, {
                        query: p,
                        placeholder: n,
                        autofocus: o,
                        refine: f,
                        searchAsYouType: a,
                        ignoreCompositionEvents: s,
                        templates: i,
                        showSubmit: u,
                        showReset: c,
                        showLoadingIndicator: l,
                        isSearchStalled: h,
                        cssClasses: r
                    }), t)
                }
            }({
                containerNode: w,
                cssClasses: _,
                placeholder: i,
                templates: j,
                autofocus: c,
                searchAsYouType: l,
                ignoreCompositionEvents: p,
                showReset: d,
                showSubmit: g,
                showLoadingIndicator: v
            });
            return ds(ds({}, fs(P, (function() {
                return $r(null, w)
            }
            ))({
                queryHook: b
            })), {}, {
                $$widgetType: "ais.searchBox"
            })
        };
        function bs(e) {
            return bs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            bs(e)
        }
        var Ss = ["nbHits", "nbSortedHits", "cssClasses", "templateProps"];
        function Os() {
            return Os = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Os.apply(this, arguments)
        }
        function ws(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function _s(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ws(Object(r), !0).forEach((function(t) {
                    js(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ws(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function js(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== bs(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== bs(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === bs(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Ps(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        const Rs = function(e) {
            var t = e.nbHits
              , r = e.nbSortedHits
              , n = e.cssClasses
              , i = e.templateProps
              , o = Ps(e, Ss);
            return gr("div", {
                className: rr(n.root)
            }, gr(Po, Os({}, i, {
                templateKey: "text",
                rootTagName: "span",
                rootProps: {
                    className: n.text
                },
                data: _s({
                    hasManySortedResults: r && r > 1,
                    hasNoSortedResults: 0 === r,
                    hasOneSortedResults: 1 === r,
                    hasManyResults: t > 1,
                    hasNoResults: 0 === t,
                    hasOneResult: 1 === t,
                    nbHits: t,
                    nbSortedHits: r,
                    cssClasses: n
                }, o)
            })))
        };
        function xs(e) {
            return xs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            xs(e)
        }
        function Es(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ks(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Es(Object(r), !0).forEach((function(t) {
                    Is(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Es(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Is(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== xs(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== xs(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === xs(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Ts = qe({
            name: "stats",
            connector: !0
        });
        const Ns = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, Ts()),
            function(r) {
                return {
                    $$type: "ais.stats",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(ks(ks({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(ks(ks({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function() {
                        t()
                    },
                    getRenderState: function(e, t) {
                        return ks(ks({}, e), {}, {
                            stats: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.results
                          , n = e.state;
                        return t ? {
                            hitsPerPage: t.hitsPerPage,
                            nbHits: t.nbHits,
                            nbSortedHits: t.nbSortedHits,
                            areHitsSorted: void 0 !== t.appliedRelevancyStrictness && t.appliedRelevancyStrictness > 0 && t.nbSortedHits !== t.nbHits,
                            nbPages: t.nbPages,
                            page: t.page,
                            processingTimeMS: t.processingTimeMS,
                            query: t.query,
                            widgetParams: r
                        } : {
                            hitsPerPage: n.hitsPerPage,
                            nbHits: 0,
                            nbSortedHits: void 0,
                            areHitsSorted: !1,
                            nbPages: 0,
                            page: n.page || 0,
                            processingTimeMS: -1,
                            query: n.query || "",
                            widgetParams: r
                        }
                    }
                }
            }
        };
        function Fs(e) {
            return Fs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Fs(e)
        }
        function Cs(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function As(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Cs(Object(r), !0).forEach((function(t) {
                    Ds(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cs(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Ds(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Fs(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Fs(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Fs(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Hs = qe({
            name: "stats"
        })
          , $s = n("Stats")
          , Ls = {
            text: function(e) {
                return "".concat(e.areHitsSorted ? function(e) {
                    var t = e.nbHits
                      , r = e.hasNoSortedResults
                      , n = e.hasOneSortedResults
                      , i = e.hasManySortedResults
                      , o = e.nbSortedHits
                      , a = "sorted out of ".concat(yt(t));
                    if (r)
                        return "No relevant results ".concat(a);
                    if (n)
                        return "1 relevant result ".concat(a);
                    if (i)
                        return "".concat(yt(o || 0), " relevant results ").concat(a);
                    return ""
                }(e) : function(e) {
                    var t = e.nbHits
                      , r = e.hasNoResults
                      , n = e.hasOneResult
                      , i = e.hasManyResults;
                    if (r)
                        return "No results";
                    if (n)
                        return "1 result";
                    if (i)
                        return "".concat(yt(t), " results");
                    return ""
                }(e), " found in ").concat(e.processingTimeMS, "ms")
            }
        };
        const Ms = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.cssClasses
              , i = void 0 === n ? {} : n
              , o = t.templates
              , a = void 0 === o ? {} : o;
            if (!r)
                throw new Error(Hs("The `container` option is required."));
            var s = Qn(r)
              , c = {
                root: rr($s(), i.root),
                text: rr($s({
                    descendantName: "text"
                }), i.text)
            }
              , u = function(e) {
                var t = e.renderState
                  , r = e.cssClasses
                  , n = e.containerNode
                  , i = e.templates;
                return function(e, o) {
                    var a = e.hitsPerPage
                      , s = e.nbHits
                      , c = e.nbSortedHits
                      , u = e.areHitsSorted
                      , l = e.nbPages
                      , f = e.page
                      , p = e.processingTimeMS
                      , h = e.query
                      , d = e.instantSearchInstance;
                    o ? t.templateProps = ja({
                        defaultTemplates: Ls,
                        templatesConfig: d.templatesConfig,
                        templates: i
                    }) : $r(gr(Rs, {
                        cssClasses: r,
                        hitsPerPage: a,
                        nbHits: s,
                        nbSortedHits: c,
                        areHitsSorted: u,
                        nbPages: l,
                        page: f,
                        processingTimeMS: p,
                        query: h,
                        templateProps: t.templateProps
                    }), n)
                }
            }({
                containerNode: s,
                cssClasses: c,
                templates: a,
                renderState: {}
            });
            return As(As({}, Ns(u, (function() {
                return $r(null, s)
            }
            ))({})), {}, {
                $$widgetType: "ais.stats"
            })
        };
        const qs = function(e) {
            var t = e.currentValue
              , r = e.options
              , n = e.cssClasses
              , i = e.setValue
              , o = e.ariaLabel;
            return gr("select", {
                className: rr(n.select),
                onChange: function(e) {
                    return i(e.target.value)
                },
                value: "".concat(t),
                "aria-label": o
            }, r.map((function(e) {
                return gr("option", {
                    className: rr(n.option),
                    key: e.label + e.value,
                    value: "".concat(e.value)
                }, e.label)
            }
            )))
        };
        function Ws(e) {
            return Ws = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Ws(e)
        }
        function Us(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Bs(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Us(Object(r), !0).forEach((function(t) {
                    Qs(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Us(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Qs(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Ws(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Ws(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Ws(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Vs = qe({
            name: "sort-by",
            connector: !0
        });
        const zs = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            Cn(e, Vs());
            var r = {};
            return function(n) {
                var i = n || {}
                  , o = i.items
                  , a = i.transformItems
                  , s = void 0 === a ? function(e) {
                    return e
                }
                : a;
                if (!Array.isArray(o))
                    throw new Error(Vs("The `items` option expects an array of objects."));
                return {
                    $$type: "ais.sortBy",
                    init: function(t) {
                        var r = t.instantSearchInstance
                          , n = this.getWidgetRenderState(t)
                          , i = n.currentRefinement;
                        ie(o, (function(e) {
                            return e.value === i
                        }
                        ));
                        e(Bs(Bs({}, n), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(Bs(Bs({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function(e) {
                        var n = e.state;
                        return t(),
                        r.initialIndex ? n.setIndex(r.initialIndex) : n
                    },
                    getRenderState: function(e, t) {
                        return Bs(Bs({}, e), {}, {
                            sortBy: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.results
                          , i = e.helper
                          , a = e.state
                          , c = e.parent;
                        !r.initialIndex && c && (r.initialIndex = c.getIndexName()),
                        r.setIndex || (r.setIndex = function(e) {
                            i.setIndex(e).search()
                        }
                        );
                        var u = !t || 0 === t.nbHits;
                        return {
                            currentRefinement: a.index,
                            options: s(o, {
                                results: t
                            }),
                            refine: r.setIndex,
                            hasNoResults: u,
                            canRefine: !u && o.length > 0,
                            widgetParams: n
                        }
                    },
                    getWidgetUiState: function(e, t) {
                        var n = t.searchParameters.index;
                        return Bs(Bs({}, e), {}, {
                            sortBy: n !== r.initialIndex ? n : void 0
                        })
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var n = t.uiState;
                        return e.setQueryParameter("index", n.sortBy || r.initialIndex || e.index)
                    }
                }
            }
        };
        function Js(e) {
            return Js = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Js(e)
        }
        function Ks(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Ys(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ks(Object(r), !0).forEach((function(t) {
                    Gs(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ks(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Gs(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Js(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Js(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Js(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Xs = qe({
            name: "sort-by"
        })
          , Zs = n("SortBy");
        const ec = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.items
              , i = t.cssClasses
              , o = void 0 === i ? {} : i
              , a = t.transformItems;
            if (!r)
                throw new Error(Xs("The `container` option is required."));
            var s = Qn(r)
              , c = {
                root: rr(Zs(), o.root),
                select: rr(Zs({
                    descendantName: "select"
                }), o.select),
                option: rr(Zs({
                    descendantName: "option"
                }), o.option)
            }
              , u = function(e) {
                var t = e.containerNode
                  , r = e.cssClasses;
                return function(e, n) {
                    var i = e.currentRefinement
                      , o = e.options
                      , a = e.refine;
                    n || $r(gr("div", {
                        className: r.root
                    }, gr(qs, {
                        cssClasses: r,
                        currentValue: i,
                        options: o,
                        setValue: a,
                        ariaLabel: "Sort results by"
                    })), t)
                }
            }({
                containerNode: s,
                cssClasses: c
            });
            return Ys(Ys({}, zs(u, (function() {
                return $r(null, s)
            }
            ))({
                container: s,
                items: n,
                transformItems: a
            })), {}, {
                $$widgetType: "ais.sortBy"
            })
        };
        function tc() {
            return tc = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            tc.apply(this, arguments)
        }
        const rc = function(e) {
            var t = e.hasRefinements
              , r = e.refine
              , n = e.cssClasses
              , i = e.templateProps;
            return gr("div", {
                className: n.root
            }, gr(Po, tc({}, i, {
                templateKey: "resetLabel",
                rootTagName: "button",
                rootProps: {
                    className: rr(n.button, !t && n.disabledButton),
                    onClick: r,
                    disabled: !t
                },
                data: {
                    hasRefinements: t
                }
            })))
        };
        function nc(e) {
            var t = e.helper
              , r = e.attributesToClear
              , n = void 0 === r ? [] : r
              , i = t.state.setPage(0);
            return i = n.reduce((function(e, t) {
                return i.isNumericRefined(t) ? e.removeNumericRefinement(t) : i.isHierarchicalFacet(t) ? e.removeHierarchicalFacetRefinement(t) : i.isDisjunctiveFacet(t) ? e.removeDisjunctiveFacetRefinement(t) : i.isConjunctiveFacet(t) ? e.removeFacetRefinement(t) : e
            }
            ), i),
            -1 !== n.indexOf("query") && (i = i.setQuery("")),
            i
        }
        function ic(e, t, r, n) {
            var i, o, a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], s = {
                type: t,
                attribute: r,
                name: n,
                escapedValue: (i = n,
                "number" == typeof i && i < 0 || "string" == typeof i ? String(i).replace(/^-/, "\\-") : i)
            }, c = ie(a, (function(e) {
                return e.name === r
            }
            ));
            if ("hierarchical" === t) {
                for (var u = e.getHierarchicalFacetByName(r), l = n.split(u.separator), f = function(e) {
                    var t;
                    c = c && c.data && ie(Object.keys(c.data).map((t = c.data,
                    function(e) {
                        return t[e]
                    }
                    )), (function(t) {
                        return t.name === l[e]
                    }
                    ))
                }, p = 0; void 0 !== c && p < l.length; ++p)
                    f(p);
                o = c && c.count
            } else
                o = c && c.data && c.data[s.name];
            return void 0 !== o && (s.count = o),
            c && void 0 !== c.exhaustive && (s.exhaustive = c.exhaustive),
            s
        }
        function oc(e, t) {
            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
              , n = []
              , i = t.facetsRefinements
              , o = void 0 === i ? {} : i
              , a = t.facetsExcludes
              , s = void 0 === a ? {} : a
              , c = t.disjunctiveFacetsRefinements
              , u = void 0 === c ? {} : c
              , l = t.hierarchicalFacetsRefinements
              , f = void 0 === l ? {} : l
              , p = t.numericRefinements
              , h = void 0 === p ? {} : p
              , d = t.tagRefinements
              , m = void 0 === d ? [] : d;
            return Object.keys(o).forEach((function(r) {
                o[r].forEach((function(i) {
                    n.push(ic(t, "facet", r, i, e.facets))
                }
                ))
            }
            )),
            Object.keys(s).forEach((function(e) {
                s[e].forEach((function(t) {
                    n.push({
                        type: "exclude",
                        attribute: e,
                        name: t,
                        exclude: !0
                    })
                }
                ))
            }
            )),
            Object.keys(u).forEach((function(r) {
                u[r].forEach((function(i) {
                    var o;
                    n.push(ic(t, "disjunctive", r, "string" == typeof (o = i) ? o.replace(/^\\-/, "-") : o, e.disjunctiveFacets))
                }
                ))
            }
            )),
            Object.keys(f).forEach((function(r) {
                f[r].forEach((function(i) {
                    n.push(ic(t, "hierarchical", r, i, e.hierarchicalFacets))
                }
                ))
            }
            )),
            Object.keys(h).forEach((function(e) {
                var t = h[e];
                Object.keys(t).forEach((function(r) {
                    var i = r
                      , o = t[i];
                    (Array.isArray(o) ? o : [o]).forEach((function(t) {
                        n.push({
                            type: "numeric",
                            attribute: e,
                            name: "".concat(t),
                            numericValue: t,
                            operator: i
                        })
                    }
                    ))
                }
                ))
            }
            )),
            m.forEach((function(e) {
                n.push({
                    type: "tag",
                    attribute: "_tags",
                    name: e
                })
            }
            )),
            r && t.query && t.query.trim() && n.push({
                attribute: "query",
                type: "query",
                name: t.query,
                query: t.query
            }),
            n
        }
        function ac(e) {
            return ac = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            ac(e)
        }
        function sc(e) {
            return function(e) {
                if (Array.isArray(e))
                    return cc(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return cc(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return cc(e, t)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function cc(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function uc(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function lc(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? uc(Object(r), !0).forEach((function(t) {
                    fc(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uc(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function fc(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== ac(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== ac(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === ac(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var pc = qe({
            name: "clear-refinements",
            connector: !0
        });
        const hc = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, pc()),
            function(r) {
                var n = r || {}
                  , i = n.includedAttributes
                  , o = void 0 === i ? [] : i
                  , a = n.excludedAttributes
                  , s = void 0 === a ? ["query"] : a
                  , c = n.transformItems
                  , u = void 0 === c ? function(e) {
                    return e
                }
                : c;
                if (r && r.includedAttributes && r.excludedAttributes)
                    throw new Error(pc("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
                var l = {
                    refine: ne,
                    createURL: function() {
                        return ""
                    },
                    attributesToClear: []
                }
                  , f = function() {
                    return l.refine()
                }
                  , p = function() {
                    return l.createURL()
                };
                return {
                    $$type: "ais.clearRefinements",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(lc(lc({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(lc(lc({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function() {
                        t()
                    },
                    getRenderState: function(e, t) {
                        return lc(lc({}, e), {}, {
                            clearRefinements: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.createURL
                          , n = e.scopedResults
                          , i = e.results;
                        l.attributesToClear = n.reduce((function(e, t) {
                            return e.concat(function(e) {
                                var t = e.scopedResult
                                  , r = e.includedAttributes
                                  , n = e.excludedAttributes
                                  , i = e.transformItems
                                  , o = e.results
                                  , a = -1 !== r.indexOf("query") || -1 === n.indexOf("query");
                                return {
                                    helper: t.helper,
                                    items: i(Ue(oc(t.results, t.helper.state, a).map((function(e) {
                                        return e.attribute
                                    }
                                    )).filter((function(e) {
                                        return 0 === r.length || -1 !== r.indexOf(e)
                                    }
                                    )).filter((function(e) {
                                        return "query" === e && a || -1 === n.indexOf(e)
                                    }
                                    ))), {
                                        results: o
                                    })
                                }
                            }({
                                scopedResult: t,
                                includedAttributes: o,
                                excludedAttributes: s,
                                transformItems: u,
                                results: i
                            }))
                        }
                        ), []),
                        l.refine = function() {
                            l.attributesToClear.forEach((function(e) {
                                var t = e.helper
                                  , r = e.items;
                                t.setState(nc({
                                    helper: t,
                                    attributesToClear: r
                                })).search()
                            }
                            ))
                        }
                        ,
                        l.createURL = function() {
                            return t(Ge.apply(void 0, sc(l.attributesToClear.map((function(e) {
                                return nc({
                                    helper: e.helper,
                                    attributesToClear: e.items
                                })
                            }
                            )))))
                        }
                        ;
                        var a = l.attributesToClear.some((function(e) {
                            return e.items.length > 0
                        }
                        ));
                        return {
                            canRefine: a,
                            hasRefinements: a,
                            refine: f,
                            createURL: p,
                            widgetParams: r
                        }
                    }
                }
            }
        };
        const dc = {
            resetLabel: function() {
                return "Clear refinements"
            }
        };
        function mc(e) {
            return mc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            mc(e)
        }
        function gc(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function yc(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? gc(Object(r), !0).forEach((function(t) {
                    vc(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gc(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function vc(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== mc(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== mc(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === mc(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var bc = qe({
            name: "clear-refinements"
        })
          , Sc = n("ClearRefinements");
        const Oc = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.templates
              , i = void 0 === n ? {} : n
              , o = t.includedAttributes
              , a = t.excludedAttributes
              , s = t.transformItems
              , c = t.cssClasses
              , u = void 0 === c ? {} : c;
            if (!r)
                throw new Error(bc("The `container` option is required."));
            var l = Qn(r)
              , f = {
                root: rr(Sc(), u.root),
                button: rr(Sc({
                    descendantName: "button"
                }), u.button),
                disabledButton: rr(Sc({
                    descendantName: "button",
                    modifierName: "disabled"
                }), u.disabledButton)
            }
              , p = function(e) {
                var t = e.containerNode
                  , r = e.cssClasses
                  , n = e.renderState
                  , i = e.templates;
                return function(e, o) {
                    var a = e.refine
                      , s = e.canRefine
                      , c = e.instantSearchInstance;
                    o ? n.templateProps = ja({
                        defaultTemplates: dc,
                        templatesConfig: c.templatesConfig,
                        templates: i
                    }) : $r(gr(rc, {
                        refine: a,
                        cssClasses: r,
                        hasRefinements: s,
                        templateProps: n.templateProps
                    }), t)
                }
            }({
                containerNode: l,
                cssClasses: f,
                renderState: {},
                templates: i
            });
            return yc(yc({}, hc(p, (function() {
                return $r(null, l)
            }
            ))({
                includedAttributes: o,
                excludedAttributes: a,
                transformItems: s
            })), {}, {
                $$widgetType: "ais.clearRefinements"
            })
        };
        var wc, _c, jc, Pc, Rc = 0, xc = [], Ec = [], kc = ir.__b, Ic = ir.__r, Tc = ir.diffed, Nc = ir.__c, Fc = ir.unmount;
        function Cc(e, t) {
            ir.__h && ir.__h(_c, e, Rc || t),
            Rc = 0;
            var r = _c.__H || (_c.__H = {
                __: [],
                __h: []
            });
            return e >= r.__.length && r.__.push({
                __V: Ec
            }),
            r.__[e]
        }
        function Ac(e) {
            return Rc = 1,
            function(e, t, r) {
                var n = Cc(wc++, 2);
                if (n.t = e,
                !n.__c && (n.__ = [r ? r(t) : Uc(void 0, t), function(e) {
                    var t = n.__N ? n.__N[0] : n.__[0]
                      , r = n.t(t, e);
                    t !== r && (n.__N = [r, n.__[1]],
                    n.__c.setState({}))
                }
                ],
                n.__c = _c,
                !_c.u)) {
                    var i = function(e, t, r) {
                        if (!n.__c.__H)
                            return !0;
                        var i = n.__c.__H.__.filter((function(e) {
                            return e.__c
                        }
                        ));
                        if (i.every((function(e) {
                            return !e.__N
                        }
                        )))
                            return !o || o.call(this, e, t, r);
                        var a = !1;
                        return i.forEach((function(e) {
                            if (e.__N) {
                                var t = e.__[0];
                                e.__ = e.__N,
                                e.__N = void 0,
                                t !== e.__[0] && (a = !0)
                            }
                        }
                        )),
                        !(!a && n.__c.props === e) && (!o || o.call(this, e, t, r))
                    };
                    _c.u = !0;
                    var o = _c.shouldComponentUpdate
                      , a = _c.componentWillUpdate;
                    _c.componentWillUpdate = function(e, t, r) {
                        if (this.__e) {
                            var n = o;
                            o = void 0,
                            i(e, t, r),
                            o = n
                        }
                        a && a.call(this, e, t, r)
                    }
                    ,
                    _c.shouldComponentUpdate = i
                }
                return n.__N || n.__
            }(Uc, e)
        }
        function Dc(e, t) {
            var r = Cc(wc++, 7);
            return Wc(r.__H, t) ? (r.__V = e(),
            r.i = t,
            r.__h = e,
            r.__V) : r.__
        }
        function Hc() {
            for (var e; e = xc.shift(); )
                if (e.__P && e.__H)
                    try {
                        e.__H.__h.forEach(Mc),
                        e.__H.__h.forEach(qc),
                        e.__H.__h = []
                    } catch (t) {
                        e.__H.__h = [],
                        ir.__e(t, e.__v)
                    }
        }
        ir.__b = function(e) {
            _c = null,
            kc && kc(e)
        }
        ,
        ir.__r = function(e) {
            Ic && Ic(e),
            wc = 0;
            var t = (_c = e.__c).__H;
            t && (jc === _c ? (t.__h = [],
            _c.__h = [],
            t.__.forEach((function(e) {
                e.__N && (e.__ = e.__N),
                e.__V = Ec,
                e.__N = e.i = void 0
            }
            ))) : (t.__h.forEach(Mc),
            t.__h.forEach(qc),
            t.__h = [],
            wc = 0)),
            jc = _c
        }
        ,
        ir.diffed = function(e) {
            Tc && Tc(e);
            var t = e.__c;
            t && t.__H && (t.__H.__h.length && (1 !== xc.push(t) && Pc === ir.requestAnimationFrame || ((Pc = ir.requestAnimationFrame) || Lc)(Hc)),
            t.__H.__.forEach((function(e) {
                e.i && (e.__H = e.i),
                e.__V !== Ec && (e.__ = e.__V),
                e.i = void 0,
                e.__V = Ec
            }
            ))),
            jc = _c = null
        }
        ,
        ir.__c = function(e, t) {
            t.some((function(e) {
                try {
                    e.__h.forEach(Mc),
                    e.__h = e.__h.filter((function(e) {
                        return !e.__ || qc(e)
                    }
                    ))
                } catch (r) {
                    t.some((function(e) {
                        e.__h && (e.__h = [])
                    }
                    )),
                    t = [],
                    ir.__e(r, e.__v)
                }
            }
            )),
            Nc && Nc(e, t)
        }
        ,
        ir.unmount = function(e) {
            Fc && Fc(e);
            var t, r = e.__c;
            r && r.__H && (r.__H.__.forEach((function(e) {
                try {
                    Mc(e)
                } catch (e) {
                    t = e
                }
            }
            )),
            r.__H = void 0,
            t && ir.__e(t, r.__v))
        }
        ;
        var $c = "function" == typeof requestAnimationFrame;
        function Lc(e) {
            var t, r = function() {
                clearTimeout(n),
                $c && cancelAnimationFrame(t),
                setTimeout(e)
            }, n = setTimeout(r, 100);
            $c && (t = requestAnimationFrame(r))
        }
        function Mc(e) {
            var t = _c
              , r = e.__c;
            "function" == typeof r && (e.__c = void 0,
            r()),
            _c = t
        }
        function qc(e) {
            var t = _c;
            e.__c = e.__(),
            _c = t
        }
        function Wc(e, t) {
            return !e || e.length !== t.length || t.some((function(t, r) {
                return t !== e[r]
            }
            ))
        }
        function Uc(e, t) {
            return "function" == typeof t ? t(e) : t
        }
        function Bc(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return Qc(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return Qc(e, t)
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function Qc(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        const Vc = function(e) {
            var t = Bc(Ac(e.isCollapsed), 2)
              , r = t[0]
              , n = t[1]
              , i = Bc(Ac(!1), 2)
              , o = i[0]
              , a = i[1]
              , s = function(e) {
                return Rc = 5,
                Dc((function() {
                    return {
                        current: e
                    }
                }
                ), [])
            }(null);
            return function(e, t) {
                var r = Cc(wc++, 3);
                !ir.__s && Wc(r.__H, t) && (r.__ = e,
                r.i = t,
                _c.__H.__h.push(r))
            }((function() {
                var t = s.current;
                if (t)
                    return t.appendChild(e.bodyElement),
                    function() {
                        t.removeChild(e.bodyElement)
                    }
            }
            ), [s, e.bodyElement]),
            o || e.isCollapsed === r || n(e.isCollapsed),
            gr("div", {
                className: rr(e.cssClasses.root, e.hidden && e.cssClasses.noRefinementRoot, e.collapsible && e.cssClasses.collapsibleRoot, r && e.cssClasses.collapsedRoot),
                hidden: e.hidden
            }, e.templates.header && gr("div", {
                className: e.cssClasses.header
            }, gr(Po, {
                templates: e.templates,
                templateKey: "header",
                rootTagName: "span",
                data: e.data
            }), e.collapsible && gr("button", {
                className: e.cssClasses.collapseButton,
                "aria-expanded": !r,
                onClick: function(e) {
                    e.preventDefault(),
                    a(!0),
                    n((function(e) {
                        return !e
                    }
                    ))
                }
            }, gr(Po, {
                templates: e.templates,
                templateKey: "collapseButtonText",
                rootTagName: "span",
                data: {
                    collapsed: r
                }
            }))), gr("div", {
                className: e.cssClasses.body,
                ref: s
            }), e.templates.footer && gr(Po, {
                templates: e.templates,
                templateKey: "footer",
                rootProps: {
                    className: e.cssClasses.footer
                },
                data: e.data
            }))
        };
        function zc(e) {
            return zc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            zc(e)
        }
        function Jc(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Kc(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Jc(Object(r), !0).forEach((function(t) {
                    Yc(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Jc(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Yc(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== zc(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== zc(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === zc(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Gc = qe({
            name: "panel"
        })
          , Xc = n("Panel");
        const Zc = function(e) {
            var t = e || {}
              , r = t.templates
              , n = void 0 === r ? {} : r
              , i = t.hidden
              , o = void 0 === i ? function() {
                return !1
            }
            : i
              , a = t.collapsed
              , s = t.cssClasses
              , c = void 0 === s ? {} : s
              , u = document.createElement("div")
              , l = Boolean(a)
              , f = "function" == typeof a ? a : function() {
                return !1
            }
              , p = {
                root: rr(Xc(), c.root),
                noRefinementRoot: rr(Xc({
                    modifierName: "noRefinement"
                }), c.noRefinementRoot),
                collapsibleRoot: rr(Xc({
                    modifierName: "collapsible"
                }), c.collapsibleRoot),
                collapsedRoot: rr(Xc({
                    modifierName: "collapsed"
                }), c.collapsedRoot),
                collapseButton: rr(Xc({
                    descendantName: "collapseButton"
                }), c.collapseButton),
                collapseIcon: rr(Xc({
                    descendantName: "collapseIcon"
                }), c.collapseIcon),
                body: rr(Xc({
                    descendantName: "body"
                }), c.body),
                header: rr(Xc({
                    descendantName: "header"
                }), c.header),
                footer: rr(Xc({
                    descendantName: "footer"
                }), c.footer)
            };
            return function(e) {
                return function(t) {
                    if (!t || !t.container)
                        throw new Error(Gc("The `container` option is required in the widget within the panel."));
                    var r = Qn(t.container)
                      , i = {
                        collapseButtonText: function(e) {
                            var t = e.collapsed;
                            return '<svg\n          class="'.concat(p.collapseIcon, '"\n          style="width: 1em; height: 1em;"\n          viewBox="0 0 500 500"\n        >\n        <path d="').concat(t ? "M100 250l300-150v300z" : "M250 400l150-300H100z", '" fill="currentColor" />\n        </svg>')
                        }
                    }
                      , a = function(e) {
                        var t = e.containerNode
                          , r = e.bodyContainerNode
                          , n = e.cssClasses
                          , i = e.templates;
                        return function(e) {
                            var o = e.options
                              , a = e.hidden
                              , s = e.collapsible
                              , c = e.collapsed;
                            $r(gr(Vc, {
                                cssClasses: n,
                                hidden: a,
                                collapsible: s,
                                isCollapsed: c,
                                templates: i,
                                data: o,
                                bodyElement: r
                            }), t)
                        }
                    }({
                        containerNode: r,
                        bodyContainerNode: u,
                        cssClasses: p,
                        templates: Kc(Kc({}, i), n)
                    })
                      , s = e(Kc(Kc({}, t), {}, {
                        container: u
                    }));
                    return Kc(Kc({}, s), {}, {
                        init: function() {
                            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                                t[r] = arguments[r];
                            var n, i = t[0], o = Kc(Kc({}, s.getWidgetRenderState ? s.getWidgetRenderState(i) : {}), i);
                            (a({
                                options: o,
                                hidden: !0,
                                collapsible: l,
                                collapsed: !1
                            }),
                            "function" == typeof s.init) && (n = s.init).call.apply(n, [this].concat(t))
                        },
                        render: function() {
                            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
                                t[r] = arguments[r];
                            var n, i = t[0], c = Kc(Kc({}, s.getWidgetRenderState ? s.getWidgetRenderState(i) : {}), i);
                            (a({
                                options: c,
                                hidden: Boolean(o(c)),
                                collapsible: l,
                                collapsed: Boolean(f(c))
                            }),
                            "function" == typeof s.render) && (n = s.render).call.apply(n, [this].concat(t))
                        },
                        dispose: function() {
                            if ($r(null, r),
                            "function" == typeof s.dispose) {
                                for (var e, t = arguments.length, n = new Array(t), i = 0; i < t; i++)
                                    n[i] = arguments[i];
                                return (e = s.dispose).call.apply(e, [this].concat(n))
                            }
                        }
                    })
                }
            }
        };
        var eu = ["classNames", "hits", "itemComponent", "sendEvent", "emptyComponent", "banner", "bannerComponent"];
        function tu(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ru(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? tu(Object(r), !0).forEach((function(t) {
                    nu(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tu(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function nu(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== au(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== au(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === au(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function iu(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], c = !0, u = !1;
                    try {
                        if (o = (r = r.call(e)).next,
                        0 === t) {
                            if (Object(r) !== r)
                                return;
                            c = !1
                        } else
                            for (; !(c = (n = o.call(r)).done) && (s.push(n.value),
                            s.length !== t); c = !0)
                                ;
                    } catch (e) {
                        u = !0,
                        i = e
                    } finally {
                        try {
                            if (!c && null != r.return && (a = r.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (u)
                                throw i
                        }
                    }
                    return s
                }
            }(e, t) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return ou(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return ou(e, t)
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function ou(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function au(e) {
            return au = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            au(e)
        }
        function su(e) {
            var t = e.getIndex
              , r = e.widgetType
              , n = (e.methodName,
            e.args)
              , i = e.instantSearchInstance;
            if (1 === n.length && "object" === au(n[0]))
                return [n[0]];
            var o = iu(n[0].split(":"), 2)
              , a = o[0]
              , s = o[1]
              , c = n[1]
              , u = n[2]
              , l = n[3] || {};
            if (!c)
                return [];
            if (("click" === a || "conversion" === a) && !u)
                return [];
            var f = Array.isArray(c) ? c : [c];
            if (0 === f.length)
                return [];
            var p = f[0].__queryID
              , h = function(e) {
                for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 20, r = [], n = 0; n < Math.ceil(e.length / t); n++)
                    r.push(e.slice(n * t, (n + 1) * t));
                return r
            }(f)
              , d = h.map((function(e) {
                return e.map((function(e) {
                    return e.objectID
                }
                ))
            }
            ))
              , m = h.map((function(e) {
                return e.map((function(e) {
                    return e.__position
                }
                ))
            }
            ));
            return "view" === a ? "idle" !== i.status ? [] : h.map((function(e, n) {
                return {
                    insightsMethod: "viewedObjectIDs",
                    widgetType: r,
                    eventType: a,
                    payload: ru({
                        eventName: u || "Hits Viewed",
                        index: t(),
                        objectIDs: d[n]
                    }, l),
                    hits: e,
                    eventModifier: s
                }
            }
            )) : "click" === a ? h.map((function(e, n) {
                return {
                    insightsMethod: "clickedObjectIDsAfterSearch",
                    widgetType: r,
                    eventType: a,
                    payload: ru({
                        eventName: u || "Hit Clicked",
                        index: t(),
                        queryID: p,
                        objectIDs: d[n],
                        positions: m[n]
                    }, l),
                    hits: e,
                    eventModifier: s
                }
            }
            )) : "conversion" === a ? h.map((function(e, n) {
                return {
                    insightsMethod: "convertedObjectIDsAfterSearch",
                    widgetType: r,
                    eventType: a,
                    payload: ru({
                        eventName: u || "Hit Converted",
                        index: t(),
                        queryID: p,
                        objectIDs: d[n]
                    }, l),
                    hits: e,
                    eventModifier: s
                }
            }
            )) : []
        }
        function cu(e) {
            return cu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            cu(e)
        }
        function uu(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function lu(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? uu(Object(r), !0).forEach((function(t) {
                    fu(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uu(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function fu(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== cu(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== cu(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === cu(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function pu(e) {
            return pu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            pu(e)
        }
        function hu(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function du(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? hu(Object(r), !0).forEach((function(t) {
                    mu(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hu(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function mu(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== pu(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== pu(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === pu(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function gu(e) {
            return gu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            gu(e)
        }
        function yu(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function vu(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? yu(Object(r), !0).forEach((function(t) {
                    bu(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yu(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function bu(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== gu(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== gu(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === gu(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Su = qe({
            name: "hits",
            connector: !0
        });
        const Ou = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, Su()),
            function(r) {
                var n, i, o = r || {}, a = o.escapeHTML, s = void 0 === a || a, c = o.transformItems, u = void 0 === c ? function(e) {
                    return e
                }
                : c;
                return {
                    $$type: "ais.hits",
                    init: function(t) {
                        e(vu(vu({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !0)
                    },
                    render: function(t) {
                        var r = this.getWidgetRenderState(t);
                        e(vu(vu({}, r), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !1),
                        r.sendEvent("view:internal", r.hits)
                    },
                    getRenderState: function(e, t) {
                        return vu(vu({}, e), {}, {
                            hits: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t, o, a, c = e.results, l = e.helper, f = e.instantSearchInstance;
                        if (n || (n = function(e) {
                            var t = e.instantSearchInstance
                              , r = e.getIndex
                              , n = e.widgetType
                              , i = {}
                              , o = void 0;
                            return function() {
                                for (var e = arguments.length, a = new Array(e), s = 0; s < e; s++)
                                    a[s] = arguments[s];
                                su({
                                    widgetType: n,
                                    getIndex: r,
                                    methodName: "sendEvent",
                                    args: a,
                                    instantSearchInstance: t
                                }).forEach((function(e) {
                                    "click" === e.eventType && "internal" === e.eventModifier && i[e.eventType] || (i[e.eventType] = !0,
                                    t.sendEventToInsights(e))
                                }
                                )),
                                clearTimeout(o),
                                o = setTimeout((function() {
                                    i = {}
                                }
                                ), 0)
                            }
                        }({
                            instantSearchInstance: f,
                            getIndex: function() {
                                return l.getIndex()
                            },
                            widgetType: this.$$type
                        })),
                        i || (i = function(e) {
                            var t = e.getIndex
                              , r = e.widgetType
                              , n = e.instantSearchInstance;
                            return function() {
                                for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
                                    i[o] = arguments[o];
                                var a = su({
                                    widgetType: r,
                                    getIndex: t,
                                    methodName: "bindEvent",
                                    args: i,
                                    instantSearchInstance: n
                                });
                                return a.length ? "data-insights-event=".concat(q(a)) : ""
                            }
                        }({
                            getIndex: function() {
                                return l.getIndex()
                            },
                            widgetType: this.$$type,
                            instantSearchInstance: f
                        })),
                        !c)
                            return {
                                hits: [],
                                results: void 0,
                                banner: void 0,
                                sendEvent: n,
                                bindEvent: i,
                                widgetParams: r
                            };
                        s && c.hits.length > 0 && (c.hits = _(c.hits));
                        var p = function(e, t, r) {
                            return e.map((function(e, n) {
                                return lu(lu({}, e), {}, {
                                    __position: r * t + n + 1
                                })
                            }
                            ))
                        }(c.hits, c.page, c.hitsPerPage)
                          , h = function(e, t) {
                            return t ? e.map((function(e) {
                                return du(du({}, e), {}, {
                                    __queryID: t
                                })
                            }
                            )) : e
                        }(p, c.queryID);
                        return {
                            hits: u(h, {
                                results: c
                            }),
                            results: c,
                            banner: null === (t = c.renderingContent) || void 0 === t || null === (o = t.widgets) || void 0 === o || null === (a = o.banners) || void 0 === a ? void 0 : a[0],
                            sendEvent: n,
                            bindEvent: i,
                            widgetParams: r
                        }
                    },
                    dispose: function(e) {
                        var r = e.state;
                        return t(),
                        s ? r.setQueryParameters(Object.keys(b).reduce((function(e, t) {
                            return vu(vu({}, e), {}, bu({}, t, void 0))
                        }
                        ), {})) : r
                    },
                    getWidgetSearchParameters: function(e) {
                        return s ? e.setQueryParameters(b) : e
                    }
                }
            }
        };
        function wu(e) {
            return wu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            wu(e)
        }
        function _u(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function ju(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? _u(Object(r), !0).forEach((function(t) {
                    Pu(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _u(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Pu(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== wu(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== wu(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === wu(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Ru = function(e) {
            var t = e.method
              , r = e.results
              , n = e.hits
              , i = e.objectIDs
              , o = r.index
              , a = function(e, t) {
                return t.map((function(t) {
                    var r = ie(e, (function(e) {
                        return e.objectID === t
                    }
                    ));
                    if (void 0 === r)
                        throw new Error('Could not find objectID "'.concat(t, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
                    return r
                }
                ))
            }(n, i)
              , s = function(e) {
                var t = Ue(e.map((function(e) {
                    return e.__queryID
                }
                )));
                if (t.length > 1)
                    throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
                var r = t[0];
                if ("string" != typeof r)
                    throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
                return r
            }(a);
            switch (t) {
            case "clickedObjectIDsAfterSearch":
                var c = function(e) {
                    return e.map((function(e) {
                        return e.__position
                    }
                    ))
                }(a);
                return {
                    index: o,
                    queryID: s,
                    objectIDs: i,
                    positions: c
                };
            case "convertedObjectIDsAfterSearch":
                return {
                    index: o,
                    queryID: s,
                    objectIDs: i
                };
            default:
                throw new Error('Unsupported method passed to insights: "'.concat(t, '".'))
            }
        };
        function xu(e) {
            return function(t, r) {
                return e((function(e, r) {
                    var n = e.results
                      , i = e.hits
                      , o = e.instantSearchInstance;
                    if (n && i && o) {
                        var a = function(e, t, r) {
                            return function(n) {
                                for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
                                    o[a - 1] = arguments[a];
                                var s = o[0];
                                if (!e) {
                                    var c = qe({
                                        name: "instantsearch"
                                    });
                                    throw new Error(c("The `insightsClient` option has not been provided to `instantsearch`."))
                                }
                                if (!Array.isArray(s.objectIDs))
                                    throw new TypeError("Expected `objectIDs` to be an array.");
                                var u = Ru({
                                    method: n,
                                    results: t,
                                    hits: r,
                                    objectIDs: s.objectIDs
                                });
                                e(n, ju(ju({}, u), s))
                            }
                        }(o.insightsClient, n, i);
                        return t(ju(ju({}, e), {}, {
                            insights: a
                        }), r)
                    }
                    return t(e, r)
                }
                ), r)
            }
        }
        var Eu = function(e) {
            var t = e.insights
              , r = e.sendEvent;
            return function(e) {
                var n = ku(e.target, e.currentTarget, (function(e) {
                    return e.hasAttribute("data-insights-event")
                }
                ));
                n && function(e) {
                    var t = e.getAttribute("data-insights-event");
                    if ("string" != typeof t)
                        throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
                    try {
                        return W(t)
                    } catch (e) {
                        throw new Error("The insights middleware was unable to parse `data-insights-event`.")
                    }
                }(n).forEach((function(e) {
                    return r(e)
                }
                ));
                var i = ku(e.target, e.currentTarget, (function(e) {
                    return e.hasAttribute("data-insights-method") && e.hasAttribute("data-insights-payload")
                }
                ));
                if (i) {
                    var o = function(e) {
                        var t = e.getAttribute("data-insights-method")
                          , r = e.getAttribute("data-insights-payload");
                        if ("string" != typeof r)
                            throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
                        try {
                            return {
                                method: t,
                                payload: W(r)
                            }
                        } catch (e) {
                            throw new Error("The insights helper was unable to parse `data-insights-payload`.")
                        }
                    }(i)
                      , a = o.method
                      , s = o.payload;
                    t(a, s)
                }
            }
        };
        function ku(e, t, r) {
            for (var n = e; n && !r(n); ) {
                if (n === t)
                    return null;
                n = n.parentElement
            }
            return n
        }
        const Iu = {
            empty: function() {
                return "No results"
            },
            item: function(e) {
                return JSON.stringify((r = ["__hitIndex"],
                null == (t = e) ? t : Object.keys(t).reduce((function(e, n) {
                    if (r.indexOf(n) >= 0)
                        return e;
                    var i = n;
                    return e[i] = t[i],
                    e
                }
                ), {})), null, 2);
                var t, r
            }
        };
        function Tu(e) {
            return Tu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Tu(e)
        }
        var Nu = ["hit", "index"];
        function Fu(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Cu(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Fu(Object(r), !0).forEach((function(t) {
                    Au(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fu(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Au(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Tu(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Tu(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Tu(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Du(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        function Hu() {
            return Hu = Object.assign ? Object.assign.bind() : function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var r = arguments[t];
                    for (var n in r)
                        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                }
                return e
            }
            ,
            Hu.apply(this, arguments)
        }
        var $u = qe({
            name: "hits"
        })
          , Lu = function(e) {
            var t = e.createElement
              , r = e.Fragment
              , n = function(e) {
                var t = e.createElement;
                return function(e) {
                    var r = e.classNames
                      , n = e.banner;
                    return n.image.urls[0].url ? t("aside", {
                        className: rr("ais-Hits-banner", r.bannerRoot)
                    }, n.link ? t("a", {
                        className: rr("ais-Hits-banner-link", r.bannerLink),
                        href: n.link.url,
                        target: n.link.target
                    }, t("img", {
                        className: rr("ais-Hits-banner-image", r.bannerImage),
                        src: n.image.urls[0].url,
                        alt: n.image.title
                    })) : t("img", {
                        className: rr("ais-Hits-banner-image", r.bannerImage),
                        src: n.image.urls[0].url,
                        alt: n.image.title
                    })) : null
                }
            }({
                createElement: t,
                Fragment: r
            });
            return function(e) {
                var r = e.classNames
                  , i = void 0 === r ? {} : r
                  , o = e.hits
                  , a = e.itemComponent
                  , s = e.sendEvent
                  , c = e.emptyComponent
                  , u = e.banner
                  , l = e.bannerComponent
                  , f = si(e, eu);
                return t("div", ai({}, f, {
                    className: rr("ais-Hits", i.root, 0 === o.length && rr("ais-Hits--empty", i.emptyRoot), f.className)
                }), u && (l ? t(l, {
                    className: rr("ais-Hits-banner", i.bannerRoot),
                    banner: u
                }) : t(n, {
                    classNames: i,
                    banner: u
                })), 0 === o.length && c ? t(c, null) : t("ol", {
                    className: rr("ais-Hits-list", i.list)
                }, o.map((function(e, r) {
                    return t(a, {
                        key: e.objectID,
                        hit: e,
                        index: r,
                        className: rr("ais-Hits-item", i.item),
                        onClick: function() {
                            s("click:internal", e, "Hit Clicked")
                        },
                        onAuxClick: function() {
                            s("click:internal", e, "Hit Clicked")
                        }
                    })
                }
                ))))
            }
        }({
            createElement: gr,
            Fragment: vr
        })
          , Mu = function(e) {
            var t = e.renderState
              , r = e.cssClasses
              , n = e.containerNode
              , i = e.templates;
            return function(e, o) {
                var a = e.hits
                  , s = e.results
                  , c = e.instantSearchInstance
                  , u = e.insights
                  , l = e.bindEvent
                  , f = e.sendEvent
                  , p = e.banner;
                if (o)
                    t.templateProps = ja({
                        defaultTemplates: Iu,
                        templatesConfig: c.templatesConfig,
                        templates: i
                    });
                else {
                    var h = Eu({
                        insights: u,
                        sendEvent: f
                    });
                    $r(gr(Lu, {
                        hits: a,
                        itemComponent: function(e) {
                            var r = e.hit
                              , n = e.index
                              , i = Du(e, Nu);
                            return gr(Po, Hu({}, t.templateProps, {
                                templateKey: "item",
                                rootTagName: "li",
                                rootProps: Cu(Cu({}, i), {}, {
                                    onClick: function(e) {
                                        h(e),
                                        i.onClick()
                                    },
                                    onAuxClick: function(e) {
                                        h(e),
                                        i.onAuxClick()
                                    }
                                }),
                                data: Cu(Cu({}, r), {}, {
                                    get __hitIndex() {
                                        return n
                                    }
                                }),
                                bindEvent: l,
                                sendEvent: f
                            }))
                        },
                        sendEvent: f,
                        classNames: r,
                        emptyComponent: function(e) {
                            var r = Hu({}, (function(e) {
                                if (null == e)
                                    throw new TypeError("Cannot destructure " + e)
                            }(e),
                            e));
                            return gr(Po, Hu({}, t.templateProps, {
                                rootProps: r,
                                templateKey: "empty",
                                data: s,
                                rootTagName: "fragment"
                            }))
                        },
                        banner: p,
                        bannerComponent: i.banner ? function(e) {
                            return gr(Po, Hu({}, t.templateProps, {
                                templateKey: "banner",
                                data: e,
                                rootTagName: "fragment"
                            }))
                        }
                        : void 0
                    }), n)
                }
            }
        };
        const qu = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.escapeHTML
              , i = t.transformItems
              , o = t.templates
              , a = void 0 === o ? {} : o
              , s = t.cssClasses
              , c = void 0 === s ? {} : s;
            if (!r)
                throw new Error($u("The `container` option is required."));
            var u = Qn(r)
              , l = Mu({
                containerNode: u,
                cssClasses: c,
                renderState: {},
                templates: a
            });
            return Cu(Cu({}, xu(Ou)(l, (function() {
                return $r(null, u)
            }
            ))({
                escapeHTML: n,
                transformItems: i
            })), {}, {
                $$widgetType: "ais.hits"
            })
        };
        function Wu(e) {
            var t = e.templates
              , r = e.templateKey
              , n = e.ariaLabel
              , i = e.pageNumber
              , o = e.className
              , a = e.isDisabled
              , s = void 0 !== a && a
              , c = e.isSelected
              , u = void 0 !== c && c
              , l = e.cssClasses
              , f = e.createURL
              , p = e.createClickHandler;
            return gr("li", {
                className: rr(l.item, s && l.disabledItem, o, u && l.selectedItem)
            }, gr(Po, s ? {
                rootTagName: "span",
                rootProps: {
                    className: l.link,
                    "aria-label": n
                },
                templateKey: r,
                templates: t,
                data: {
                    page: i + 1
                }
            } : {
                rootTagName: "a",
                rootProps: {
                    className: l.link,
                    "aria-label": n,
                    href: f(i),
                    onClick: p(i)
                },
                templateKey: r,
                templates: t,
                data: {
                    page: i + 1
                }
            }))
        }
        const Uu = function(e) {
            function t(t) {
                return function(r) {
                    ti(r) || (r.preventDefault(),
                    e.setCurrentPage(t))
                }
            }
            return gr("div", {
                className: rr(e.cssClasses.root, e.nbPages <= 1 && e.cssClasses.noRefinementRoot)
            }, gr("ul", {
                className: e.cssClasses.list
            }, e.showFirst && gr(Wu, {
                ariaLabel: "First Page",
                className: e.cssClasses.firstPageItem,
                isDisabled: e.isFirstPage,
                templates: e.templates,
                templateKey: "first",
                pageNumber: 0,
                createURL: e.createURL,
                cssClasses: e.cssClasses,
                createClickHandler: t
            }), e.showPrevious && gr(Wu, {
                ariaLabel: "Previous Page",
                className: e.cssClasses.previousPageItem,
                isDisabled: e.isFirstPage,
                templates: e.templates,
                templateKey: "previous",
                pageNumber: e.currentPage - 1,
                createURL: e.createURL,
                cssClasses: e.cssClasses,
                createClickHandler: t
            }), e.pages.map((function(r) {
                return gr(Wu, {
                    key: r,
                    ariaLabel: "Page ".concat(r + 1),
                    className: e.cssClasses.pageItem,
                    isSelected: r === e.currentPage,
                    templates: e.templates,
                    templateKey: "page",
                    pageNumber: r,
                    createURL: e.createURL,
                    cssClasses: e.cssClasses,
                    createClickHandler: t
                })
            }
            )), e.showNext && gr(Wu, {
                ariaLabel: "Next Page",
                className: e.cssClasses.nextPageItem,
                isDisabled: e.isLastPage,
                templates: e.templates,
                templateKey: "next",
                pageNumber: e.currentPage + 1,
                createURL: e.createURL,
                cssClasses: e.cssClasses,
                createClickHandler: t
            }), e.showLast && gr(Wu, {
                ariaLabel: "Last Page, Page ".concat(e.nbPages),
                className: e.cssClasses.lastPageItem,
                isDisabled: e.isLastPage,
                templates: e.templates,
                templateKey: "last",
                pageNumber: e.nbPages - 1,
                createURL: e.createURL,
                cssClasses: e.cssClasses,
                createClickHandler: t
            })))
        };
        function Bu(e) {
            return Bu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Bu(e)
        }
        function Qu(e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, zu(n.key), n)
            }
        }
        function Vu(e, t, r) {
            return (t = zu(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function zu(e) {
            var t = function(e, t) {
                if ("object" !== Bu(e) || null === e)
                    return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== Bu(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === Bu(t) ? t : String(t)
        }
        const Ju = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e),
                Vu(this, "currentPage", void 0),
                Vu(this, "total", void 0),
                Vu(this, "padding", void 0),
                this.currentPage = t.currentPage,
                this.total = t.total,
                this.padding = t.padding
            }
            var t, r, n;
            return t = e,
            (r = [{
                key: "pages",
                value: function() {
                    var e = this.total
                      , t = this.currentPage
                      , r = this.padding;
                    if (0 === e)
                        return [0];
                    var n = this.nbPagesDisplayed(r, e);
                    if (n === e)
                        return qr({
                            end: e
                        });
                    var i = this.calculatePaddingLeft(t, r, e, n);
                    return qr({
                        start: t - i,
                        end: t + (n - i)
                    })
                }
            }, {
                key: "nbPagesDisplayed",
                value: function(e, t) {
                    return Math.min(2 * e + 1, t)
                }
            }, {
                key: "calculatePaddingLeft",
                value: function(e, t, r, n) {
                    return e <= t ? e : e >= r - t ? n - (r - e) : t
                }
            }, {
                key: "isLastPage",
                value: function() {
                    return this.currentPage === this.total - 1 || 0 === this.total
                }
            }, {
                key: "isFirstPage",
                value: function() {
                    return 0 === this.currentPage
                }
            }]) && Qu(t.prototype, r),
            n && Qu(t, n),
            Object.defineProperty(t, "prototype", {
                writable: !1
            }),
            e
        }();
        function Ku(e) {
            return Ku = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Ku(e)
        }
        function Yu(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Gu(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Yu(Object(r), !0).forEach((function(t) {
                    Xu(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yu(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Xu(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Ku(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Ku(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Ku(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Zu = qe({
            name: "pagination",
            connector: !0
        });
        const el = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, Zu()),
            function(r) {
                var n = r || {}
                  , i = n.totalPages
                  , o = n.padding
                  , a = new Ju({
                    currentPage: 0,
                    total: 0,
                    padding: void 0 === o ? 3 : o
                })
                  , s = {};
                return {
                    $$type: "ais.pagination",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(Gu(Gu({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(Gu(Gu({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function(e) {
                        var r = e.state;
                        return t(),
                        r.setQueryParameter("page", void 0)
                    },
                    getWidgetUiState: function(e, t) {
                        var r = t.searchParameters.page || 0;
                        return r ? Gu(Gu({}, e), {}, {
                            page: r + 1
                        }) : e
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var r = t.uiState
                          , n = r.page ? r.page - 1 : 0;
                        return e.setQueryParameter("page", n)
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.results
                          , n = e.helper
                          , o = e.state
                          , c = e.createURL;
                        s.refine || (s.refine = function(e) {
                            n.setPage(e),
                            n.search()
                        }
                        ),
                        s.createURL || (s.createURL = function(e) {
                            return c((function(t) {
                                return Gu(Gu({}, t), {}, {
                                    page: e + 1
                                })
                            }
                            ))
                        }
                        );
                        var u = o.page || 0
                          , l = function(e) {
                            var t = e.nbPages;
                            return void 0 !== i ? Math.min(i, t) : t
                        }(t || {
                            nbPages: 0
                        });
                        return a.currentPage = u,
                        a.total = l,
                        {
                            createURL: s.createURL,
                            refine: s.refine,
                            canRefine: l > 1,
                            currentRefinement: u,
                            nbHits: (null == t ? void 0 : t.nbHits) || 0,
                            nbPages: l,
                            pages: t ? a.pages() : [],
                            isFirstPage: a.isFirstPage(),
                            isLastPage: a.isLastPage(),
                            widgetParams: r
                        }
                    },
                    getRenderState: function(e, t) {
                        return Gu(Gu({}, e), {}, {
                            pagination: this.getWidgetRenderState(t)
                        })
                    }
                }
            }
        };
        function tl(e) {
            return tl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            tl(e)
        }
        function rl(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function nl(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? rl(Object(r), !0).forEach((function(t) {
                    il(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rl(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function il(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== tl(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== tl(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === tl(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var ol = n("Pagination")
          , al = qe({
            name: "pagination"
        })
          , sl = {
            previous: function() {
                return "‹"
            },
            next: function() {
                return "›"
            },
            page: function(e) {
                var t = e.page;
                return "".concat(t)
            },
            first: function() {
                return "«"
            },
            last: function() {
                return "»"
            }
        };
        const cl = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.templates
              , i = void 0 === n ? {} : n
              , o = t.cssClasses
              , a = void 0 === o ? {} : o
              , s = t.totalPages
              , c = t.padding
              , u = t.showFirst
              , l = void 0 === u || u
              , f = t.showLast
              , p = void 0 === f || f
              , h = t.showPrevious
              , d = void 0 === h || h
              , m = t.showNext
              , g = void 0 === m || m
              , y = t.scrollTo
              , v = void 0 === y ? "body" : y;
            if (!r)
                throw new Error(al("The `container` option is required."));
            var b = Qn(r)
              , S = !0 === v ? "body" : v
              , O = !1 !== S && Qn(S)
              , w = {
                root: rr(ol(), a.root),
                noRefinementRoot: rr(ol({
                    modifierName: "noRefinement"
                }), a.noRefinementRoot),
                list: rr(ol({
                    descendantName: "list"
                }), a.list),
                item: rr(ol({
                    descendantName: "item"
                }), a.item),
                firstPageItem: rr(ol({
                    descendantName: "item",
                    modifierName: "firstPage"
                }), a.firstPageItem),
                lastPageItem: rr(ol({
                    descendantName: "item",
                    modifierName: "lastPage"
                }), a.lastPageItem),
                previousPageItem: rr(ol({
                    descendantName: "item",
                    modifierName: "previousPage"
                }), a.previousPageItem),
                nextPageItem: rr(ol({
                    descendantName: "item",
                    modifierName: "nextPage"
                }), a.nextPageItem),
                pageItem: rr(ol({
                    descendantName: "item",
                    modifierName: "page"
                }), a.pageItem),
                selectedItem: rr(ol({
                    descendantName: "item",
                    modifierName: "selected"
                }), a.selectedItem),
                disabledItem: rr(ol({
                    descendantName: "item",
                    modifierName: "disabled"
                }), a.disabledItem),
                link: rr(ol({
                    descendantName: "link"
                }), a.link)
            }
              , _ = nl(nl({}, sl), i)
              , j = function(e) {
                var t = e.containerNode
                  , r = e.cssClasses
                  , n = e.templates
                  , i = e.showFirst
                  , o = e.showLast
                  , a = e.showPrevious
                  , s = e.showNext
                  , c = e.scrollToNode;
                return function(e, u) {
                    var l = e.createURL
                      , f = e.currentRefinement
                      , p = e.nbPages
                      , h = e.pages
                      , d = e.isFirstPage
                      , m = e.isLastPage
                      , g = e.refine;
                    u || $r(gr(Uu, {
                        createURL: l,
                        cssClasses: r,
                        currentPage: f,
                        templates: n,
                        nbPages: p,
                        pages: h,
                        isFirstPage: d,
                        isLastPage: m,
                        setCurrentPage: function(e) {
                            g(e),
                            !1 !== c && c.scrollIntoView()
                        },
                        showFirst: i,
                        showLast: o,
                        showPrevious: a,
                        showNext: s
                    }), t)
                }
            }({
                containerNode: b,
                cssClasses: w,
                templates: _,
                showFirst: l,
                showLast: p,
                showPrevious: d,
                showNext: g,
                scrollToNode: O
            });
            return nl(nl({}, el(j, (function() {
                return $r(null, b)
            }
            ))({
                totalPages: s,
                padding: c
            })), {}, {
                $$widgetType: "ais.pagination"
            })
        };
        function ul(e) {
            return ul = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            ul(e)
        }
        function ll(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function fl(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ll(Object(r), !0).forEach((function(t) {
                    pl(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ll(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function pl(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== ul(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== ul(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === ul(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var hl = qe({
            name: "configure",
            connector: !0
        });
        function dl(e, t) {
            return e.setQueryParameters(Object.keys(t.searchParameters).reduce((function(e, t) {
                return fl(fl({}, e), {}, pl({}, t, void 0))
            }
            ), {}))
        }
        const ml = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ne
              , t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return function(r) {
                if (!r || !h(r.searchParameters))
                    throw new Error(hl("The `searchParameters` option expects an object."));
                var n = {};
                return {
                    $$type: "ais.configure",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(fl(fl({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(fl(fl({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function(e) {
                        var n = e.state;
                        return t(),
                        dl(n, r)
                    },
                    getRenderState: function(e, t) {
                        var r, n = this.getWidgetRenderState(t);
                        return fl(fl({}, e), {}, {
                            configure: fl(fl({}, n), {}, {
                                widgetParams: fl(fl({}, n.widgetParams), {}, {
                                    searchParameters: Ge(new re.SearchParameters(null === (r = e.configure) || void 0 === r ? void 0 : r.widgetParams.searchParameters), new re.SearchParameters(n.widgetParams.searchParameters)).getQueryParams()
                                })
                            })
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.helper;
                        return n.refine || (n.refine = function(e) {
                            return function(t) {
                                var n = dl(e.state, r)
                                  , i = Ge(n, new re.SearchParameters(t));
                                r.searchParameters = t,
                                e.setState(i).search()
                            }
                        }(t)),
                        {
                            refine: n.refine,
                            widgetParams: r
                        }
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var n = t.uiState;
                        return Ge(e, new re.SearchParameters(fl(fl({}, n.configure), r.searchParameters)))
                    },
                    getWidgetUiState: function(e) {
                        return fl(fl({}, e), {}, {
                            configure: fl(fl({}, e.configure), r.searchParameters)
                        })
                    }
                }
            }
        };
        function gl(e) {
            return gl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            gl(e)
        }
        function yl(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function vl(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? yl(Object(r), !0).forEach((function(t) {
                    bl(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yl(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function bl(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== gl(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== gl(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === gl(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        const Sl = function(e) {
            return vl(vl({}, ml(ne)({
                searchParameters: e
            })), {}, {
                $$widgetType: "ais.configure"
            })
        };
        function Ol(e, t) {
            var r, n = null === (r = e.getWidgetRenderState) || void 0 === r ? void 0 : r.call(e, t), i = null;
            if (n && n.widgetParams) {
                var o = n.widgetParams;
                o.attribute ? i = o.attribute : Array.isArray(o.attributes) && (i = o.attributes[0])
            }
            if ("string" != typeof i)
                throw new Error("Could not find the attribute of the widget:\n\n".concat(JSON.stringify(e), "\n\nPlease check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly."));
            return i
        }
        function wl(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function _l(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? wl(Object(r), !0).forEach((function(t) {
                    jl(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wl(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function jl(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== Pl(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== Pl(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === Pl(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Pl(e) {
            return Pl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            Pl(e)
        }
        var Rl = qe({
            name: "dynamic-widgets",
            connector: !0
        });
        const xl = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, Rl()),
            function(r) {
                var n = r.widgets
                  , i = r.maxValuesPerFacet
                  , o = void 0 === i ? 20 : i
                  , a = r.facets
                  , s = void 0 === a ? ["*"] : a
                  , c = r.transformItems
                  , u = void 0 === c ? function(e) {
                    return e
                }
                : c
                  , l = r.fallbackWidget;
                if (!(n && Array.isArray(n) && n.every((function(e) {
                    return "object" === Pl(e)
                }
                ))))
                    throw new Error(Rl("The `widgets` option expects an array of widgets."));
                if (!Array.isArray(s))
                    throw new Error(Rl("The `facets` option only accepts an array of facets, you passed ".concat(JSON.stringify(s))));
                var f = new Map;
                return {
                    $$type: "ais.dynamicWidgets",
                    init: function(t) {
                        n.forEach((function(e) {
                            var r = Ol(e, t);
                            f.set(r, {
                                widget: e,
                                isMounted: !1
                            })
                        }
                        )),
                        e(_l(_l({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.parent
                          , n = this.getWidgetRenderState(t)
                          , i = []
                          , o = [];
                        l && n.attributesToRender.forEach((function(e) {
                            if (!f.has(e)) {
                                var t = l({
                                    attribute: e
                                });
                                f.set(e, {
                                    widget: t,
                                    isMounted: !1
                                })
                            }
                        }
                        )),
                        f.forEach((function(e, t) {
                            var r = e.widget
                              , a = e.isMounted
                              , s = n.attributesToRender.indexOf(t) > -1;
                            !a && s ? (o.push(r),
                            f.set(t, {
                                widget: r,
                                isMounted: !0
                            })) : a && !s && (i.push(r),
                            f.set(t, {
                                widget: r,
                                isMounted: !1
                            }))
                        }
                        )),
                        r.addWidgets(o),
                        setTimeout((function() {
                            return r.removeWidgets(i)
                        }
                        ), 0),
                        e(_l(_l({}, n), {}, {
                            instantSearchInstance: t.instantSearchInstance
                        }), !1)
                    },
                    dispose: function(e) {
                        var r = e.parent
                          , n = [];
                        f.forEach((function(e) {
                            var t = e.widget;
                            e.isMounted && n.push(t)
                        }
                        )),
                        r.removeWidgets(n),
                        t()
                    },
                    getWidgetSearchParameters: function(e) {
                        return s.reduce((function(e, t) {
                            return e.addFacet(t)
                        }
                        ), e.setQueryParameters({
                            maxValuesPerFacet: Math.max(o || 0, e.maxValuesPerFacet || 0)
                        }))
                    },
                    getRenderState: function(e, t) {
                        return _l(_l({}, e), {}, {
                            dynamicWidgets: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t, n, i, o, a = e.results;
                        e.state;
                        if (!a)
                            return {
                                attributesToRender: [],
                                widgetParams: r
                            };
                        var s = u(null !== (t = null === (n = a.renderingContent) || void 0 === n || null === (i = n.facetOrdering) || void 0 === i || null === (o = i.facets) || void 0 === o ? void 0 : o.order) && void 0 !== t ? t : [], {
                            results: a
                        });
                        if (!Array.isArray(s))
                            throw new Error(Rl("The `transformItems` option expects a function that returns an Array."));
                        return {
                            attributesToRender: s,
                            widgetParams: r
                        }
                    }
                }
            }
        };
        function El(e) {
            return El = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            El(e)
        }
        var kl = ["container", "widgets", "fallbackWidget"];
        function Il(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Tl(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Il(Object(r), !0).forEach((function(t) {
                    Nl(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Il(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Nl(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== El(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== El(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === El(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        function Fl(e, t) {
            if (null == e)
                return {};
            var r, n, i = function(e, t) {
                if (null == e)
                    return {};
                var r, n, i = {}, o = Object.keys(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++)
                    r = o[n],
                    t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }
        var Cl = qe({
            name: "dynamic-widgets"
        })
          , Al = n("DynamicWidgets");
        function Dl(e) {
            var t = document.createElement("div");
            return t.className = Al({
                descendantName: "widget"
            }),
            e.appendChild(t),
            t
        }
        const Hl = function(e) {
            var t = e || {}
              , r = t.container
              , n = t.widgets
              , i = t.fallbackWidget
              , o = Fl(t, kl);
            if (!r)
                throw new Error(Cl("The `container` option is required."));
            if (!(n && Array.isArray(n) && n.every((function(e) {
                return "function" == typeof e
            }
            ))))
                throw new Error(Cl("The `widgets` option expects an array of callbacks."));
            var a = Qn(r)
              , s = document.createElement("div");
            s.className = Al();
            var c = new Map
              , u = []
              , l = xl((function(e, t) {
                var r = e.attributesToRender;
                t && a.appendChild(s),
                r.forEach((function(e) {
                    if (c.has(e)) {
                        var t = c.get(e);
                        s.appendChild(t)
                    }
                }
                ))
            }
            ), (function() {
                a.removeChild(s)
            }
            ))
              , f = l(Tl(Tl({}, o), {}, {
                widgets: u,
                fallbackWidget: "function" == typeof i ? function(e) {
                    var t = e.attribute
                      , r = Dl(s);
                    return c.set(t, r),
                    i({
                        attribute: t,
                        container: r
                    })
                }
                : void 0
            }));
            return Tl(Tl({}, f), {}, {
                init: function(e) {
                    n.forEach((function(t) {
                        var r = Dl(s)
                          , n = t(r)
                          , i = Ol(n, e);
                        c.set(i, r),
                        u.push(n)
                    }
                    )),
                    f.init(e)
                },
                $$widgetType: "ais.dynamicWidgets"
            })
        };
        function $l(e) {
            return $l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            }
            : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            }
            ,
            $l(e)
        }
        function Ll(e) {
            return function(e) {
                if (Array.isArray(e))
                    return Ml(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return Ml(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === r && e.constructor && (r = e.constructor.name);
                if ("Map" === r || "Set" === r)
                    return Array.from(e);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                    return Ml(e, t)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function Ml(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++)
                n[r] = e[r];
            return n
        }
        function ql(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }
                ))),
                r.push.apply(r, n)
            }
            return r
        }
        function Wl(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ql(Object(r), !0).forEach((function(t) {
                    Ul(e, t, r[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ql(Object(r)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                }
                ))
            }
            return e
        }
        function Ul(e, t, r) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" !== $l(e) || null === e)
                        return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" !== $l(n))
                            return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === t ? String : Number)(e)
                }(e, "string");
                return "symbol" === $l(t) ? t : String(t)
            }(t))in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r,
            e
        }
        var Bl = qe({
            name: "current-refinements",
            connector: !0
        });
        function Ql(e) {
            var t = e.results
              , r = e.helper
              , n = e.indexId
              , i = e.includedAttributes
              , o = e.excludedAttributes
              , a = -1 !== (i || []).indexOf("query") || -1 === (o || []).indexOf("query")
              , s = i ? function(e) {
                return -1 !== i.indexOf(e.attribute)
            }
            : function(e) {
                return -1 === o.indexOf(e.attribute)
            }
              , c = oc(t, r.state, a).map(Jl).filter(s);
            return c.reduce((function(e, t) {
                return [].concat(Ll(e.filter((function(e) {
                    return e.attribute !== t.attribute
                }
                ))), [{
                    indexName: r.state.index,
                    indexId: n,
                    attribute: t.attribute,
                    label: t.attribute,
                    refinements: c.filter((function(e) {
                        return e.attribute === t.attribute
                    }
                    )).sort((function(e, t) {
                        return "numeric" === e.type ? e.value - t.value : 0
                    }
                    )),
                    refine: function(e) {
                        return zl(r, e)
                    }
                }])
            }
            ), [])
        }
        function Vl(e, t) {
            switch (e = e.resetPage(),
            t.type) {
            case "facet":
                return e.removeFacetRefinement(t.attribute, String(t.value));
            case "disjunctive":
                return e.removeDisjunctiveFacetRefinement(t.attribute, String(t.value));
            case "hierarchical":
                return e.removeHierarchicalFacetRefinement(t.attribute);
            case "exclude":
                return e.removeExcludeRefinement(t.attribute, String(t.value));
            case "numeric":
                return e.removeNumericRefinement(t.attribute, t.operator, String(t.value));
            case "tag":
                return e.removeTagRefinement(String(t.value));
            case "query":
                return e.setQueryParameter("query", "");
            default:
                return e
            }
        }
        function zl(e, t) {
            e.setState(Vl(e.state, t)).search()
        }
        function Jl(e) {
            var t = function(e) {
                if ("numeric" === e.type)
                    return Number(e.name);
                if ("escapedValue"in e)
                    return e.escapedValue;
                return e.name
            }(e)
              , r = e.operator ? "".concat(function(e) {
                switch (e) {
                case ">=":
                    return "≥";
                case "<=":
                    return "≤";
                default:
                    return e
                }
            }(e.operator), " ").concat(e.name) : e.name
              , n = {
                attribute: e.attribute,
                type: e.type,
                value: t,
                label: r
            };
            return void 0 !== e.operator && (n.operator = e.operator),
            void 0 !== e.count && (n.count = e.count),
            void 0 !== e.exhaustive && (n.exhaustive = e.exhaustive),
            n
        }
        const Kl = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ne;
            return Cn(e, Bl()),
            function(r) {
                if ((r || {}).includedAttributes && (r || {}).excludedAttributes)
                    throw new Error(Bl("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
                var n = r || {}
                  , i = n.includedAttributes
                  , o = n.excludedAttributes
                  , a = void 0 === o ? ["query"] : o
                  , s = n.transformItems
                  , c = void 0 === s ? function(e) {
                    return e
                }
                : s;
                return {
                    $$type: "ais.currentRefinements",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(Wl(Wl({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(Wl(Wl({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function() {
                        t()
                    },
                    getRenderState: function(e, t) {
                        return Wl(Wl({}, e), {}, {
                            currentRefinements: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.results
                          , n = e.scopedResults
                          , o = e.createURL
                          , s = e.helper;
                        var u = t ? n.reduce((function(e, r) {
                            return e.concat(c(Ql({
                                results: r.results,
                                helper: r.helper,
                                indexId: r.indexId,
                                includedAttributes: i,
                                excludedAttributes: a
                            }), {
                                results: t
                            }))
                        }
                        ), []) : c(Ql({
                            results: {},
                            helper: s,
                            indexId: s.state.index,
                            includedAttributes: i,
                            excludedAttributes: a
                        }), {
                            results: t
                        });
                        return {
                            items: u,
                            canRefine: u.length > 0,
                            refine: function(e) {
                                return zl(s, e)
                            },
                            createURL: function(e) {
                                return o(Vl(s.state, e))
                            },
                            widgetParams: r
                        }
                    }
                }
            }
        }
          , Yl = (e, t, r) => {
            e && e.props && (e.props[t] === r && delete e.props[t],
            e.props.children && Array.isArray(e.props.children) ? e.props.children.forEach((e => Yl(e, t, r))) : e.props.children && Yl(e.props.children, t, r))
        }
        ;
        const Gl = function(e) {
            if (e.hooks_has_initialize)
                return;
            e.hooks_has_initialize = !0,
            e.hooks = e.hooks || {},
            e.hooks.deprecatedHooks = [],
            e.hooks.deprecatingWarning = ["afterInstantSearchHitClickAction", "afterAutocompleteProductClickAction", "beforeInstantSearchFacetLimitNumber", "beforeISFacetSearchablePlaceholderString", "beforeISFacetSearchableNoResultsString", "beforeInstantSearchFacetHeaderString", "beforeInstantSearchFacetTransformItemsOptions"],
            e.hooks.allowedHooks = ["beforeAutocompleteOptions", "beforeAutocompleteRedirectUrlOptions", "beforeAutocompleteFiltersString", "beforeAutocompleteMainTemplate", "beforeAutocompleteNoResultsTemplate", "beforeAutocompleteArticlesTemplate", "beforeAutocompleteCollectionsTemplate", "beforeAutocompleteFooterTemplate", "beforeAutocompleteHeaderTemplate", "beforeAutocompleteMainProductsTemplate", "beforeAutocompletePagesTemplate", "beforeAutocompleteProductTemplate", "beforeAutocompleteSuggestionsTemplate", "beforeAutocompleteProductTransformResponseHits", "afterAutocompleteProductClickAction", "beforeInstantSearchConfigurationOptions", "beforeInstantSearchOptions", "beforeInstantSearchAllowParamsArray", "beforeInstantSearchFiltersString", "beforeInstantSearchFacetItemTemplate", "beforeInstantSearchShowMoreTemplate", "beforeInstantSearchMainTemplate", "beforeInstantSearchNoResultTemplate", "beforeInstantSearchProductTemplate", "beforeInstantSearchStatsTemplate", "beforeISTransformItems", "beforeISStartAddWidgetArray", "afterISStartRemoveDefaultWidget", "afterInstantSearchHitClickAction", "beforeInstantSearchFacetLimitNumber", "beforeISFacetSearchablePlaceholderString", "beforeISFacetSearchableNoResultsString", "beforeInstantSearchFacetHeaderTemplate", "beforeInstantSearchFacetTransformItemsOptions", "beforeInstantSearchFacetParamsOptions", "beforeInstantSearchFacetPanelOptions", "beforeISearchInitSortOrdersArray", "beforeISInitCollectionSortOrdersArray", "beforeAlgoliaAnalyticsOptions", "beforeAddToCartSelectorString", "beforeRecommendHitTemplate"],
            e.hooks.registeredHooks = [],
            e.hooks.registerHook = (t, r) => {
                e.hooks.deprecatingWarning.indexOf(t) > -1 && console.warn(`Algolia AI Search & Discovery: ${t} will be deprecated and may not be supported in a future release.`),
                e.hooks.deprecatedHooks.indexOf(t) > -1 ? console.error(`Algolia AI Search & Discovery: ${t} has been deprecated. Please use one of ${e.hooks.allowedHooks.join(", ")}`) : -1 !== e.hooks.allowedHooks.indexOf(t) ? e.hooks.registeredHooks[t] ? e.hooks.registeredHooks[t].push(r) : e.hooks.registeredHooks[t] = [r] : console.error(`Algolia AI Search & Discovery: Hook "${t}" cannot be defined. Please use one of ${e.hooks.allowedHooks.join(", ")}`)
            }
            ,
            e.hooks.getRegisteredHooks = t => (-1 === e.hooks.allowedHooks.indexOf(t) && console.error(`Hook "${t}" cannot be defined. Please use one of ${e.hooks.allowedHooks.join(", ")}`),
            e.hooks.registeredHooks[t] ? e.hooks.registeredHooks[t] : []),
            e.hooks.triggerHooks = (t, r, ...n) => {
                try {
                    const i = function(e, t) {
                        switch (e) {
                        case "beforeInstantSearchProductTemplate":
                        case "beforeInstantSearchMainTemplate":
                            Yl(t, "onclick", "void(0)")
                        }
                        return t
                    }(t, e.hooks.getRegisteredHooks(t).reduce(( (e, t) => t(...[...Array.isArray(e) ? e : [e], ...n])), r));
                    return i
                } catch (e) {
                    return console.error(`Error occurred in ${t}:`, e),
                    r
                }
            }
            ;
            const t = new Event("algolia.hooks.initialize");
            document.dispatchEvent(t)
        }
          , Xl = (e, t, r) => {
            const n = e`
    <div class="ais-page">
      <h1 class="ais-h2">検索結果</h1>
      <div class="ais-input">
        <div class="ais-search-box-container"></div>
        <div class="ais-input-button">
          <div class="ais-clear-input-icon"></div>
        </div>
      </div>
      <div class="ais-facets-button">
        フィルターを表示
      </div>
      <div class="ais-facets">
        <div class="ais-clear-refinements-container"></div>
        <div class="ais-current-refined-values-container"></div>
        ${r.config.app_blocks_dynamic_widgets_beta_enabled ? e`<div class="ais-dynamic-widgets-container"></div>` : t.facets.map((t => e`
              <div
                class="ais-facet-dropdown-wrapper ais-facet-${t.type} ais-facet-${t.escapedName}"
              >
                <label
                  for="${t.escapedName}"
                  class="ais-range-slider--header ais-facet--header ais-header"
                  >${t.title}</label
                >
                <input
                  class="ais-dropdown-checkbox"
                  type="checkbox"
                  id="${t.escapedName}"
                  name="dropdown"
                />
                <div
                  class="ais-facet-${t.escapedName}-container ais-facet-dropdown-container"
                ></div>
              </div>
            `))}
      </div>
      <div class="ais-block">
        <div class="ais-search-header">
          <div class="ais-stats-container"></div>
          <div class="ais-change-display">
            <span
              class="ais-change-display-block ais-change-display-selected"
              role="button"
              aria-pressed="true"
              aria-label="grid display"
              ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1664 1450"><path d="M768 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM768 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90z"/></svg>
            </span>
            <span
              class="ais-change-display-list"
              role="button"
              aria-pressed="false"
              aria-label="list display"
              ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1450"><path d="M512 288v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM512 800v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 288v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM512 1312v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 800v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM1792 1312v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68z"/></svg>
            </span>
          </div>
          <div class="ais-sort">
            ${t.multipleSortOrders ? e`
                  ${"ソート順："}
                  <span class="ais-sort-orders-container"></span>
                ` : e`
                  ${"ソート順："}
                  ${r.translations.relevance}
                `}
          </div>
        </div>
        <div class="ais-hits-container ais-results-as-block"></div>
      </div>
      <div class="ais-pagination-container"></div>
    </div>
  `;
            return r.hooks.triggerHooks("beforeInstantSearchMainTemplate", n, t, e)
        }
          , Zl = (e, t) => {
            const r = e`
    <div class="ais-hit-empty">
      <div class="ais-hit-empty--title">
        ${t.translations.noResultFound}
      </div>
      <div class="ais-hit-empty--clears">
        ${t.translations.try} ${" "}
        <a class="ais-hit-empty--clear-filters ais-link">
          ${t.translations.clearFilters} ${" "}
        </a>
        ${t.translations.or} ${" "}
        <a class="ais-hit-empty--clear-input ais-link">
          ${t.translations.changeInput}
        </a>
      </div>
    </div>
  `;
            return t.hooks.triggerHooks("beforeInstantSearchNoResultTemplate", r, e)
        }
          , ef = (e, t, r, n) => {
            const i = n.helpers.localizeHitData(e);
            i._distinct = n.instantsearch.distinct;
            const o = n.helpers.renderImage(i, 250);
            n.helpers.preloadProductHitImage(i);
            const a = t`
    <div
      class="ais-hit ais-product"
      data-algolia-index="${i.index}"
      data-algolia-position="${i.productPosition}"
      data-algolia-queryid="${i.queryID}"
      data-algolia-objectid="${i.objectID}"
      data-handle="${i.handle}"
      data-variant-id="${i.objectID}"
      data-distinct="${i._distinct}"
      data-product-id="${i.id}"
      onClick="${e => n.helpers.handleItemClick(i)}"
    >
      <img
        class="ais-hit--picture"
        src="${o.src}"
        srcset="${o.srcset}"
        sizes="${o.sizes}"
        alt="${i.title} - ${i.variant_title}"
        loading="${Number(i.productPosition) <= 4 ? "eager" : "lazy"}"
        fetchpriority="${Number(i.productPosition) <= 1 ? "high" : "auto"}"
      />

      <div class="ais-hit--details">
        <p class="ais-hit--title">
          <a
            data-algolia-index="${i.index}"
            data-algolia-position="${i.productPosition}"
            data-algolia-queryid="${i.queryID}"
            data-algolia-objectid="${i.objectID}"
            href="${n.helpers.instantsearchLink(i)}"
            title="${n.helpers.fullTitle(i.title, i._distinct, i.variant_title)}"
          >
            ${r.Highlight({
                attribute: "title",
                hit: i
            })}
            ${n.helpers.variantTitleAddition(i, i._distinct)}
          </a>
        </p>
        <p
          class="ais-hit--subtitle"
          title="${i.product_type}${n.translation_helpers.by(i.vendor)}"
        >
          ${r.Highlight({
                attribute: "product_type",
                hit: i
            })}
          ${i.vendor && t`
              <span> ${n.translations.by} </span>
            `}
          ${i.vendor && r.Highlight({
                attribute: "vendor",
                hit: i
            })}
        </p>
        <p class="ais-hit--price">
          <b>${n.helpers.displayPrice(i, i._distinct)}</b>
          ${!i._distinct && t`
              <span class="ais-hit--price-striked"
                ><span
                  >${n.helpers.displayStrikedPrice(i.price, i.compare_at_price)}</span
                ></span
              >
            `}
          ${!i._distinct && t`
              <span class="ais-hit--price-discount"
                >${n.helpers.displayDiscount(i.price, i.compare_at_price, i.price_ratio)}</span
              >
            `}
        </p>
        <!-- Extra info examples - Remove the display: none to show them -->
        <p class="ais-hit--info" style="display: none">
          ${i.sku && t`
              <span class="algolia-sku"
                >${r.Highlight({
                attribute: "sku",
                hit: i
            })}</span
              >
            `}
          ${i.barcode && t`
              <span class="algolia-barcode"
                >${r.Highlight({
                attribute: "barcode",
                hit: i
            })}</span
              >
            `}
          ${i.weight && t`
              <span class="algolia-weight">${i.weight}</span>
            `}
          ${!i.taxable && t`
              <span class="algolia-taxable"
                >${n.translations.taxFree}</span
              >
            `}
        </p>
        <!-- Tags example - Remove the display: none to show them -->
<p class="ais-hit--short_tags">
  ${
    i?._highlightResult?.meta?.custom?.short_tags?.value
      ?.split(';') // ";"で分割
      .map(tag => `<span class="ais-hit--tag">${tag.trim()}</span>`) // trim()で前後の空白を除去
      .join('') // HTML文字列に結合
  }
</p>
        ${!i._distinct && t`
            <form
              id="algolia-add-to-cart-${i.objectID}"
              style="display: none;"
              action="/cart/add"
              method="post"
              enctype="multipart/form-data"
            >
              <input type="hidden" name="id" value="${i.objectID}" />
            </form>
            <p class="ais-hit--cart">
              ${i.can_order ? t`
                    <button
                      class="ais-hit--cart-button"
                      data-form-id="algolia-add-to-cart-${i.objectID}"
                    >
                      ${n.translations.addToCart}
                    </button>
                  ` : t`
                    <button
                      class="ais-hit--cart-button ais-hit--cart-button__disabled"
                    >
                      ${n.translations.outOfStock}
                    </button>
                  `}
            </p>
          `}
      </div>
    </div>
  `;
            return n.hooks.triggerHooks("beforeInstantSearchProductTemplate", a, i, t, r)
        }
          , tf = (e, t, r) => {
            const n = t`
    <span>
      ${e.hasNoResults && r.translations.noResultFound}
      ${e.hasOneResult && t`
          <span class="ais-stats--nb-results">
            1 件見つかりました
          </span>
        `}
      ${e.hasManyResults && t`
          ${e.page * e.hitsPerPage + 1} - ${' '}
          ${Math.min((e.page + 1) * e.hitsPerPage, e.nbHits)} ${' '}
          /
          <span class="ais-stats--nb-results">
            ${" "} ${r.helpers.formatNumber(e.nbHits)} ${" 件見つかりました"}
            
          </span>
        `}
      ${" ("} ${(e.processingTimeMS) / 1000} ${"秒)"} 
    </span>
  `;
            return r.hooks.triggerHooks("beforeInstantSearchStatsTemplate", n, e, t)
        }
          , rf = async function(e) {
            const t = e.externals.instantsearch
              , r = e.externals.algoliasearch
              , n = e.externals.widgets.searchBox
              , i = e.externals.widgets.stats
              , o = e.externals.widgets.sortBy
              , a = e.externals.widgets.clearRefinements
              , s = e.externals.widgets.panel
              , c = e.externals.widgets.hits
              , u = e.externals.widgets.pagination
              , l = e.externals.widgets.configure
              , f = e.externals.widgets.dynamicWidgets
              , p = await e.config.index_suffix
              , h = e.externals.connectors.connectCurrentRefinements
              , d = e.is_collection_results_page && e.config.instant_search_enabled_on_collection
              , m = new Event("algolia.instantsearch.beforeInit");
            if (document.dispatchEvent(m),
            e.is_collection_results_page && !e.config.instant_search_enabled_on_collection)
                return;
            const g = [];
            let y = null
              , v = null
              , b = null;
            if (d) {
                const t = window.location.pathname.match(/\/collections\/([^/]+)/i);
                b = Boolean(t) && 2 === t.length ? t[1] : null,
                y = e.config.collection_id_indexing ? e.current_collection_id ? `collection_ids:"${e.current_collection_id}"` : null : `collections:"${b}"`,
                g.push(y),
                v = e.config.collection_id_query_rules ? e.current_collection_id : b
            }
            let S = null;
            e.config.stock_policy && ("allow" === e.config.stock_policy || ("deny" === e.config.stock_policy ? S = "inventory_quantity > 0" : "continue" === e.config.stock_policy && (S = "inventory_available:true")),
            S && g.push(S));
            const O = "#algolia-shopify-instantsearch"
              , w = d && e.collectionSortOrders ? e.collectionSortOrders : e.sortOrders;
            function _(e) {
                const t = {};
                return Object.keys(e).forEach((function(r) {
                    "configure" !== r && "query" !== r && "q" !== r && (t[r] = e[r])
                }
                )),
                t
            }
            let j = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
            const P = e.hooks.triggerHooks("beforeInstantSearchAllowParamsArray", j);
            let R;
            j = P;
            const x = {
                searchClient: r(e.config.app_id, e.config.search_api_key),
                insights: e.config.analytics_enabled,
                indexName: `${e.config.index_prefix}products${p}`,
                routing: {
                    stateMapping: (E = `${e.config.index_prefix}products${p}`,
                    {
                        stateToRoute: e => {
                            const t = _(e[E] || {});
                            return t.q = e[E].query,
                            Object.assign({}, R, t)
                        }
                        ,
                        routeToState: e => {
                            R || (R = j.reduce((function(t, r) {
                                return t[r] = e[r],
                                t
                            }
                            ), {}));
                            const t = {};
                            return t[E] = _(e || {}),
                            t[E].query = e.q,
                            t
                        }
                    })
                },
                searchFunction: t => {
                    const r = t.getPage();
                    e.instantsearch.distinct && t.setQueryParameter("distinct", !0);
                    const n = g.join(" AND ")
                      , i = e.hooks.triggerHooks("beforeInstantSearchFiltersString", n);
                    i.length && t.setQueryParameter("filters", i),
                    d && (v ? t.setQueryParameter("ruleContexts", [v.toString(), "shopify_default_collection"]) : t.setQueryParameter("ruleContexts", [])),
                    t.setPage(r),
                    t.search()
                }
            };
            var E;
            const k = e.hooks.triggerHooks("beforeInstantSearchConfigurationOptions", x)
              , I = {
                colors: e.config.colors,
                distinct: Boolean(e.config.show_products),
                facets: {
                    hidden: d && e.collectionHiddenFacets ? e.collectionHiddenFacets : e.hiddenFacets,
                    shown: d && e.collectionShownFacets ? e.collectionShownFacets : e.shownFacets,
                    list: d && e.collectionFacets ? e.collectionFacets : e.facets,
                    widgets: d && e.collectionFacetsWidgets ? e.collectionFacetsWidgets : e.facetsWidgets
                },
                hitsPerPage: d && e.config.collections_full_results_hits_per_page ? e.config.collections_full_results_hits_per_page : e.config.products_full_results_hits_per_page,
                search: t(k),
                selector: O,
                sortOrders: w,
                templates: {
                    instantSearchMainTemplate: Xl,
                    instantSearchNoResultTemplate: Zl,
                    instantSearchProductTemplate: ef,
                    instantSearchStatsTemplate: tf
                }
            };
            I.search.client.addAlgoliaAgent("Shopify Integration"),
            I.search.client.addAlgoliaAgent("Shopify App Blocks");
            const T = e.hooks.triggerHooks("beforeInstantSearchOptions", I);
            function N() {
                const t = e.instantsearch.$results.offsetWidth;
                let r = "lg";
                t < 400 ? r = "xs" : t < 800 ? r = "sm" : t < 1200 && (r = "md"),
                e.instantsearch.$results.classList.remove("ais-results-size-xs"),
                e.instantsearch.$results.classList.remove("ais-results-size-sm"),
                e.instantsearch.$results.classList.remove("ais-results-size-md"),
                e.instantsearch.$results.classList.remove("ais-results-size-lg"),
                e.instantsearch.$results.classList.remove("ais-results-size-preload"),
                e.instantsearch.$results.classList.add(`ais-results-size-${r}`)
            }
            if (e.instantsearch = T,
            document.documentElement.style.setProperty("--main-color", `${e.config.colors.main}`),
            document.documentElement.style.setProperty("--secondary-color", `${e.config.colors.secondary}`),
            document.documentElement.style.setProperty("--highlight-bg-color", `${e.helpers.hexToRGB(e.config.colors.highlight)}`),
            !document.querySelector(O))
                throw new Error("Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector");
            e.instantsearch.$results = document.querySelector(e.instantsearch.selector),
            e.render(Xl, e.instantsearch.$results, {
                facets: e.instantsearch.facets.list,
                multipleSortOrders: w.length > 1
            }),
            N(),
            window.addEventListener("resize", (function() {
                N()
            }
            ), {
                passive: !0
            });
            const F = [];
            e.instantsearch.search.addWidgets([{
                init: () => {
                    const e = document.querySelector(".ais-facets-button");
                    e.addEventListener("click", (function() {
                        //alert("AAA");
                        const t = document.querySelector(".ais-facets");
                        //console.log(t);
                        t.classList.contains("ais-facets__shown") ? (e.textContent = "フィルターを隠す",
                        t.classList.remove("ais-facets__shown")) : (e.textContent = "フィルターを表示",
                        t.classList.add("ais-facets__shown"))
                        //理由はわからないが、なぜかこれでうまく動く。テキスト変更の行を加えると動かなくなる。
                        if(t.classList.contains('ais-facets__shown')){
                            t.classList.remove('ais-facets__shown');
                        }else{
                            t.classList.add('ais-facets__shown');
                        }
                    }
                    ), {
                        passive: !0
                    })
                }
            }]),
            e.instantsearch.search.addWidgets([l({
                hitsPerPage: e.instantsearch.hitsPerPage,
                facetingAfterDistinct: e.instantsearch.distinct
            })]);
            const C = n({
                container: ".ais-search-box-container",
                placeholder: "検索条件を入力",
                showReset: !1,
                showSubmit: !1
            });
            F.push(C),
            e.instantsearch.search.addWidgets([{
                init: e => {
                    document.querySelector(".ais-clear-input-icon").addEventListener("click", (function() {
                        e.helper.setQuery("").search();
                        const t = document.querySelector(".ais-search-box--input");
                        t.value = "",
                        t.focus()
                    }
                    ), {
                        passive: !0
                    })
                }
                ,
                render: t => {
                    t.state.query ? document.querySelector(".ais-clear-input-icon").style.display = "" : document.querySelector(".ais-clear-input-icon").style.display = "none";
                    const r = document.querySelector(".ais-SearchBox-input");
                    r && r.setAttribute("aria-label", e.translations.searchForProduct)
                }
            }]);
            const A = i({
                container: ".ais-stats-container",
                templates: {
                    text: (t, {html: r}) => (e.full_results && (document.title = `Search: ${e.helpers.formatNumber(t.nbHits)} for "${t.query}"`),
                    tf(t, r, e))
                }
            });
            if (F.push(A),
            w.length > 1) {
                const t = o({
                    container: ".ais-sort-orders-container",
                    items: e.instantsearch.sortOrders
                });
                F.push(t)
            }
            e.instantsearch.search.addWidgets([{
                init: () => {
                    const e = (e, t, r, n) => {
                        const i = document.querySelector(`.${e}`)
                          , o = document.querySelector(`.${t}`)
                          , a = document.querySelector(`.ais-results-as-${r}`);
                        i.classList.add("ais-change-display-selected"),
                        i.setAttribute("aria-pressed", "true"),
                        o.classList.remove("ais-change-display-selected"),
                        o.setAttribute("aria-pressed", "false"),
                        a.classList.replace(`ais-results-as-${r}`, `ais-results-as-${n}`)
                    }
                    ;
                    document.querySelector(".ais-search-header .ais-change-display-block").addEventListener("click", (function() {
                        e("ais-change-display-block", "ais-change-display-list", "list", "block")
                    }
                    ), {
                        passive: !0
                    }),
                    document.querySelector(".ais-search-header .ais-change-display-list").addEventListener("click", (function() {
                        e("ais-change-display-list", "ais-change-display-block", "block", "list")
                    }
                    ), {
                        passive: !0
                    })
                }
            }]);
            const D = e.instantsearch.facets.hidden.map((function(e) {
                return e.name
            }
            ));
            e.instantsearch.search.addWidgets([{
                getConfiguration: () => ({
                    facets: D,
                    disjunctiveFacets: D
                }),
                init: () => {}
            }]);
            const H = function(t) {
                const r = e.instantsearch.facets.list.find((function(e) {
                    return e.name === t.label
                }
                ));
                return t.refinements.map((function(e) {
                    return `<li class="ais-current-refined-values--item">\n            <a ${(e => Object.keys(e).map((function(t) {
                        return `data-${t}="${encodeURIComponent(e[t] || "")}"`
                    }
                    )).join(" "))(e)} class="ais-current-refined-values--link">\n              <div>\n                <div class="ais-current-refined-values--label">${r.title}</div>\n                : ${e.label} \n              </div>\n            </a>\n          </li>`
                }
                )).join("")
            }
              , $ = h((function(t) {
                const r = t.items
                  , n = t.refine
                  , i = t.widgetParams;
                i.container.innerHTML = `\n    <div class="ais-current-refined-values--header ais-facet--header ais-header">\n      選択中のフィルター\n    </div>\n    <div class="ais-root ais-current-refined-values ais-facet">\n      <ul class="ais-current-refined-values--list">\n        ${r.map(H).join("")}\n      </ul>\n    </div>`,
                Array.prototype.slice.call(i.container.querySelectorAll(".ais-current-refined-values--link")).forEach((function(t) {
                    t.addEventListener("click", (function(t) {
                        const r = Object.keys(t.currentTarget.dataset).reduce((function(r, n) {
                            const i = {};
                            return i[n] = decodeURIComponent(t.currentTarget.dataset[n]),
                            e.assign({}, r, i)
                        }
                        ), {});
                        n(r)
                    }
                    ))
                }
                ))
            }
            ))
              , L = function(e, t) {
                return t.some((function(t) {
                    const r = e.state.isConjunctiveFacet(t.name) && e.state.isFacetRefined(t.name)
                      , n = e.state.isDisjunctiveFacet(t.name) && e.state.isDisjunctiveFacetRefined(t.name)
                      , i = e.state.isHierarchicalFacet(t.name) && e.state.isHierarchicalFacetRefined(t.name)
                      , o = e.state.getNumericRefinements(t.name);
                    return Object.keys(o).some((function(e) {
                        return o[e].length > 0
                    }
                    )) || r || n || i
                }
                ))
            }
              , M = s({
                hidden: t => !L(t.helper, e.instantsearch.facets.list)
            })($)
              , q = s({
                hidden: t => !L(t.helper, e.instantsearch.facets.list)
            })(a);
            e.instantsearch.search.addWidgets([q({
                container: document.querySelector(".ais-clear-refinements-container"),
                templates: {
                    resetLabel: "消去"
                }
            }), M({
                container: document.querySelector(".ais-current-refined-values-container")
            })]);
            const W = e.instantsearch.facets.widgets.map((function(t) {
                const r = e.hooks.triggerHooks("beforeInstantSearchFacetParamsOptions", t.params, t.facet)
                  , n = {
                    hidden: e => {
                        const r = !e.canRefine
                          , n = r ? "none" : ""
                          , i = `.ais-facet-${encodeURIComponent(t.params.attribute).replace(/\./g, "\\.").replace(/\%/g, "\\%")}`
                          , o = document.querySelector(i);
                        return o && (o.style.display = n),
                        r
                    }
                };
                e.config.app_blocks_dynamic_widgets_beta_enabled && (n.templates = t.params.templates);
                const i = e.hooks.triggerHooks("beforeInstantSearchFacetPanelOptions", n, t.facet);
                return e.config.app_blocks_dynamic_widgets_beta_enabled ? e => s({
                    ...i
                })(t.widget)({
                    ...r,
                    container: e
                }) : s({
                    ...i
                })(t.widget)({
                    ...r
                })
            }
            ));
            if (e.config.app_blocks_dynamic_widgets_beta_enabled) {
                const t = f({
                    container: ".ais-dynamic-widgets-container",
                    widgets: W,
                    maxValuesPerFacet: 100
                });
                e.instantsearch.search.addWidgets([t])
            } else
                e.instantsearch.search.addWidgets(W);
            const U = c({
                container: ".ais-hits-container",
                templates: {
                    item: (t, {html: r, components: n}) => ef(t, r, n, e),
                    empty: (t, {html: r}) => Zl(r, e)
                },
                transformItems: t => {
                    const r = t.map((t => {
                        let r = "continue" === t.inventory_policy || t.inventory_quantity > 0;
                        return e.config.app_block_inv_avail_replace_can_order && (r = t.inventory_available),
                        {
                            ...t,
                            _distinct: e.instantsearch.distinct,
                            can_order: r,
                            queryID: t.__queryID,
                            productPosition: t.__position,
                            index: e.instantsearch.search.mainIndex.getIndexName()
                        }
                    }
                    ));
                    return e.hooks.triggerHooks("beforeISTransformItems", r, t)
                }
            });
            F.push(U),
            e.instantsearch.search.addWidgets([{
                init: () => {
                    const t = document.querySelector(".ais-hits-container");
                    t.addEventListener("click", (function(r) {
                        let n, i = r.target;
                        do {
                            if (i.matches(".ais-hit")) {
                                n = i;
                                break
                            }
                            i = i.parentNode
                        } while (i && i !== t);
                        if (!n)
                            return;
                        const o = n
                          , a = o.dataset.handle
                          , s = o.dataset.variantId;
                        let c = "";
                        d && b && (c = `${window.Shopify.routes.root}collections/${b}`),
                        c = `${c}${window.Shopify.routes.root}products/${a}`,
                        s && (c += `?variant=${s}`);
                        const u = new Event("algolia.instantsearch.hitClickAction");
                        document.dispatchEvent(u);
                        const l = e.hooks.triggerHooks("afterInstantSearchHitClickAction", void 0, n);
                        "function" == typeof l ? l() : window.location.href = c
                    }
                    ), {
                        passive: !0
                    })
                }
            }]),
            e.instantsearch.search.addWidgets([{
                init: () => {
                    const e = document.querySelector(".ais-hits-container");
                    e.addEventListener("click", (function(t) {
                        let r, n = t.target;
                        do {
                            if (n.matches(".ais-hit--cart-button")) {
                                r = n;
                                break
                            }
                            n = n.parentNode
                        } while (n && n !== e);
                        if (!r)
                            return;
                        t.stopPropagation();
                        const i = r.dataset.formId;
                        i && document.getElementById(i).submit()
                    }
                    ), {
                        passive: !0
                    })
                }
            }]),
            e.instantsearch.search.addWidgets([{
                init: t => {
                    const r = document.querySelector(".ais-hits-container");
                    r.addEventListener("click", (function(n) {
                        let i, o = n.target;
                        do {
                            if (o.matches(".ais-hit-empty--clear-filters")) {
                                i = o;
                                break
                            }
                            o = o.parentNode
                        } while (o && o !== r);
                        if (!i)
                            return;
                        const a = t.helper;
                        a.clearTags(),
                        e.instantsearch.facets.list.forEach((function(e) {
                            a.clearRefinements(e.name)
                        }
                        )),
                        a.search()
                    }
                    ), {
                        passive: !0
                    }),
                    r.addEventListener("click", (function(e) {
                        let n, i = e.target;
                        do {
                            if (i.matches(".ais-hit-empty--clear-input")) {
                                n = i;
                                break
                            }
                            i = i.parentNode
                        } while (i && i !== r);
                        if (!n)
                            return;
                        t.helper.setQuery("").search();
                        const o = document.querySelector(".ais-search-box--input");
                        o.value = "",
                        o.focus()
                    }
                    ), {
                        passive: !0
                    })
                }
            }]);
            const B = u({
                container: ".ais-pagination-container",
                padding: 2,
                maxPages: 20
            });
            F.push(B),
            e.instantsearch.search.addWidgets([...F]);
            const Q = e.hooks.triggerHooks("beforeISStartAddWidgetArray", []);
            Q.length && e.instantsearch.search.addWidgets([...Q]),
            e.instantsearch.search.start();
            const V = e.hooks.triggerHooks("afterISStartRemoveDefaultWidget", [], F);
            V.length && (V.forEach((t => {
                e.helpers.removeDefaultWidgetContainers(t)
            }
            )),
            e.instantsearch.search.removeWidgets([...V]));
            const z = new Event("algolia.instantSearch.onError");
            e.instantsearch.search.on("error", ( ({error: e}) => {
                document.dispatchEvent(z, {
                    error: e
                })
            }
            ));
            const J = new Event("algolia.instantSearch.onRender");
            e.instantsearch.search.on("render", ( () => {
                document.dispatchEvent(J)
            }
            ));
            const K = new Event("algolia.instantSearch.afterInit");
            document.dispatchEvent(K)
        }
          , nf = async function(e) {
            const t = new Event("algolia.instantsearch.beforeInitFacets");
            document.dispatchEvent(t);
            const r = await e.config.index_suffix
              , n = e.externals.widgets.rangeSlider
              , i = e.externals.widgets.menu
              , o = e.externals.widgets.refinementList
              , a = e.translations
              , s = e.hooks.triggerHooks("beforeInstantSearchFacetLimitNumber", parseInt(e.config.default_facet_param_limit || 10, 10))
              , c = {
                slider: {
                    name: "rangeSlider",
                    useDefault: !0,
                    widget: n
                },
                menu: {
                    name: "menu",
                    params: {
                        limit: s
                    },
                    widget: i
                },
                conjunctive: {
                    name: "refinementList",
                    params: {
                        operator: "and",
                        limit: s
                    },
                    widget: o
                },
                disjunctive: {
                    name: "refinementList",
                    params: {
                        operator: "or",
                        limit: s
                    },
                    widget: o
                }
            };
            if (r && e.config.app_block_translated_option_names_enabled) {
                const t = `${e.config.index_prefix}products${r}`
                  , n = await e.helpers.retrieveOptionNames(t);
                Object.keys(n).length > 0 && (e.config.facets = ( (e, t) => {
                    const r = Object.keys(t).reduce(( (e, t) => {
                        if (-1 === t.indexOf("---"))
                            return e;
                        const [r,n] = t.split("---");
                        return e[r] = n,
                        e
                    }
                    ), {});
                    return e.map((e => {
                        if (-1 === e.name.indexOf("options."))
                            return e;
                        const t = e.name.split(".")[1];
                        if (r[t]) {
                            const n = r[t].replace(/_/g, " ").replace(/\b\w/g, (e => e.toUpperCase()));
                            return {
                                ...e,
                                title: n
                            }
                        }
                        return e
                    }
                    ))
                }
                )(e.config.facets, n))
            }
            var u;
            e.facetSortFunctions = {
                price_range: (u = function(e, t) {
                    return e.name.length === t.name.length ? e.name.localeCompare(t.name) : e.name.length - t.name.length
                }
                ,
                function(e, t) {
                    if (e.refined !== t.refined) {
                        if (e.refined)
                            return -1;
                        if (t.refined)
                            return 1
                    }
                    return u(e, t)
                }
                )
            },
            e.facetDisplayFunctions = {
                price_range: function(t) {
                    return t.split(":").map((t => e.formatMoney(100 * Number(t)).replace(/\.\d+/, ""))).join(" - ")
                }
            },
            e.facetCssClasses = {
                root: "ais-facet",
                header: "ais-facet--header",
                body: "ais-facet--body",
                item: "ais-facet--item",
                label: "ais-facet--label",
                checkbox: "ais-facet--checkbox",
                active: "ais-facet--active",
                count: Boolean(e.config.show_products) ? "ais-facet--count-distinct" : "ais-facet--count"
            };
            const l = e.config.facets.filter((e => e.enabled || parseInt(e.enabled, 10)));
            e.facets = l.map((e => {
                const t = a?.facets?.find((t => t.name === e.name))
                  , r = t ? t.title : e.title;
                return {
                    ...e,
                    title: r,
                    escapedName: encodeURIComponent(e.name)
                }
            }
            )),
            e.shownFacets = e.facets.filter((e => "hidden" !== e.type)),
            e.hiddenFacets = e.config.facets.filter((e => "hidden" === e.type));
            const f = function(t) {
                const r = c[t.type]
                  , n = e.assign({}, r.params);
                if (n.container = `[class~='ais-facet-${t.escapedName}-container']`,
                n.attribute = t.name,
                n.templates = {},
                n.cssClasses = e.facetCssClasses,
                t.limit && (n.limit = t.limit),
                n.templates.showMoreText = function(t, {html: r}) {
                    return ( (e, t, r) => {
                        const n = t`
    <span
      >${e.isShowingMore ? r.translations.showLess : r.translations.showMore}</span
    >
  `;
                        return r.hooks.triggerHooks("beforeInstantSearchShowMoreTemplate", n, e, t)
                    }
                    )(t, r, e)
                }
                ,
                t.searchable) {
                    n.searchable = !0;
                    const r = e.hooks.triggerHooks("beforeISFacetSearchablePlaceholderString", `Search for ${t.title}`, t);
                    n.searchablePlaceholder = r;
                    const i = e.hooks.triggerHooks("beforeISFacetSearchableNoResultsString", `<div> No matching for ${t.title}</div>`, t);
                    n.templates.searchableNoResults = i
                }
                n.templates.header = (r, {html: n}) => {
                    const i = n`
        <div
          class="ais-facet-dropdown-wrapper ais-facet-${t.type} ais-facet-${t.escapedName}"
        >
          <label
            for="${t.escapedName}"
            class="ais-range-slider--header ais-facet--header ais-header ${e.skeletonLoaderDisabled ? "" : "ais-facet--header-skeleton"}"
            >${t.title}</label
          >
          <input
            class="ais-dropdown-checkbox"
            type="checkbox"
            id="${t.escapedName}"
            name="dropdown"
          />
        </div>
      `;
                    return e.hooks.triggerHooks("beforeInstantSearchFacetHeaderTemplate", i, t, r, n)
                }
                ,
                r.useDefault || (n.templates.item = (t, {html: r}) => (t.attribute = n.attribute,
                ( (e, t, r) => {
                    const n = t`
    <label class="${e.cssClasses.label}">
      ${"disjunctive" === e.type && (e.isRefined ? t`
              <input
                type="checkbox"
                class="${e.cssClasses.checkbox}"
                checked
              />
            ` : t`
              <input type="checkbox" class="${e.cssClasses.checkbox}" />
            `)}
      ${e.label}
      <span class="${e.cssClasses.count}">
        ${r.helpers.formatNumber(e.count)}
      </span>
    </label>
  `;
                    return r.hooks.triggerHooks("beforeInstantSearchFacetItemTemplate", n, e, t)
                }
                )(t, r, e))),
                e.facetSortFunctions[t.name] && (n.sortBy = e.facetSortFunctions[t.name]);
                const i = e.facetDisplayFunctions[t.name];
                n.transformItems = r => {
                    const n = r.map((e => ({
                        ...e,
                        type: t.type,
                        label: i ? i(e.value) : e.value
                    })));
                    return e.hooks.triggerHooks("beforeInstantSearchFacetTransformItemsOptions", n, r)
                }
                ;
                return {
                    name: r.name,
                    widget: r.widget,
                    params: n,
                    facet: t
                }
            }
              , p = e.current_collection_id && e.config.collection_facets && e.config.collection_facets[e.current_collection_id] ? e.config.collection_facets[e.current_collection_id] : e.config.collection_facets && e.config.collection_facets.default;
            if (p) {
                const t = p.filter((e => e.enabled || parseInt(e.enabled, 10)));
                e.collectionFacets = t.map((e => ({
                    ...e,
                    escapedName: encodeURIComponent(e.name)
                }))),
                e.collectionShownFacets = e.collectionFacets.filter((e => "hidden" !== e.type)),
                e.collectionHiddenFacets = p.filter((e => "hidden" === e.type)),
                e.collectionFacetsWidgets = e.collectionShownFacets.map(f)
            }
            e.facetsWidgets = e.shownFacets.map(f)
        };
        const of = async function(e) {
            const t = window[window.AlgoliaAnalyticsObject];
            if (!e.config.analytics_enabled || !t)
                return;
            if (e.analytics_has_initialize)
                return;
            e.analytics_has_initialize = !0;
            const r = new Event("algolia.analytics.beforeInit");
            document.dispatchEvent(r);
            const n = e.hooks.triggerHooks("beforeAlgoliaAnalyticsOptions", {
                partial: !0
            })
              , i = (await e.config.index_suffix,
            "enabled" === e.config.usertoken_with_cookies);
            let o = !1;
            i ? window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
            }], (async e => {
                e && console.error("Customer Privacy API Error", e);
                const r = !!window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.userCanBeTracked();
                o = i && r,
                t("init", {
                    ...n,
                    useCookie: o
                }),
                t("addAlgoliaAgent", "Shopify Integration");
                const a = JSON.parse(localStorage.getItem("algolia_config") || {});
                a.user_token = await function(e) {
                    return new Promise((t => {
                        e("getUserToken", null, ( (e, r) => t(e || void 0 === r ? null : r)))
                    }
                    ))
                }(t),
                localStorage.setItem("algolia_config", JSON.stringify(a))
            }
            )) : (t("init", {
                ...n,
                useCookie: o
            }),
            t("addAlgoliaAgent", "Shopify Integration"));
            const a = `${e.config.index_prefix}products`;
            localStorage.setItem("algolia_analytics_options", JSON.stringify(n)),
            localStorage.setItem("algolia_config", JSON.stringify({
                app_id: e.config.app_id,
                search_api_key: e.config.search_api_key,
                index_name: a,
                useCookie: o
            }));
            const s = "algolia_analytics_clicked_objects";
            if (e.saveForConversionTracking = e => {
                try {
                    const t = localStorage.getItem(s) || "[]"
                      , r = JSON.parse(t);
                    r.push(e),
                    localStorage.setItem(s, JSON.stringify(r))
                } catch (e) {
                    console.error(e)
                }
            }
            ,
            e.sendAnalyticsEventData = (r, i, a, s, c=void 0, u=void 0) => {
                t("init", {
                    appId: e.config.app_id,
                    apiKey: e.config.search_api_key,
                    ...n,
                    useCookie: o
                });
                const l = {
                    index: i,
                    eventType: a,
                    eventName: s,
                    objectIDs: r
                };
                c && (l.queryID = c),
                u && (l.positions = u),
                t("sendEvents", [l])
            }
            ,
            e.config.app_block_analytics_disabled)
                return;
            const c = e.hooks.triggerHooks("beforeAddToCartSelectorString", '[name="add"]')
              , u = document.querySelector(c);
            u && !e.config.app_block_analytics_disabled && u.addEventListener("click", (function() {
                ( () => {
                    try {
                        const r = localStorage.getItem(s);
                        r && JSON.parse(r).forEach((r => {
                            t("init", {
                                appId: e.config.app_id,
                                apiKey: e.config.search_api_key,
                                ...n,
                                useCookie: o
                            }),
                            t("addAlgoliaAgent", "Shopify Integration"),
                            t("convertedObjectIDsAfterSearch", r)
                        }
                        ))
                    } catch (e) {
                        console.error(e)
                    }
                    try {
                        localStorage.removeItem(s)
                    } catch (e) {
                        console.error(e)
                    }
                }
                )()
            }
            ), {
                passive: !0
            })
        };
        window.algoliaShopify = window.algoliaShopify || {},
        window.algoliaShopify.externals = window.algoliaShopify.externals || {},
        window.algoliaShopify.externals.algoliasearch = t(),
        window.algoliaShopify.externals.instantsearch = tr,
        window.algoliaShopify.externals.widgets = {
            rangeSlider: ei,
            menu: Fa,
            refinementList: is,
            searchBox: vs,
            stats: Ms,
            sortBy: ec,
            clearRefinements: Oc,
            panel: Zc,
            hits: qu,
            pagination: cl,
            configure: Sl,
            dynamicWidgets: Hl
        },
        window.algoliaShopify.externals.connectors = {
            connectCurrentRefinements: Kl
        },
        window.addEventListener("DOMContentLoaded", ( () => {
            let e = !1;
            const t = document.querySelector("#ais-first-product-image");
            function r() {
                e || (e = !0,
                async function(e) {
                    Gl(e),
                    function(e) {
                        if (e.init_has_initialize)
                            return;
                        e.init_has_initialize = !0,
                        e.storeName = window.location.hostname.replace(/^www\./, "").replace(/^([^.]*)\..*$/, "$1"),
                        e.full_results = Boolean(window.location.href.match(/\/search/)),
                        e.is_collection_results_page = Boolean(window.location.pathname.match(/(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/([^/]+)[/]*$/)),
                        e.current_collection_id = e?.shopify?.collection_id || null,
                        e.assign = function(e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var r = arguments[t];
                                for (var n in r)
                                    Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                            }
                            return e
                        }
                        ;
                        let t = null;
                        e.config.markets_indexing_enabled && e.config.markets_mapping.length > 1 && (t = e.shopify.market.multicurrency_default_format.split(":")),
                        e.formatMoney = function(r, n=!1) {
                            let i = r;
                            const o = (i / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            let a = e.money_format;
                            t && n && t[0].toUpperCase() == n.toUpperCase() && (a = t[1].replace(/^\s+|\s+$/g, ""));
                            let s = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
                            if (a.match(s))
                                return a.replace(s, `$1${o}$2`);
                            if (s = /^([^{}]*)\{\{amount_with_comma_separator\}\}([^{}]*)$/,
                            a.match(s)) {
                                let e = o.replace(/[.]/, "|");
                                return e = e.replace(/[,]/, "."),
                                e = e.replace(/[|]/, ","),
                                a.replace(s, `$1${e}$2`)
                            }
                            try {
                                if (window.Shopify && window.Shopify.formatMoney)
                                    return window.Shopify.formatMoney(i, a)
                            } catch (e) {
                                console.error("Error while formatting money", e)
                            }
                            return `$${o}`
                        }
                    }(e),
                    function(e) {
                        if (e.helpers_has_initialize)
                            return;
                        e.helpers_has_initialize = !0;
                        const t = e.externals.render
                          , r = e.externals.html
                          , n = e.externals.algoliasearch;
                        e.searchClient = n(e.config.app_id, e.config.search_api_key),
                        e.render = (n, i, o) => t(n(r, o, e), i);
                        const i = e => {
                            const t = !e._distinct && e.objectID !== e.id;
                            return `${window.Shopify.routes.root}products/${e.handle}${t ? `?variant=${e.objectID}` : ""}`
                        }
                          , o = function(t, r=!1) {
                            return e.formatMoney(100 * Number(t), r)
                        };
                        e.is_mobile_device = ( () => {
                            let e = !1;
                            if ("maxTouchPoints"in navigator)
                                e = navigator.maxTouchPoints > 0;
                            else if ("mxMaxTouchPoints"in navigator)
                                e = navigator.mxMaxTouchPoints > 0;
                            else {
                                const t = matchMedia?.("(pointer:coarse)");
                                if ("(pointer:coarse)" === t?.media)
                                    e = Boolean(t.matches);
                                else if ("orientation"in window)
                                    e = !0;
                                else {
                                    const t = navigator.userAgent;
                                    e = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(t) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(t)
                                }
                            }
                            return e
                        }
                        )(),
                        e.helpers = {
                            removeDefaultWidgetContainers: e => {
                                let t;
                                switch (e.$$widgetType) {
                                case "ais.searchBox":
                                    t = ".ais-SearchBox";
                                    break;
                                case "ais.stats":
                                    t = ".ais-Stats";
                                    break;
                                case "ais.sortBy":
                                    t = ".ais-SortBy";
                                    break;
                                case "ais.hits":
                                    t = ".ais-Hits";
                                    break;
                                case "ais.pagination":
                                    t = ".ais-Pagination"
                                }
                                if (t) {
                                    const e = document.querySelector(t);
                                    e && e.remove()
                                }
                            }
                            ,
                            preloadProductHitImage: t => {
                                if (e.is_mobile_device && !e.has_preloaded_images && (4 === Number(t.productPosition) && (e.has_preloaded_images = !0),
                                Number(t.productPosition) <= 4)) {
                                    const r = document.createElement("link");
                                    r.rel = "preload",
                                    r.as = "image",
                                    r.href = e.helpers.renderImage(t, 125).src,
                                    r.imagesrcset = e.helpers.renderImage(t, 125).srcset,
                                    r.imagesizes = e.helpers.renderImage(t, 125).sizes,
                                    document.getElementsByTagName("head")[0].appendChild(r)
                                }
                            }
                            ,
                            handleItemClick: async t => {
                                if (e.config.analytics_enabled) {
                                    const r = e.config.index_prefix
                                      , n = e.helpers.marketsEnabled() ? await e.config.index_suffix : "";
                                    try {
                                        const i = {
                                            eventName: "Added to cart",
                                            index: `${r}products${n}`,
                                            queryID: t.__queryID || t.__autocomplete_queryID,
                                            objectIDs: [t.objectID],
                                            productId: t.id
                                        };
                                        e.saveForConversionTracking(i)
                                    } catch (e) {
                                        console.error("Error in Algolia click function", e)
                                    }
                                }
                            }
                            ,
                            marketsEnabled: function() {
                                return Boolean(e.config.markets_indexing_enabled && e.config.markets_mapping?.length)
                            },
                            activeCurrencyCode: function() {
                                return Shopify.currency.active.toLowerCase()
                            },
                            formatNumber: function(e) {
                                return Number(e).toLocaleString()
                            },
                            localizeHitData: t => {
                                if (e.helpers.marketsEnabled() && (t.currency = e.config.store_currency.toLowerCase()),
                                !e.helpers.marketsEnabled() || e.helpers.activeCurrencyCode() === e.config.store_currency.toLowerCase())
                                    return t;
                                const r = `market_pricing_${e.helpers.activeCurrencyCode()}`;
                                return r in t && (t.price = t[r]?.price || t.price,
                                t.compare_at_price = t[r]?.compare_at_price || t.compare_at_price,
                                t.variants_min_price = t[r]?.variants_min_price || t.variants_min_price,
                                t.variants_max_price = t[r]?.variants_max_price || t.variants_max_price,
                                t.variants_compare_at_price_min = t[r]?.variants_compare_at_price_min || t.variants_compare_at_price_min,
                                t.variants_compare_at_price_max = t[r]?.variants_compare_at_price_max || t.variants_compare_at_price_max,
                                t.price_ratio = t[r]?.price_ratio || t.price_ratio,
                                t.currency = r.split("_").pop()),
                                t
                            }
                            ,
                            displayPrice: function(e, t) {
                                if (t) {
                                    const t = e.variants_min_price
                                      , r = e.variants_max_price
                                      , n = e.currency || !1;
                                    if (t && r && t !== r)
                                        return `${o(t, n)} - ${o(r, n)}`
                                }
                                return o(e.price, e.currency)
                            },
                            displayStrikedPrice: function(e, t, r) {
                                return Number(t) && Number(t) > Number(e) ? o(t, r) : ""
                            },
                            displayDiscount: function(e, t, r) {
                                const n = 1 - r;
                                return Number(t) && Number(t) > Number(e) ? `- ${Math.floor(100 * n)} %` : ""
                            },
                            instantsearchLink: e => i(e),
                            productLink: e => i(e),
                            fullTitle: function(e, t, r) {
                                let n = e;
                                return !t && r && "Default Title" !== r && "Default" !== r && (n += ` ( ${r} )`),
                                (n || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;")
                            },
                            variantTitleAddition: function(e, t) {
                                let r = " ";
                                return !t && e.variant_title && "Default Title" !== e.variant_title && "Default" !== e.variant_title && (r += `( ${e.variant_title} )`),
                                r
                            },
                            hexToRGB: function(e) {
                                if (!e)
                                    return "";
                                4 == e.length && (e = e.substring(1).replace(/./g, "$&$&"));
                                const t = e.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
                                return `${parseInt(t[1], 16)},${parseInt(t[2], 16)},${parseInt(t[3], 16)}`
                            },
                            sizedImage: function(e, t, r) {
                                const n = r ? t.product_image : t.image;
                                if (!n)
                                    return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
                                const i = e.replace(/^\s+|\s+$/g, "");
                                return "original" === i ? n : n.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${i}.$2`)
                            },
                            retrieveOptionNames: async e => (await window.algoliaShopify.searchClient.initIndex(e).search("", {
                                hitsPerPage: 0,
                                facets: ["option_names"],
                                maxValuesPerFacet: 1e3,
                                analytics: !1
                            })).facets.option_names,
                            index_suffix: function() {
                                const t = "algolia_market";
                                let r = ""
                                  , n = !1;
                                return async function() {
                                    if (n)
                                        return r;
                                    if (e.config.markets_indexing_enabled && e.config.markets_mapping?.length) {
                                        let i = !0;
                                        try {
                                            const o = JSON.parse(localStorage.getItem(t) || "{}");
                                            o.id == e.shopify.market.id && o.locale == e.shopify.market.language.shop_locale.locale && (r = o.suffix ? `_${o.suffix}` : "",
                                            i = !1,
                                            n = !0)
                                        } catch (e) {
                                            localStorage.removeItem(t),
                                            r = "",
                                            n = !0
                                        }
                                        if (i)
                                            try {
                                                const i = `${e.shopify.market.id}_${e.shopify.market.language.shop_locale.locale}`
                                                  , o = e.config.markets_mapping.find((e => e.key === i));
                                                if (o) {
                                                    const i = o.suffix ? `_${o.suffix}` : ""
                                                      , a = `${e.config.index_prefix}products${i}`
                                                      , s = e.searchClient.initIndex(a);
                                                    await s.search("", {
                                                        analytics: !1,
                                                        page: 1,
                                                        hitsPerPage: 1
                                                    }),
                                                    r = i,
                                                    localStorage.setItem(t, JSON.stringify(o)),
                                                    n = !0
                                                }
                                            } catch (e) {
                                                localStorage.removeItem(t),
                                                r = "",
                                                n = !0
                                            }
                                        return r
                                    }
                                    return r
                                }
                            }()
                        },
                        e.config.index_suffix = e.helpers.index_suffix(),
                        ["pico", "icon", "thumb", "small", "compact", "medium", "large", "grande", "original"].forEach((function(t) {
                            e.helpers[`${t}Image`] = function(e) {
                                const r = e.distinct ? e.product_image : e.image;
                                return r ? "original" === t ? r : r.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${t}.$2`) : "http://cdn.shopify.com/s/images/admin/no-image-compact.gif"
                            }
                        }
                        )),
                        e.helpers.renderImage = function(e, t=125) {
                            const r = e.distinct ? e.product_image : e.image;
                            if (!r)
                                return {
                                    src: "http://cdn.shopify.com/s/images/admin/no-image-compact.gif",
                                    srcset: "",
                                    sizes: ""
                                };
                            const n = [`${r.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${t}x.$2`)} 1x`, `${r.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${2 * t}x.$2`)} 2x`, `${r.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${3 * t}x.$2`)} 3x`].join(", ");
                            return {
                                src: r.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${t}x.$2`),
                                srcset: n,
                                sizes: `(max-width: ${t}px) 100vw, ${t}px`
                            }
                        }
                    }(e),
                    function(e) {
                        e.translations_has_initialize || (e.translations_has_initialize = !0,
                        e.translations = {
                            ...e.shopify.market.translations
                        },
                        e.translation_helpers = {
                            no_result_for: t => `${e.translations.noResultFor} " ${t} ".`,
                            in: t => `${e.translations.in} ${t / 1e3}s`,
                            outOf: (t, r, n) => `${t * r + 1} - ${Math.min((t + 1) * r, n)} ${e.translations.outOf}`,
                            by: t => t ? ` ${e.translations.by} ${t}` : "",
                            render_title: (e, t) => "Products" === e && t ? `${e} for ${t}` : e
                        })
                    }(e),
                    await async function(e) {
                        const t = new Event("algolia.instantsearch.beforeInitSortOrders");
                        document.dispatchEvent(t);
                        const r = e.translations
                          , n = await e.config.index_suffix
                          , i = `${e.config.index_prefix}products${n}`
                          , o = r?.sort_orders?.find((e => "relevant" === e.key))
                          , a = [{
                            value: i,
                            label: `${o ? o.title : e.translations.relevance}`
                        }];
                        e.config.sort_orders.forEach((function(e) {
                            if (e.asc && (!0 === e.asc.active || "1" === e.asc.active)) {
                                const t = r?.sort_orders?.find((t => `${t.key}` == `${e.key}_asc`));
                                a.push({
                                    value: `${i}_${e.key}_asc`,
                                    label: t ? t.title : e.asc.title
                                })
                            }
                            if (e.desc && (!0 === e.desc.active || "1" === e.desc.active)) {
                                const t = r?.sort_orders?.find((t => `${t.key}` == `${e.key}_desc`));
                                a.push({
                                    value: `${i}_${e.key}_desc`,
                                    label: t ? t.title : e.desc.title
                                })
                            }
                        }
                        ));
                        const s = e.hooks.triggerHooks("beforeISearchInitSortOrdersArray", a, e.config.sort_orders);
                        e.sortOrders = s;
                        const c = e.current_collection_id && e.config.collection_sort_orders && e.config.collection_sort_orders[e.current_collection_id] ? e.config.collection_sort_orders[e.current_collection_id] : e.config.collection_sort_orders && e.config.collection_sort_orders.default;
                        if (c) {
                            const t = [{
                                value: i,
                                label: `${e.translations.relevance}`
                            }];
                            c.forEach((function(e) {
                                !e.asc || !0 !== e.asc.active && "1" !== e.asc.active || t.push({
                                    value: `${i}_${e.key}_asc`,
                                    label: e.asc.title
                                }),
                                !e.desc || !0 !== e.desc.active && "1" !== e.desc.active || t.push({
                                    value: `${i}_${e.key}_desc`,
                                    label: e.desc.title
                                })
                            }
                            ));
                            const r = e.hooks.triggerHooks("beforeISInitCollectionSortOrdersArray", t, c);
                            e.collectionSortOrders = r
                        }
                    }(e),
                    await nf(e),
                    await rf(e),
                    await of(e)
                }(window.algoliaShopify))
            }
            if (!t)
                return void r();
            if (t.complete && t.naturalWidth > 0)
                return void setTimeout(r, 200);
            const n = setTimeout(( () => {
                r()
            }
            ), 1e3);
            t.addEventListener("load", ( () => {
                clearTimeout(n),
                r()
            }
            )),
            t.addEventListener("error", ( () => {
                clearTimeout(n),
                r()
            }
            ))
        }
        ))
    }
    )()
}
)();
